// src/generated/enums.ts
import { z } from "zod";
var ANNOTATION_KIND_VALUES = ["note", "chat", "bug_report", "review"];
var AnnotationKindSchema = z.enum(ANNOTATION_KIND_VALUES);
var ANNOTATION_RESOURCE_TYPE_VALUES = ["briefing", "ordinance"];
var AnnotationResourceTypeSchema = z.enum(ANNOTATION_RESOURCE_TYPE_VALUES);
var OCR_STATUS_VALUES = ["pending", "processing", "completed", "failed", "skipped"];
var OcrStatusSchema = z.enum(OCR_STATUS_VALUES);
var ARTIFACT_RESOURCE_TYPE_VALUES = ["agenda_item"];
var ArtifactResourceTypeSchema = z.enum(ARTIFACT_RESOURCE_TYPE_VALUES);
var ARTIFACT_FEEDBACK_KIND_VALUES = ["positive", "negative"];
var ArtifactFeedbackKindSchema = z.enum(ARTIFACT_FEEDBACK_KIND_VALUES);
var ARTIFACT_REVIEW_VERDICT_VALUES = ["passed", "failed"];
var ArtifactReviewVerdictSchema = z.enum(ARTIFACT_REVIEW_VERDICT_VALUES);
var ARTIFACT_REVIEW_RESOURCE_TYPE_VALUES = ["briefing", "community_issues_top", "community_issues_trending", "race_opponent_contrast"];
var ArtifactReviewResourceTypeSchema = z.enum(ARTIFACT_REVIEW_RESOURCE_TYPE_VALUES);
var CAMPAIGN_TIER_VALUES = ["WIN", "LOSE", "TOSSUP"];
var CampaignTierSchema = z.enum(CAMPAIGN_TIER_VALUES);
var CAMPAIGN_TASK_TYPE_VALUES = ["text", "robocall", "doorKnocking", "phoneBanking", "socialMedia", "events", "education", "compliance", "awareness", "recurring"];
var CampaignTaskTypeSchema = z.enum(CAMPAIGN_TASK_TYPE_VALUES);
var TRACKER_TASK_SKIP_REASON_VALUES = ["later", "notForMe"];
var TrackerTaskSkipReasonSchema = z.enum(TRACKER_TASK_SKIP_REASON_VALUES);
var CAMPAIGN_UPDATE_HISTORY_TYPE_VALUES = ["doorKnocking", "calls", "digital", "directMail", "digitalAds", "text", "events", "yardSigns", "robocall", "phoneBanking", "socialMedia"];
var CampaignUpdateHistoryTypeSchema = z.enum(CAMPAIGN_UPDATE_HISTORY_TYPE_VALUES);
var CENSUS_TRACT_NAME_SOURCE_VALUES = ["neighborhood", "street", "none"];
var CensusTractNameSourceSchema = z.enum(CENSUS_TRACT_NAME_SOURCE_VALUES);
var CHAT_ATTACHMENT_SOURCE_VALUES = ["UPLOAD", "URL"];
var ChatAttachmentSourceSchema = z.enum(CHAT_ATTACHMENT_SOURCE_VALUES);
var CHAT_ATTACHMENT_STATUS_VALUES = ["pending", "processing", "ready", "failed"];
var ChatAttachmentStatusSchema = z.enum(CHAT_ATTACHMENT_STATUS_VALUES);
var CHAT_SCOPE_VALUES = ["briefing_annotation", "chief_of_staff", "campaign_assistant", "ordinance_flow", "priority_flow"];
var ChatScopeSchema = z.enum(CHAT_SCOPE_VALUES);
var CHAT_MESSAGE_ROLE_VALUES = ["user", "assistant", "system", "tool"];
var ChatMessageRoleSchema = z.enum(CHAT_MESSAGE_ROLE_VALUES);
var CHAT_FEEDBACK_KIND_VALUES = ["positive", "negative"];
var ChatFeedbackKindSchema = z.enum(CHAT_FEEDBACK_KIND_VALUES);
var CHAT_MESSAGE_SEGMENT_KIND_VALUES = ["text", "tool", "citation"];
var ChatMessageSegmentKindSchema = z.enum(CHAT_MESSAGE_SEGMENT_KIND_VALUES);
var COMMUNITY_ISSUE_LIST_VALUES = ["top_community", "trending"];
var CommunityIssueListSchema = z.enum(COMMUNITY_ISSUE_LIST_VALUES);
var COMMUNITY_ISSUE_CATEGORY_VALUES = ["infrastructure_and_transportation", "public_safety", "education", "housing_and_development", "health_and_human_services", "economic_development", "quality_of_life", "government_operations", "other"];
var CommunityIssueCategorySchema = z.enum(COMMUNITY_ISSUE_CATEGORY_VALUES);
var COMMUNITY_ISSUE_PRIORITY_VALUES = ["low", "medium", "high"];
var CommunityIssuePrioritySchema = z.enum(COMMUNITY_ISSUE_PRIORITY_VALUES);
var CONSTITUENT_FEEDBACK_CHANNEL_VALUES = ["door_knock", "phone_bank", "text"];
var ConstituentFeedbackChannelSchema = z.enum(CONSTITUENT_FEEDBACK_CHANNEL_VALUES);
var CONSTITUENT_FEEDBACK_STANCE_VALUES = ["supports", "opposes", "mixed", "unclear"];
var ConstituentFeedbackStanceSchema = z.enum(CONSTITUENT_FEEDBACK_STANCE_VALUES);
var CONSTITUENT_FEEDBACK_CAPTURE_METHOD_VALUES = ["dictation", "typed", "dictation_offline"];
var ConstituentFeedbackCaptureMethodSchema = z.enum(CONSTITUENT_FEEDBACK_CAPTURE_METHOD_VALUES);
var CONSTITUENT_FEEDBACK_EXTRACTION_STATUS_VALUES = ["pending", "extracted", "failed"];
var ConstituentFeedbackExtractionStatusSchema = z.enum(CONSTITUENT_FEEDBACK_EXTRACTION_STATUS_VALUES);
var CONSTITUENT_FEEDBACK_CONFIRMATION_VALUES = ["reviewed", "skipped", "automatic"];
var ConstituentFeedbackConfirmationSchema = z.enum(CONSTITUENT_FEEDBACK_CONFIRMATION_VALUES);
var SUPPORT_ANSWER_VALUES = ["supporter", "unsure", "non_supporter"];
var SupportAnswerSchema = z.enum(SUPPORT_ANSWER_VALUES);
var DOOR_KNOCK_OUTCOME_VALUES = ["answered", "not_home", "refused_to_engage", "inaccessible", "not_a_voter"];
var DoorKnockOutcomeSchema = z.enum(DOOR_KNOCK_OUTCOME_VALUES);
var WILL_VOTE_ANSWER_VALUES = ["yes", "no", "unsure", "already_voted"];
var WillVoteAnswerSchema = z.enum(WILL_VOTE_ANSWER_VALUES);
var FOLLOW_UP_ANSWER_VALUES = ["yes", "no"];
var FollowUpAnswerSchema = z.enum(FOLLOW_UP_ANSWER_VALUES);
var PHONE_BANK_CALL_OUTCOME_VALUES = ["answered", "no_answer", "voicemail", "wrong_number", "refused", "disconnected", "hung_up"];
var PhoneBankCallOutcomeSchema = z.enum(PHONE_BANK_CALL_OUTCOME_VALUES);
var VOTER_LIKELIHOOD_VALUES = ["unknown", "unlikely", "unreliable", "likely", "super"];
var VoterLikelihoodSchema = z.enum(VOTER_LIKELIHOOD_VALUES);
var CONTACT_STATUS_FIELD_VALUES = ["voter_likelihood", "support_status", "do_not_knock", "not_a_voter", "follow_up", "civic_panel"];
var ContactStatusFieldSchema = z.enum(CONTACT_STATUS_FIELD_VALUES);
var DO_NOT_KNOCK_STATUS_VALUES = ["active", "cleared"];
var DoNotKnockStatusSchema = z.enum(DO_NOT_KNOCK_STATUS_VALUES);
var NOT_AVOTER_STATUS_VALUES = ["moved", "deceased", "cleared"];
var NotAVoterStatusSchema = z.enum(NOT_AVOTER_STATUS_VALUES);
var FOLLOW_UP_STATUS_VALUES = ["requested", "cleared"];
var FollowUpStatusSchema = z.enum(FOLLOW_UP_STATUS_VALUES);
var CIVIC_PANEL_STATUS_VALUES = ["member", "left"];
var CivicPanelStatusSchema = z.enum(CIVIC_PANEL_STATUS_VALUES);
var CONTACT_STATUS_SOURCE_VALUES = ["manual", "door_knock", "phone_banking", "sms", "share_page"];
var ContactStatusSourceSchema = z.enum(CONTACT_STATUS_SOURCE_VALUES);
var CONTACT_UPLOAD_STATUS_VALUES = ["awaiting_file", "processing", "needs_input", "complete", "failed"];
var ContactUploadStatusSchema = z.enum(CONTACT_UPLOAD_STATUS_VALUES);
var CONTACT_UPLOAD_FAILURE_KIND_VALUES = ["file", "transient"];
var ContactUploadFailureKindSchema = z.enum(CONTACT_UPLOAD_FAILURE_KIND_VALUES);
var CONTACT_UPLOAD_MATCH_OUTCOME_VALUES = ["pending", "matched", "new", "needs_input", "resolved", "skipped", "invalid"];
var ContactUploadMatchOutcomeSchema = z.enum(CONTACT_UPLOAD_MATCH_OUTCOME_VALUES);
var CONTACT_UPLOAD_MATCH_METHOD_VALUES = ["prior_upload", "name_and_phone", "name_and_address", "manual"];
var ContactUploadMatchMethodSchema = z.enum(CONTACT_UPLOAD_MATCH_METHOD_VALUES);
var CONTENT_TYPE_VALUES = ["aiChatPrompt", "aiContentCategories", "aiContentTemplate", "candidateContentPrompts", "contentPromptsQuestions", "onboardingPrompts", "pledge", "promptInputFields"];
var ContentTypeSchema = z.enum(CONTENT_TYPE_VALUES);
var DASHBOARD_CARD_TYPE_VALUES = ["briefing", "agenda_item", "community_issue", "civic_panel", "report_back"];
var DashboardCardTypeSchema = z.enum(DASHBOARD_CARD_TYPE_VALUES);
var DOMAIN_STATUS_VALUES = ["pending", "submitted", "registered", "active", "inactive"];
var DomainStatusSchema = z.enum(DOMAIN_STATUS_VALUES);
var DOMAIN_SOURCE_VALUES = ["manual", "agentic"];
var DomainSourceSchema = z.enum(DOMAIN_SOURCE_VALUES);
var DOOR_KNOCKING_MODE_VALUES = ["walk", "drive"];
var DoorKnockingModeSchema = z.enum(DOOR_KNOCKING_MODE_VALUES);
var DOOR_KNOCKING_PURPOSE_VALUES = ["introduce_myself", "persuade_voters", "event_invite", "early_voting", "election_day_turnout", "custom", "explain_decision", "community_input", "share_resource", "build_citizens_panel"];
var DoorKnockingPurposeSchema = z.enum(DOOR_KNOCKING_PURPOSE_VALUES);
var ELECTED_OFFICE_WIN_SOURCE_VALUES = ["self_reported", "staff", "ddhq"];
var ElectedOfficeWinSourceSchema = z.enum(ELECTED_OFFICE_WIN_SOURCE_VALUES);
var EXPERIMENT_RUN_STATUS_VALUES = ["QUEUED", "RUNNING", "AWAITING_RESUME", "COMPLETED", "FAILED", "SUPERSEDED"];
var ExperimentRunStatusSchema = z.enum(EXPERIMENT_RUN_STATUS_VALUES);
var SYNTHESIS_SCOPE_VALUES = ["effort", "organization", "priority"];
var SynthesisScopeSchema = z.enum(SYNTHESIS_SCOPE_VALUES);
var SYNTHESIS_RUN_STATUS_VALUES = ["running", "completed", "failed", "superseded"];
var SynthesisRunStatusSchema = z.enum(SYNTHESIS_RUN_STATUS_VALUES);
var ISSUE_TAG_STATUS_VALUES = ["proposed", "accepted", "retired"];
var IssueTagStatusSchema = z.enum(ISSUE_TAG_STATUS_VALUES);
var ISSUE_TAG_SOURCE_VALUES = ["seed", "synthesis", "human"];
var IssueTagSourceSchema = z.enum(ISSUE_TAG_SOURCE_VALUES);
var MANAGED_CIVIC_PANEL_STATUS_VALUES = ["building", "ready", "paused", "stopped", "exhausted"];
var ManagedCivicPanelStatusSchema = z.enum(MANAGED_CIVIC_PANEL_STATUS_VALUES);
var MEETING_RESOURCE_LOCATION_TYPE_VALUES = ["AGENDA", "SCHEDULE"];
var MeetingResourceLocationTypeSchema = z.enum(MEETING_RESOURCE_LOCATION_TYPE_VALUES);
var ONBOARDING_CARD_KEY_VALUES = ["meet", "priorities"];
var OnboardingCardKeySchema = z.enum(ONBOARDING_CARD_KEY_VALUES);
var ORDINANCE_STATUS_VALUES = ["in_progress", "draft", "in_review", "proposed", "passed", "repealed"];
var OrdinanceStatusSchema = z.enum(ORDINANCE_STATUS_VALUES);
var ORDINANCE_SEED_TYPE_VALUES = ["issue", "new"];
var OrdinanceSeedTypeSchema = z.enum(ORDINANCE_SEED_TYPE_VALUES);
var ORDINANCE_QUALITY_LOOP_STATUS_VALUES = ["running", "converged", "stopped_max_iterations", "stopped_not_improving", "superseded_by_edit", "cancelled", "failed"];
var OrdinanceQualityLoopStatusSchema = z.enum(ORDINANCE_QUALITY_LOOP_STATUS_VALUES);
var ORDINANCE_DATA_QUALITY_VALUES = ["OK", "PARTIAL", "UNCODIFIED", "NOT_FOUND", "AMBIGUOUS"];
var OrdinanceDataQualitySchema = z.enum(ORDINANCE_DATA_QUALITY_VALUES);
var ORDINANCE_CONFIDENCE_VALUES = ["HIGH", "MEDIUM", "LOW"];
var OrdinanceConfidenceSchema = z.enum(ORDINANCE_CONFIDENCE_VALUES);
var ORDINANCE_HOST_TYPE_VALUES = ["MUNICODE", "ECODE360", "AMERICAN_LEGAL", "CODEPUBLISHING", "ENCODEPLUS", "MUNICIPALCODEONLINE", "CITY_GOV", "OTHER"];
var OrdinanceHostTypeSchema = z.enum(ORDINANCE_HOST_TYPE_VALUES);
var ORGANIZATION_ROLE_VALUES = ["owner", "campaignAdmin", "volunteer"];
var OrganizationRoleSchema = z.enum(ORGANIZATION_ROLE_VALUES);
var OUTREACH_TYPE_VALUES = ["text", "doorKnocking", "nativeDoorKnocking", "phoneBanking", "nativePhoneBanking", "socialMedia", "robocall", "p2p", "poll", "email"];
var OutreachTypeSchema = z.enum(OUTREACH_TYPE_VALUES);
var OUTREACH_STATUS_VALUES = ["pending", "approved", "denied", "paid", "in_progress", "completed", "pending_payment", "canceled", "failed", "draft"];
var OutreachStatusSchema = z.enum(OUTREACH_STATUS_VALUES);
var OUTREACH_FUNDING_VALUES = ["goodparty_pilot"];
var OutreachFundingSchema = z.enum(OUTREACH_FUNDING_VALUES);
var OUTREACH_HANDOFF_HANDLER_VALUES = ["agent", "manual"];
var OutreachHandoffHandlerSchema = z.enum(OUTREACH_HANDOFF_HANDLER_VALUES);
var OUTREACH_HANDOFF_STATUS_VALUES = ["queued", "replies_submitted"];
var OutreachHandoffStatusSchema = z.enum(OUTREACH_HANDOFF_STATUS_VALUES);
var OUTREACH_EMAIL_PAUSE_REASON_VALUES = ["bounce_rate", "complaint_rate", "ses_account", "ses_tenant", "daily_quota", "manual"];
var OutreachEmailPauseReasonSchema = z.enum(OUTREACH_EMAIL_PAUSE_REASON_VALUES);
var OUTREACH_EMAIL_RECIPIENT_STATUS_VALUES = ["queued", "sending", "sent", "bounced", "complained", "failed"];
var OutreachEmailRecipientStatusSchema = z.enum(OUTREACH_EMAIL_RECIPIENT_STATUS_VALUES);
var OUTREACH_EMAIL_REPLY_CLASS_VALUES = ["forwarded", "auto_reply", "bounce", "unsubscribe", "spam"];
var OutreachEmailReplyClassSchema = z.enum(OUTREACH_EMAIL_REPLY_CLASS_VALUES);
var OUTREACH_EMAIL_SUPPRESSION_REASON_VALUES = ["link", "one_click", "reply"];
var OutreachEmailSuppressionReasonSchema = z.enum(OUTREACH_EMAIL_SUPPRESSION_REASON_VALUES);
var P2P_SMS_SETTLE_STATE_VALUES = ["pending_payment", "hold_pending", "authorized", "capturing", "captured", "refunding", "voided", "refunded", "hold_failed"];
var P2pSmsSettleStateSchema = z.enum(P2P_SMS_SETTLE_STATE_VALUES);
var OUTREACH_HOLD_STATE_VALUES = ["scheduled", "placing", "held", "hold_failed", "capturing", "captured", "releasing", "released", "uncollectable", "disputed"];
var OutreachHoldStateSchema = z.enum(OUTREACH_HOLD_STATE_VALUES);
var POLL_AUDIENCE_KIND_VALUES = ["sample", "list"];
var PollAudienceKindSchema = z.enum(POLL_AUDIENCE_KIND_VALUES);
var ROBOCALL_SETTLE_STATE_VALUES = ["pending_payment", "authorized", "settling", "captured", "charged", "voided", "cancelled", "disputed", "uncollectable", "hold_pending", "hold_failed", "staging", "dialing", "dialed", "capturing", "charging", "send_failed", "draft"];
var RobocallSettleStateSchema = z.enum(ROBOCALL_SETTLE_STATE_VALUES);
var SOCIAL_ASSET_PLATFORM_VALUES = ["facebook", "instagram", "nextdoor", "x", "tiktok", "youtube_shorts"];
var SocialAssetPlatformSchema = z.enum(SOCIAL_ASSET_PLATFORM_VALUES);
var SOCIAL_ASSET_KIND_VALUES = ["post_copy", "video_script"];
var SocialAssetKindSchema = z.enum(SOCIAL_ASSET_KIND_VALUES);
var PHONE_LIST_BUILD_STATUS_VALUES = ["queued", "building", "processing", "ready", "failed"];
var PhoneListBuildStatusSchema = z.enum(PHONE_LIST_BUILD_STATUS_VALUES);
var PERSON_PROFILE_ISSUE_STATUS_VALUES = ["IN_PROGRESS", "PRIORITIZED", "ONGOING", "RESOLVED"];
var PersonProfileIssueStatusSchema = z.enum(PERSON_PROFILE_ISSUE_STATUS_VALUES);
var PHONE_BANKING_PURPOSE_VALUES = ["introduce_myself", "persuade_voters", "event_invite", "early_voting", "election_day_turnout", "custom", "explain_decision", "community_input", "share_resource", "build_citizens_panel"];
var PhoneBankingPurposeSchema = z.enum(PHONE_BANKING_PURPOSE_VALUES);
var POLL_STATUS_VALUES = ["SCHEDULED", "IN_PROGRESS", "COMPLETED", "EXPANDING"];
var PollStatusSchema = z.enum(POLL_STATUS_VALUES);
var POLL_CONFIDENCE_VALUES = ["LOW", "HIGH"];
var PollConfidenceSchema = z.enum(POLL_CONFIDENCE_VALUES);
var POLL_INDIVIDUAL_MESSAGE_SENDER_VALUES = ["ELECTED_OFFICIAL", "CONSTITUENT"];
var PollIndividualMessageSenderSchema = z.enum(POLL_INDIVIDUAL_MESSAGE_SENDER_VALUES);
var PRIORITY_SOURCE_VALUES = ["win_import", "user_stated", "community_issue"];
var PrioritySourceSchema = z.enum(PRIORITY_SOURCE_VALUES);
var PRIORITY_ANSWER_SOURCE_VALUES = ["text", "phone_banking", "door_knocking"];
var PriorityAnswerSourceSchema = z.enum(PRIORITY_ANSWER_SOURCE_VALUES);
var PRIORITY_ANSWER_CODE_VALUES = ["yes", "no", "mixed", "not_an_answer"];
var PriorityAnswerCodeSchema = z.enum(PRIORITY_ANSWER_CODE_VALUES);
var PROFILE_CLAIM_REQUEST_SOURCE_VALUES = ["notify", "owner"];
var ProfileClaimRequestSourceSchema = z.enum(PROFILE_CLAIM_REQUEST_SOURCE_VALUES);
var RACE_OPPONENT_SOURCE_TYPE_VALUES = ["ballotpedia", "opponent_website", "campaign_plan_db"];
var RaceOpponentSourceTypeSchema = z.enum(RACE_OPPONENT_SOURCE_TYPE_VALUES);
var RACE_OPPONENT_RESEARCH_STATUS_VALUES = ["not_started", "queued", "running", "completed", "failed"];
var RaceOpponentResearchStatusSchema = z.enum(RACE_OPPONENT_RESEARCH_STATUS_VALUES);
var RACE_OPPONENT_CONTRAST_STATUS_VALUES = ["draft", "pending_review", "cleared", "blocked", "approved", "used", "discarded"];
var RaceOpponentContrastStatusSchema = z.enum(RACE_OPPONENT_CONTRAST_STATUS_VALUES);
var RACE_OPPONENT_FINDING_KIND_VALUES = ["self", "opponent"];
var RaceOpponentFindingKindSchema = z.enum(RACE_OPPONENT_FINDING_KIND_VALUES);
var TCR_COMPLIANCE_STATUS_VALUES = ["submitted", "pending", "approved", "rejected", "error"];
var TcrComplianceStatusSchema = z.enum(TCR_COMPLIANCE_STATUS_VALUES);
var OFFICE_LEVEL_VALUES = ["federal", "state", "local"];
var OfficeLevelSchema = z.enum(OFFICE_LEVEL_VALUES);
var COMMITTEE_TYPE_VALUES = ["HOUSE", "SENATE", "PRESIDENTIAL", "CANDIDATE"];
var CommitteeTypeSchema = z.enum(COMMITTEE_TYPE_VALUES);
var USER_ROLE_VALUES = ["admin", "sales", "candidate", "campaignManager", "demo"];
var UserRoleSchema = z.enum(USER_ROLE_VALUES);
var USER_AGENDA_SOURCE_VALUES = ["URL", "UPLOAD"];
var UserAgendaSourceSchema = z.enum(USER_AGENDA_SOURCE_VALUES);
var VENDOR_MOCK_VENDOR_VALUES = ["peerly", "callhub", "geoapify", "vercel", "route53", "people_db"];
var VendorMockVendorSchema = z.enum(VENDOR_MOCK_VENDOR_VALUES);
var VOTED_STATUS_VALUES = ["already_voted", "unknown"];
var VotedStatusSchema = z.enum(VOTED_STATUS_VALUES);
var SUPPORT_STATUS_ROLLUP_VALUES = ["supporter", "non_supporter", "unknown", "undecided", "refused"];
var SupportStatusRollupSchema = z.enum(SUPPORT_STATUS_ROLLUP_VALUES);
var ACTIVITY_CONDITION_ACTION_VALUES = ["responded", "no_response", "opted_out", "answered", "not_home", "refused_to_engage", "support_yes", "support_unsure", "support_no", "voicemail_left", "no_answer", "voicemail", "wrong_number", "refused", "disconnected", "hung_up"];
var ActivityConditionActionSchema = z.enum(ACTIVITY_CONDITION_ACTION_VALUES);
var VOTER_OUTREACH_ATTRIBUTION_SOURCE_VALUES = ["recipient", "segmentDerived"];
var VoterOutreachAttributionSourceSchema = z.enum(VOTER_OUTREACH_ATTRIBUTION_SOURCE_VALUES);
var WEBSITE_STATUS_VALUES = ["published", "unpublished"];
var WebsiteStatusSchema = z.enum(WEBSITE_STATUS_VALUES);

// src/people/Person.schema.ts
import { z as z3 } from "zod";

// src/people/ContactStatus.schema.ts
import { z as z2 } from "zod";
var VoterLikelihoodSchema2 = VoterLikelihoodSchema;
var ContactStatusFieldSchema2 = ContactStatusFieldSchema;
var ContactStatusSourceSchema2 = ContactStatusSourceSchema;
var DoNotKnockStatusSchema2 = DoNotKnockStatusSchema;
var NotAVoterStatusSchema2 = NotAVoterStatusSchema;
var FollowUpStatusSchema2 = FollowUpStatusSchema;
var UpdateFollowUpInputSchema = z2.object({ value: FollowUpStatusSchema2 }).strict();
var FollowUpStatusResponseSchema = z2.object({
  followUp: FollowUpStatusSchema2
});
var CivicPanelStatusSchema2 = CivicPanelStatusSchema;
var UpdateCivicPanelInputSchema = z2.object({ value: CivicPanelStatusSchema2 }).strict();
var CivicPanelStatusResponseSchema = z2.object({
  civicPanel: CivicPanelStatusSchema2
});
var NotAVoterReasonSchema = NotAVoterStatusSchema2.exclude(["cleared"]);
var UpdateContactStatusInputSchema = z2.discriminatedUnion("field", [
  z2.object({
    field: z2.literal("voter_likelihood"),
    value: VoterLikelihoodSchema2
  }).strict(),
  z2.object({
    field: z2.literal("support_status"),
    value: SupportStatusRollupSchema
  }).strict()
]);
var ContactStatusesSchema = z2.object({
  voterLikelihood: VoterLikelihoodSchema2,
  supportStatus: SupportStatusRollupSchema
});
var VOTER_LIKELIHOOD_LABELS = {
  unknown: "Unknown",
  unlikely: "Unlikely",
  unreliable: "Unreliable",
  likely: "Likely",
  super: "Super"
};
var SUPPORT_STATUS_ROLLUP_LABELS = {
  supporter: "Supporter",
  non_supporter: "Non-supporter",
  unknown: "Support unknown",
  undecided: "Undecided",
  refused: "Refused"
};
var DO_NOT_KNOCK_LABELS = {
  active: "On",
  cleared: "Off"
};
var NOT_A_VOTER_LABELS = {
  moved: "Moved away",
  deceased: "Deceased",
  cleared: "Off"
};
var FOLLOW_UP_STATUS_LABELS = {
  requested: "Yes",
  cleared: "No"
};
var CIVIC_PANEL_STATUS_LABELS = {
  member: "Member",
  left: "Not a member"
};
var LABELS_BY_FIELD = {
  voter_likelihood: VOTER_LIKELIHOOD_LABELS,
  support_status: SUPPORT_STATUS_ROLLUP_LABELS,
  do_not_knock: DO_NOT_KNOCK_LABELS,
  not_a_voter: NOT_A_VOTER_LABELS,
  follow_up: FOLLOW_UP_STATUS_LABELS,
  civic_panel: CIVIC_PANEL_STATUS_LABELS
};
var resolveContactStatusLabel = (field, value) => LABELS_BY_FIELD[field][value] ?? value;

// src/people/Person.schema.ts
var SupportStatusRollupSchema2 = SupportStatusRollupSchema;
var CivicPanelActivitySchema = z3.object({
  latestChange: z3.object({
    value: CivicPanelStatusSchema2,
    source: ContactStatusSourceSchema2,
    at: z3.string()
  }).nullable(),
  lastReachedAt: z3.string().nullable()
});
var HOUSEHOLD_KEY_RESIDENCE_COLUMNS = [
  "Residence_Addresses_AddressLine",
  "Residence_Addresses_City",
  "Residence_Addresses_State",
  "Residence_Addresses_Zip"
];
var DOOR_KNOCKING_UNIT_KEY_COLUMNS = [
  "Residence_Addresses_AddressLine",
  "Residence_Addresses_ApartmentNum",
  "Residence_Addresses_Zip"
];
var DOOR_KNOCKING_LEGACY_UNIT_KEY_COLUMNS = [
  "Residence_Addresses_HouseNumber",
  "Residence_Addresses_PrefixDirection",
  "Residence_Addresses_StreetName",
  "Residence_Addresses_Designator",
  "Residence_Addresses_SuffixDirection",
  "Residence_Addresses_ApartmentNum",
  "Residence_Addresses_Zip"
];
var isLegacyDoorKnockingUnitKey = (addressKey) => addressKey.split("|").length === DOOR_KNOCKING_LEGACY_UNIT_KEY_COLUMNS.length;
var PersonSchema = z3.object({
  id: z3.string(),
  // Null on consumer-only rows (Serve constituents with no voter record).
  lalVoterId: z3.string().nullable(),
  firstName: z3.string().nullable(),
  middleName: z3.string().nullable(),
  lastName: z3.string().nullable(),
  nameSuffix: z3.string().nullable(),
  age: z3.number().nullable(),
  state: z3.string(),
  address: z3.object({
    line1: z3.string().nullable(),
    line2: z3.string().nullable(),
    city: z3.string().nullable(),
    state: z3.string().nullable(),
    zip: z3.string().nullable(),
    zipPlus4: z3.string().nullable(),
    latitude: z3.string().nullable(),
    longitude: z3.string().nullable()
  }),
  cellPhone: z3.string().nullable(),
  landline: z3.string().nullable(),
  // From the org's imported contacts (Import contacts); null without one.
  email: z3.string().nullable(),
  // A person an import added who is not in the voter or constituent file.
  isNewContact: z3.boolean(),
  gender: z3.enum(["Male", "Female"]).nullable(),
  // Absent (not null) for `eo-` (Serve) organizations: gp-api strips this key
  // before serializing list, detail, and typeahead responses to an elected-
  // office org, per the server-enforced Serve party-visibility rule
  // (ENG-10696). Win responses always carry it. Null for a person only an
  // import added, whom no voter file holds.
  politicalParty: z3.enum(["Independent", "Democratic", "Republican", "Other"]).nullable().optional(),
  // Null for a person only an import added, whom no voter file holds.
  registeredVoter: z3.enum(["Yes", "No"]).nullable(),
  estimatedIncomeAmount: z3.number().nullable(),
  voterStatus: z3.enum(["Super", "Likely", "Unreliable", "Unlikely"]).nullable(),
  // Likelihood of voting before Election Day, early in person or by mail,
  // from Haystaq's within-state percentile scores, so it is relative to the
  // person's state rather than a probability.
  earlyVoteStatus: z3.enum(["Very Likely", "Likely", "Unlikely", "Very Unlikely"]).nullable(),
  maritalStatus: z3.enum(["Likely Married", "Likely Single", "Married", "Single"]).nullable(),
  hasChildrenUnder18: z3.enum(["Yes", "No"]).nullable(),
  veteranStatus: z3.enum(["Yes"]).nullable(),
  // Probable homeowner folds into 'Homeowner' — see the homeowner entry in
  // peopleDb's VALUE_MAPPERS (ENG-10947).
  homeowner: z3.enum(["Homeowner", "Renter"]).nullable(),
  businessOwner: z3.enum(["Yes"]).nullable(),
  levelOfEducation: z3.enum([
    "None",
    "High School Diploma",
    "Technical School",
    "Some College",
    "College Degree",
    "Graduate Degree"
  ]).nullable(),
  ethnicityGroup: z3.enum(["Asian", "European", "Hispanic", "African American", "Other"]).nullable(),
  // Nullable like every other mapped attribute here: `Language_Code` is
  // nullable with no sentinel, and this field used to report 'Other' for an
  // absent one — the display half of the `OR ... IS NULL` the filter carried,
  // so a person the filter now calls Unknown read as an Other-language
  // speaker in the person detail.
  language: z3.enum(["English", "Spanish", "Other"]).nullable(),
  // Populated only when people-api runs in household-grouped mode (door
  // knocking). `householdId` is a normalized residence-address composite (see
  // HOUSEHOLD_KEY_RESIDENCE_COLUMNS) shared by every voter at the same physical
  // address; `householdSize` is how many of the voters MATCHING the current
  // segment/filters share that address (filter-scoped, not raw occupancy — a
  // hasCellPhone segment counts only the matching contacts at the address).
  // null on the ungrouped (one-row-per-voter) path.
  householdId: z3.string().nullable().optional(),
  householdSize: z3.number().int().nullable().optional(),
  // Derived, never stored (SupportStatusService). Only gp-api's person-detail
  // response (`GET /v1/contacts/:id`) attaches this — list/typeahead rows
  // don't carry it in the locked design (ENG-10696).
  supportStatus: SupportStatusRollupSchema2.optional(),
  // Derived, never stored (ContactInteractionTextService). Only gp-api's
  // person-detail response (`GET /v1/contacts/:id`) attaches this — same
  // detail-only scope as supportStatus above. ISO timestamp of the most
  // recent `optedOutAt` across the org's ContactInteractionText rows for
  // this person, or null if they've never opted out. A timestamp (not a
  // boolean) so the UI can show recency later without a contract change
  // (ENG-10732).
  optedOutAt: z3.string().nullable().optional(),
  // Effective value (manual override ?? seed mapping from `voterStatus`
  // above) — override ownership lives in gp-api's ContactStatusService
  // (ENG-10833). Detail-only, like supportStatus/optedOutAt; omitted for
  // `eo-` (Serve) orgs, which don't get this status at all.
  voterLikelihood: VoterLikelihoodSchema2.optional(),
  // Derived, never stored: true when L2 reports the person voting early or
  // absentee this general, or their latest will-vote answer this election
  // is "Already voted" (gp-api's VotedStatusService). Detail-only and
  // Win-only, like voterLikelihood above.
  voted: z3.boolean().optional(),
  // The mirror image of the two lines above: Serve's standing "asked to be
  // followed up with", omitted for a Win org, which has no such flag. Its
  // absence on a Serve person means nothing is owed — nothing derives this
  // field, so there is no seed to distinguish "no override" from "answered
  // no".
  followUp: FollowUpStatusSchema2.optional(),
  // Serve's civic panel membership, omitted for a Win org like followUp.
  civicPanel: CivicPanelStatusSchema2.optional(),
  // Its history, beside it and on the same terms.
  civicPanelActivity: CivicPanelActivitySchema.optional()
});
var PeopleListPaginationSchema = z3.object({
  totalResults: z3.number(),
  currentPage: z3.number(),
  pageSize: z3.number(),
  totalPages: z3.number(),
  hasNextPage: z3.boolean(),
  hasPreviousPage: z3.boolean()
});
var PeopleListResponseSchema = z3.object({
  pagination: PeopleListPaginationSchema,
  people: z3.array(PersonSchema)
});

// src/people/CivicPanelSummary.schema.ts
import { z as z6 } from "zod";

// src/shared/Date.schema.ts
import { z as z4 } from "zod";
var withDateTimeJsonSchema = (schema) => {
  ;
  schema._zod.toJSONSchema = () => ({ type: "string", format: "date-time" });
  return schema;
};
var zCoerceDate = () => withDateTimeJsonSchema(z4.coerce.date());
var zDate = () => withDateTimeJsonSchema(z4.date());

// src/priorities/PriorityResults.schema.ts
import { z as z5 } from "zod";
var PRIORITY_RESULTS_CHANNELS = [
  "text",
  "phoneBanking",
  "doorKnocking",
  "social"
];
var PriorityResultsChannelSchema = z5.enum(PRIORITY_RESULTS_CHANNELS);
var PriorityResultsSendSchema = z5.object({
  outreachId: z5.number().int(),
  name: z5.string().nullable(),
  channel: PriorityResultsChannelSchema,
  date: z5.string().nullable(),
  // People the send reached (texted, called, knocked). Null for a post,
  // which has no audience to count.
  reached: z5.number().int().nullable(),
  responded: z5.number().int().nullable()
});
var PriorityResultsPointSchema = z5.object({
  lat: z5.number(),
  lng: z5.number()
});
var ThemeVoicesSchema = z5.enum(["strong", "fair", "thin"]);
var THEME_VOICES_PER_GROUP = 3;
var PriorityThemeSchema = z5.object({
  id: z5.string(),
  title: z5.string(),
  summary: z5.string(),
  people: z5.number().int(),
  voices: ThemeVoicesSchema.optional()
});
var PriorityThemeCommentKindSchema = z5.enum(["reply", "note"]);
var PriorityThemeCommentSchema = z5.object({
  text: z5.string(),
  kind: PriorityThemeCommentKindSchema
});
var PriorityThemeCommentsSchema = z5.object({
  themeId: z5.string(),
  comments: z5.array(PriorityThemeCommentSchema)
});
var ReadRepresentativenessSchema = z5.enum([
  "tooEarly",
  "notYetRepresentative",
  "gettingClose",
  "representative",
  "enoughAnswers"
]);
var GOOD_READ_STATUSES = [
  "representative",
  "enoughAnswers"
];
var UnderrepresentedGroupSchema = z5.enum([
  "age18to24",
  "age25to34",
  "age35to44",
  "age45to54",
  "age55to64",
  "age65plus",
  "unreachedAreas",
  "men",
  "women",
  "white",
  "black",
  "hispanic",
  "asian"
]);
var UNDERREPRESENTED_GROUP_NAMES = {
  age18to24: "people 18 to 24",
  age25to34: "people 25 to 34",
  age35to44: "people 35 to 44",
  age45to54: "people 45 to 54",
  age55to64: "people 55 to 64",
  age65plus: "people 65 and over",
  unreachedAreas: "people in some parts of your district",
  men: "men",
  women: "women",
  white: "white residents",
  black: "Black residents",
  hispanic: "Hispanic or Latino residents",
  asian: "Asian residents"
};
var UNSURE_AREAS_NAME = "people in a few neighborhoods";
var underrepresentedGroupName = (group, status) => group === "unreachedAreas" && status === "gettingClose" ? UNSURE_AREAS_NAME : UNDERREPRESENTED_GROUP_NAMES[group];
var joinGroupNames = (names) => names.length <= 2 ? names.join(" and ") : `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
var READ_REPRESENTATIVENESS_LABELS = {
  tooEarly: "Waiting to hear back",
  notYetRepresentative: "A few groups need more answers",
  gettingClose: "Still unsure what some groups think",
  representative: "Every group heard",
  enoughAnswers: "Enough people have answered"
};
var DISTRICT_GRID_CELL_DEGREES = 4e-3;
var PriorityReadStatusSchema = z5.object({
  answers: z5.number().int().nonnegative(),
  needed: z5.number().int().positive(),
  groupsHeard: z5.number().int().nonnegative().default(0),
  groupsTotal: z5.number().int().nonnegative().default(0),
  // Of the groups not yet heard, how many belong to the groups named in
  // `underrepresented`: the ones the read needs answers from next. Absent
  // from reads served before it existed.
  groupsNext: z5.number().int().nonnegative().optional(),
  // People toward a balanced read: `representativeAnswers` counts each
  // answer only while its group is within its share of
  // `representativeNeeded`, the district's floor, so the extra answers of a
  // group heard plenty never fill a seat. The seats and bar show these.
  // Absent from reads served before they existed.
  representativeAnswers: z5.number().int().nonnegative().optional(),
  representativeNeeded: z5.number().int().positive().optional(),
  good: z5.boolean(),
  status: ReadRepresentativenessSchema,
  // The one or two groups holding the read back, the one to hear from
  // first leading. Empty once representative.
  underrepresented: z5.array(UnderrepresentedGroupSchema).max(2),
  // The groups in `underrepresented` nobody in has answered yet, so the
  // line says "Still need to hear from" them rather than asking for more
  // answers. Absent from reads served before it existed.
  unheard: z5.array(UnderrepresentedGroupSchema).max(2).optional(),
  // A follow-up text paid for and not sent yet: when it goes out and how
  // many it texts. Absent when there is none.
  followUp: z5.object({
    scheduledLocalDate: z5.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    texts: z5.number().int().positive()
  }).optional(),
  // A check is out: something sent to residents on any channel, counted
  // from checkout. Absent means nobody has been asked yet, so there is
  // nothing to get answers on.
  checkOut: z5.boolean().optional(),
  // The follow-up text has gone out. With it, a short read is closed with
  // doors and calls, never a third text.
  followUpSent: z5.boolean().optional()
});
var PriorityResultsGroupSchema = z5.object({
  group: UnderrepresentedGroupSchema,
  districtShare: z5.number(),
  answerShare: z5.number()
});
var PriorityResultsSchema = z5.object({
  priorityId: z5.string(),
  readStatus: PriorityReadStatusSchema,
  sends: z5.array(PriorityResultsSendSchema),
  respondents: z5.object({
    total: z5.number().int(),
    // Distinct people per channel. Someone heard by text and at the door
    // counts once in each, so the channels can add up to more than total.
    byChannel: z5.object({
      text: z5.number().int(),
      phoneBanking: z5.number().int(),
      doorKnocking: z5.number().int()
    }),
    joinedCivicPanel: z5.number().int()
  }),
  themes: z5.array(PriorityThemeSchema),
  // A pooled run is in flight: the themes shown are the previous run's.
  summarizing: z5.boolean(),
  points: z5.array(PriorityResultsPointSchema),
  // Each major group the read counts (age band, gender, and race when it may
  // be named): its share of the district and of the coded answers. Empty
  // when the district could not be read.
  groups: z5.array(PriorityResultsGroupSchema)
});

// src/people/CivicPanelSummary.schema.ts
var CIVIC_PANEL_SEGMENT = "civicPanel";
var CIVIC_PANEL_PAGE_HREF = "/dashboard/contacts/citizens-panel";
var PANEL_ACTIVE_WINDOW_DAYS = 90;
var PANEL_MIN_MEMBERS_FOR_BALANCE = 30;
var CIVIC_PANEL_BALANCE_STATUSES = [
  "tooFewMembers",
  "missingGroups",
  "everyGroup"
];
var CivicPanelBalanceStatusSchema = z6.enum(
  CIVIC_PANEL_BALANCE_STATUSES
);
var CIVIC_PANEL_BALANCE_STATUS_LABELS = {
  tooFewMembers: "Too few members yet",
  missingGroups: "Missing some groups",
  everyGroup: "Every group on your panel"
};
var CivicPanelBalanceSchema = z6.object({
  status: CivicPanelBalanceStatusSchema,
  inviteMore: UnderrepresentedGroupSchema.nullable(),
  groupsNeedingFresh: z6.number().int().nonnegative().optional()
});
var civicPanelFreshnessText = (groupsNeedingFresh) => groupsNeedingFresh === 0 ? "Every group has fresh voices" : groupsNeedingFresh === 1 ? "1 group needs fresh voices" : `${groupsNeedingFresh} groups need fresh voices`;
var CivicPanelProgressSchema = z6.object({
  members: z6.number().int(),
  goal: z6.number().int(),
  answersNeeded: z6.number().int(),
  expectedAnswers: z6.number().int(),
  groupsCovered: z6.number().int().nonnegative().default(0),
  groupsTotal: z6.number().int().nonnegative().default(0)
});
var CIVIC_PANEL_PLACE_KINDS = ["tract", "precinct"];
var CivicPanelPlaceKindSchema = z6.enum(CIVIC_PANEL_PLACE_KINDS);
var CivicPanelCompositionPlaceSchema = z6.object({
  key: z6.string(),
  name: z6.string(),
  label: z6.string().optional(),
  districtShare: z6.number(),
  members: z6.number().int().nonnegative()
});
var CivicPanelCompositionGroupSchema = z6.object({
  group: UnderrepresentedGroupSchema,
  districtShare: z6.number(),
  memberShare: z6.number()
});
var CivicPanelCompositionSchema = z6.object({
  placeKind: CivicPanelPlaceKindSchema,
  places: z6.array(CivicPanelCompositionPlaceSchema),
  groups: z6.array(CivicPanelCompositionGroupSchema)
});
var CivicPanelJoinedBySchema = z6.object({
  text: z6.number().int().nonnegative(),
  door: z6.number().int().nonnegative(),
  phone: z6.number().int().nonnegative(),
  hand: z6.number().int().nonnegative()
});
var NO_CIVIC_PANEL_JOINS = {
  text: 0,
  door: 0,
  phone: 0,
  hand: 0
};
var CivicPanelSummarySchema = z6.object({
  members: z6.number().int(),
  joinedBy: CivicPanelJoinedBySchema.default(NO_CIVIC_PANEL_JOINS),
  reachedRecently: z6.number().int(),
  askableNow: z6.number().int(),
  lastOutreachAt: zDate().nullable(),
  progress: CivicPanelProgressSchema,
  balance: CivicPanelBalanceSchema.nullable(),
  composition: CivicPanelCompositionSchema.nullable()
});

// src/people/CivicPanelShortGroups.ts
var CIVIC_PANEL_SEAT_COUNT = 100;
var allocateSeats = (weights, total, caps) => {
  const sum = weights.reduce((a, b) => a + b, 0);
  if (sum <= 0 || total <= 0) return weights.map(() => 0);
  const capOf = (i) => caps?.[i] ?? Infinity;
  const raw = weights.map((w) => w * total / sum);
  const out = raw.map((r, i) => Math.min(Math.floor(r), capOf(i)));
  let left = total - out.reduce((a, b) => a + b, 0);
  const order = raw.map((_, i) => i).sort(
    (a, b) => (raw[b] ?? 0) - (out[b] ?? 0) - ((raw[a] ?? 0) - (out[a] ?? 0)) || (weights[b] ?? 0) - (weights[a] ?? 0)
  );
  while (left > 0) {
    let placed = false;
    for (const i of order) {
      if (left <= 0) break;
      if ((out[i] ?? 0) >= capOf(i) || (weights[i] ?? 0) <= 0) continue;
      out[i] = (out[i] ?? 0) + 1;
      left -= 1;
      placed = true;
    }
    if (!placed) break;
  }
  return out;
};
var placeSeats = ({
  places,
  goal
}) => {
  const target = Math.max(1, goal);
  const shareSum = places.reduce((a, p) => a + p.districtShare, 0) || 1;
  const shares = places.map((p) => p.districtShare / shareSum);
  const seatsFor = allocateSeats(shares, CIVIC_PANEL_SEAT_COUNT);
  const counted = places.map(
    (p, i) => (seatsFor[i] ?? 0) > 0 ? Math.min(p.members, (shares[i] ?? 0) * target) : 0
  );
  const filledTotal = Math.min(
    CIVIC_PANEL_SEAT_COUNT,
    Math.round(
      counted.reduce((a, b) => a + b, 0) / target * CIVIC_PANEL_SEAT_COUNT
    )
  );
  const earned = counted.map(
    (c, i) => Math.min(
      seatsFor[i] ?? 0,
      Math.ceil(c / target * CIVIC_PANEL_SEAT_COUNT)
    )
  );
  const filledFor = allocateSeats(counted, filledTotal, earned);
  return places.map((_, i) => ({
    count: seatsFor[i] ?? 0,
    filled: filledFor[i] ?? 0
  }));
};
var civicPanelShortGroups = ({
  composition,
  members,
  goal
}) => {
  const fill = members / Math.max(1, goal);
  const groups = composition.groups.map((g) => ({
    kind: "group",
    key: g.group,
    group: g.group,
    have: Math.round(g.memberShare * fill * CIVIC_PANEL_SEAT_COUNT),
    need: Math.round(g.districtShare * CIVIC_PANEL_SEAT_COUNT)
  }));
  const seats = placeSeats({ places: composition.places, goal });
  const places = composition.places.flatMap(
    (place, i) => {
      const seat = seats[i];
      return seat && seat.count > 0 ? [
        {
          kind: "place",
          key: place.key,
          place,
          have: seat.filled,
          need: seat.count
        }
      ] : [];
    }
  );
  return [...groups, ...places].filter((row) => row.need > 0 && row.have < row.need).sort((a, b) => a.have / a.need - b.have / b.need || b.need - a.need);
};
var CIVIC_PANEL_SHORT_GROUPS_SHOWN = 4;

// src/people/CivicPanelReach.schema.ts
import { z as z7 } from "zod";
var CIVIC_PANEL_REACH_CHANNELS = ["door", "phone"];
var CivicPanelReachChannelSchema = z7.enum(CIVIC_PANEL_REACH_CHANNELS);
var CivicPanelReachGroupSchema = z7.discriminatedUnion("kind", [
  z7.object({
    kind: z7.literal("group"),
    group: UnderrepresentedGroupSchema.exclude(["unreachedAreas"])
  }),
  z7.object({
    kind: z7.literal("tract"),
    key: z7.string().regex(/^\d{11}$/)
  }),
  z7.object({
    kind: z7.literal("precinct"),
    key: z7.string().min(3).max(200).regex(/^[^|]+\|.+$/)
  })
]);
var CreateCivicPanelReachListInputSchema = z7.object({
  group: CivicPanelReachGroupSchema,
  channel: CivicPanelReachChannelSchema,
  // The list's name in the official's lists, as the button that made it
  // reads ("Knock doors in West Asheville").
  name: z7.string().trim().min(1).max(120)
});
var CivicPanelReachListResponseSchema = z7.object({
  listId: z7.number().int().positive(),
  people: z7.number().int().positive()
});
var CivicPanelReachOptionSchema = z7.object({
  label: z7.string(),
  detail: z7.string(),
  group: CivicPanelReachGroupSchema,
  channel: CivicPanelReachChannelSchema,
  seatsShort: z7.number().int().positive(),
  homes: z7.number().int().positive()
});
var CivicPanelReachOptionsResponseSchema = z7.object({
  place: z7.string().nullable(),
  mostlyNoCell: z7.boolean(),
  options: z7.array(CivicPanelReachOptionSchema)
});

// src/people/ManagedCivicPanel.schema.ts
import { z as z20 } from "zod";

// src/outreach/OutreachSms.schema.ts
import { z as z19 } from "zod";

// src/outreach/OutreachSocial.schema.ts
import { z as z18 } from "zod";

// src/outreach/OutreachEvent.schema.ts
import { z as z8 } from "zod";
var OUTREACH_EVENT_LOCATION_MAX_LENGTH = 200;
var EventDateSchema = z8.string().regex(/^\d{4}-\d{2}-\d{2}$/).refine((v) => !Number.isNaN(Date.parse(`${v}T00:00:00Z`)), "Invalid date");
var OutreachEventDetailsSchema = z8.object({
  /** YYYY-MM-DD. */
  date: EventDateSchema,
  /** 24-hour HH:MM start time. */
  time: z8.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/),
  location: z8.string().trim().min(1).max(OUTREACH_EVENT_LOCATION_MAX_LENGTH)
});
var ProposalEventSchema = OutreachEventDetailsSchema.partial();

// src/chats/ChatCard.schema.ts
import { z as z12 } from "zod";

// src/priorities/PriorityStatus.schema.ts
import { z as z9 } from "zod";
var PRIORITY_STEP_IDS = [
  "define",
  "evidence",
  "listen_problem",
  "options",
  "listen_options",
  "method",
  "plan"
];
var PriorityStepIdSchema = z9.enum(PRIORITY_STEP_IDS);
var PRIORITY_STEP_LABELS = {
  define: "The problem",
  evidence: "What we know",
  listen_problem: "Who to hear from",
  options: "Your options",
  listen_options: "What people back",
  method: "The path",
  plan: "The plan"
};
var PRIORITY_STEP_PURPOSE = {
  define: "Until you can state it in one sentence, no one can agree or disagree with you.",
  evidence: "Separates what you can prove from what you have been told.",
  listen_problem: "The people living with it know things the records don't.",
  options: "Puts the real choices side by side, including doing nothing.",
  listen_options: "Tells you where the support is before you commit to one.",
  method: "Nothing happens without an ordinance, a budget line, or a program to carry it.",
  plan: "Dates and owners are what turn a decision into something that happens."
};
var PriorityStepStateSchema = z9.enum([
  "open",
  "active",
  "settled",
  "stale"
]);
var PRIORITY_CHECK_STATES = [
  "asked",
  "out",
  "confirmed",
  "revised",
  "deferred",
  "declined"
];
var PriorityCheckStateSchema = z9.enum(PRIORITY_CHECK_STATES);
var PRIORITY_CHECK_SIDES = ["main", "contrast"];
var PriorityCheckSideSchema = z9.enum(PRIORITY_CHECK_SIDES);
var PRIORITY_GATE_STEPS = [
  "define",
  "options",
  "method",
  "plan"
];
var MAX_CHECK_RAISES = 3;
var PriorityStepContrastSchema = z9.object({
  state: PriorityCheckStateSchema,
  who: z9.string().default(""),
  question: z9.string().default(""),
  when: z9.string().optional(),
  /** Stamped by the server when this side was really put to the official. */
  offeredAt: z9.string().optional(),
  /** What constituents on this side said, and who said it. */
  heard: z9.string().optional(),
  /** Stamped by the server when outreach to this side actually went out. */
  sentAt: z9.string().optional(),
  /** The proposal that send came from, so a repeat records nothing new. */
  sentProposalKey: z9.string().optional()
});
var PriorityStepCheckSchema = z9.object({
  state: PriorityCheckStateSchema,
  /** The group whose answer would confirm or break the step, in plain words. */
  who: z9.string().default(""),
  /** The one question put to them. */
  question: z9.string().default(""),
  /** On a deferral, what the official said about timing, in their words. */
  when: z9.string().optional(),
  /** Times a deferred check has been raised again. Counted by the server. */
  raised: z9.number().int().nonnegative().default(0),
  updatedAt: z9.string().optional(),
  /**
   * Stamped by the server, never written by the agent, when the check was
   * recorded as asked in a turn where a card or a question really went out.
   * An `asked` without it was never shown and counts as no check at all.
   */
  offeredAt: z9.string().optional(),
  /** What constituents said, and who said it. Required to confirm or revise. */
  heard: z9.string().optional(),
  /**
   * Stamped by the server, never written by the agent, when outreach to this
   * side actually went out (a list built, a post saved, a text paid for).
   */
  sentAt: z9.string().optional(),
  /** The proposal that send came from, so a repeat records nothing new. */
  sentProposalKey: z9.string().optional(),
  /** The least-affected group. Dropped on its own if it fails to parse. */
  contrast: PriorityStepContrastSchema.optional().catch(void 0)
});
var PriorityStepContrastInputSchema = z9.object({
  state: PriorityCheckStateSchema,
  who: z9.string().optional(),
  question: z9.string().optional(),
  when: z9.string().optional(),
  heard: z9.string().optional()
});
var PriorityStepCheckInputSchema = z9.object({
  state: PriorityCheckStateSchema.optional(),
  who: z9.string().optional(),
  question: z9.string().optional(),
  when: z9.string().optional(),
  heard: z9.string().optional(),
  contrast: PriorityStepContrastInputSchema.optional()
});
var offeredAtFor = (stored, recordsAsked, offered, now) => recordsAsked && offered ? now : stored;
var sentStamp = (stored) => ({
  ...stored?.sentAt === void 0 ? {} : { sentAt: stored.sentAt },
  ...stored?.sentProposalKey === void 0 ? {} : { sentProposalKey: stored.sentProposalKey }
});
var mergeContrast = (stored, patch, now, offered) => {
  if (patch === void 0) return stored;
  const when = patch.when ?? stored?.when;
  const heard = patch.heard ?? stored?.heard;
  const offeredAt = offeredAtFor(
    stored?.offeredAt,
    patch.state === "asked",
    offered,
    now
  );
  return {
    state: patch.state,
    who: patch.who ?? stored?.who ?? "",
    question: patch.question ?? stored?.question ?? "",
    ...when === void 0 ? {} : { when },
    ...offeredAt === void 0 ? {} : { offeredAt },
    ...heard === void 0 ? {} : { heard },
    ...sentStamp(stored)
  };
};
var mergeStepCheck = (stored, patch, now, offered = false) => {
  if (patch === void 0) return stored;
  const raisedAgain = stored?.state === "deferred" && patch.state === "deferred" || stored?.contrast?.state === "deferred" && patch.contrast?.state === "deferred";
  const when = patch.when ?? stored?.when;
  const heard = patch.heard ?? stored?.heard;
  const offeredAt = offeredAtFor(
    stored?.offeredAt,
    patch.state === "asked",
    offered,
    now
  );
  const contrast = mergeContrast(stored?.contrast, patch.contrast, now, offered);
  return {
    state: patch.state ?? stored?.state ?? "asked",
    who: patch.who ?? stored?.who ?? "",
    question: patch.question ?? stored?.question ?? "",
    ...when === void 0 ? {} : { when },
    raised: Math.min(
      MAX_CHECK_RAISES,
      (stored?.raised ?? 0) + (raisedAgain ? 1 : 0)
    ),
    updatedAt: now,
    ...offeredAt === void 0 ? {} : { offeredAt },
    ...heard === void 0 ? {} : { heard },
    ...sentStamp(stored),
    ...contrast === void 0 ? {} : { contrast }
  };
};
var PRIORITY_LISTEN_GATES = {
  listen_problem: "define",
  listen_options: "options"
};
var isCheckAnswered = (check) => check === void 0 || check.state === "confirmed" || check.state === "revised" || check.state === "declined";
var openListenBefore = (steps, id) => {
  const at = PRIORITY_STEP_IDS.indexOf(id);
  return steps.find(
    (step) => PRIORITY_LISTEN_GATES[step.id] !== void 0 && PRIORITY_STEP_IDS.indexOf(step.id) < at && step.state !== "settled"
  )?.id;
};
var healCheck = (step) => {
  const check = step.check;
  if (check === void 0) return step;
  if (!PRIORITY_GATE_STEPS.includes(step.id)) {
    return { ...step, check: void 0 };
  }
  if (check.state === "asked" && check.offeredAt === void 0) {
    return { ...step, check: void 0 };
  }
  const contrast = check.contrast;
  return contrast?.state === "asked" && contrast.offeredAt === void 0 ? { ...step, check: { ...check, contrast: void 0 } } : step;
};
var PriorityStepSchema = z9.object({
  id: PriorityStepIdSchema,
  state: PriorityStepStateSchema,
  /** What this step settled, in the official's own words. Empty until worked. */
  summary: z9.string().default(""),
  /** Why it is thin or back in doubt. Shown, never silently dropped. */
  caveat: z9.string().optional(),
  updatedAt: z9.string().optional(),
  // A check that fails to parse (a newer build's check state, say) drops on
  // its own instead of failing the step, which would empty the whole status.
  check: PriorityStepCheckSchema.optional().catch(void 0)
});
var PRIORITY_STATUS_VERSION = 3;
var PriorityStatusSchema = z9.object({
  version: z9.number().int().default(PRIORITY_STATUS_VERSION),
  steps: z9.array(PriorityStepSchema).default([])
});
var emptyPriorityStatus = () => ({
  version: PRIORITY_STATUS_VERSION,
  steps: PRIORITY_STEP_IDS.map((id) => ({ id, state: "open", summary: "" }))
});
var parsePriorityStatus = (value) => {
  const parsed = PriorityStatusSchema.safeParse(value);
  if (!parsed.success) return emptyPriorityStatus();
  const byId = new Map(parsed.data.steps.map((s) => [s.id, s]));
  const steps = PRIORITY_STEP_IDS.map((id) => {
    const step = byId.get(id);
    return step === void 0 ? { id, state: "open", summary: "" } : healCheck(step);
  });
  const checks = new Map(steps.map((step) => [step.id, step.check]));
  return {
    version: parsed.data.version,
    steps: steps.map((step) => {
      const gate = PRIORITY_LISTEN_GATES[step.id];
      return gate !== void 0 && step.state === "settled" && !isCheckAnswered(checks.get(gate)) ? { ...step, state: "open" } : step;
    })
  };
};

// src/people/ListSample.schema.ts
import { z as z10 } from "zod";
var MAX_LIST_SAMPLE_SIZE = 1e4;
var ListSampleSchema = z10.object({
  size: z10.number().int().min(1).max(MAX_LIST_SAMPLE_SIZE),
  /** Names the draw, so the same key draws the same people again. */
  seedKey: z10.string().min(1).max(200).optional(),
  /**
   * Outreach already sent to an earlier sample of this audience. Whoever
   * those lists drew is left out, so a wider sample reaches new people.
   */
  excludeOutreachIds: z10.array(z10.number().int().positive()).max(20).optional(),
  /**
   * Serve only. Of `size`, this many are drawn from the official's civic
   * panel and the rest from people not on it, each part its own random draw
   * within the criteria, so one list asks the panel and grows it at once.
   * Absent, the draw ignores the panel.
   */
  panelSize: z10.number().int().min(1).max(MAX_LIST_SAMPLE_SIZE).optional(),
  /**
   * Serve only. Draw from the people this text send reached, minus anyone
   * who has opted out since, so a report back goes to exactly who was
   * asked. Everyone left is kept when they fit in `size`.
   */
  recipientsOfOutreachId: z10.number().int().positive().optional()
}).refine(
  (sample) => sample.panelSize === void 0 || sample.panelSize < sample.size,
  {
    path: ["panelSize"],
    message: "panelSize is part of size, with room for new residents"
  }
).refine(
  (sample) => sample.recipientsOfOutreachId === void 0 || sample.panelSize === void 0 && sample.excludeOutreachIds === void 0,
  {
    path: ["recipientsOfOutreachId"],
    message: "The people a send reached are drawn on their own"
  }
);

// src/outreach/OutreachPurpose.schema.ts
import { z as z11 } from "zod";
var OUTREACH_PURPOSE_VALUES = [
  "introduce_myself",
  "persuade_voters",
  "event_invite",
  "early_voting",
  "election_day_turnout",
  // "Hear from voters": the one Win purpose that asks a question instead of
  // delivering a message. The same slug as Serve's community input, so issue
  // capture reads an effort's question the same way on both products.
  "community_input",
  "custom"
];
var OutreachPurposeSchema = z11.enum(OUTREACH_PURPOSE_VALUES);
var BROADCAST_OUTREACH_PURPOSE_VALUES = [
  "introduce_myself",
  "persuade_voters",
  "event_invite",
  "early_voting",
  "election_day_turnout",
  "custom"
];
var SERVE_OUTREACH_PURPOSE_VALUES = [
  "introduce_myself",
  "explain_decision",
  "event_invite",
  "community_input",
  "share_resource",
  "custom"
];
var ServeOutreachPurposeSchema = z11.enum(SERVE_OUTREACH_PURPOSE_VALUES);
var BUILD_CITIZENS_PANEL_PURPOSE = "build_citizens_panel";
var REPORT_BACK_PURPOSE = "report_back";
var SERVE_SMS_PURPOSE_VALUES = [
  BUILD_CITIZENS_PANEL_PURPOSE,
  REPORT_BACK_PURPOSE,
  ...SERVE_OUTREACH_PURPOSE_VALUES
];
var ServeSmsPurposeSchema = z11.enum(SERVE_SMS_PURPOSE_VALUES);
var COMMUNITY_INPUT_PURPOSE = "community_input";
var COMMUNITY_INPUT_QUESTION_MAX_LENGTH = 300;

// src/chats/ChatCard.schema.ts
var CHAT_CARD_KINDS = [
  "outreach_proposal",
  "past_outreach",
  "constituents",
  "outside_contact"
];
var ChatCardKindSchema = z12.enum(CHAT_CARD_KINDS);
var PROPOSAL_CHANNELS = [
  "social",
  "phoneBanking",
  "text",
  "doorKnocking"
];
var ProposalChannelSchema = z12.enum(PROPOSAL_CHANNELS);
var PROPOSAL_AUDIENCE_LIST_KEYS = [
  "languageCodes",
  "incomeRanges",
  "precincts",
  "supportStatus"
];
var PROPOSAL_AUDIENCE_LIST_KEY_SET = new Set(
  PROPOSAL_AUDIENCE_LIST_KEYS
);
var ProposalAudienceFiltersSchema = z12.record(z12.string(), z12.union([z12.boolean(), z12.array(z12.string())])).superRefine((filters, ctx) => {
  for (const [key, value] of Object.entries(filters)) {
    if (Array.isArray(value) !== PROPOSAL_AUDIENCE_LIST_KEY_SET.has(key)) {
      ctx.addIssue({
        code: "custom",
        path: [key],
        message: Array.isArray(value) ? `${key} is not a list filter` : `${key} takes a list`
      });
    }
  }
  const status = filters.supportStatus;
  if (Array.isArray(status) && !status.every((s) => SupportStatusRollupSchema.safeParse(s).success)) {
    ctx.addIssue({
      code: "custom",
      path: ["supportStatus"],
      message: "Unknown support status"
    });
  }
});
var OutreachProposalSchema = z12.object({
  proposalKey: z12.string().uuid(),
  event: ProposalEventSchema.optional().describe(
    "For an event invite: the date (YYYY-MM-DD), start time (24-hour HH:MM) and location you know. Write the same details into the message. Leave out any part you do not know; never guess one or leave a placeholder for it."
  ),
  audience: z12.string().min(1),
  count: z12.number().int().nonnegative(),
  channel: ProposalChannelSchema,
  /** A list saved before the card. Cards written before audienceFilters. */
  savedFilterId: z12.number().int().positive().nullish(),
  /** The audience, unsaved. The flow saves it when the official confirms. */
  audienceFilters: ProposalAudienceFiltersSchema.optional(),
  listName: z12.string().nullish(),
  /** What goes out under the official's name. */
  message: z12.string().min(1),
  civicPanelAsk: z12.boolean().optional().describe(
    "Text only: true to ask the people texted to join the civic panel. The flow adds the ask and what it means; never write it into the message."
  ),
  /**
   * Text only, Serve only: the purpose the text flow opens on, past its
   * purpose picker. Only the civic panel invite sets it, so the flow
   * locks the join line and the build card closes once it is paid for.
   */
  purpose: ServeSmsPurposeSchema.optional(),
  /**
   * Nothing shows this: the agent says why in its message. Kept so cards
   * already persisted with it still parse.
   */
  why: z12.string().min(1).optional(),
  /**
   * True when the channel cannot be completed from a card (door knocking is
   * drawn on a map), so the only action is the deep link into the full flow.
   */
  deepLinkOnly: z12.boolean().default(false),
  /**
   * The check this outreach puts out, on a priority: the gate step and which
   * side of it. A real send moves that side to out.
   */
  stepId: PriorityStepIdSchema.optional(),
  side: PriorityCheckSideSchema.optional(),
  /**
   * How many of the audience to reach, picked at random, when a check needs
   * a read and not everyone. Absent, or no smaller than `count`, means the
   * whole audience.
   */
  sampleSize: z12.number().int().positive().max(MAX_LIST_SAMPLE_SIZE).optional(),
  /** The replies a text sample was sized to bring back. */
  targetResponses: z12.number().int().positive().optional(),
  /** The reply rate it was sized with, as a fraction: 0.025 is 2.5%. */
  assumedReplyRate: z12.number().positive().max(1).optional(),
  /**
   * Earlier sends to a sample of this same audience. Whoever they reached is
   * left out of this one, so asking again reaches new people.
   */
  widensOutreachIds: z12.array(z12.number().int().positive()).max(20).optional(),
  /**
   * A report back: the text goes to everyone this earlier text send reached,
   * minus anyone who has opted out since, and tells them what the official
   * heard and will do next. The audience is that send's, so a card carrying
   * it has no audienceFilters, sample, panel part or check.
   */
  reportBackForOutreachId: z12.number().int().positive().optional().describe(
    "Text only: the outreachId of the send this reports back on, from read_report_back. The card goes to everyone it reached who has not opted out since."
  ),
  /**
   * On a priority: the follow-up held from this text's own purchase. The
   * card's sampleSize goes out first, at random; this many more go out
   * FOLLOW_UP_BUSINESS_DAYS later, drawn shortly before toward the groups the
   * answers so far say least about, leaving out everyone already reached.
   */
  roundTwoSize: z12.number().int().positive().max(MAX_LIST_SAMPLE_SIZE).optional().describe(
    "Text only, on a priority: the follow-up texts held from the same purchase, exactly as size_round_one returns them. sampleSize is the first send."
  ),
  /**
   * On a priority: keep the audience to the parts of the district its
   * answers have not reached. The list is saved with that area as a drawn
   * boundary, built by gp-api when the list is saved; no card carries
   * coordinates.
   */
  areaTarget: z12.enum(["unreached"]).optional().describe(
    "unreached to keep the audience to the parts of the district this priority's answers have not reached. The app draws the area."
  )
});
var ProposalLinkSchema = z12.object({
  proposalKey: z12.string().uuid().optional(),
  priorityId: z12.string().min(1).optional(),
  stepId: PriorityStepIdSchema.optional(),
  side: PriorityCheckSideSchema.optional()
});
var PROPOSAL_SENT_MARKER = "[Sent from a card]";
var REPORT_BACK_MARKER = "[Report back]";
var reportBackMessage = (outreachId) => `${REPORT_BACK_MARKER} Help me report back to the people I texted. outreach:${outreachId}`;
var isReportBackMessage = (content) => /^outreach:\d+$/.test(content.split(" ").at(-1) ?? "") && content === reportBackMessage(Number(content.split(":").at(-1)));
var GET_ANSWERS_MARKER = "[Get answers]";
var GET_ANSWERS_MESSAGE = `${GET_ANSWERS_MARKER} Help me get more answers on this priority.`;
var isGetAnswersMessage = (content) => content === GET_ANSWERS_MESSAGE;
var isToolRefusal = (result) => typeof result === "object" && result !== null && "error" in result && typeof result.error === "string";
var PastOutreachRefSchema = z12.object({
  /** Outreach rows to render. Resolved at render, not snapshotted. */
  outreachIds: z12.array(z12.number().int().positive()).min(1).max(5),
  /** The agent's one-line read of why these matter here. */
  note: z12.string().min(1)
});
var ConstituentRefSchema = z12.object({
  contactIds: z12.array(z12.string()).min(1).max(5),
  note: z12.string().min(1)
});
var ContactRefSchema = ConstituentRefSchema;
var OutsideContactSchema = z12.object({
  name: z12.string().min(1),
  /** Their role, or the organization they are part of. */
  role: z12.string().min(1),
  /** One line on why this is the person to reach. */
  why: z12.string().min(1),
  /** Who to ask for once the official gets through. */
  askFor: z12.string().min(1),
  /** What to say, ready to read down the phone or send as-is. */
  script: z12.string().min(1),
  email: z12.string().email().nullish(),
  phone: z12.string().min(1).nullish(),
  // Rejects `javascript:`, which a bare URL check accepts and which reaches
  // an href.
  url: z12.url({ protocol: /^https?$/ }).nullish()
});
var ChatCardSchema = z12.discriminatedUnion("kind", [
  z12.object({ kind: z12.literal("outreach_proposal") }).merge(OutreachProposalSchema),
  z12.object({ kind: z12.literal("past_outreach") }).merge(PastOutreachRefSchema),
  z12.object({ kind: z12.literal("constituents") }).merge(ConstituentRefSchema),
  z12.object({ kind: z12.literal("outside_contact") }).merge(OutsideContactSchema)
]);

// src/phoneBanking/PhoneBankingList.schema.ts
import { z as z14 } from "zod";

// src/phoneBanking/PhoneBankingCreate.schema.ts
import { z as z13 } from "zod";
var PHONE_BANKING_PURPOSE_VALUES2 = OUTREACH_PURPOSE_VALUES;
var PhoneBankingPurposeSchema2 = z13.enum(PHONE_BANKING_PURPOSE_VALUES2);
var SERVE_PHONE_BANKING_PURPOSE_VALUES = [
  BUILD_CITIZENS_PANEL_PURPOSE,
  ...SERVE_OUTREACH_PURPOSE_VALUES
];
var ServePhoneBankingPurposeSchema = z13.enum(
  SERVE_PHONE_BANKING_PURPOSE_VALUES
);
var PHONE_BANKING_NAME_MAX_LENGTH = 60;
var PHONE_BANKING_CREATE_SCRIPT_MAX_LENGTH = 5e3;
var PHONE_BANKING_MAX_SHEET_COUNT = 20;
var PHONE_BANKING_SHEET_SIZE = 60;
var communityInputQuestionSchema = z13.string().min(1).max(COMMUNITY_INPUT_QUESTION_MAX_LENGTH).optional();
var questionMatchesPurpose = {
  check: (input) => input.purpose === COMMUNITY_INPUT_PURPOSE === (input.communityInputQuestion !== void 0),
  params: {
    message: "communityInputQuestion is required for community_input and refused otherwise",
    path: ["communityInputQuestion"]
  }
};
var PhoneBankingCreateSchema = z13.object({
  name: z13.string().min(1).max(PHONE_BANKING_NAME_MAX_LENGTH),
  script: z13.string().min(1).max(PHONE_BANKING_CREATE_SCRIPT_MAX_LENGTH),
  sheetCount: z13.number().int().min(1).max(PHONE_BANKING_MAX_SHEET_COUNT),
  voterFileFilterId: z13.number().int().positive(),
  purpose: PhoneBankingPurposeSchema2,
  communityInputQuestion: communityInputQuestionSchema,
  // The campaign-plan task the flow was opened from. Stored on the list's
  // outreach so the task list can mark that task done.
  trackerTaskId: z13.string().min(1).optional(),
  // The Campaign Manager card this list was started from. Win carries the
  // key alone: its card puts out no priority check.
  proposalKey: z13.string().uuid().optional()
}).strict().refine(questionMatchesPurpose.check, questionMatchesPurpose.params);
var ServePhoneBankingCreateSchema = z13.object({
  name: z13.string().min(1).max(PHONE_BANKING_NAME_MAX_LENGTH),
  script: z13.string().min(1).max(PHONE_BANKING_CREATE_SCRIPT_MAX_LENGTH),
  sheetCount: z13.number().int().min(1).max(PHONE_BANKING_MAX_SHEET_COUNT),
  voterFileFilterId: z13.number().int().positive(),
  purpose: ServePhoneBankingPurposeSchema,
  communityInputQuestion: communityInputQuestionSchema
}).extend(ProposalLinkSchema.shape).strict().refine(questionMatchesPurpose.check, questionMatchesPurpose.params);
var PhoneBankingCreateResponseSchema = z13.object({
  id: z13.number().int(),
  name: z13.string(),
  sheetCount: z13.number().int(),
  entryCount: z13.number().int(),
  personCount: z13.number().int(),
  outreachId: z13.number().int().nullable(),
  // True when usable contacts remain beyond this batch — the build hit the
  // sheetCount x sheet-size entry cap with people left over. Re-running the
  // flow with the same saved list continues where this batch stopped, since
  // people frozen into earlier batches of a filter are excluded at build
  // time (ENG-10958).
  hasMore: z13.boolean()
});

// src/phoneBanking/PhoneBankingList.schema.ts
var PhoneBankingInteractionSchema = z14.object({
  outcome: PhoneBankCallOutcomeSchema,
  supportAnswer: SupportAnswerSchema.nullable(),
  willVote: WillVoteAnswerSchema.nullable(),
  // Serve's answered-call answer, and null on every Win row — the write
  // schema refuses it alongside supportAnswer/willVote, so that holds for any
  // caller and not just ours. Also null on anything logged before it existed.
  followUp: FollowUpAnswerSchema.nullable(),
  // Serve's closing question, read back so a corrected save keeps it. Same
  // null-on-Win rule as followUp.
  joinCivicPanel: FollowUpAnswerSchema.nullable(),
  // The panel-only list's version of the closing question. Same rule.
  stayOnCivicPanel: FollowUpAnswerSchema.nullable(),
  occurredAt: zCoerceDate()
});
var PhoneBankingListPersonSchema = z14.object({
  personId: z14.string(),
  name: z14.string(),
  // Nullable: lists frozen before ENG-10938 predate this field, and even a
  // new build can carry a null firstName when the voter record itself has
  // none — callers fall back to the first word of `name` for both.
  firstName: z14.string().nullable(),
  age: z14.number().int().nullable(),
  party: z14.string().nullable(),
  address: z14.string().nullable(),
  cellPhone: z14.string().nullable(),
  landline: z14.string().nullable(),
  interaction: PhoneBankingInteractionSchema.nullable()
});
var PhoneBankingListEntrySchema = z14.object({
  id: z14.number().int(),
  seq: z14.number().int(),
  sheetIndex: z14.number().int(),
  phone: z14.string(),
  persons: z14.array(PhoneBankingListPersonSchema)
});
var PhoneBankingListSchema = z14.object({
  id: z14.number().int(),
  name: z14.string(),
  script: z14.string(),
  sheetCount: z14.number().int(),
  purpose: z14.union([PhoneBankingPurposeSchema2, ServePhoneBankingPurposeSchema]),
  createdAt: zCoerceDate(),
  entries: z14.array(PhoneBankingListEntrySchema),
  // The owning org's surface (the `eo-` slug prefix, the system-wide Win/
  // Serve invariant — see src/contacts/AGENTS.md) — callers that share this
  // route across both surfaces (e.g. the caller page's back-link) can't
  // infer it from the URL, which is identical for both.
  isServe: z14.boolean(),
  // The list can only hold civic panel members (isCivicPanelOnlyList on its
  // saved criteria), so a Serve caller asks whether they want to stay on the
  // panel instead of whether they want to join. False on Win.
  civicPanelOnly: z14.boolean()
});
var PhoneBankingOutreachDetailSchema = z14.object({
  listId: z14.number().int(),
  entriesTotal: z14.number().int(),
  entriesCalled: z14.number().int(),
  peopleTotal: z14.number().int(),
  peopleCalled: z14.number().int(),
  byOutcome: z14.record(PhoneBankCallOutcomeSchema, z14.number().int()),
  // Person-level support-question tallies (contactInteractionPhoneBanking
  // rows, same base as peopleCalled) — sibling counts to `supporters`, split
  // out so the history drawer's completed results can render the full
  // yes/unsure/no breakdown instead of only the "yes" count.
  supporters: z14.number().int(),
  unsure: z14.number().int(),
  nonSupporters: z14.number().int(),
  // Serve's equivalent, and the reason it is a record rather than three more
  // flat siblings: the answer is binary, the drawer renders whichever of the
  // two tallies belongs to the list's surface, and `byOutcome` above is
  // already the record-shaped precedent in this same object. A Win list's
  // rows carry no followUp and a Serve list's carry no supportAnswer (the
  // write schema refuses the mix), so exactly one of the two is ever
  // non-zero — the drawer picks by surface rather than by which is populated,
  // so a list with no calls yet still reads in its own vocabulary.
  byFollowUp: z14.record(FollowUpAnswerSchema, z14.number().int())
});

// src/doorKnocking/DoorKnockingTurf.schema.ts
import { z as z16 } from "zod";

// src/outreach/DoorKnockingTalkingPoints.schema.ts
import { z as z15 } from "zod";
var DoorKnockingTalkingPointsPurposeSchema = OutreachPurposeSchema;
var ServeDoorKnockingTalkingPointsPurposeSchema = ServePhoneBankingPurposeSchema;
var DOOR_KNOCKING_TALKING_POINTS_MAX_LENGTH = 2e3;
var DOOR_KNOCKING_INSTRUCTIONS_MAX_LENGTH = 500;
var DOOR_KNOCKING_BULLET = "\u2022 ";
var DoorKnockingTalkingPointsDraftResponseSchema = z15.object({
  draft: z15.string().min(1).max(DOOR_KNOCKING_TALKING_POINTS_MAX_LENGTH)
});

// src/doorKnocking/DoorKnockingTurf.schema.ts
var PositionSchema = z16.tuple([
  z16.number().min(-180).max(180),
  z16.number().min(-90).max(90)
]);
var closedRing = (ring) => {
  const first = ring[0];
  const last = ring[ring.length - 1];
  return first !== void 0 && last !== void 0 && first[0] === last[0] && first[1] === last[1];
};
var GeoJsonPolygonSchema = z16.object({
  type: z16.literal("Polygon"),
  coordinates: z16.array(
    z16.array(PositionSchema).min(4).refine(closedRing, "ring must close")
  ).min(1)
}).strict();
var CreateDoorKnockingTurfFields = z16.object({
  voterFileFilterId: z16.number().int().positive(),
  name: z16.string().min(1).max(120),
  color: z16.string().regex(/^#[0-9a-fA-F]{6}$/),
  geoPoly: GeoJsonPolygonSchema,
  mode: DoorKnockingModeSchema.optional(),
  loop: z16.boolean().optional(),
  // The campaign-plan task the flow was opened from, sent on the anchor turf
  // only. Stored on the walk's outreach so the task list can mark that task
  // done.
  trackerTaskId: z16.string().min(1).optional(),
  // The goal the candidate picked on the wizard's first step. It has always
  // been asked and never persisted — until now it decided a suggested list
  // name and was dropped on submit.
  //
  // Optional on the wire, and the column is nullable to match: the flow can
  // reach submit without it (the "Something else" card carries no slug the
  // server would store), and a client that has not shipped this field yet
  // must keep creating lists.
  //
  // The union of both rails' vocabularies, because door knocking has ONE
  // route for both surfaces — the server does not re-derive which rail is
  // asking, so a Serve-only slug and a Win-only slug both have to be
  // acceptable here. The wizard only ever offers the six for the rail it is
  // drawing.
  purpose: DoorKnockingPurposeSchema.optional(),
  // What this effort is asking, when the purpose is `community_input`. The
  // wizard requires it on that branch and omits it on every other, and the
  // server refuses the mismatch both ways below — a question recorded
  // against a purpose that never asks one would be read as context by the
  // extraction that runs at every door.
  communityInputQuestion: z16.string().min(1).max(COMMUNITY_INPUT_QUESTION_MAX_LENGTH).optional(),
  // The talking points, drafted and then edited by the candidate, frozen with
  // the list.
  //
  // Free text, where a line starting with DOOR_KNOCKING_BULLET is a bullet,
  // landing on the `Outreach.script` column that every other channel already
  // uses for exactly this. Sent by
  // the client rather than generated here because generation is a separate,
  // stateless draft endpoint — the create transaction already carries a paid
  // Geoapify round trip inside a 120-second window, and an LLM call has no
  // business inside it.
  talkingPoints: z16.string().max(DOOR_KNOCKING_TALKING_POINTS_MAX_LENGTH).optional(),
  // The Outreach id of an existing turf whose campaign this new turf
  // should join — the "Add turf" flow reads it back from the
  // sibling-list drawer and threads it through save. Omitted (or
  // absent from a legacy client) means the new turf is its own
  // campaign anchor, matching how a solo campaign already looks.
  // When set, the server takes the audience, purpose, question and
  // talking points from the campaign and ignores the ones sent here.
  campaignOutreachId: z16.number().int().positive().optional(),
  // What the CAMPAIGN is called, as opposed to `name` above, which is what
  // this one turf is called. A campaign has no row of its own — it is the
  // anchor Outreach plus every sibling pointing at it — so its title has to
  // live on an envelope, and history surfaces read the anchor's.
  //
  // Written onto EVERY turf's envelope in the campaign, not just the
  // anchor's, even though only the anchor's is ever displayed. Deleting the
  // anchor makes `collapseDoorKnockingCampaigns` fall back to the earliest
  // surviving sibling, and a campaign that silently renames itself to
  // whatever that sibling's turf was called is the failure this avoids.
  //
  // Optional, and absent falls back to the turf's own name: a client that
  // predates the multi-turf flow sends one turf and means it to title the
  // campaign, which is exactly what the fallback does.
  campaignName: z16.string().min(1).max(120).optional()
});
var walkSettingsTogether = (input) => input.mode === void 0 === (input.loop === void 0);
var WALK_SETTINGS_MESSAGE = {
  message: "mode and loop must be sent together, or neither",
  path: ["loop"]
};
var questionTravelsWithPurpose = (input) => input.purpose === COMMUNITY_INPUT_PURPOSE === (input.communityInputQuestion !== void 0);
var QUESTION_MESSAGE = {
  message: "communityInputQuestion is required for community_input and refused otherwise",
  path: ["communityInputQuestion"]
};
var CreateDoorKnockingTurfSchema = CreateDoorKnockingTurfFields.extend(
  { proposalKey: z16.string().uuid().optional() }
).strict().refine(walkSettingsTogether, WALK_SETTINGS_MESSAGE).refine(questionTravelsWithPurpose, QUESTION_MESSAGE);
var CreateServeDoorKnockingTurfSchema = CreateDoorKnockingTurfFields.extend(ProposalLinkSchema.shape).strict().refine(walkSettingsTogether, WALK_SETTINGS_MESSAGE).refine(questionTravelsWithPurpose, QUESTION_MESSAGE);
var UpdateDoorKnockingTurfSchema = z16.object({
  name: z16.string().min(1).max(120),
  color: z16.string().regex(/^#[0-9a-fA-F]{6}$/)
}).partial().strict();
var DoorKnockingTurfSchema = z16.object({
  id: z16.number().int(),
  // This turf's own Outreach envelope. Every turf has exactly one (the
  // 1:1:1 chain the schema comment above describes), and it is the id the
  // campaign grouping is expressed in: `campaignOutreachId` on a create
  // names one of these, never a turf id.
  //
  // Exposed because the multi-turf create needs it and can get it nowhere
  // else. It cuts several turfs into one campaign, which means the first
  // turf it creates has to become the anchor the rest point at — and until
  // this field existed the client had just bought that anchor and had no
  // way to learn what to call it.
  outreachId: z16.number().int(),
  voterFileFilterId: z16.number().int(),
  name: z16.string(),
  color: z16.string(),
  geoPoly: GeoJsonPolygonSchema,
  // Three quantities, not one, and every surface that lists turfs prints
  // two of them. A multi-unit building is ONE stop with many doors behind
  // it, and its residents are more people again. Stops is the router's own
  // unit and the one the 150 cap is stated in, so it is what a card leads
  // with; doors is what the walk knocks; people is who is behind them.
  stopCount: z16.number().int(),
  doorCount: z16.number().int(),
  knockedDoorCount: z16.number().int(),
  peopleCount: z16.number().int(),
  loggedCount: z16.number().int(),
  // The route's own `totalSeconds` — travel between doors, with no time spent
  // at them (see `doorKnockingServe.service.ts`). The create flow's estimate
  // and the details drawer's are a different quantity, and printing one here
  // under the same clock icon would put two of them in one column of the rail.
  //
  // NULL means the turf has no route yet, which is a real state now that the
  // route is bought at first knock rather than at create. It is the one field
  // that says so, deliberately, rather than a second `routed` boolean that
  // could disagree with it — a surface asking "is this routed" asks whether
  // this is null. The COUNTS do not answer that question: they are non-zero
  // from creation, because the doors are frozen with the turf and only their
  // order is bought. A routed turf whose travel happens to be 0 seconds is
  // not a case the router can produce, since a route spans at least two
  // stops.
  routeSeconds: z16.number().int().nullable(),
  // Both read off the turf's Outreach envelope, which since 3.0 is the one
  // place the lifecycle lives. They are shaped differently because the
  // envelope stores them differently: completion is a `status` value, so it
  // arrives as a boolean, while archiving has a real `archivedAt` column and
  // keeps its timestamp. The turf used to carry a `completedAt` instant, but
  // nothing ever rendered the date — `turfStage` only asks whether it is set —
  // so there is no reader to strand, and inventing an instant out of the
  // envelope's `updatedAt` would have been a plausible-looking lie.
  //
  // `deletedAt` is deliberately absent: a soft-deleted turf never leaves the
  // API at all, so exposing the column would only invite a client to render a
  // list the server considers gone.
  completed: z16.boolean(),
  archivedAt: zDate().nullable(),
  // The priority whose card opened this turf's campaign. A chat card's link
  // is written to the campaign's anchor envelope only, so a sibling turf
  // reads it off its anchor. Carried so the completion event can count the
  // walk toward that priority, as text and phone banking already do.
  priorityId: z16.string().nullable(),
  // What the candidate picked at "What do you want to do?". Carried so the
  // completion event reports it, as every other channel's does. NULL on a turf
  // made before the column existed.
  purpose: DoorKnockingPurposeSchema.nullable(),
  createdAt: zDate(),
  updatedAt: zDate()
});
var DoorKnockingOutreachDetailSchema = z16.object({
  turfId: z16.number().int(),
  // NULL until the route is bought at first knock. The three counts below do
  // NOT wait on it — the doors are frozen when the turf is drawn — so an
  // unwalked campaign opens a drawer reporting what it covers, with this
  // field as the one thing saying nobody has started.
  routeId: z16.number().int().nullable(),
  // The turf's live name, not the envelope's `name` snapshot taken at knock
  // time: a list renamed since is one list, and two names for it across two
  // drawers is the same class of defect as two counts.
  turfName: z16.string(),
  doorCount: z16.number().int(),
  peopleCount: z16.number().int(),
  loggedCount: z16.number().int(),
  // The walk's lifecycle. It used to be carried here because it lived on the
  // turf and the envelope held only a mirror that could fall behind it; now
  // both come off the envelope this block already describes, so they agree by
  // construction. Kept on the block anyway so a caller holding it does not
  // have to reach back out to the row for two fields, and shaped to match
  // `DoorKnockingTurfSchema` above.
  completed: z16.boolean(),
  archivedAt: zCoerceDate().nullable()
});
var BuildDoorKnockingRouteSchema = z16.object({
  mode: DoorKnockingModeSchema,
  loop: z16.boolean()
}).strict();
var DoorKnockingArchiveRequestSchema = z16.object({
  archived: z16.boolean()
}).strict();
var DoorKnockingRouteHeaderSchema = z16.object({
  id: z16.number().int(),
  doorKnockingTurfId: z16.number().int(),
  mode: DoorKnockingModeSchema,
  loop: z16.boolean(),
  totalSeconds: z16.number().int(),
  totalMeters: z16.number().int(),
  stopCount: z16.number().int(),
  createdAt: zDate()
});

// src/outreach/RobocallPurchase.schema.ts
import { z as z17 } from "zod";

// src/outreach/OutreachScript.const.ts
var P2P_SCRIPT_MAX_LENGTH = 2e3;
var ROBOCALL_SCRIPT_MAX_LENGTH = 2e3;

// src/outreach/RobocallPurchase.schema.ts
var RobocallDraftCreateRequestSchema = z17.object({
  // The saved voter list the send targets. The billable landline count is
  // derived from this server-side; a client count is never trusted.
  voterFileFilterId: z17.number().int().positive(),
  // The recorded audio's S3 object key (from the presign step). Confirmed to
  // belong to this campaign server-side before the draft is written.
  audioKey: z17.string().min(1),
  // The rented CallHub caller-ID number the candidate reads aloud.
  callbackNumber: z17.string().min(1).max(32),
  // When the robocall should go out, ISO-8601 WITH a timezone offset (not UTC
  // 'Z'). The offset is required because the server takes the local calendar
  // day from this string (its date portion) to schedule the dial — a bare 'Z'
  // erases the offset, so an evening US send would record the next UTC day.
  scheduledAt: z17.string().datetime({ offset: true }).refine((value) => !value.endsWith("Z"), {
    message: "scheduledAt must include a timezone offset, not UTC Z, so the local send day is unambiguous"
  }),
  // The script the candidate read into the recording (display/record only).
  script: z17.string().min(1).max(ROBOCALL_SCRIPT_MAX_LENGTH).optional(),
  name: z17.string().min(1).max(120).optional(),
  // The campaign-plan task's due date, when the flow was opened from a tracker
  // or manager task. Carried so it can ride the outreach record the way the
  // p2p create already does (POST /v1/outreach); the flow never derives it.
  campaignPlanDueDate: z17.string().regex(/^\d{4}-\d{2}-\d{2}$/, "campaignPlanDueDate must be YYYY-MM-DD").refine((value) => !Number.isNaN(Date.parse(value)), {
    message: "campaignPlanDueDate must be a valid calendar date"
  }).optional(),
  // The campaign-plan task the flow was opened from. Stored on the outreach
  // so the task list can mark that task done once the robocall is scheduled.
  trackerTaskId: z17.string().min(1).optional(),
  // Converts an existing `draft` row in place instead of inserting (resume).
  draftOutreachId: z17.number().int().positive().optional()
});
var OutreachRobocallDetailSchema = z17.object({
  audioKey: z17.string(),
  callbackNumber: z17.string(),
  billableCount: z17.number().int().nullable(),
  // Payment-settlement state (pending → held → captured, or null before
  // hold). Read by the E2E spec to confirm the capture job ran.
  settleState: z17.string().optional()
});
var RobocallDraftCreateResponseSchema = z17.object({
  // The draft's Outreach id — the anchor the later hold/settlement slices act
  // on, the way the p2p draft's id does.
  outreachId: z17.number().int().positive(),
  // The server-derived landline count and the estimate authorized for it, so
  // the pay step renders the same numbers the hold will place. `amountInCents`
  // is the TOTAL (per-call cost + the flat number-rental fee); `numberFeeInCents`
  // is that fee alone, so the pay step can show the breakdown without computing
  // any money figure itself (the per-call subtotal is amount − fee).
  billableCount: z17.number().int().min(0),
  amountInCents: z17.number().int().min(0),
  numberFeeInCents: z17.number().int().min(0),
  // A reward promotion code remembered on the draft (null when none). The
  // discount and the amount left to authorize are server-derived: the client
  // never subtracts money itself. `coversTotal` means nothing is left to hold,
  // so the pay step schedules without a card.
  promoCode: z17.string().nullable(),
  promoDiscountInCents: z17.number().int().min(0),
  amountDueInCents: z17.number().int().min(0),
  coversTotal: z17.boolean()
});
var RobocallPromoApplyRequestSchema = z17.object({
  code: z17.string().trim().min(1).max(64)
});
var RobocallPromoStateResponseSchema = z17.object({
  promoCode: z17.string().nullable(),
  promoDiscountInCents: z17.number().int().min(0),
  amountDueInCents: z17.number().int().min(0),
  coversTotal: z17.boolean()
});

// src/outreach/OutreachSocial.schema.ts
var SOCIAL_PURPOSE_VALUES = [
  ...BROADCAST_OUTREACH_PURPOSE_VALUES,
  "issue_update"
];
var SocialPurposeSchema = z18.enum(SOCIAL_PURPOSE_VALUES);
var SERVE_SOCIAL_PURPOSE_VALUES = [
  "introduce_myself",
  "explain_decision",
  "event_invite",
  "community_input",
  "share_resource",
  "issue_update",
  "custom"
];
var ServeSocialPurposeSchema = z18.enum(SERVE_SOCIAL_PURPOSE_VALUES);
var WIN_SOCIAL_PLATFORM_EXCLUSIONS = {
  persuade_voters: ["nextdoor"],
  early_voting: ["nextdoor"],
  election_day_turnout: ["nextdoor"]
};
var SERVE_SOCIAL_PLATFORM_EXCLUSIONS = {};
var SOCIAL_PLATFORM_EXCLUSION_REASON = {
  nextdoor: "Nextdoor doesn't allow telling neighbors how to vote."
};
var excludedSocialPlatformsForPurpose = (surface, purpose) => (surface === "win" ? WIN_SOCIAL_PLATFORM_EXCLUSIONS[purpose] : SERVE_SOCIAL_PLATFORM_EXCLUSIONS[purpose]) ?? [];
var isSocialPlatformAllowed = (surface, purpose, platform) => !excludedSocialPlatformsForPurpose(surface, purpose).includes(platform);
var SOCIAL_TONE_VALUES = [
  "warm",
  "direct",
  "urgent",
  "friendly"
];
var SocialToneSchema = z18.enum(SOCIAL_TONE_VALUES);
var SOCIAL_DRAFT_MESSAGE_MAX_LENGTH = 2e3;
var SOCIAL_POST_COPY_MAX_LENGTH = 4e3;
var SOCIAL_VIDEO_SCRIPT_MAX_LENGTH = 8e3;
var SOCIAL_VIDEO_PLATFORMS = ["tiktok", "youtube_shorts"];
var socialAssetKindForPlatform = (platform) => SOCIAL_VIDEO_PLATFORMS.includes(platform) ? "video_script" : "post_copy";
var SocialAssetSchema = z18.object({
  platform: SocialAssetPlatformSchema,
  kind: SocialAssetKindSchema,
  text: z18.string().min(1).max(SOCIAL_VIDEO_SCRIPT_MAX_LENGTH),
  caption: z18.string().max(SOCIAL_POST_COPY_MAX_LENGTH).nullish().transform((val) => val ?? null)
}).refine(
  (asset) => asset.kind === socialAssetKindForPlatform(asset.platform),
  {
    message: "Asset kind does not match its platform",
    path: ["kind"]
  }
).refine(
  (asset) => socialAssetKindForPlatform(asset.platform) !== "post_copy" || asset.text.length <= SOCIAL_POST_COPY_MAX_LENGTH,
  {
    message: `Post copy cannot exceed ${SOCIAL_POST_COPY_MAX_LENGTH} characters`,
    path: ["text"]
  }
);
var SocialDraftRequestSchema = z18.object({
  purpose: SocialPurposeSchema,
  tone: SocialToneSchema,
  currentDraft: z18.string().min(1).max(SOCIAL_DRAFT_MESSAGE_MAX_LENGTH).optional()
});
var SocialDraftResponseSchema = z18.object({
  draft: z18.string().min(1).max(SOCIAL_DRAFT_MESSAGE_MAX_LENGTH)
});
var SocialGenerateRequestSchema = z18.object({
  draftMessage: z18.string().min(1).max(SOCIAL_DRAFT_MESSAGE_MAX_LENGTH),
  purpose: SocialPurposeSchema,
  platforms: z18.array(SocialAssetPlatformSchema).min(1).max(6)
});
var SocialGenerateResponseSchema = z18.object({
  assets: z18.array(SocialAssetSchema).min(1).max(6)
});
var SocialSaveRequestSchema = z18.object({
  name: z18.string().min(1).max(60),
  purpose: SocialPurposeSchema,
  draftMessage: z18.string().min(1).max(SOCIAL_DRAFT_MESSAGE_MAX_LENGTH),
  assets: z18.array(SocialAssetSchema).min(1).max(6),
  // The campaign-plan task the flow was opened from. Stored on the outreach
  // so the task list can mark that task done.
  trackerTaskId: z18.string().min(1).optional(),
  // The Campaign Manager card this post was started from, key alone.
  proposalKey: z18.string().uuid().optional()
});
var ServeSocialDraftRequestSchema = z18.object({
  purpose: ServeSocialPurposeSchema,
  tone: SocialToneSchema,
  currentDraft: z18.string().min(1).max(SOCIAL_DRAFT_MESSAGE_MAX_LENGTH).optional()
});
var ServeSocialGenerateRequestSchema = z18.object({
  draftMessage: z18.string().min(1).max(SOCIAL_DRAFT_MESSAGE_MAX_LENGTH),
  purpose: ServeSocialPurposeSchema,
  platforms: z18.array(SocialAssetPlatformSchema).min(1).max(6)
});
var ServeSocialSaveRequestSchema = z18.object({
  name: z18.string().min(1).max(60),
  purpose: ServeSocialPurposeSchema,
  draftMessage: z18.string().min(1).max(SOCIAL_DRAFT_MESSAGE_MAX_LENGTH),
  assets: z18.array(SocialAssetSchema).min(1).max(6)
}).extend(ProposalLinkSchema.shape);
var OutreachSocialDetailSchema = z18.object({
  purpose: z18.string(),
  draftMessage: z18.string(),
  assets: z18.array(SocialAssetSchema)
});
var OutreachDetailSchema = z18.object({
  id: z18.number(),
  createdAt: zCoerceDate(),
  updatedAt: zCoerceDate(),
  // Null for a Serve org-only row (no campaign) — see the Win/Serve
  // isolation boundary in gp-api's src/outreach/AGENTS.md (ENG-10976).
  campaignId: z18.number().nullable(),
  outreachType: OutreachTypeSchema,
  projectId: z18.string().nullable(),
  name: z18.string().nullable(),
  status: OutreachStatusSchema.nullable(),
  error: z18.string().nullable(),
  audienceRequest: z18.string().nullable(),
  script: z18.string().nullable(),
  message: z18.string().nullable(),
  date: zCoerceDate().nullable(),
  // The day a text is set to go out (yyyy-MM-dd). A Serve text carries its
  // day only here, with `date` null. .nullish() for fixtures that omit it.
  scheduledLocalDate: z18.string().nullish(),
  imageUrl: z18.string().nullable(),
  voterFileFilterId: z18.number().nullable(),
  doorKnockingRouteId: z18.number().nullable(),
  // .nullish() (not .nullable()): existing rows/fixtures predate this column
  // and omit the key entirely, not just send it null (ENG-10543 lesson).
  phoneBankingListId: z18.number().nullish(),
  phoneListId: z18.number().nullable(),
  identityId: z18.string().nullable(),
  didState: z18.string().nullable(),
  didNpaSubset: z18.array(z18.string()),
  title: z18.string().nullable(),
  textCount: z18.number().nullable(),
  billableTextCount: z18.number().nullable(),
  campaignPlanDueDate: z18.string().nullable(),
  organizationSlug: z18.string().nullable(),
  archivedAt: zCoerceDate().nullable(),
  social: OutreachSocialDetailSchema.optional(),
  phoneBanking: PhoneBankingOutreachDetailSchema.optional(),
  // Present only on a nativeDoorKnocking row whose turf still resolves — a
  // tombstoned list leaves the envelope standing, and the drawer degrades to
  // the id-only rendering it had before this block existed.
  doorKnocking: DoorKnockingOutreachDetailSchema.optional(),
  // Present on a robocall row: the recording and caller-ID number a saved
  // draft has to hand back so the resume can schedule it without recording
  // again.
  robocall: OutreachRobocallDetailSchema.optional()
});

// src/outreach/OutreachSms.schema.ts
var SMS_PURPOSE_VALUES = BROADCAST_OUTREACH_PURPOSE_VALUES;
var SmsPurposeSchema = z19.enum(SMS_PURPOSE_VALUES);
var SMS_COMPOSED_MAX_LENGTH = 2e3;
var SMS_BODY_MAX_LENGTH = 360;
var SmsDraftRequestSchema = z19.object({
  purpose: SmsPurposeSchema,
  tone: SocialToneSchema,
  currentDraft: z19.string().min(1).max(SMS_COMPOSED_MAX_LENGTH).optional(),
  // An event invite's date, time and place, written into a fresh draft.
  event: OutreachEventDetailsSchema.optional()
});
var SmsDraftResponseSchema = z19.object({
  draft: z19.string().min(1).max(SMS_COMPOSED_MAX_LENGTH)
});

// src/people/ManagedCivicPanel.schema.ts
var MANAGED_CIVIC_PANEL_STATUSES = [
  "building",
  "ready",
  "paused",
  "stopped",
  // Nobody is left to invite by text before the goal.
  "exhausted"
];
var ManagedCivicPanelStatusSchema2 = z20.enum(
  MANAGED_CIVIC_PANEL_STATUSES
);
var ApproveManagedCivicPanelInputSchema = z20.object({
  inviteMessage: z20.string().trim().min(1).max(SMS_COMPOSED_MAX_LENGTH),
  consentVersion: z20.string().trim().min(1).max(100)
}).strict();
var MANAGED_CIVIC_PANEL_ACTIONS = ["pause", "resume", "stop"];
var UpdateManagedCivicPanelInputSchema = z20.object({ action: z20.enum(MANAGED_CIVIC_PANEL_ACTIONS) }).strict();
var ManagedCivicPanelProgressSchema = z20.object({
  members: z20.number().int(),
  goalMembers: z20.number().int(),
  wavesSent: z20.number().int(),
  nextWaveAt: zDate().nullable(),
  firstSendDate: z20.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  readyWeekOf: z20.string().regex(/^\d{4}-\d{2}-\d{2}$/)
});
var ManagedCivicPanelSchema = z20.object({
  id: z20.string(),
  status: ManagedCivicPanelStatusSchema2,
  inviteMessage: z20.string(),
  consentVersion: z20.string(),
  approvedAt: zDate(),
  approvedByUserId: z20.number().int().nullable(),
  goalMembers: z20.number().int(),
  freeTextCap: z20.number().int(),
  freeTextsUsed: z20.number().int(),
  readyAt: zDate().nullable(),
  pausedAt: zDate().nullable(),
  stoppedAt: zDate().nullable(),
  createdAt: zDate(),
  updatedAt: zDate(),
  progress: ManagedCivicPanelProgressSchema
});
var ManagedCivicPanelResponseSchema = z20.object({
  panel: ManagedCivicPanelSchema.nullable()
});
var MANAGED_CIVIC_PANEL_CONSENT_VERSION = "managed-panel-invite-2026-10-30";
var START_MANAGED_CIVIC_PANEL_MARKER = "[Set up civic panel]";
var START_MANAGED_CIVIC_PANEL_MESSAGE = `${START_MANAGED_CIVIC_PANEL_MARKER} Build my civic panel for me.`;
var SHOW_MANAGED_CIVIC_PANEL_INVITE = "Review the invite";
var MANAGED_CIVIC_PANEL_SET_UP_MESSAGE = "I approved the invite and set up my civic panel.";
var MANAGED_CIVIC_PANEL_BACKED_OUT_MESSAGE = "I closed the invite without setting up my civic panel.";
var MANAGED_CIVIC_PANEL_EXHAUSTED_MARKER = "[Civic panel invites done]";
var MANAGED_CIVIC_PANEL_EXHAUSTED_MESSAGE = `${MANAGED_CIVIC_PANEL_EXHAUSTED_MARKER} Help me fill the rest of my civic panel.`;

// src/people/ManagedCivicPanelExplainer.ts
var MANAGED_CIVIC_PANEL_HOW_IT_WORKS = "How does it work?";
var managedCivicPanelOneInN = (share) => {
  if (!Number.isFinite(share) || share <= 0) return null;
  const n = Math.round(1 / share);
  return n >= 2 && n <= 10 ? `1 in ${n}` : null;
};
var managedCivicPanelExplanation = (place) => [
  `Your civic panel is a group of ${place ? `${place} residents` : "residents"}, from every age group, neighborhood, gender and race, who've said yes to hearing from your office. You can turn to them whenever you want to hear from the whole city, not just the people at the podium: before a big vote, while you're shaping a policy, or when you want to understand an issue more deeply.`,
  "Your part is approving one invite. We gather the residents for you, in your name. It's free in early access."
].join("\n\n");
var managedCivicPanelHowItWorks = ({
  place,
  goalMembers,
  olderShare
}) => {
  const where = place ?? "your district";
  const oneInN = olderShare === null ? null : managedCivicPanelOneInN(olderShare);
  const example = oneInN ? `If about ${oneInN} residents is 65 or older, about ${oneInN} seats goes to people 65 and older.` : `Every age group gets seats in line with its share of ${where}.`;
  return [
    `We invite residents from every part of ${where} by text, in your name. Anyone who replies JOIN takes a seat.`,
    `Your civic panel has ${goalMembers} seats, split to match ${where}. ${example} The same goes for neighborhoods, gender and race. We keep inviting until every group has its fair share.`,
    `When you ask a question, we wait until every group has answered before showing results, so a few loud voices can't tip it. Then we balance the answers so they reflect all of ${where}, not just whoever replied most. That's how a few hundred people can speak for the whole city.`,
    "Members hear from your office about once a month, and anyone can text STOP to leave."
  ].join("\n\n");
};

// src/people/CivicPanelOnlyList.ts
var isDay = (value) => typeof value === "string" && value.length > 0;
var isCivicPanelOnlyList = (list) => {
  const joined = list.civicPanelJoinedByText === true || list.civicPanelJoinedByDoor === true || list.civicPanelJoinedByPhone === true || list.civicPanelJoinedByHand === true || isDay(list.civicPanelJoinedFrom) || isDay(list.civicPanelJoinedTo);
  if (joined) return true;
  return list.civicPanelMember === true && list.civicPanelLeft !== true && list.civicPanelNeverInvited !== true;
};

// src/outreach/AnswersNeeded.const.ts
var MIN_VOICES_PER_GROUP = 3;
var MAJOR_GROUP_SHARE = 0.03;
var answersNeeded = (smallestMajorShare) => {
  const share = Math.max(smallestMajorShare ?? 0, MAJOR_GROUP_SHARE);
  return Math.ceil(Number((MIN_VOICES_PER_GROUP / share).toFixed(6)));
};

// src/outreach/CivicPanelJoin.ts
var CIVIC_PANEL_JOIN_KEYWORD = "JOIN";
var CIVIC_PANEL_JOIN_LINE = `Reply ${CIVIC_PANEL_JOIN_KEYWORD} to share your perspectives.`;
var CIVIC_PANEL_JOIN_LINES = [
  CIVIC_PANEL_JOIN_LINE,
  `Reply ${CIVIC_PANEL_JOIN_KEYWORD} to join my civic panel. My office will text you about once a month to ask what you think before I decide. Sent with GoodParty.org.`,
  `Reply ${CIVIC_PANEL_JOIN_KEYWORD} to join my civic panel. My office will text you about once a month to ask what you think before I decide. Empowered by GoodParty.org.`,
  `Reply ${CIVIC_PANEL_JOIN_KEYWORD} to join my citizens' panel. My office will text you about once a month to ask what you think before I decide. Empowered by GoodParty.org.`,
  `Reply ${CIVIC_PANEL_JOIN_KEYWORD} to join my citizens' panel, residents my office (not my campaign) texts a few times a year to hear what you think before I make decisions. Empowered by GoodParty.org.`
];
var CIVIC_PANEL_JOIN_REFUSED_MESSAGE = "Only the invite we send to build your civic panel can ask people to join it. Remove that line and try again.";
var findCivicPanelJoinLine = (message) => {
  let found = null;
  for (const text2 of CIVIC_PANEL_JOIN_LINES) {
    const start = message.lastIndexOf(text2);
    if (start !== -1 && (!found || start > found.start)) found = { text: text2, start };
  }
  return found;
};
var CIVIC_PANEL_LEAVE_KEYWORD = "LEAVE";
var CIVIC_PANEL_LEAVE_LINE = `Reply ${CIVIC_PANEL_LEAVE_KEYWORD} to leave my civic panel.`;
var findCivicPanelLeaveLine = (message) => {
  const start = message.lastIndexOf(CIVIC_PANEL_LEAVE_LINE);
  return start === -1 ? null : { text: CIVIC_PANEL_LEAVE_LINE, start };
};
var countCivicPanelLines = (message) => [...CIVIC_PANEL_JOIN_LINES, CIVIC_PANEL_LEAVE_LINE].reduce(
  (count, line) => count + message.split(line).length - 1,
  0
);
var PANEL_ASSUMED_REPLY_RATE = 0.4;
var CONTACT_REST_DAYS = 30;
var PANEL_SEED_ASSUMED_JOIN_RATE = 0.03;

// src/people/PanelAnswers.ts
var ceilClean = (value) => Math.ceil(Number(value.toFixed(6)));
var panelGoalMembers = (answers) => ceilClean(answers / PANEL_ASSUMED_REPLY_RATE);
var PANEL_MEMBERS_PER_GROUP = ceilClean(
  MIN_VOICES_PER_GROUP / PANEL_ASSUMED_REPLY_RATE
);
var panelExpectedAnswers = (members) => Math.round(members * PANEL_ASSUMED_REPLY_RATE);
var panelSeedSampleSize = (goalMembers) => Math.min(
  ceilClean(goalMembers / PANEL_SEED_ASSUMED_JOIN_RATE),
  MAX_LIST_SAMPLE_SIZE
);
var PANEL_SEED_SAMPLE_SIZE = panelSeedSampleSize(
  panelGoalMembers(answersNeeded())
);

// src/people/ContactNote.schema.ts
import { z as z21 } from "zod";
var ContactNoteSchema = z21.object({
  id: z21.string(),
  personId: z21.string(),
  body: z21.string(),
  createdAt: z21.string(),
  updatedAt: z21.string(),
  actorName: z21.string().nullable()
});
var ContactNoteInputSchema = z21.object({
  body: z21.string().min(1).max(1e4)
});
var ContactNoteListResponseSchema = z21.object({
  results: z21.array(ContactNoteSchema)
});

// src/people/ContactActivity.schema.ts
import { z as z22 } from "zod";
var ConstituentActivityTypeSchema = z22.enum([
  "POLL_INTERACTIONS",
  "OUTREACH",
  "DOOR_KNOCK",
  "TEXT",
  "ROBOCALL",
  "PHONE_BANKING",
  "STATUS_CHANGE",
  "CONTACT_IMPORT"
]);
var ConstituentActivityEventTypeSchema = z22.enum([
  "SENT",
  "RESPONDED",
  "OPTED_OUT"
]);
var ConstituentActivityEventSchema = z22.object({
  type: ConstituentActivityEventTypeSchema,
  date: z22.string()
});
var ConstituentPriorityAnswerSchema = z22.object({
  priorityId: z22.string(),
  priorityTitle: z22.string(),
  answer: PriorityAnswerCodeSchema
});
var PollConstituentActivitySchema = z22.object({
  type: z22.literal(ConstituentActivityTypeSchema.enum.POLL_INTERACTIONS),
  date: z22.string(),
  data: z22.object({
    pollId: z22.string(),
    pollTitle: z22.string(),
    events: z22.array(ConstituentActivityEventSchema)
  })
});
var OutreachConstituentActivitySchema = z22.object({
  type: z22.literal(ConstituentActivityTypeSchema.enum.OUTREACH),
  date: z22.string(),
  data: z22.object({
    activityId: z22.number(),
    outreachType: OutreachTypeSchema,
    attributionSource: VoterOutreachAttributionSourceSchema
  })
});
var DoorKnockConstituentActivitySchema = z22.object({
  type: z22.literal(ConstituentActivityTypeSchema.enum.DOOR_KNOCK),
  date: z22.string(),
  data: z22.object({
    activityId: z22.string(),
    outcome: DoorKnockOutcomeSchema,
    // One vocabulary per row, decided by the org the feed is read for:
    // supportAnswer is Win's and reads null for an `eo-` org, followUp is
    // Serve's and reads null otherwise (contactEngagement.service.ts). A row
    // logged before its surface asked its question carries neither.
    supportAnswer: SupportAnswerSchema.nullable(),
    followUp: FollowUpAnswerSchema.nullable(),
    note: z22.string().nullable(),
    manual: z22.boolean(),
    actorName: z22.string().nullable(),
    actorUserId: z22.number().nullable(),
    priorityAnswer: ConstituentPriorityAnswerSchema.nullable().optional()
  })
});
var TextConstituentActivitySchema = z22.object({
  type: z22.literal(ConstituentActivityTypeSchema.enum.TEXT),
  date: z22.string(),
  data: z22.object({
    activityId: z22.string(),
    respondedAt: z22.string().nullable(),
    optedOutAt: z22.string().nullable(),
    note: z22.string().nullable(),
    manual: z22.boolean(),
    outreachId: z22.number().nullable(),
    // What they wrote back, oldest first. Only a Serve text keeps reply
    // bodies (Win's Peerly sweep records timestamps), and only the person
    // feed reads them; absent means none to show.
    replies: z22.array(z22.string()).optional(),
    priorityAnswer: ConstituentPriorityAnswerSchema.nullable().optional()
  })
});
var RobocallConstituentActivitySchema = z22.object({
  type: z22.literal(ConstituentActivityTypeSchema.enum.ROBOCALL),
  date: z22.string(),
  data: z22.object({
    activityId: z22.string(),
    answeredAt: z22.string().nullable(),
    voicemailLeftAt: z22.string().nullable(),
    note: z22.string().nullable(),
    manual: z22.boolean(),
    outreachId: z22.number().nullable()
  })
});
var PhoneBankingConstituentActivitySchema = z22.object({
  type: z22.literal(ConstituentActivityTypeSchema.enum.PHONE_BANKING),
  date: z22.string(),
  data: z22.object({
    activityId: z22.string(),
    outcome: PhoneBankCallOutcomeSchema,
    // Same rule as the door-knock row above.
    supportAnswer: SupportAnswerSchema.nullable(),
    willVote: WillVoteAnswerSchema.nullable(),
    followUp: FollowUpAnswerSchema.nullable(),
    note: z22.string().nullable(),
    manual: z22.boolean(),
    actorName: z22.string().nullable(),
    actorUserId: z22.number().nullable(),
    priorityAnswer: ConstituentPriorityAnswerSchema.nullable().optional()
  })
});
var StatusChangeConstituentActivitySchema = z22.object({
  type: z22.literal(ConstituentActivityTypeSchema.enum.STATUS_CHANGE),
  date: z22.string(),
  data: z22.object({
    activityId: z22.string(),
    field: ContactStatusFieldSchema,
    fromLabel: z22.string().nullable(),
    toLabel: z22.string(),
    actorName: z22.string().nullable(),
    actorUserId: z22.number().nullable(),
    source: ContactStatusSourceSchema
  })
});
var ContactImportConstituentActivitySchema = z22.object({
  type: z22.literal(ConstituentActivityTypeSchema.enum.CONTACT_IMPORT),
  date: z22.string(),
  data: z22.object({
    activityId: z22.string(),
    uploadId: z22.string(),
    uploadName: z22.string(),
    isNewPerson: z22.boolean(),
    isFirstImport: z22.boolean(),
    suppliedFields: z22.array(z22.string()),
    changedFields: z22.array(z22.string()),
    manual: z22.boolean(),
    actorName: z22.string().nullable(),
    actorUserId: z22.number().nullable()
  })
});
var ConstituentActivitySchema = z22.discriminatedUnion("type", [
  PollConstituentActivitySchema,
  OutreachConstituentActivitySchema,
  DoorKnockConstituentActivitySchema,
  TextConstituentActivitySchema,
  RobocallConstituentActivitySchema,
  PhoneBankingConstituentActivitySchema,
  StatusChangeConstituentActivitySchema,
  ContactImportConstituentActivitySchema
]);
var GetIndividualActivitiesResponseSchema = z22.object({
  nextCursor: z22.string().nullable(),
  results: z22.array(ConstituentActivitySchema)
});
var PersonPriorityAnswerSchema = ConstituentPriorityAnswerSchema.extend({
  id: z22.string(),
  source: PriorityAnswerSourceSchema
});
var GetPersonPriorityAnswersResponseSchema = z22.object({
  results: z22.array(PersonPriorityAnswerSchema)
});

// src/people/LogContactInteraction.schema.ts
import { z as z23 } from "zod";
var TextOutcomeSchema = z23.enum(["responded", "opted_out"]);
var RobocallOutcomeSchema = z23.enum(["answered", "voicemail_left"]);
var NoteSchema = z23.string().max(1e4).optional().transform((v) => v === "" ? void 0 : v);
var OccurredAtSchema = zCoerceDate().refine((d) => d <= /* @__PURE__ */ new Date(), {
  message: "occurredAt cannot be in the future"
}).optional();
var LogDoorKnockInteractionSchema = z23.object({
  channel: z23.literal("doorKnock"),
  outcome: DoorKnockOutcomeSchema,
  supportAnswer: SupportAnswerSchema.optional(),
  note: NoteSchema,
  occurredAt: OccurredAtSchema
}).strict();
var LogTextInteractionSchema = z23.object({
  channel: z23.literal("text"),
  outcome: TextOutcomeSchema.optional(),
  note: NoteSchema,
  occurredAt: OccurredAtSchema
}).strict();
var LogRobocallInteractionSchema = z23.object({
  channel: z23.literal("robocall"),
  outcome: RobocallOutcomeSchema.optional(),
  note: NoteSchema,
  occurredAt: OccurredAtSchema
}).strict();
var LogContactInteractionInputSchema = z23.discriminatedUnion(
  "channel",
  [
    LogDoorKnockInteractionSchema,
    LogTextInteractionSchema,
    LogRobocallInteractionSchema
  ]
);
var LoggedInteractionBaseSchema = z23.object({
  id: z23.string(),
  personId: z23.string(),
  occurredAt: zCoerceDate(),
  note: z23.string().nullable(),
  manual: z23.boolean()
});
var LoggedDoorKnockInteractionSchema = LoggedInteractionBaseSchema.extend({
  channel: z23.literal("doorKnock"),
  outcome: DoorKnockOutcomeSchema,
  supportAnswer: SupportAnswerSchema.nullable()
});
var LoggedTextInteractionSchema = LoggedInteractionBaseSchema.extend({
  channel: z23.literal("text"),
  outcome: TextOutcomeSchema.nullable()
});
var LoggedRobocallInteractionSchema = LoggedInteractionBaseSchema.extend({
  channel: z23.literal("robocall"),
  outcome: RobocallOutcomeSchema.nullable()
});
var LogContactInteractionResponseSchema = z23.discriminatedUnion(
  "channel",
  [
    LoggedDoorKnockInteractionSchema,
    LoggedTextInteractionSchema,
    LoggedRobocallInteractionSchema
  ]
);

// src/people/ListDetailContacts.schema.ts
import { z as z24 } from "zod";
var ListDetailDemographicsSchema = z24.object({
  people: z24.number().int().min(0),
  avgAge: z24.number().nullable(),
  avgIncome: z24.number().nullable(),
  // Of `people`, how many only an import added (new contacts, not voters).
  // Set for a Win campaign with imported contacts; voters are
  // `people - newContactsCount`.
  newContactsCount: z24.number().int().min(0).optional()
});
var ListDetailReachabilitySchema = z24.object({
  // Nullable for the webapp's "Unavailable" tile only. gp-api now derives
  // every channel from one conditional-aggregate statement alongside the
  // demographics, so a channel is null only if the whole payload is missing —
  // which fails the route instead (see fetchListDetailAggregates).
  sms: z24.number().int().min(0).nullable(),
  robocall: z24.number().int().min(0).nullable(),
  phoneBanking: z24.number().int().min(0).nullable(),
  doorKnocking: z24.number().int().min(0).nullable(),
  // People with an imported email address. Always 0 for an organization
  // without imported contacts, since the voter file carries no emails.
  email: z24.number().int().min(0).nullable(),
  // Polls are delivered by text, so reachability mirrors sms 1:1.
  polls: z24.number().int().min(0).nullable()
});
var NewContactsReachableSchema = z24.object({
  sms: z24.number().int().min(0).nullable(),
  robocall: z24.number().int().min(0).nullable(),
  phoneBanking: z24.number().int().min(0).nullable(),
  doorKnocking: z24.number().int().min(0).nullable(),
  email: z24.number().int().min(0).nullable(),
  polls: z24.number().int().min(0).nullable()
});
var ListDetailOutreachHistoryEntrySchema = z24.object({
  id: z24.number().int(),
  name: z24.string().nullable(),
  outreachType: OutreachTypeSchema,
  status: OutreachStatusSchema.nullable(),
  date: zDate().nullable(),
  // ENG-10776: a legacy row can have a null `date` — the webapp falls back
  // to this to render a real timestamp instead of "—".
  createdAt: zDate()
});
var ListDetailContactsResponseSchema = z24.object({
  demographics: ListDetailDemographicsSchema,
  reachability: ListDetailReachabilitySchema,
  outreachHistory: z24.array(ListDetailOutreachHistoryEntrySchema),
  newContactsReachable: NewContactsReachableSchema.optional()
});

// src/people/PeopleAggregates.schema.ts
import { z as z25 } from "zod";
var PeopleAggregatesResponseSchema = z25.object({
  count: z25.number().int().min(0),
  avgAge: z25.number().nullable(),
  avgIncome: z25.number().nullable()
});
var PeopleListDetailAggregatesResponseSchema = z25.object({
  count: z25.number().int().min(0),
  avgAge: z25.number().nullable(),
  avgIncome: z25.number().nullable(),
  sms: z25.number().int().min(0),
  robocall: z25.number().int().min(0),
  phoneBanking: z25.number().int().min(0),
  doorKnocking: z25.number().int().min(0),
  email: z25.number().int().min(0),
  // Set only when the read counts new contacts (a Win campaign with
  // imported contacts): of each count above, the people only an import
  // added.
  newContacts: z25.object({
    count: z25.number().int().min(0),
    sms: z25.number().int().min(0),
    robocall: z25.number().int().min(0),
    phoneBanking: z25.number().int().min(0),
    doorKnocking: z25.number().int().min(0),
    email: z25.number().int().min(0)
  }).optional()
});

// src/shared/Email.schema.ts
import { z as z26 } from "zod";
var EmailSchema = z26.string().email();

// src/shared/Phone.schema.ts
import validator from "validator";
import { z as z27 } from "zod";
var PhoneSchema = z27.string().refine((val) => validator.isMobilePhone(val), "Must be valid phone number");

// src/shared/Zip.schema.ts
import validator2 from "validator";
import { z as z28 } from "zod";
var ZipSchema = z28.string().refine((val) => validator2.isPostalCode(val, "US"), "Must be valid Zip code");

// src/shared/Password.schema.ts
import { z as z29 } from "zod";
var PasswordSchema = z29.string().min(8, { message: "Password must be at least 8 characters long" }).regex(/[a-zA-Z]/, {
  message: "Password must contain at least one letter"
}).regex(/\d/, { message: "Password must contain at least one number" });

// src/shared/Roles.schema.ts
import { z as z30 } from "zod";
var RolesSchema = z30.array(UserRoleSchema).optional();

// src/shared/Pagination.schema.ts
import { z as z31 } from "zod";
var MAX_RESULTS_PER_PAGE = 1e4;
var MAX_PAGE = 1e5;
var MAX_PAGINATION_OFFSET = 1e6;
var basePaginationSchema = z31.object({
  offset: z31.coerce.number().optional(),
  limit: z31.coerce.number().optional(),
  sortOrder: z31.enum(["asc", "desc"]).optional()
});
var PaginationSchema = () => basePaginationSchema;
var SortablePaginationSchema = (sortKeys) => {
  const [first, ...rest] = sortKeys;
  if (!first) {
    throw new Error("sortKeys must contain at least one value");
  }
  return basePaginationSchema.extend({
    sortBy: z31.enum([first, ...rest]).optional()
  });
};
var paginationFilter = z31.string().optional();
var FilterablePaginationSchema = ({
  sortKeys,
  filterFields
}) => SortablePaginationSchema(sortKeys).extend(filterFields);
var PaginationOptionsSchema = basePaginationSchema.extend({
  sortBy: z31.string().optional()
});
var PaginationMetaSchema = z31.object({
  total: z31.number(),
  offset: z31.number(),
  limit: z31.number()
});

// src/shared/zod.util.ts
import { z as z32 } from "zod";
var makeOptional = (schema) => z32.union([z32.null(), z32.undefined(), z32.literal(""), schema]);

// src/users/UserMetaData.schema.ts
import { z as z33 } from "zod";
var WHY_BROWSING_VALUES = [
  "considering",
  "learning",
  "test",
  "else"
];
var WhyBrowsingSchema = z33.enum(WHY_BROWSING_VALUES);
var UserMetaDataObjectSchema = z33.object({
  customerId: z33.string().optional(),
  checkoutSessionId: z33.string().nullish(),
  accountType: z33.string().nullish(),
  lastVisited: z33.number().optional(),
  sessionCount: z33.number().optional(),
  isDeleted: z33.boolean().optional(),
  fsUserId: z33.string().optional(),
  whyBrowsing: WhyBrowsingSchema.nullish(),
  hubspotId: z33.string().optional(),
  profile_updated_count: z33.number().optional(),
  textNotifications: z33.boolean().optional(),
  websiteSunsetModalDismissed: z33.boolean().optional()
});
var UserMetaDataSchema = UserMetaDataObjectSchema.nullish();

// src/users/CreateUserInput.schema.ts
import { z as z34 } from "zod";
var SIGN_UP_MODE = /* @__PURE__ */ ((SIGN_UP_MODE2) => {
  SIGN_UP_MODE2["CANDIDATE"] = "candidate";
  SIGN_UP_MODE2["FACILITATED"] = "facilitated";
  return SIGN_UP_MODE2;
})(SIGN_UP_MODE || {});
var CreateUserInputSchema = z34.object({
  firstName: z34.string().min(2),
  lastName: z34.string().min(2),
  email: EmailSchema,
  password: PasswordSchema.optional(),
  name: z34.string().optional(),
  zip: ZipSchema.optional(),
  phone: PhoneSchema.optional(),
  roles: RolesSchema,
  signUpMode: z34.enum(["candidate" /* CANDIDATE */, "facilitated" /* FACILITATED */]).optional(),
  allowTexts: z34.boolean().optional()
});

// src/users/ReadUserOutput.schema.ts
import { z as z35 } from "zod";
var ReadUserOutputSchema = CreateUserInputSchema.omit({
  password: true,
  allowTexts: true,
  signUpMode: true
}).extend({
  // firstName/lastName override CreateUserInputSchema's min(2): that's a
  // signup-form rule, but the DB column has no such constraint (nullable,
  // default ''), so plenty of existing rows are shorter than 2 chars.
  // Enforcing it here made the global ZodResponseInterceptor 500 on any
  // response that included one of those rows.
  firstName: z35.string(),
  lastName: z35.string(),
  name: z35.string().nullish(),
  // zip overrides CreateUserInputSchema's ZipSchema for the same reason
  // firstName/lastName override its min(2): `isPostalCode(val, 'US')` is a
  // signup-form rule, but the DB column is `zip String?` with no format
  // constraint, so rows exist that never passed it. Enforcing it here made
  // the global ZodResponseInterceptor 500 on any response containing one --
  // and because Zod validates the whole `data` array, a single bad row failed
  // an entire page of GET /v1/users rather than degrading one field.
  zip: z35.string().nullish(),
  phone: makeOptional(PhoneSchema),
  id: z35.number(),
  email: EmailSchema,
  avatar: z35.string().nullish(),
  hasPassword: z35.boolean(),
  roles: RolesSchema,
  metaData: UserMetaDataSchema,
  createdAt: zCoerceDate()
});

// src/users/UpdatePassword.schema.ts
import { z as z36 } from "zod";
var UpdatePasswordSchema = z36.object({
  oldPassword: PasswordSchema.optional(),
  newPassword: PasswordSchema
}).strict();

// src/users/ListUsersPagination.schema.ts
import { z as z37 } from "zod";

// src/generated/scalarFields.ts
var USER_SCALAR_FIELDS = ["id", "createdAt", "updatedAt", "firstName", "lastName", "name", "avatar", "password", "hasPassword", "email", "clerkId", "personId", "phone", "zip", "roles", "metaData", "passwordResetToken"];
var CAMPAIGN_SCALAR_FIELDS = ["id", "organizationSlug", "createdAt", "updatedAt", "slug", "isActive", "isVerified", "isPro", "isDemo", "didWin", "primaryResult", "ballotStatus", "signupGoal", "dateVerified", "tier", "formattedAddress", "placeId", "campaignEmail", "data", "details", "aiContent", "vendorTsData", "userId", "canDownloadFederal", "completedTaskIds", "hasFreeTextsOffer", "freeTextsOfferRedeemedAt"];

// src/users/ListUsersPagination.schema.ts
var USER_SORT_KEYS = USER_SCALAR_FIELDS;
var ListUsersPaginationSchema = FilterablePaginationSchema({
  sortKeys: USER_SORT_KEYS.filter(
    (key) => ["password", "passwordResetToken"].includes(key)
  ),
  filterFields: {
    firstName: paginationFilter,
    lastName: paginationFilter,
    email: paginationFilter,
    isPro: z37.enum(["true", "false"]).transform((v) => v === "true").optional()
  }
});

// src/users/UpdateUserInput.schema.ts
var UpdateUserInputSchema = CreateUserInputSchema.omit({
  password: true
}).partial().extend({
  metaData: UserMetaDataSchema
});

// src/campaigns/enums.ts
import { z as z38 } from "zod";
var toEnumObject = (values) => Object.fromEntries(values.map((v) => [v, v]));
var BALLOT_READY_POSITION_LEVEL_VALUES = [
  "CITY",
  "COUNTY",
  "FEDERAL",
  "LOCAL",
  "REGIONAL",
  "STATE",
  "TOWNSHIP"
];
var BallotReadyPositionLevelSchema = z38.enum(
  BALLOT_READY_POSITION_LEVEL_VALUES
);
var BallotReadyPositionLevel = toEnumObject(
  BALLOT_READY_POSITION_LEVEL_VALUES
);
var ELECTION_LEVEL_VALUES = [
  "state",
  "county",
  "federal",
  "city"
];
var ElectionLevelSchema = z38.enum(ELECTION_LEVEL_VALUES);
var ElectionLevel = toEnumObject(ELECTION_LEVEL_VALUES);
var CAMPAIGN_CREATED_BY_VALUES = ["admin"];
var CampaignCreatedBySchema = z38.enum(CAMPAIGN_CREATED_BY_VALUES);
var CampaignCreatedBy = { ADMIN: "admin" };
var CAMPAIGN_LAUNCH_STATUS_VALUES = ["launched"];
var CampaignLaunchStatusSchema = z38.enum(CAMPAIGN_LAUNCH_STATUS_VALUES);
var CampaignLaunchStatus = toEnumObject(CAMPAIGN_LAUNCH_STATUS_VALUES);
var CAMPAIGN_STATUS_VALUES = ["candidate", "onboarding"];
var CampaignStatusSchema = z38.enum(CAMPAIGN_STATUS_VALUES);
var CampaignStatus = toEnumObject(CAMPAIGN_STATUS_VALUES);
var ONBOARDING_STEP_VALUES = [
  "onboarding-complete",
  "registration"
];
var OnboardingStepSchema = z38.enum(ONBOARDING_STEP_VALUES);
var OnboardingStep = {
  complete: "onboarding-complete",
  registration: "registration"
};
var GENERATION_STATUS_VALUES = ["processing", "completed"];
var GenerationStatusSchema = z38.enum(GENERATION_STATUS_VALUES);
var GenerationStatus = toEnumObject(GENERATION_STATUS_VALUES);
var ORGANIZATION_STATUS_VALUES = ["active", "past"];
var OrganizationStatusSchema = z38.enum(ORGANIZATION_STATUS_VALUES);
var OrganizationStatus = toEnumObject(ORGANIZATION_STATUS_VALUES);
var COMPLIANCE_STAGE_VALUES = [
  "needs_profile",
  "needs_filing",
  "pending_domain_purchase",
  "pending_website_live",
  "ready_to_submit",
  "filing_review_hold",
  "awaiting_pin",
  "tcr_in_review",
  "tcr_approved",
  "tcr_rejected"
];
var ComplianceStageSchema = z38.enum(COMPLIANCE_STAGE_VALUES);
var ComplianceStage = toEnumObject(COMPLIANCE_STAGE_VALUES);
var PEERLY_CV_VERIFICATION_STATUS_VALUES = [
  "REQUESTED",
  "IN_REVIEW",
  "APPROVED",
  "VERIFIED",
  "REJECTED",
  "WITHDRAWN"
];
var PeerlyCvVerificationStatusSchema = z38.enum(
  PEERLY_CV_VERIFICATION_STATUS_VALUES
);
var PeerlyCvVerificationStatus = toEnumObject(
  PEERLY_CV_VERIFICATION_STATUS_VALUES
);
var PIN_DELIVERY_METHOD_VALUES = [
  "email",
  "text",
  "phone",
  "call",
  "mail"
];
var PinDeliveryMethodSchema = z38.enum(PIN_DELIVERY_METHOD_VALUES);
var PinDeliveryMethod = toEnumObject(PIN_DELIVERY_METHOD_VALUES);
var SMS_COMPLIANCE_WINDOW_VALUES = [
  "open",
  "closing",
  "closed",
  "not_applicable"
];
var SmsComplianceWindowSchema = z38.enum(SMS_COMPLIANCE_WINDOW_VALUES);
var SmsComplianceWindow = toEnumObject(SMS_COMPLIANCE_WINDOW_VALUES);

// src/campaigns/Campaign.schema.ts
import { z as z39 } from "zod";
var CampaignSchema = z39.object({
  id: z39.number(),
  createdAt: zCoerceDate(),
  updatedAt: zCoerceDate(),
  slug: z39.string(),
  isActive: z39.boolean(),
  isVerified: z39.boolean().nullish(),
  isPro: z39.boolean().nullish(),
  isDemo: z39.boolean(),
  didWin: z39.boolean().nullish(),
  primaryResult: z39.enum(["won", "lost"]).nullish(),
  dateVerified: zCoerceDate().nullish(),
  tier: CampaignTierSchema.nullish(),
  formattedAddress: z39.string().nullish(),
  placeId: z39.string().nullish(),
  data: z39.record(z39.string(), z39.unknown()),
  details: z39.record(z39.string(), z39.unknown()),
  aiContent: z39.record(z39.string(), z39.unknown()),
  vendorTsData: z39.record(z39.string(), z39.unknown()),
  userId: z39.number(),
  canDownloadFederal: z39.boolean(),
  completedTaskIds: z39.array(z39.string()),
  hasFreeTextsOffer: z39.boolean(),
  freeTextsOfferRedeemedAt: zCoerceDate().nullish(),
  derp: z39.string().optional()
});

// src/campaigns/ReadCampaignOutput.schema.ts
var ReadCampaignOutputSchema = CampaignSchema.omit({
  vendorTsData: true
});

// src/campaigns/SetDistrictOutput.schema.ts
var SetDistrictOutputSchema = ReadCampaignOutputSchema;

// src/campaigns/RaceTargetMetrics.schema.ts
import { z as z40 } from "zod";
var RaceCandidateSchema = z40.object({
  gpCandidateId: z40.string().nullable(),
  firstName: z40.string(),
  lastName: z40.string(),
  fullName: z40.string(),
  email: z40.string().nullable(),
  websiteUrl: z40.string().nullable(),
  party: z40.string().nullable(),
  isIncumbent: z40.boolean().nullable()
});
var MilestoneWindowSchema = z40.object({
  start: z40.string().nullable(),
  end: z40.string().nullable()
});
var RaceMilestonesSchema = z40.object({
  voter_registration: MilestoneWindowSchema.nullable(),
  early_voting: MilestoneWindowSchema.nullable(),
  request_ballot: MilestoneWindowSchema.nullable()
});
var RaceTargetMetricsSchema = z40.object({
  winNumber: z40.number(),
  voterContactGoal: z40.number(),
  projectedTurnout: z40.number(),
  /**
   * Estimated filing fee for the race, in dollars, sourced from BallotReady
   * `filing_requirements` via election-api. `null` when the fee can't be
   * extracted unambiguously (multiple dollar amounts, missing data, or no
   * regex match). See `filingRequirementsText` for the raw source string.
   */
  filingFee: z40.number().nullable(),
  /**
   * Raw `filing_requirements` text from BallotReady. Always passed through so
   * the UI can show "filing fees are estimated — click for full text" even
   * when `filingFee` is null. `null` when BallotReady has no data.
   */
  filingRequirementsText: z40.string().nullable(),
  /**
   * Structured filing-office contact for the race, sourced from BallotReady
   * via election-api's `/races/by-br-hash-id/:hash/filing-fee` lookup. Powers
   * the "filing office" block on the Pro-upgrade filing-instructions screen.
   * `filingOfficeAddress` is a single free-text block (address line 1/2, city,
   * state, zip); `paperworkInstructions` is BallotReady's narrative on the
   * local election authority a candidate contacts. All `null` when BallotReady
   * has no office data for the race.
   */
  filingOfficeAddress: z40.string().nullable(),
  filingPhoneNumber: z40.string().nullable(),
  paperworkInstructions: z40.string().nullable(),
  // The fields below come straight from election-api's
  // /campaign-strategy-context endpoint. All nullable — null when the race
  // hash didn't resolve to a Position+District or the upstream data is
  // sparse.
  registeredVoters: z40.number().nullable(),
  uniqueCellphones: z40.number().nullable(),
  uniqueLandlines: z40.number().nullable(),
  /**
   * 70% prediction interval around `projectedTurnout`, measured from how far
   * the model's past projections landed from actual results, and the same
   * interval carried through the win-number math. Null where the model has no
   * projection for the race, and the win-number pair is also null when
   * `winNumber` came from the civics archive rather than the projection.
   */
  projectedTurnoutLower: z40.number().nullable(),
  projectedTurnoutUpper: z40.number().nullable(),
  winNumberLower: z40.number().nullable(),
  winNumberUpper: z40.number().nullable(),
  candidates: z40.array(RaceCandidateSchema),
  generalElectionDate: z40.string().nullable(),
  primaryElectionDate: z40.string().nullable(),
  relevantElectionDate: z40.string().nullable(),
  officialOfficeName: z40.string().nullable(),
  officeLevel: z40.string().nullable(),
  officeType: z40.string().nullable(),
  numberOfSeats: z40.number().nullable(),
  /**
   * Campaign-timeline milestones sourced live from BallotReady. Null
   * when BR is unreachable or the race has no upstream Election; the
   * rest of the response stays usable in that case.
   */
  milestones: RaceMilestonesSchema.nullable()
});

// src/campaigns/CommunityEvents.schema.ts
import { z as z41 } from "zod";
var HttpsOrHttpUrl = z41.string().url().refine(
  (value) => /^https?:$/.test(new URL(value).protocol),
  "Only http and https URLs are allowed"
);
var CommunityEventSchema = z41.object({
  title: z41.string().min(1),
  description: z41.string().min(1),
  /** YYYY-MM-DD; events outside `[today, electionDate]` are filtered out server-side. */
  date: z41.string().min(1),
  /**
   * Physical street address of the event venue (e.g.
   * "123 Main St, Springfield, MA 01103"). `null` when the search data
   * didn't surface one — gp-api's prompt explicitly instructs the model
   * to return null rather than invent an address.
   */
  address: z41.string().nullable(),
  /** Direct event page URL when one is present in the search results; null otherwise. */
  url: HttpsOrHttpUrl.nullable()
});
var CommunityEventsResultSchema = z41.object({
  events: z41.array(CommunityEventSchema).max(3)
});
var CommunityEventsReadySchema = z41.object({
  status: z41.literal("ready"),
  data: CommunityEventsResultSchema
});
var CommunityEventsGeneratingSchema = z41.object({
  status: z41.literal("generating")
});
var CommunityEventsResponseSchema = z41.discriminatedUnion("status", [
  CommunityEventsReadySchema,
  CommunityEventsGeneratingSchema
]);

// src/campaigns/CampaignStory.schema.ts
import { z as z42 } from "zod";
var CAMPAIGN_STORY_FIELD_MAX_LENGTH = 1e4;
var CampaignStorySchema = z42.object({
  background: z42.string().nullable()
});

// src/campaigns/CampaignStoryRewrite.schema.ts
import { z as z43 } from "zod";
var CampaignStoryRewriteSchema = z43.object({
  rewrite: z43.string().max(CAMPAIGN_STORY_FIELD_MAX_LENGTH)
});

// src/campaigns/CampaignTaskCatalog.schema.ts
import { z as z44 } from "zod";
var CampaignStrategyPhaseKeySchema = z44.enum([
  "preLaunch",
  "launch",
  "active",
  "gotv"
]);
var TaskTypeSchema = z44.enum(["static", "dynamic"]);
var TaskChannelSchema = z44.enum([
  "text",
  "robocall",
  "doorKnocking",
  "phoneBanking",
  "socialMedia",
  "directMail",
  "event",
  "awareness",
  "general"
]);
var TaskChannelFanoutSchema = z44.enum(["one-to-many", "one-to-one"]);
var CHANNEL_FANOUT = {
  text: "one-to-many",
  robocall: "one-to-many",
  socialMedia: "one-to-many",
  directMail: "one-to-many",
  event: "one-to-many",
  awareness: "one-to-many",
  general: "one-to-many",
  doorKnocking: "one-to-one",
  phoneBanking: "one-to-one"
};
var DayOfWeekSchema = z44.enum([
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday"
]);
var TaskStatusSchema = z44.enum(["live", "proposed"]);
var TaskPersonalizationSchema = z44.enum([
  "content-pill",
  "generated-per-item",
  "static"
]);
var PriorityTierSchema = z44.enum(["P1", "P2", "P3", "P4"]);
var GeneratorSourceSchema = z44.enum([
  "communityEvents",
  "pressOutlets",
  "officeMeetings"
]);
var TaskTimingSchema = z44.discriminatedUnion("kind", [
  z44.object({ kind: z44.literal("asap") }),
  z44.object({ kind: z44.literal("onboardingWeek") }),
  z44.object({ kind: z44.literal("preLaunch") }),
  z44.object({ kind: z44.literal("launch") }),
  z44.object({
    kind: z44.literal("electionRelative"),
    offset: z44.number(),
    unit: z44.enum(["weeks", "days"])
  }),
  z44.object({ kind: z44.literal("electionDay") }),
  z44.object({ kind: z44.literal("afterElection"), weeks: z44.number() }),
  z44.object({ kind: z44.literal("jurisdiction"), pill: z44.string().optional() }),
  z44.object({
    kind: z44.literal("recurring"),
    interval: z44.enum(["weekly", "monthly", "evenWeeks", "oddWeeks", "waves"])
  }),
  z44.object({ kind: z44.literal("perItem") })
]);
var CampaignTaskDefinitionSchema = z44.object({
  id: z44.string(),
  phase: CampaignStrategyPhaseKeySchema,
  type: TaskTypeSchema,
  category: z44.string(),
  title: z44.string(),
  description: z44.string(),
  channel: TaskChannelSchema,
  timing: TaskTimingSchema,
  dayOfWeek: DayOfWeekSchema.optional(),
  // 'adapts' = copy/sends adapt to primary vs general.
  electionType: z44.enum(["both", "adapts"]),
  proRequired: z44.boolean(),
  status: TaskStatusSchema,
  personalization: TaskPersonalizationSchema,
  pills: z44.array(z44.string()),
  priorityTier: PriorityTierSchema,
  // Raw prerequisite label from the sheet (a task title or a gate); a hint only.
  unlocksAfter: z44.string().optional(),
  generatorSource: GeneratorSourceSchema.optional()
});

// src/campaigns/VoterContactSchedule.data.ts
var VOTER_CONTACT_SCHEDULE = [
  {
    catalogId: "introduction-text",
    tactic: "Text",
    daysBeforeElection: 56,
    purpose: "Introduce yourself to voters with cellphones."
  },
  {
    catalogId: "introduction-robocall",
    tactic: "Robocall",
    daysBeforeElection: 49,
    purpose: "Introduce yourself to voters with landlines."
  },
  {
    catalogId: "persuasion-text",
    tactic: "Text",
    daysBeforeElection: 35,
    purpose: "Build trust and persuade voters with cellphones to vote for you."
  },
  {
    catalogId: "persuasion-robocall",
    tactic: "Robocall",
    daysBeforeElection: 28,
    purpose: "Build trust and persuade voters with landlines to vote for you."
  },
  {
    catalogId: "early-voting-text",
    tactic: "Text",
    daysBeforeElection: 14,
    purpose: "Encourage voters with cellphones to vote early."
  },
  {
    catalogId: "election-day-reminder-robocall",
    tactic: "Robocall",
    daysBeforeElection: 1,
    purpose: "Get out the vote on election day."
  },
  {
    catalogId: "election-day-reminder-text",
    tactic: "Text",
    daysBeforeElection: 0,
    purpose: "Get out the vote on election day."
  }
];
var TEXT_SEND_ROBOCALL_SWAPS = [
  {
    catalogId: "introduction-text",
    title: "Early Introduction Robocall",
    description: "Introduce yourself to voters with an automated call."
  },
  {
    catalogId: "persuasion-text",
    title: "Early Persuasion Robocall",
    description: "Build trust and make your case for why voters should pick you, by automated call."
  },
  {
    catalogId: "early-voting-text",
    title: "Early Voting Robocall",
    description: "Encourage your supporters to vote early with an automated call."
  }
];
var voterContactSendOffsetDays = (catalogId) => {
  const send = VOTER_CONTACT_SCHEDULE.find((s) => s.catalogId === catalogId);
  if (!send) {
    throw new Error(`Unknown voter-contact send: ${catalogId}`);
  }
  return send.daysBeforeElection;
};

// src/campaigns/CampaignTaskCatalog.data.ts
var BALLOT_ACCESS_CATEGORY = "Ballot access";
var CAMPAIGN_STORY_CATEGORY = "Campaign story";
var CAMPAIGN_TASK_CATALOG = [
  // ----- Pre-launch -----
  {
    id: "begin-ballot-access",
    phase: "preLaunch",
    type: "static",
    category: BALLOT_ACCESS_CATEGORY,
    title: "Begin Ballot Access Period",
    description: "The date you can start collecting signatures to get on the ballot.",
    channel: "awareness",
    timing: { kind: "jurisdiction", pill: "ballotAccessStart" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["ballotAccessStart"],
    priorityTier: "P1"
  },
  {
    id: "submit-ballot-access-signatures",
    phase: "preLaunch",
    type: "static",
    category: BALLOT_ACCESS_CATEGORY,
    title: "Submit your Ballot Access Signatures",
    description: "Turn in your valid signatures to secure your place on the ballot.",
    channel: "general",
    timing: { kind: "jurisdiction", pill: "filingDeadline" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["filingDeadline", "filingFee"],
    priorityTier: "P1"
  },
  {
    id: "add-finance-deadlines",
    phase: "preLaunch",
    type: "static",
    category: "Compliance & Admin",
    title: "Add your campaign finance deadlines to your calendar",
    description: "Most campaigns have legal deadlines for finance reports. Add them now so you never miss one.",
    channel: "awareness",
    timing: { kind: "onboardingWeek" },
    dayOfWeek: "saturday",
    electionType: "both",
    proRequired: false,
    status: "live",
    personalization: "content-pill",
    pills: ["financeDeadlines"],
    priorityTier: "P1"
  },
  {
    id: "get-meta-verified",
    phase: "preLaunch",
    type: "static",
    category: "Preparation",
    title: "Get Meta verified",
    description: "Get identity verified on Meta so you can run ads on Facebook and Instagram.",
    channel: "awareness",
    timing: { kind: "asap" },
    dayOfWeek: "wednesday",
    electionType: "both",
    proRequired: false,
    status: "live",
    personalization: "static",
    pills: [],
    priorityTier: "P4"
  },
  {
    id: "design-materials",
    phase: "preLaunch",
    type: "static",
    category: "Preparation",
    title: "Design materials",
    description: "Design yard signs, door hangers, palm cards, and other materials.",
    channel: "awareness",
    timing: { kind: "asap" },
    dayOfWeek: "thursday",
    electionType: "both",
    proRequired: false,
    status: "live",
    personalization: "content-pill",
    pills: ["candidateName", "office"],
    priorityTier: "P4"
  },
  {
    id: "get-ein",
    phase: "preLaunch",
    type: "static",
    category: "Setup",
    title: "Get your EIN",
    description: "Your campaign needs its own federal tax ID before you can open a bank account. Apply free on the IRS website with Form SS-4 and mark line 9B 'political organization.'",
    channel: "general",
    timing: { kind: "asap" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "static",
    pills: [],
    priorityTier: "P1"
  },
  {
    id: "open-bank-account",
    phase: "preLaunch",
    type: "static",
    category: "Setup",
    title: "Open a campaign bank account",
    description: "Open a bank account in your committee's name using your new EIN. Never run campaign money through your personal account.",
    channel: "general",
    timing: { kind: "asap" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "static",
    pills: [],
    priorityTier: "P1",
    unlocksAfter: "Get your EIN"
  },
  {
    id: "register-with-state",
    phase: "preLaunch",
    type: "static",
    category: "Setup",
    title: "Register with your state",
    description: "Officially register your campaign committee with your state's campaign finance agency and pay any filing fee so you're cleared to raise and spend money.",
    channel: "general",
    timing: { kind: "jurisdiction" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["state", "filingAgency", "filingFee"],
    priorityTier: "P1"
  },
  {
    id: "get-po-box",
    phase: "preLaunch",
    type: "static",
    category: "Setup",
    title: "Get a campaign PO Box",
    description: "Get a PO Box for campaign mail so your home address doesn't become public record.",
    channel: "general",
    timing: { kind: "asap" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "static",
    pills: [],
    priorityTier: "P4"
  },
  {
    id: "setup-email-phone",
    phase: "preLaunch",
    type: "static",
    category: "Setup",
    title: "Set up a campaign email and phone",
    description: "Create a campaign-only email and phone number (a free Gmail and Google Voice work great) to keep campaign messages separate from your personal life.",
    channel: "general",
    timing: { kind: "asap" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "static",
    pills: [],
    priorityTier: "P4"
  },
  {
    id: "submit-voters-pamphlet",
    phase: "preLaunch",
    type: "static",
    category: "Setup",
    title: "Submit to your local voters' pamphlet",
    description: "Many areas publish a voters' pamphlet that is free publicity. Submit your statement before the deadline.",
    channel: "general",
    timing: { kind: "jurisdiction", pill: "pamphletDeadline" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["pamphletDeadline", "jurisdiction"],
    priorityTier: "P3"
  },
  {
    id: "setup-online-donations",
    phase: "preLaunch",
    type: "static",
    category: "Fundraising",
    title: "Set up online donations",
    description: "Set up a donation page with a nonpartisan processor like Anedot so supporters can give online in a few clicks.",
    channel: "general",
    timing: { kind: "preLaunch" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "static",
    pills: [],
    priorityTier: "P2",
    unlocksAfter: "Open a campaign bank account"
  },
  {
    id: "build-call-list",
    phase: "preLaunch",
    type: "static",
    category: "Fundraising",
    title: "Build your call list",
    description: "Spend a few hours going through your phone, email, LinkedIn, and any groups you belong to, and build a list of 100 to 200 people you can ask for support. This is the single best thing you can do for fundraising.",
    channel: "general",
    timing: { kind: "onboardingWeek" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["fundraisingGoal"],
    priorityTier: "P2"
  },
  {
    id: "pick-treasurer",
    phase: "preLaunch",
    type: "static",
    category: "Fundraising",
    title: "Pick your treasurer",
    description: "Choose someone you trust to track your campaign's money and filings, ideally someone other than your spouse.",
    channel: "general",
    timing: { kind: "preLaunch" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "static",
    pills: [],
    priorityTier: "P4"
  },
  // Campaign setup work, so it belongs in pre-launch — and at the end of it:
  // `preLaunch` timing dates it a week past the block's anchor, alongside the
  // other two rows that close the phase out.
  {
    id: "tell-us-your-story",
    phase: "preLaunch",
    type: "static",
    category: CAMPAIGN_STORY_CATEGORY,
    title: "Tell us your campaign story",
    description: "Share your why, your background, and the issues you care about to sharpen your plan.",
    channel: "general",
    timing: { kind: "preLaunch" },
    electionType: "both",
    proRequired: false,
    status: "live",
    personalization: "static",
    pills: [],
    priorityTier: "P1"
  },
  // ----- Launch -----
  {
    id: "organize-house-party",
    phase: "launch",
    type: "static",
    category: "Events & Volunteer Organizing",
    title: "Organize a House Party with Supporters",
    description: "Work with supporters to host an informal house party where you talk to voters directly.",
    channel: "general",
    timing: { kind: "recurring", interval: "monthly" },
    dayOfWeek: "wednesday",
    electionType: "both",
    proRequired: false,
    status: "live",
    personalization: "content-pill",
    pills: ["districtName"],
    priorityTier: "P2"
  },
  {
    id: "organize-kickoff-fundraiser",
    phase: "launch",
    type: "static",
    category: "Fundraising",
    title: "Organize a kickoff fundraiser",
    description: "Work with supporters to plan a fundraiser to get the financial support you need.",
    channel: "general",
    timing: { kind: "recurring", interval: "monthly" },
    dayOfWeek: "wednesday",
    electionType: "both",
    proRequired: false,
    status: "live",
    personalization: "content-pill",
    pills: ["fundraisingGoal", "nextFundraisingMilestone"],
    priorityTier: "P2",
    unlocksAfter: "Set up online donations"
  },
  {
    id: "submit-letters-to-editor",
    phase: "launch",
    type: "static",
    category: "Communications & Visibility",
    title: "Submit 2 Letters to the Editor",
    description: "Have supporters write letters to the editor backing your campaign to the local press.",
    channel: "general",
    timing: { kind: "electionRelative", offset: 4, unit: "weeks" },
    dayOfWeek: "thursday",
    electionType: "both",
    proRequired: false,
    status: "live",
    personalization: "generated-per-item",
    pills: ["pressOutlet", "outletContact", "pitchAngle", "topIssue"],
    priorityTier: "P3",
    generatorSource: "pressOutlets"
  },
  {
    id: "pick-announcement-date",
    phase: "launch",
    type: "static",
    category: "Launch",
    title: "Pick your announcement date",
    description: "Choose the day you go public. Time it against the election calendar and your opponent's likely announcement, not just when you feel ready.",
    channel: "general",
    timing: { kind: "launch" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["electionDay", "filingDeadline"],
    priorityTier: "P2"
  },
  {
    id: "hold-kickoff-event",
    phase: "launch",
    type: "static",
    category: "Launch",
    title: "Hold your kickoff event",
    description: "Make it official. Gather friends, family, neighbors, and early supporters for a launch event that gives your campaign its first burst of energy and content.",
    channel: "general",
    timing: { kind: "launch" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["districtName", "candidateSuperpower"],
    priorityTier: "P2"
  },
  {
    id: "lock-in-three-messages",
    phase: "launch",
    type: "static",
    category: "Launch",
    title: "Lock in your three messages",
    description: "Write the three short sentences you will repeat everywhere: every door, interview, and event. Saying the same three things all the way to election day is how local races are won.",
    channel: "general",
    timing: { kind: "launch" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["topIssues", "candidateSuperpower"],
    priorityTier: "P2"
  },
  {
    id: "launch-website",
    phase: "launch",
    type: "static",
    category: "Launch",
    title: "Launch your website",
    description: "Put up a simple site with a working donate button, an email signup form, and a page on your top three issues.",
    channel: "general",
    timing: { kind: "launch" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["candidateName", "office", "topIssues"],
    priorityTier: "P2"
  },
  {
    id: "setup-social-media",
    phase: "launch",
    type: "static",
    category: "Launch",
    title: "Set up your social media",
    description: "Claim your handles on each platform with the same photo and bio everywhere so voters recognize you.",
    channel: "general",
    timing: { kind: "launch" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["candidateName", "office"],
    priorityTier: "P2"
  },
  // ----- Active campaign -----
  {
    id: "knock-on-doors",
    phase: "active",
    type: "dynamic",
    category: "Voter Outreach & Persuasion",
    title: "Knock on Doors",
    description: "Knock your target doors to connect with voters face-to-face.",
    channel: "doorKnocking",
    timing: { kind: "recurring", interval: "weekly" },
    dayOfWeek: "friday",
    electionType: "both",
    proRequired: true,
    status: "live",
    personalization: "content-pill",
    pills: ["contactGoal", "targetDoors", "precinct", "topIssue"],
    priorityTier: "P2"
  },
  {
    id: "make-phone-bank-calls",
    phase: "active",
    type: "dynamic",
    category: "Voter Outreach & Persuasion",
    title: "Make phone bank calls",
    description: "Complete a phone bank shift to reach voters and share your message.",
    channel: "phoneBanking",
    timing: { kind: "recurring", interval: "weekly" },
    dayOfWeek: "friday",
    electionType: "both",
    proRequired: true,
    status: "live",
    personalization: "content-pill",
    pills: ["contactGoal", "callTarget", "topIssue"],
    priorityTier: "P2"
  },
  {
    id: "schedule-social-posts",
    phase: "active",
    type: "dynamic",
    category: "Communications & Visibility",
    title: "Plan and Schedule 2 Social Posts for the week",
    description: "Plan and schedule two social posts to engage supporters and reach voters.",
    channel: "socialMedia",
    timing: { kind: "recurring", interval: "weekly" },
    dayOfWeek: "friday",
    electionType: "both",
    proRequired: false,
    status: "live",
    personalization: "content-pill",
    pills: ["topIssue", "recentEvent"],
    priorityTier: "P3"
  },
  {
    id: "social-media-update",
    phase: "active",
    type: "dynamic",
    category: "Communications & Visibility",
    title: "Social media update",
    description: "Post campaign activities and photos on your channel of choice.",
    channel: "socialMedia",
    timing: { kind: "recurring", interval: "weekly" },
    dayOfWeek: "friday",
    electionType: "both",
    proRequired: false,
    status: "live",
    personalization: "content-pill",
    pills: ["recentActivity"],
    priorityTier: "P3"
  },
  {
    id: "fundraising-ask",
    phase: "active",
    type: "dynamic",
    category: "Fundraising",
    title: "Fundraising ask",
    description: "Make a fundraising solicitation (email and/or social) to close the month strong.",
    channel: "general",
    timing: { kind: "recurring", interval: "weekly" },
    dayOfWeek: "friday",
    electionType: "both",
    proRequired: false,
    status: "live",
    personalization: "content-pill",
    pills: ["fundraisingGoal", "amountRaised"],
    priorityTier: "P2",
    unlocksAfter: "Set up online donations"
  },
  {
    id: "email-update",
    phase: "active",
    type: "dynamic",
    category: "Communications & Visibility",
    title: "Email update",
    description: "Send a campaign progress update to your email contacts.",
    channel: "general",
    timing: { kind: "recurring", interval: "monthly" },
    dayOfWeek: "friday",
    electionType: "both",
    proRequired: false,
    status: "live",
    personalization: "content-pill",
    pills: ["recentMilestone"],
    priorityTier: "P3"
  },
  {
    id: "organize-volunteer-event",
    phase: "active",
    type: "dynamic",
    category: "Events & Volunteer Organizing",
    title: "Organize a Volunteer Voter Contact Event",
    description: "Give supporters a way to give back. Plan a volunteer voter contact event.",
    channel: "general",
    timing: { kind: "recurring", interval: "evenWeeks" },
    dayOfWeek: "tuesday",
    electionType: "both",
    proRequired: false,
    status: "live",
    personalization: "content-pill",
    pills: ["contactGoal"],
    priorityTier: "P2"
  },
  {
    id: "hold-volunteer-event",
    phase: "active",
    type: "dynamic",
    category: "Events & Volunteer Organizing",
    title: "Hold a Volunteer Voter Contact Event",
    description: "Bring volunteers together to connect with voters and build momentum.",
    channel: "general",
    timing: { kind: "recurring", interval: "oddWeeks" },
    dayOfWeek: "tuesday",
    electionType: "both",
    proRequired: false,
    status: "live",
    personalization: "content-pill",
    pills: ["contactGoal"],
    priorityTier: "P2",
    unlocksAfter: "Organize a Volunteer Voter Contact Event"
  },
  {
    id: "attend-community-event",
    phase: "active",
    type: "dynamic",
    category: "Events",
    title: "Attend a community event",
    description: "Show up where voters already gather. Your plan's events list creates one card per event - festival, parade, farmers' market, holiday celebration, or candidate forum - each with its own date and address. Sign up or RSVP ahead where the event needs it.",
    channel: "event",
    timing: { kind: "perItem" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "generated-per-item",
    pills: ["eventName", "eventDate", "eventAddress", "eventWhy"],
    priorityTier: "P3",
    generatorSource: "communityEvents"
  },
  {
    id: "attend-related-office-meeting",
    phase: "active",
    type: "dynamic",
    category: "Events",
    title: "Attend the local related-office meeting",
    description: "Attend the public meeting for the office you are running for (e.g. city council). Generated from the governing body's meeting calendar, not the plan's events list.",
    channel: "event",
    timing: { kind: "perItem" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "generated-per-item",
    pills: ["meetingName", "meetingDate", "office"],
    priorityTier: "P3",
    generatorSource: "officeMeetings"
  },
  {
    id: "setup-opponent-monitoring",
    phase: "active",
    type: "dynamic",
    category: "Opponent",
    title: "Set up opponent monitoring",
    description: "Set Google Alerts for your opponents and watch local news. Most of the time the right move is not to respond, so decide on purpose rather than reacting to everything.",
    channel: "general",
    timing: { kind: "recurring", interval: "weekly" },
    dayOfWeek: "monday",
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["opponentName", "opponentParty", "isIncumbent"],
    priorityTier: "P3"
  },
  {
    id: "send-direct-mail",
    phase: "active",
    type: "dynamic",
    category: "Direct mail",
    title: "Send a direct mail piece",
    description: "Plan a mail program of at least three pieces over the campaign and send your first one. Repetition is what makes mail stick.",
    channel: "directMail",
    timing: { kind: "recurring", interval: "waves" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["topIssue", "contactGoal"],
    priorityTier: "P2"
  },
  {
    id: "record-voter-contacts",
    phase: "active",
    type: "dynamic",
    category: "Progress & tracking",
    title: "Record your voter contacts",
    description: "Log the doors, calls, and conversations you had off the platform this week so your progress counts everything you've done, not just what ran through GoodParty. Continues every week through GOTV.",
    channel: "general",
    timing: { kind: "recurring", interval: "weekly" },
    dayOfWeek: "sunday",
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["contactGoal", "contactsToDate"],
    priorityTier: "P1"
  },
  {
    id: "introduction-robocall",
    phase: "active",
    type: "dynamic",
    category: "Voter Outreach & Persuasion",
    title: "Introduction Robocall",
    description: "Introduce yourself to voters with an automated call.",
    channel: "robocall",
    timing: {
      kind: "electionRelative",
      offset: voterContactSendOffsetDays("introduction-robocall"),
      unit: "days"
    },
    electionType: "adapts",
    proRequired: true,
    status: "live",
    personalization: "content-pill",
    pills: ["candidateName", "office", "sendDate"],
    priorityTier: "P1"
  },
  {
    id: "introduction-text",
    phase: "active",
    type: "dynamic",
    category: "Voter Outreach & Persuasion",
    title: "Introduction Text",
    description: "Introduce yourself to voters with a text.",
    channel: "text",
    timing: {
      kind: "electionRelative",
      offset: voterContactSendOffsetDays("introduction-text"),
      unit: "days"
    },
    electionType: "adapts",
    proRequired: true,
    status: "live",
    personalization: "content-pill",
    pills: ["candidateName", "office", "sendDate"],
    priorityTier: "P1",
    unlocksAfter: "10DLC registration"
  },
  {
    id: "persuasion-robocall",
    phase: "active",
    type: "dynamic",
    category: "Voter Outreach & Persuasion",
    title: "Persuasion Robocall",
    description: "Build trust and make your case for why voters should pick you, by automated call.",
    channel: "robocall",
    timing: {
      kind: "electionRelative",
      offset: voterContactSendOffsetDays("persuasion-robocall"),
      unit: "days"
    },
    electionType: "adapts",
    proRequired: true,
    status: "live",
    personalization: "content-pill",
    pills: ["topIssues", "opponentName", "sendDate"],
    priorityTier: "P1"
  },
  {
    id: "persuasion-text",
    phase: "active",
    type: "dynamic",
    category: "Voter Outreach & Persuasion",
    title: "Persuasion Text",
    description: "Build trust and make your case by text.",
    channel: "text",
    timing: {
      kind: "electionRelative",
      offset: voterContactSendOffsetDays("persuasion-text"),
      unit: "days"
    },
    electionType: "adapts",
    proRequired: true,
    status: "live",
    personalization: "content-pill",
    pills: ["topIssues", "opponentName", "sendDate"],
    priorityTier: "P1",
    unlocksAfter: "10DLC registration"
  },
  // ----- GOTV -----
  {
    id: "voter-registration-deadline",
    phase: "gotv",
    type: "dynamic",
    category: "Election admin",
    title: "Voter Registration Deadline",
    description: "Final day for voters to register for this election.",
    channel: "awareness",
    timing: { kind: "jurisdiction", pill: "regDeadline" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["regDeadline"],
    priorityTier: "P1"
  },
  {
    id: "early-voting-start",
    phase: "gotv",
    type: "dynamic",
    category: "Election admin",
    title: "Early Voting Start Date",
    description: "Beginning of the early vote period.",
    channel: "awareness",
    timing: { kind: "jurisdiction", pill: "earlyVotingStart" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["earlyVotingStart"],
    priorityTier: "P1"
  },
  {
    id: "early-voting-end",
    phase: "gotv",
    type: "dynamic",
    category: "Election admin",
    title: "Early Voting End Date",
    description: "End of the early vote period.",
    channel: "awareness",
    timing: { kind: "jurisdiction", pill: "earlyVotingEnd" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["earlyVotingEnd"],
    priorityTier: "P1"
  },
  {
    id: "election-day",
    phase: "gotv",
    type: "dynamic",
    category: "Get Out the Vote (GOTV)",
    title: "Election Day",
    description: "Today is Election Day! Get out and vote, and make sure your supporters do too. Good luck!",
    channel: "awareness",
    timing: { kind: "electionDay" },
    dayOfWeek: void 0,
    electionType: "adapts",
    proRequired: false,
    status: "live",
    personalization: "content-pill",
    pills: ["electionDay", "electionType"],
    priorityTier: "P1"
  },
  {
    id: "greet-voters-at-polls",
    phase: "gotv",
    type: "static",
    category: "Holidays/parades/external events",
    title: "Greet voters at the polls",
    description: "Your last chance to make an impression. Shake hands and introduce yourself as voters head in.",
    channel: "event",
    timing: { kind: "electionDay" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["electionDay", "pollingPlaces"],
    priorityTier: "P2"
  },
  {
    id: "gotv-social-post",
    phase: "gotv",
    type: "dynamic",
    category: "Communications & Visibility",
    title: "Create a Get Out The Vote social post",
    description: "Remind your supporters that it is time to vote.",
    channel: "socialMedia",
    timing: { kind: "electionDay" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["electionDay", "votesNeededToWin"],
    priorityTier: "P3"
  },
  {
    id: "early-voting-text",
    phase: "gotv",
    type: "dynamic",
    category: "Voter Outreach & Persuasion",
    title: "Early Voting Text",
    description: "Encourage your supporters to vote early.",
    channel: "text",
    timing: {
      kind: "electionRelative",
      offset: voterContactSendOffsetDays("early-voting-text"),
      unit: "days"
    },
    electionType: "adapts",
    proRequired: true,
    status: "live",
    personalization: "content-pill",
    pills: ["sendDate", "earlyVotingStart", "earlyVotingEnd"],
    priorityTier: "P1",
    unlocksAfter: "10DLC registration"
  },
  {
    id: "election-day-reminder-robocall",
    phase: "gotv",
    type: "dynamic",
    category: "Voter Outreach & Persuasion",
    title: "Election Day Reminder Robocall",
    description: "Get out the vote with an automated call on election (or primary) day.",
    channel: "robocall",
    timing: {
      kind: "electionRelative",
      offset: voterContactSendOffsetDays("election-day-reminder-robocall"),
      unit: "days"
    },
    electionType: "adapts",
    proRequired: true,
    status: "live",
    personalization: "content-pill",
    pills: ["sendDate", "electionDay"],
    priorityTier: "P1"
  },
  {
    id: "election-day-reminder-text",
    phase: "gotv",
    type: "dynamic",
    category: "Voter Outreach & Persuasion",
    title: "Election Day Reminder Text",
    description: "Get out the vote with a text on election (or primary) day.",
    channel: "text",
    timing: {
      kind: "electionRelative",
      offset: voterContactSendOffsetDays("election-day-reminder-text"),
      unit: "days"
    },
    electionType: "adapts",
    proRequired: true,
    status: "live",
    personalization: "content-pill",
    pills: ["sendDate", "electionDay"],
    priorityTier: "P1",
    unlocksAfter: "10DLC registration"
  },
  {
    id: "build-chase-list",
    phase: "gotv",
    type: "dynamic",
    category: "Get Out the Vote (GOTV)",
    title: "Build your chase list",
    description: "Pull together the list of supporters who are with you but have not voted yet. These are the people your final push is all about.",
    channel: "general",
    timing: { kind: "electionRelative", offset: 3, unit: "days" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["identifiedSupporters", "votesNeededToWin"],
    priorityTier: "P1",
    unlocksAfter: "Record your voter contacts"
  },
  {
    id: "start-vote-tripling",
    phase: "gotv",
    type: "dynamic",
    category: "Get Out the Vote (GOTV)",
    title: "Start vote tripling",
    description: "Ask each supporter to remind three friends to vote, and write down their names. One of the cheapest ways to add votes in the final stretch.",
    channel: "general",
    timing: { kind: "electionRelative", offset: 2, unit: "days" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["identifiedSupporters"],
    priorityTier: "P1",
    unlocksAfter: "Build your chase list"
  },
  {
    id: "recruit-poll-watchers",
    phase: "gotv",
    type: "static",
    category: "Election day ops",
    title: "Recruit poll watchers",
    description: "Where your state allows it, line up volunteers to watch the polls on election day.",
    channel: "general",
    timing: { kind: "electionRelative", offset: 1, unit: "days" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["state", "pollingPlaces"],
    priorityTier: "P1"
  },
  {
    id: "organize-rides-to-polls",
    phase: "gotv",
    type: "static",
    category: "Election day ops",
    title: "Organize rides to the polls",
    description: "Set up a simple way to get supporters who need a ride to their polling place.",
    channel: "general",
    timing: { kind: "electionRelative", offset: 1, unit: "days" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["pollingPlaces"],
    priorityTier: "P1"
  },
  {
    id: "track-who-voted",
    phase: "gotv",
    type: "static",
    category: "Election day ops",
    title: "Track who has voted",
    description: "Keep a live list of which supporters have voted so your team knows who still needs a friendly reminder.",
    channel: "general",
    timing: { kind: "electionDay" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["chaseList"],
    priorityTier: "P1",
    unlocksAfter: "Build your chase list"
  },
  {
    id: "thank-volunteers",
    phase: "gotv",
    type: "static",
    category: "Close-out",
    title: "Thank your volunteers",
    description: "Send a personal thank-you to every volunteer who showed up. They are the reason you made it through, win or lose.",
    channel: "general",
    timing: { kind: "afterElection", weeks: 1 },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["volunteerList"],
    priorityTier: "P2"
  },
  {
    id: "thank-donors",
    phase: "gotv",
    type: "static",
    category: "Close-out",
    title: "Thank your donors",
    description: "Send a thank-you to every person who gave. It keeps them with you for whatever comes next.",
    channel: "general",
    timing: { kind: "afterElection", weeks: 1 },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["donorList"],
    priorityTier: "P2"
  },
  {
    id: "post-election-message",
    phase: "gotv",
    type: "static",
    category: "Close-out",
    title: "Share your post-election message",
    description: "Win or lose, post a short public statement thanking your supporters and your community.",
    channel: "general",
    timing: { kind: "electionDay" },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["result", "votesNeededToWin"],
    priorityTier: "P2"
  },
  {
    id: "file-final-report",
    phase: "gotv",
    type: "static",
    category: "Close-out",
    title: "File your final report",
    description: "Submit your final campaign finance report on time so you close out cleanly.",
    channel: "general",
    timing: { kind: "afterElection", weeks: 2 },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["finalFilingDeadline", "state"],
    priorityTier: "P1"
  },
  {
    id: "write-campaign-debrief",
    phase: "gotv",
    type: "static",
    category: "Close-out",
    title: "Write your campaign debrief",
    description: "Note what worked and what did not while it is fresh. If you run again, this is gold.",
    channel: "general",
    timing: { kind: "afterElection", weeks: 2 },
    electionType: "both",
    proRequired: false,
    status: "proposed",
    personalization: "content-pill",
    pills: ["campaignStats"],
    priorityTier: "P2"
  }
];

// src/campaigns/CampaignTimeline.ts
var DAY_MS = 24 * 60 * 60 * 1e3;
var GOTV_WINDOW_DAYS = 30;
var ACTIVE_WEEKS_BEFORE_ELECTION = 10;
var MIN_LAUNCH_DAYS = 28;
var GOING_PUBLIC_DAYS = 14;
var plusDays = (date, days) => new Date(date.getTime() + days * DAY_MS);
var earlier = (a, b) => a < b ? a : b;
var later = (a, b) => a > b ? a : b;
var timelineElectionDate = (dates, now) => {
  const today = now.toISOString().slice(0, 10);
  return [dates.general, dates.primary].find(
    (date) => !!date && date.slice(0, 10) >= today
  ) ?? null;
};
var campaignPhaseWindows = (start, election) => {
  if (!election) {
    return {
      start,
      active: plusDays(start, MIN_LAUNCH_DAYS),
      gotv: /* @__PURE__ */ new Date(864e13),
      election
    };
  }
  const gotv = later(start, plusDays(election, -GOTV_WINDOW_DAYS));
  const roomDays = (gotv.getTime() - start.getTime()) / DAY_MS;
  const earliestActive = plusDays(
    start,
    Math.min(MIN_LAUNCH_DAYS, Math.floor(roomDays / 2))
  );
  const active = earlier(
    later(
      plusDays(election, -ACTIVE_WEEKS_BEFORE_ELECTION * 7),
      earliestActive
    ),
    gotv
  );
  return { start, active, gotv, election };
};
var timelinePhase = (phase) => phase === "active" ? "active" : phase === "gotv" ? "gotv" : "launch";
var phaseStart = (windows, phase) => {
  const key = timelinePhase(phase);
  return key === "launch" ? windows.start : key === "active" ? windows.active : windows.gotv;
};
var phaseForDate = (windows, date) => date < windows.active ? "launch" : date < windows.gotv ? "active" : "gotv";
var voterContactSendDate = (catalogId, election, start) => {
  const sends = VOTER_CONTACT_SCHEDULE.map((send2) => ({
    id: send2.catalogId,
    date: plusDays(election, -send2.daysBeforeElection)
  }));
  const send = sends.find((candidate) => candidate.id === catalogId);
  if (!send) return null;
  const past = sends.filter((candidate) => candidate.date < start);
  const index = past.findIndex((candidate) => candidate.id === catalogId);
  if (index === -1) return send.date;
  const next = sends.find((candidate) => candidate.date >= start)?.date ?? election;
  const roomDays = Math.floor((next.getTime() - start.getTime()) / DAY_MS);
  if (roomDays >= past.length) {
    const stepDays = Math.min(7, Math.floor(roomDays / past.length));
    return plusDays(start, index * stepDays);
  }
  return plusDays(start, Math.max(0, index - (past.length - roomDays)));
};
var resolveTrackerTaskDate = (task, windows) => {
  const { timing } = task;
  const { start, active, election } = windows;
  const send = task.id && election ? voterContactSendDate(task.id, election, start) : null;
  if (send) return send;
  const lastLaunchDay = later(start, plusDays(active, -1));
  switch (timing.kind) {
    case "asap":
    case "onboardingWeek":
      return start;
    case "preLaunch":
      return earlier(plusDays(start, 7), lastLaunchDay);
    case "launch":
      return earlier(
        later(plusDays(start, 14), plusDays(active, -GOING_PUBLIC_DAYS)),
        lastLaunchDay
      );
    case "electionRelative":
      if (!election) return start;
      return plusDays(
        election,
        -(timing.unit === "weeks" ? timing.offset * 7 : timing.offset)
      );
    case "electionDay":
      return election ?? start;
    case "afterElection":
      return election ? plusDays(election, timing.weeks * 7) : start;
    case "jurisdiction":
    case "recurring":
    case "perItem":
      return phaseStart(windows, task.phase);
  }
};
var trackerTimelineStart = (rows) => {
  const asapTitles = new Set(
    CAMPAIGN_TASK_CATALOG.filter(
      (task) => task.timing.kind === "asap" || task.timing.kind === "onboardingWeek"
    ).map((task) => task.title)
  );
  const defaults = rows.filter((row) => row.isDefaultTask);
  const anchors = defaults.filter((row) => asapTitles.has(row.title));
  const times = (anchors.length > 0 ? anchors : defaults).map(
    (row) => new Date(row.date).getTime()
  );
  return times.length > 0 ? new Date(Math.min(...times)) : null;
};

// src/campaigns/TrackerTaskSkip.ts
var TRACKER_TASK_SNOOZE_DAYS = 3;
var DAY_MS2 = 24 * 60 * 60 * 1e3;
var canSetTaskAsideForGood = (title) => CAMPAIGN_TASK_CATALOG.find((task) => task.title === title)?.category !== BALLOT_ACCESS_CATEGORY;
var FIXED_DATE_CATEGORIES = /* @__PURE__ */ new Set(["Election admin"]);
var FIXED_DATE_TITLES = /* @__PURE__ */ new Set(["Election Day"]);
var canPutOffTask = (title) => {
  if (FIXED_DATE_TITLES.has(title)) return false;
  const entry = CAMPAIGN_TASK_CATALOG.find((task) => task.title === title);
  return !entry || !FIXED_DATE_CATEGORIES.has(entry.category);
};
var trackerTaskPutOffDate = (now) => {
  const later2 = new Date(now.getTime() + TRACKER_TASK_SNOOZE_DAYS * DAY_MS2);
  return new Date(
    Date.UTC(later2.getUTCFullYear(), later2.getUTCMonth(), later2.getUTCDate())
  );
};
var isTrackerTaskSetAside = (task) => task.skipReason === "notForMe";

// src/campaigns/CampaignWithPositionName.schema.ts
import { z as z45 } from "zod";
var CampaignWithPositionNameSchema = ReadCampaignOutputSchema.extend({
  positionName: z45.string().nullable()
});

// src/campaigns/Organization.schema.ts
import { z as z46 } from "zod";
var OrganizationSchema = z46.object({
  createdAt: zCoerceDate(),
  updatedAt: zCoerceDate(),
  slug: z46.string(),
  ownerId: z46.number(),
  positionId: z46.string().nullable(),
  overrideDistrictId: z46.string().nullable(),
  customPositionName: z46.string().nullable()
});
var OrganizationWithStatusSchema = OrganizationSchema.extend({
  status: OrganizationStatusSchema
});

// src/campaigns/CampaignWithLiveContext.schema.ts
var CampaignWithLiveContextSchema = CampaignWithPositionNameSchema.extend({
  raceTargetMetrics: RaceTargetMetricsSchema.nullable(),
  organization: OrganizationSchema.optional()
});

// src/campaigns/FilingInstructionsContent.schema.ts
import { z as z47 } from "zod";
var FilingInstructionsContentSchema = z47.object({
  filingWindow: z47.string(),
  filingFee: z47.number().nullable(),
  filingRequirementsText: z47.string().nullable(),
  filingOfficeAddress: z47.string().nullable(),
  filingPhoneNumber: z47.string().nullable(),
  paperworkInstructions: z47.string().nullable()
});

// src/campaigns/DistrictCity.ts
var cityFromDistrictName = (districtName) => {
  let name = districtName.trim();
  name = name.replace(/^(City|Town|Village|Borough|Township)\s+of\s+/i, "");
  name = name.replace(/\s*\([^)]*\)\.?\s*$/i, "");
  name = name.replace(/\s+Cncl\s*(D(ist)?\.?)?\s*$/i, "");
  name = name.replace(/\s+Council\s+D(ist)?\.?\s*$/i, "");
  name = name.replace(
    /\s+(Ward|District|Precinct|Division|At-Large)\s*[\w-]*$/i,
    ""
  );
  name = name.replace(/\s+(City|Town|Village|Borough|Boro|Township)$/i, "");
  name = name.trim();
  if (!name || name.length < 2 || /^\d+$/.test(name)) return null;
  return name;
};
var LOWERCASE_WORDS = /* @__PURE__ */ new Set(["of", "on", "the"]);
var capitalizePart = (part) => {
  const lower = part.toLowerCase();
  const apostrophe = /^([od])['’](.+)$/.exec(lower);
  if (apostrophe) {
    const [, prefix, rest] = apostrophe;
    return `${prefix.toUpperCase()}'${capitalizePart(rest)}`;
  }
  if (/^mc[a-z]/.test(lower)) {
    return `Mc${lower.charAt(2).toUpperCase()}${lower.slice(3)}`;
  }
  return lower.charAt(0).toUpperCase() + lower.slice(1);
};
var cityNameCase = (name) => {
  if (!/[A-Z]/.test(name) || /[a-z]/.test(name)) return name;
  return name.split(" ").map((word, index) => {
    const lower = word.toLowerCase();
    if (index > 0 && LOWERCASE_WORDS.has(lower)) return lower;
    return word.split("-").map(capitalizePart).join("-");
  }).join(" ");
};

// src/campaigns/CampaignEverPro.ts
var campaignWasEverPro = (campaign) => Boolean(campaign.isPro) || campaign.details?.isProUpdatedAt != null || campaign.details?.subscriptionId != null || campaign.details?.subscriptionCanceledAt != null;

// src/campaigns/ElectedOffice.schema.ts
import { z as z48 } from "zod";
var ElectedOfficeSchema = z48.object({
  id: z48.string(),
  organizationSlug: z48.string(),
  electedDate: z48.string().nullable(),
  swornInDate: z48.string().nullable(),
  termStartDate: z48.string().nullable(),
  termEndDate: z48.string().nullable(),
  termLengthDays: z48.number().nullable(),
  isActive: z48.boolean(),
  party: z48.string().nullable(),
  pledgedAt: z48.string().nullable(),
  onboardingCompletedAt: z48.string().nullable(),
  // True when the holder self-reported their office/term via the net-new serve
  // onboarding flow (vs a sales/BallotReady prefill).
  selfReported: z48.boolean(),
  // Resume checkpoint: the furthest serve-onboarding step the holder reached.
  onboardingStep: z48.string().nullable(),
  userId: z48.number(),
  campaignId: z48.number().nullable(),
  createdAt: z48.string(),
  updatedAt: z48.string()
});
var MyElectedOfficeSchema = ElectedOfficeSchema.extend({
  hasWinIssues: z48.boolean(),
  campaignWasEverPro: z48.boolean()
});

// src/campaigns/Eligibility.schema.ts
import { z as z49 } from "zod";
var EligibilitySchema = z49.object({
  hasActiveCampaign: z49.boolean(),
  holdsOffice: z49.boolean(),
  canStartCampaign: z49.boolean(),
  canGainOffice: z49.boolean(),
  reelectionOfficeSlug: z49.string().nullable()
});

// src/campaigns/ListCampaignsPagination.schema.ts
import { z as z50 } from "zod";
var CAMPAIGN_SORT_KEYS = CAMPAIGN_SCALAR_FIELDS;
var ListCampaignsPaginationSchema = FilterablePaginationSchema({
  sortKeys: CAMPAIGN_SORT_KEYS,
  filterFields: {
    userId: z50.coerce.number().optional(),
    slug: paginationFilter
  }
});

// src/campaigns/TeamInviteMetadata.schema.ts
import { z as z51 } from "zod";
var TEAM_INVITE_ROLE_VALUES = ["campaignAdmin", "volunteer"];
var TeamInviteRoleSchema = z51.enum(TEAM_INVITE_ROLE_VALUES);
var TeamInviteMetadataSchema = z51.object({
  organizationSlug: z51.string(),
  role: TeamInviteRoleSchema,
  name: z51.string(),
  invitedByUserId: z51.number(),
  outreachId: z51.number().optional(),
  phone: PhoneSchema.optional()
});

// src/campaigns/Team.schema.ts
import { z as z52 } from "zod";
var TeamMemberSchema = z52.object({
  userId: z52.number(),
  name: z52.string().nullable(),
  email: z52.string(),
  role: OrganizationRoleSchema,
  createdAt: zCoerceDate()
});
var PendingInviteSchema = z52.object({
  id: z52.string(),
  email: z52.string(),
  name: z52.string(),
  role: TeamInviteRoleSchema,
  createdAt: zCoerceDate(),
  outreachId: z52.number().nullable()
});
var TeamResponseSchema = z52.object({
  members: z52.array(TeamMemberSchema),
  pendingInvites: z52.array(PendingInviteSchema)
});
var InviteMemberResponseSchema = z52.discriminatedUnion("status", [
  z52.object({ status: z52.literal("added"), member: TeamMemberSchema }),
  z52.object({ status: z52.literal("pending"), invite: PendingInviteSchema })
]);
var AcceptedAssignmentSchema = z52.object({
  outreachId: z52.number(),
  outreachType: OutreachTypeSchema,
  phoneBankingListId: z52.number().nullable(),
  doorKnockingRouteId: z52.number().nullable()
});
var AcceptInviteResponseSchema = z52.object({
  organizationSlug: z52.string(),
  role: OrganizationRoleSchema,
  assignment: AcceptedAssignmentSchema.nullable()
});
var MyPendingInviteResponseSchema = z52.object({
  invite: z52.object({
    organizationSlug: z52.string(),
    role: TeamInviteRoleSchema
  }).nullable()
});
var TeamMemberStatsSchema = z52.object({
  userId: z52.number(),
  doorsKnocked: z52.number().int(),
  callsMade: z52.number().int(),
  totalLogged: z52.number().int(),
  lastActivityAt: zCoerceDate().nullable()
});
var TeamStatsResponseSchema = z52.object({
  stats: z52.array(TeamMemberStatsSchema)
});

// src/campaigns/compliance.ts
var MIN_BIO_LENGTH = 200;
var TEMPLATE_BIO_MARKER = "running on local solutions over party politics";
var COMPLIANCE_DEFAULT_ISSUE_TITLE = "Local Solutions, Not Party Politics";
var isGenuineBioPlainText = (plainText) => plainText.trim().length >= MIN_BIO_LENGTH && !plainText.toLowerCase().includes(TEMPLATE_BIO_MARKER);
var isGenuineIssue = (issue) => typeof issue === "object" && issue !== null && (issue.title?.trim().length ?? 0) > 0 && (issue.description?.trim().length ?? 0) > 0 && issue.title?.trim() !== COMPLIANCE_DEFAULT_ISSUE_TITLE;
var hasGenuineIssue = (issues) => (issues ?? []).some(isGenuineIssue);

// src/campaigns/UpdateCampaignM2M.schema.ts
var UpdateCampaignM2MSchema = CampaignSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  userId: true,
  vendorTsData: true
}).partial();

// src/campaigns/ComplianceStateOutput.schema.ts
import { z as z53 } from "zod";
var PinDeliverySchema = z53.object({
  method: PinDeliveryMethodSchema,
  displayString: z53.string()
});
var ComplianceStateDomainSchema = z53.object({
  name: z53.string(),
  status: DomainStatusSchema,
  registrantVerifiedAt: z53.string().datetime({ offset: true }).nullable()
});
var ComplianceStateOutputSchema = z53.object({
  stage: ComplianceStageSchema,
  domain: ComplianceStateDomainSchema.nullable(),
  websiteId: z53.number().int().nullable(),
  peerlyVerificationId: z53.string().nullable(),
  // Live Peerly CampaignVerify status. Only resolved (via a Peerly read) at the
  // `awaiting_pin` stage, where it gates the PIN-entry screen; null otherwise
  // (including when no CV request exists yet at Peerly).
  peerlyCvStatus: PeerlyCvVerificationStatusSchema.nullable(),
  // Live PIN-delivery channel + destination, resolved alongside peerlyCvStatus
  // at `awaiting_pin`; null before Peerly has sent the PIN (or on an
  // unrecognized method). The FE uses it to tell the candidate where to look.
  pinDelivery: PinDeliverySchema.nullable(),
  // Set when the row is synthetic: created by the admin "treat as 10DLC
  // approved (internal testing)" checkbox or by staff Test mode. No Peerly
  // identity exists for it, so UI gates pass but real P2P sends stay blocked.
  internalTestingAt: z53.string().datetime({ offset: true }).nullable(),
  // Whether a TcrCompliance row exists at all — gp-admin uses it (with
  // internalTestingAt null) to detect real compliance in progress and
  // disable the internal-testing checkbox.
  hasComplianceRecord: z53.boolean(),
  // The persisted committee name off the TcrCompliance row — the copy every
  // runtime read uses (SMS "Paid for by" footer, checkSmsStandards, Peerly
  // submission). Null when no record exists.
  committeeName: z53.string().nullable(),
  // The persisted election-filing URL off the TcrCompliance row. Null when no
  // record exists. gp-admin links it at `filing_review_hold` so staff can
  // verify the page by eye before overriding.
  filingUrl: z53.string().nullable(),
  // The CV pre-submission validation hold (ENG-10965). Set when the gate held
  // the record; reasons are the stored failed-check copy (same text as the
  // Slack alert). Empty reasons with a null failedAt when not held.
  cvValidationFailedAt: z53.string().datetime({ offset: true }).nullable(),
  cvValidationFailureReasons: z53.array(z53.string()),
  // The SMS compliance cutoff window. Optional so a response without it reads
  // as `open`. smsCutoffDate is the last open day and generalElectionDate the
  // campaign's details.electionDate, both ISO dates, null when there is no
  // election date.
  smsCompliance: SmsComplianceWindowSchema.optional(),
  smsCutoffDate: z53.string().nullable().optional(),
  generalElectionDate: z53.string().nullable().optional()
});

// src/campaigns/SubmitToPeerlyOutput.schema.ts
import { z as z54 } from "zod";
var SubmitToPeerlyPinDeliveryChannelsSchema = z54.object({
  email: z54.string(),
  phone: z54.string()
});
var SubmitToPeerlyOutputSchema = z54.object({
  tcrComplianceId: z54.string(),
  peerlyIdentityId: z54.string(),
  peerlyIdentityProfileLink: z54.string().nullable(),
  peerly10DLCBrandSubmissionKey: z54.string().nullable(),
  peerlyVerificationId: z54.string().nullable(),
  stage: ComplianceStageSchema,
  pinDeliveryChannels: SubmitToPeerlyPinDeliveryChannelsSchema
});

// src/campaigns/TenDlcStatusSnapshot.schema.ts
import { z as z55 } from "zod";
var TenDlcStatusBucketKeySchema = z55.enum([
  "stuckSubmission",
  "kickoffError",
  "rejected",
  "billingBlocked",
  "domainPurchaseIncomplete",
  "domainNotResolving",
  "cvInReviewStalled",
  "finalizeStalled",
  "dispatchDeferred",
  "awaitingPin",
  "cvUnissued"
]);
var TenDlcStatusEntrySchema = z55.object({
  campaignId: z55.number().int(),
  campaignSlug: z55.string(),
  userId: z55.number().int(),
  committeeName: z55.string().nullable(),
  // The campaign's assigned success person — its HubSpot company owner,
  // resolved live and best-effort (null on any CRM failure), the same field
  // the SMS outreach console's queue shows as "Assigned to".
  assignedPa: z55.string().nullable(),
  peerlyIdentityId: z55.string().nullable(),
  filingUrl: z55.string().nullable(),
  since: z55.string().datetime({ offset: true }).nullable(),
  agenticRunId: z55.string().nullable(),
  runStatus: z55.string().nullable(),
  domainName: z55.string().nullable(),
  domainStatus: z55.string().nullable(),
  escalatedAt: z55.string().datetime({ offset: true }).nullable(),
  peerlyCvStatus: z55.string().nullable(),
  // Set when the record is held by the CV pre-submission validation gate —
  // the admin override-and-resubmit action applies to exactly these rows.
  cvValidationFailedAt: z55.string().datetime({ offset: true }).nullable(),
  // dispatchDeferred only: the campaign has no user association, so the fix
  // is a data repair, not a candidate nudge.
  missingUser: z55.boolean()
});
var TenDlcStatusBucketSchema = z55.object({
  key: TenDlcStatusBucketKeySchema,
  entries: z55.array(TenDlcStatusEntrySchema)
});
var TenDlcStatusSnapshotSchema = z55.object({
  generatedAt: z55.string().datetime({ offset: true }),
  buckets: z55.array(TenDlcStatusBucketSchema)
});

// src/campaigns/UpdateCommitteeName.schema.ts
import { z as z57 } from "zod";

// src/campaigns/CommitteeName.schema.ts
import { z as z56 } from "zod";
var PLACEHOLDER_COMMITTEE_NAMES = /* @__PURE__ */ new Set([
  "na",
  "n a",
  "none",
  "null",
  "nil",
  "no",
  "tbd",
  "tba",
  "self",
  "me",
  "myself",
  "test",
  "testing",
  "unknown",
  "not applicable",
  "not available",
  "no committee",
  "pending",
  "later",
  "x",
  "xx",
  "xxx",
  "asdf"
]);
var normalizeCommitteeName = (value) => value.toLowerCase().replace(/[^a-z0-9]+/g, " ").trim().replace(/\s+/g, " ");
var isPlaceholderCommitteeName = (value) => {
  const normalized = normalizeCommitteeName(value);
  return normalized === "" || PLACEHOLDER_COMMITTEE_NAMES.has(normalized);
};
var COMMITTEE_NAME_PLACEHOLDER_MESSAGE = 'That looks like a placeholder, not a committee name. Enter the name on your filing, or "Your name for office" if you have no committee.';
var CommitteeNameSchema = z56.string().trim().min(1, "A committee name is required").refine(
  (value) => !isPlaceholderCommitteeName(value),
  COMMITTEE_NAME_PLACEHOLDER_MESSAGE
);

// src/campaigns/UpdateCommitteeName.schema.ts
var UpdateCommitteeNameSchema = z57.object({
  committeeName: CommitteeNameSchema
});
var UpdateCommitteeNameOutputSchema = z57.object({
  committeeName: z57.string()
});

// src/campaigns/UpdateFilingUrl.schema.ts
import { z as z58 } from "zod";
var UpdateFilingUrlSchema = z58.object({
  filingUrl: z58.string().trim().min(1, "A filing URL is required")
});
var UpdateFilingUrlOutputSchema = z58.object({
  filingUrl: z58.string()
});

// src/elections/raceListItem.ts
import { z as z59 } from "zod";
var RaceListItemSchema = z59.object({
  id: z59.string(),
  brPositionId: z59.string(),
  position: z59.object({
    name: z59.string(),
    level: z59.string(),
    state: z59.string(),
    normalizedPosition: z59.object({ name: z59.string() }).optional()
  }),
  election: z59.object({
    electionDay: z59.string()
  }),
  // Optional only to survive a deploy-ordering window: gp-api validates the
  // election-api response against this schema, and a given gp-api can call an
  // election-api still running older code that predates these fields (notably a
  // PR preview, whose gp-api targets the dev election-api until this PR merges
  // and dev redeploys). election-api populates them from Race.isPrimary/isRunoff
  // via the positionId join — this just tolerates the environment that lags.
  isPrimary: z59.boolean().nullish(),
  isRunoff: z59.boolean().nullish(),
  city: z59.string().nullable().optional(),
  district: z59.string().nullable().optional()
});
var RaceListItemArraySchema = z59.array(RaceListItemSchema);

// src/elections/raceFull.ts
import { z as z60 } from "zod";
var FilingPeriodSchema = z60.object({
  startOn: z60.string().nullable().optional(),
  endOn: z60.string().nullable().optional()
});
var PositionFullSchema = z60.object({
  id: z60.string(),
  name: z60.string(),
  level: z60.string().nullable().optional(),
  state: z60.string().nullable().optional(),
  partisanType: z60.string().nullable().optional(),
  hasPrimary: z60.boolean().nullable().optional(),
  electionFrequencies: z60.array(z60.object({ frequency: z60.array(z60.number()) })).nullable().optional(),
  normalizedPosition: z60.object({ name: z60.string() }).nullable().optional(),
  mtfcc: z60.string().nullable().optional(),
  geoId: z60.string().nullable().optional(),
  subAreaName: z60.string().nullable().optional(),
  subAreaValue: z60.string().nullable().optional(),
  tier: z60.union([z60.string(), z60.number()]).nullable().optional()
});
var ElectionFullSchema = z60.object({
  id: z60.string().nullable().optional(),
  electionDay: z60.string(),
  primaryElectionDate: z60.string().nullable().optional(),
  primaryElectionId: z60.string().nullable().optional(),
  state: z60.string().nullable().optional(),
  name: z60.string().nullable().optional(),
  timezone: z60.string().nullable().optional()
});
var RaceFullSchema = z60.object({
  id: z60.string(),
  isPrimary: z60.boolean().nullable().optional(),
  position: PositionFullSchema,
  election: ElectionFullSchema,
  filingPeriods: z60.array(FilingPeriodSchema).nullable().optional(),
  city: z60.string().nullable().optional()
});

// src/elections/raceFrequency.ts
import { z as z61 } from "zod";
var RaceFrequencyByBrHashSchema = z61.object({
  frequency: z61.array(z61.number()),
  electionDate: z61.string().nullable()
});

// src/elections/nextElectionForPosition.ts
import { z as z62 } from "zod";
var NextElectionForPositionSchema = z62.object({
  electionDate: z62.string().nullable()
});

// src/elections/zipCodes.ts
import { z as z63 } from "zod";
var ZipCodesArraySchema = z63.array(z63.string());

// src/elections/ElectedOfficeSupport.schema.ts
import { z as z64 } from "zod";
var ElectedOfficeSupportSchema = z64.object({
  electedOfficeId: z64.guid(),
  supportConstituents: z64.number().int().nonnegative(),
  totalConstituents: z64.number().int().nonnegative()
});

// src/speech/synthesizeSpeech.schema.ts
import { z as z65 } from "zod";
var SPEECH_SYNTHESIS_ENGINE_VALUES = [
  "neural",
  "standard",
  "generative"
];
var SpeechSynthesisEngineSchema = z65.enum(
  SPEECH_SYNTHESIS_ENGINE_VALUES
);
var SPEECH_SYNTHESIS_VOICE_VALUES = [
  "Joanna",
  "Matthew",
  "Ivy",
  "Kendra",
  "Kimberly",
  "Salli",
  "Joey",
  "Justin",
  "Ruth",
  "Stephen",
  "Amy"
];
var SpeechSynthesisVoiceSchema = z65.enum(SPEECH_SYNTHESIS_VOICE_VALUES);
var GENERATIVE_VOICE_VALUES = [
  "Joanna",
  "Matthew",
  "Salli",
  "Ruth",
  "Stephen",
  "Amy"
];
var SYNTHESIZE_SPEECH_MAX_TEXT_LENGTH = 5e4;
var SynthesizeSpeechRequestSchema = z65.object({
  /**
   * The plain text to synthesize. The server splits this into Polly-sized
   * chunks at sentence boundaries, caches each chunk by content hash, and
   * returns ordered presigned URLs for the client to play in sequence.
   *
   * The caller owns text rendering: pre-render any domain object (briefing,
   * note, etc.) into the exact words you want spoken. Markdown markers and
   * link syntax should be stripped client-side; the speech service does
   * not interpret them.
   */
  text: z65.string().min(1, "text must not be empty").max(
    SYNTHESIZE_SPEECH_MAX_TEXT_LENGTH,
    `text must be at most ${SYNTHESIZE_SPEECH_MAX_TEXT_LENGTH} characters`
  ),
  options: z65.object({
    voiceId: SpeechSynthesisVoiceSchema.default("Ruth"),
    engine: SpeechSynthesisEngineSchema.default("generative")
  }).refine(
    ({ voiceId, engine }) => engine !== "generative" || GENERATIVE_VOICE_VALUES.includes(voiceId),
    { message: "Selected voice does not support the generative engine" }
  ).optional()
});
var SynthesizeSpeechSegmentSchema = z65.object({
  index: z65.number().int().nonnegative(),
  url: z65.string().url(),
  expiresInSeconds: z65.number().int().positive()
});
var SynthesizeSpeechResponseSchema = z65.object({
  format: z65.literal("audio/mpeg"),
  segments: z65.array(SynthesizeSpeechSegmentSchema)
});

// src/speech/transcribeSession.schema.ts
import { z as z66 } from "zod";
var TranscribeSessionRequestSchema = z66.object({});
var TranscribeSessionResponseSchema = z66.object({
  wsUrl: z66.string().url(),
  expiresAt: z66.string().datetime()
});

// src/annotations/Annotation.schema.ts
import { z as z67 } from "zod";
var ANNOTATION_KIND_VALUES2 = [
  "note",
  "chat",
  "bug_report",
  "review"
];
var AnnotationKindSchema2 = z67.enum(ANNOTATION_KIND_VALUES2);
var ANNOTATION_RESOURCE_TYPE_VALUES2 = [
  "briefing",
  "ordinance"
];
var AnnotationResourceTypeSchema2 = z67.enum(
  ANNOTATION_RESOURCE_TYPE_VALUES2
);
var AnnotationAnchorSchema = z67.object({
  json_path: z67.string().min(1).nullable(),
  start: z67.number().int().min(0).nullable(),
  end: z67.number().int().min(0).nullable()
}).refine(
  (a) => {
    const passage = a.json_path !== null && a.start !== null && a.end !== null;
    const cardLevel = a.json_path !== null && a.start === null && a.end === null;
    const briefingWide = a.json_path === null && a.start === null && a.end === null;
    return passage || cardLevel || briefingWide;
  },
  {
    message: "anchor must be passage-anchored (all set), card-level (json_path only), or briefing-wide (all null)"
  }
).refine((a) => a.start === null || a.end === null || a.start < a.end, {
  message: "start must be less than end"
});
var OCR_STATUS_VALUES2 = [
  "pending",
  "processing",
  "completed",
  "failed",
  "skipped"
];
var OcrStatusSchema2 = z67.enum(OCR_STATUS_VALUES2);
var AnnotationNoteAttachmentSchema = z67.object({
  id: z67.string(),
  file_name: z67.string(),
  mime_type: z67.string(),
  size_bytes: z67.number().int().nonnegative(),
  ocr_status: OcrStatusSchema2,
  ocr_text: z67.string().nullable(),
  ocr_error: z67.string().nullable(),
  ocr_completed_at: z67.string().nullable(),
  created_at: z67.string()
});
var AnnotationNoteSchema = z67.object({
  id: z67.string(),
  // Optional once a note can be attachment-only (no typed body). Phase 1
  // create requires a body, but the response shape is nullable for forward
  // compatibility with Phase 2.
  body: z67.string().nullable(),
  attachments: z67.array(AnnotationNoteAttachmentSchema),
  created_at: z67.string(),
  updated_at: z67.string()
});
var AnnotationBugReportSchema = z67.object({
  id: z67.string(),
  description: z67.string(),
  // The flagged passage, captured at submit time. Null for briefing bug
  // reports (they re-derive it from the anchor against immutable content);
  // set for ordinance drafts, whose editable body makes the anchor unreliable.
  excerpt: z67.string().nullable(),
  submitted_at: z67.string()
});
var AnnotationChatSchema = z67.object({
  id: z67.string(),
  created_at: z67.string()
});
var AnnotationReviewSchema = z67.object({
  id: z67.string(),
  body: z67.string(),
  reviewer_email: z67.string().nullable(),
  created_at: z67.string(),
  updated_at: z67.string()
});
var AnnotationSchema = z67.object({
  id: z67.string(),
  kind: AnnotationKindSchema2,
  resource_type: AnnotationResourceTypeSchema2,
  resource_id: z67.string(),
  author_user_id: z67.number().int(),
  json_path: z67.string().nullable(),
  start: z67.number().int().nullable(),
  end: z67.number().int().nullable(),
  created_at: z67.string(),
  updated_at: z67.string(),
  note: AnnotationNoteSchema.optional(),
  chat: AnnotationChatSchema.optional(),
  bug_report: AnnotationBugReportSchema.optional(),
  review: AnnotationReviewSchema.optional()
});
var noteBodySchema = z67.string().min(1).max(1e4);
var bugReportDescriptionSchema = z67.string().min(1).max(4e3);
var bugReportExcerptSchema = z67.string().min(1).max(1e4);
var reviewBodySchema = z67.string().min(1).max(1e4);
var CreateAnnotationRequestSchema = z67.discriminatedUnion("kind", [
  z67.object({
    kind: z67.literal("note"),
    anchor: AnnotationAnchorSchema,
    payload: z67.object({
      // Optional once attachment-only notes ship (Phase 2). When present,
      // `noteBodySchema` still enforces min(1) so empty strings are rejected.
      body: noteBodySchema.optional()
    })
  }),
  z67.object({
    kind: z67.literal("bug_report"),
    anchor: AnnotationAnchorSchema,
    payload: z67.object({
      description: bugReportDescriptionSchema,
      // Optional: the flagged passage, for resources whose content is editable
      // and whose anchor can't reliably re-derive it later (ordinance drafts).
      excerpt: bugReportExcerptSchema.optional()
    })
  }),
  z67.object({
    kind: z67.literal("review"),
    anchor: AnnotationAnchorSchema,
    payload: z67.object({
      body: reviewBodySchema
    })
  })
]);
var UpdateNoteRequestSchema = z67.object({
  body: noteBodySchema
});
var ATTACHMENT_MAX_BYTES = 20 * 1024 * 1024;
var ATTACHMENT_ALLOWED_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain"
];
var AttachmentPresignRequestSchema = z67.object({
  file_name: z67.string().min(1).max(255),
  mime_type: z67.enum(ATTACHMENT_ALLOWED_MIME_TYPES),
  size_bytes: z67.number().int().positive().max(ATTACHMENT_MAX_BYTES)
});
var AttachmentPresignResponseSchema = z67.object({
  attachment_id: z67.string(),
  upload_url: z67.string(),
  storage_key: z67.string()
});
var AttachmentDownloadUrlResponseSchema = z67.object({
  download_url: z67.string(),
  expires_at: z67.string()
});
var AnnotationResponseSchema = AnnotationSchema;
var AnnotationsListResponseSchema = z67.object({
  annotations: z67.array(AnnotationSchema)
});

// src/artifactFeedback/ArtifactFeedback.schema.ts
import { z as z68 } from "zod";
var ARTIFACT_RESOURCE_TYPE_VALUES2 = ["agenda_item"];
var ArtifactResourceTypeSchema2 = z68.enum(ARTIFACT_RESOURCE_TYPE_VALUES2);
var ARTIFACT_FEEDBACK_KIND_VALUES2 = ["positive", "negative"];
var ArtifactFeedbackKindSchema2 = z68.enum(ARTIFACT_FEEDBACK_KIND_VALUES2);
var FeedbackCommentSchema = z68.string().max(2e3).nullable();
var ArtifactFeedbackSchema = z68.object({
  id: z68.string(),
  organization_slug: z68.string(),
  submitter_user_id: z68.number().int(),
  artifact_type: ArtifactResourceTypeSchema2,
  artifact_id: z68.string(),
  feedback: ArtifactFeedbackKindSchema2,
  comment: FeedbackCommentSchema,
  created_at: z68.string(),
  updated_at: z68.string()
});
var SetArtifactFeedbackRequestSchema = z68.object({
  feedback: ArtifactFeedbackKindSchema2,
  comment: FeedbackCommentSchema.optional()
});
var ArtifactFeedbackResponseSchema = ArtifactFeedbackSchema;
var BriefingFeedbackListResponseSchema = z68.object({
  feedback: z68.array(ArtifactFeedbackSchema)
});

// src/artifactReview/ArtifactReview.schema.ts
import { z as z69 } from "zod";
var ArtifactReviewSchema = z69.object({
  verdict: ArtifactReviewVerdictSchema,
  failReason: z69.string().nullable(),
  reviewerEmail: z69.string().nullable(),
  reviewedAt: zCoerceDate()
});
var SetArtifactReviewVerdictRequestSchema = z69.object({
  verdict: ArtifactReviewVerdictSchema,
  // Optional here (callers simply omit it) vs nullable on the response,
  // where the DB's nullable column comes back as null.
  failReason: z69.string().min(1).max(2e3).optional()
});
var BriefingReviewLookupResponseSchema = z69.object({
  review: ArtifactReviewSchema.nullable()
});

// src/raceOpponent/RaceOpponent.schema.ts
import { z as z72 } from "zod";

// src/raceOpponent/RaceOpponentSummary.schema.ts
import { z as z70 } from "zod";
var SummarySourceSchema = z70.object({
  url: z70.string().min(1),
  title: z70.string().min(1),
  publisher: z70.string().min(1),
  description: z70.string().optional()
});
var SummarySourceRefSchema = z70.object({
  sourceType: RaceOpponentSourceTypeSchema,
  sourceUrl: z70.string().min(1)
});
var hostnameOf = (url2) => {
  try {
    return new URL(url2).hostname;
  } catch {
    return url2;
  }
};
var NormalizedSummarySourceSchema = z70.union([
  // The rich branch tolerates the transitional legacy keys: gp-api persists
  // the PARSED summary as the sections blob, so a normalized 5-key source
  // must survive the persist -> read re-parse without the rich branch
  // stripping sourceType/sourceUrl.
  SummarySourceSchema.extend({
    sourceType: RaceOpponentSourceTypeSchema.optional(),
    sourceUrl: z70.string().optional()
  }),
  SummarySourceRefSchema
]).transform(
  (source) => "url" in source ? source : {
    url: source.sourceUrl,
    title: hostnameOf(source.sourceUrl),
    publisher: hostnameOf(source.sourceUrl),
    // Transitional passthrough: the deployed webapp still reads
    // sourceType/sourceUrl off the wire; the UI tickets moving it to
    // the rich shape drop these keys.
    sourceType: source.sourceType,
    sourceUrl: source.sourceUrl
  }
);
var SummarySectionSchema = z70.object({
  text: z70.string(),
  sources: z70.array(NormalizedSummarySourceSchema).min(1)
});
var SummaryKeyPositionSchema = z70.object({
  label: z70.string(),
  detail: z70.string(),
  sources: z70.array(NormalizedSummarySourceSchema).min(1)
});
var RaceOpponentThreatTierSchema = z70.enum([
  "primary_threat",
  "watch_closely",
  "low_priority"
]);
var IssueSalienceSchema = z70.enum(["high", "medium", "low"]);
var SourcedTextItemSchema = z70.object({
  text: z70.string(),
  sources: z70.array(NormalizedSummarySourceSchema).optional()
});
var WhatYouNeedToKnowItemSchema = z70.union([z70.string(), SourcedTextItemSchema]).transform((item) => typeof item === "string" ? { text: item } : item);
var IssueContrastSchema = z70.object({
  issue: z70.string(),
  salience: IssueSalienceSchema,
  whyItMatters: z70.string(),
  opponentStance: z70.string(),
  opponentSources: z70.array(NormalizedSummarySourceSchema).optional(),
  candidateStance: z70.string()
});
var RaceOpponentFieldAnalysisSchema = z70.object({
  strengths: z70.array(z70.string()),
  weaknesses: z70.array(z70.string()),
  opportunities: z70.array(z70.string()),
  threats: z70.array(z70.string()),
  // Interpretive section: sourcing is optional/empty, unlike the
  // sourced-or-silent sections above.
  sources: z70.array(SummarySourceSchema).default([]),
  generatedAt: zCoerceDate().nullable()
});
var RaceOpponentSummarySchema = z70.object({
  opponentName: z70.string(),
  overview: SummarySectionSchema.nullable(),
  background: SummarySectionSchema.nullable(),
  generatedAt: zCoerceDate().nullable(),
  // Phase 3: the whole analysis block may be absent for an opponent with no
  // analysis yet, so every analytical field is optional.
  threatTier: RaceOpponentThreatTierSchema.optional(),
  // v2 (ENG-10630): interpretive, no required sources.
  whyTheyreRunning: z70.object({ text: z70.string() }).nullish(),
  // v2 (ENG-10630): sourced-or-silent, like overview/background.
  issuesThatMatter: z70.object({
    items: z70.array(z70.string()).min(1),
    sources: z70.array(NormalizedSummarySourceSchema).min(1)
  }).nullish(),
  // Dropped from the v2 output schema (ENG-10629); kept optional so legacy
  // persisted rows still parse. The UI stops rendering these.
  keyPositions: z70.array(SummaryKeyPositionSchema).optional(),
  whyTheyMatter: z70.string().optional(),
  whatYouNeedToKnow: z70.array(WhatYouNeedToKnowItemSchema).optional(),
  whereSoft: z70.array(SourcedTextItemSchema).optional(),
  issueContrasts: z70.array(IssueContrastSchema).optional()
});

// src/raceOpponent/RaceOpponentStandoutAction.schema.ts
import { z as z71 } from "zod";
var RaceOpponentStandoutActionHaystaqSchema = z71.object({
  hsColumn: z71.string().min(1),
  positionPhrase: z71.string().min(1).nullish(),
  positionDir: z71.enum(["high", "low"]).nullish(),
  totalActive: z71.number().int().nonnegative().nullish(),
  voterCountGe50: z71.number().int().nonnegative().nullish(),
  voterPercentageGe50: z71.number().min(0).max(100).nullish(),
  voterCountGe70: z71.number().int().nonnegative().nullish(),
  voterPercentageGe70: z71.number().min(0).max(100).nullish()
});
var RaceOpponentStandoutActionSchema = z71.object({
  title: z71.string().min(1).max(99),
  body: z71.string().min(1),
  smsMessage: z71.string().min(1).max(320),
  // nullish: DB nulls must round-trip, and older payloads may omit it.
  opponentName: z71.string().min(1).nullish(),
  issue: z71.string().min(1),
  // nullish object, mirroring issuesThatMatter: null for cards without usable
  // district sentiment, absent on legacy payloads.
  haystaq: RaceOpponentStandoutActionHaystaqSchema.nullish()
});

// src/raceOpponent/RaceOpponent.schema.ts
var RaceOpponentSchema = z72.object({
  id: z72.number(),
  opponentName: z72.string(),
  sourceType: RaceOpponentSourceTypeSchema,
  sourceUrl: z72.string().nullable(),
  // Opaque in Phase 0: the as-collected payload's shape isn't known yet, so we
  // deliberately don't model it.
  content: z72.unknown(),
  collectedAt: zCoerceDate()
});
var RACE_OPPONENT_COLLECTION_STATUS_VALUES = [
  "idle",
  // Opponents aren't known yet: opposition_research is identifying them (or its
  // auto-chained collection is pending) before collection can begin.
  "discovering",
  "running",
  "completed",
  "failed"
];
var RaceOpponentCollectionStatusSchema = z72.enum(
  RACE_OPPONENT_COLLECTION_STATUS_VALUES
);
var RaceOpponentResponseSchema = z72.object({
  opponents: z72.array(
    z72.object({
      opponentName: z72.string(),
      // Enriched from the campaign-strategy opponent roster by name match;
      // null when the collected name doesn't match a roster row (don't guess).
      party: z72.string().nullable(),
      isIncumbent: z72.boolean().nullable(),
      // Phase 3: surfaced on the opponent object (in addition to summary) so the
      // roster can tier and order without opening the detail. Optional until an
      // opponent has analysis.
      threatTier: RaceOpponentThreatTierSchema.optional(),
      // Raw per-source research rows. Sent only as the no-summary fallback the
      // page renders when an opponent has no structured summary yet; once a
      // summary exists these are redundant and gp-api omits them rather than
      // shipping the full scraped page text (ENG-10622). Optional for that
      // omit.
      items: z72.array(RaceOpponentSchema).optional(),
      // Optional + nullable: ENG-10588 wires the producer to populate this from
      // the race_opponent_summary step. Until then gp-api's get() omits the
      // field, so it must be optional (not just nullable) to validate.
      summary: RaceOpponentSummarySchema.nullish(),
      // v2 (ENG-10630): populated from the opponent's roster/collected data;
      // nullish so older gp-api payloads that predate this field still parse.
      websiteUrl: z72.string().nullish()
    })
  ),
  lastCollectedAt: zCoerceDate().nullable(),
  collectionStatus: RaceOpponentCollectionStatusSchema,
  // v2 (ENG-10630): campaign-level SWOT, null until candidate_platform data is
  // available; nullish so older gp-api payloads still parse.
  fieldAnalysis: RaceOpponentFieldAnalysisSchema.nullish(),
  // Phase 6 (ENG-10644/ENG-10647): stand-out action cards, empty array when
  // the campaign has none. Defaulted rather than required so a producer that
  // predates the field still parses while consumers always see an array.
  standoutActions: z72.array(RaceOpponentStandoutActionSchema).default([])
});

// src/raceOpponent/RaceOpponentResearch.schema.ts
import { z as z73 } from "zod";
var RaceOpponentResearchSchema = z73.object({
  id: z73.number(),
  kind: RaceOpponentFindingKindSchema,
  opponentName: z73.string().nullable(),
  electionCandidacyId: z73.string().nullable(),
  status: RaceOpponentResearchStatusSchema,
  runId: z73.string().nullable(),
  attempts: z73.number(),
  completedAt: zCoerceDate().nullable(),
  lastViewedAt: zCoerceDate().nullable(),
  createdAt: zCoerceDate(),
  updatedAt: zCoerceDate()
});

// src/raceOpponent/RaceOpponentFinding.schema.ts
import { z as z74 } from "zod";
var RaceOpponentFindingSchema = z74.object({
  id: z74.number(),
  researchId: z74.number(),
  claim: z74.string(),
  sourceUrl: z74.string().min(1),
  sourceExtract: z74.string().min(1),
  sourceTitle: z74.string().nullable(),
  sourceReachableAt: zCoerceDate().nullable(),
  category: z74.string(),
  occurredAt: zCoerceDate().nullable(),
  draftedResponse: z74.string().nullable(),
  createdAt: zCoerceDate()
});

// src/raceOpponent/RaceOpponentContrast.schema.ts
import { z as z75 } from "zod";
var RACE_OPPONENT_CONTRAST_ROUTING_VALUES = [
  "story",
  "texting",
  "mail"
];
var RaceOpponentContrastRoutingSchema = z75.enum(
  RACE_OPPONENT_CONTRAST_ROUTING_VALUES
);
var RaceOpponentContrastSchema = z75.object({
  id: z75.number(),
  opponentFact: z75.string().min(1),
  sourceUrl: z75.string().min(1),
  candidateFact: z75.string().min(1),
  contrastSentence: z75.string().min(1),
  issueTag: z75.string().min(1),
  routing: RaceOpponentContrastRoutingSchema,
  status: RaceOpponentContrastStatusSchema,
  editCount: z75.number(),
  findingId: z75.number().nullable(),
  routedWebsiteId: z75.number().nullable(),
  routedOutreachId: z75.number().nullable(),
  createdAt: zCoerceDate(),
  updatedAt: zCoerceDate()
});

// src/raceOpponent/RaceOpponentRoutes.schema.ts
import { z as z76 } from "zod";
var RaceOpponentReviewSchema = z76.object({
  verdict: ArtifactReviewVerdictSchema,
  failReason: z76.string().nullable(),
  reviewerEmail: z76.string().nullable(),
  reviewedAt: zCoerceDate()
});
var RaceOpponentResearchWithFindingsSchema = RaceOpponentResearchSchema.extend({
  findings: z76.array(RaceOpponentFindingSchema)
});
var StartSelfResearchResponseSchema = z76.object({
  research: RaceOpponentResearchSchema
});
var RaceOpponentResearchStatusResponseSchema = z76.object({
  status: RaceOpponentResearchStatusSchema,
  research: RaceOpponentResearchSchema.nullable()
});
var RaceOpponentReportResponseSchema = z76.object({
  research: RaceOpponentResearchWithFindingsSchema
});
var IdentifyOpponentsResponseSchema = z76.object({
  opponentNames: z76.array(z76.string())
});
var StartOpponentResearchRequestSchema = z76.object({
  opponentName: z76.string().min(1),
  electionCandidacyId: z76.string().nullish()
});
var StartOpponentResearchResponseSchema = z76.object({
  research: RaceOpponentResearchSchema
});
var OpponentProfileResponseSchema = z76.object({
  research: RaceOpponentResearchWithFindingsSchema
});
var RaceOpponentActivityItemSchema = RaceOpponentFindingSchema.extend({
  newSinceLastVisit: z76.boolean()
});
var RaceOpponentActivityResponseSchema = z76.object({
  findings: z76.array(RaceOpponentActivityItemSchema),
  researchStatus: RaceOpponentResearchStatusSchema,
  refresh: z76.object({
    status: z76.enum(["running", "completed", "failed"]),
    lastCompletedAt: z76.string().nullable()
  })
});
var CreateContrastRequestSchema = z76.object({
  findingId: z76.number().nullish(),
  opponentFact: z76.string().min(1),
  sourceUrl: z76.string().min(1),
  candidateFact: z76.string().min(1),
  contrastSentence: z76.string().min(1),
  issueTag: z76.string().min(1),
  routing: RaceOpponentContrastRoutingSchema
});
var EditContrastRequestSchema = z76.object({
  candidateFact: z76.string().min(1).optional(),
  contrastSentence: z76.string().min(1).optional()
}).refine((d) => Object.values(d).some((v) => v !== void 0), {
  message: "At least one field must be provided"
});
var ROUTE_CONTRAST_TARGET_VALUES = ["story", "texting"];
var RouteContrastTargetSchema = z76.enum(ROUTE_CONTRAST_TARGET_VALUES);
var RouteContrastRequestSchema = z76.object({
  target: RouteContrastTargetSchema
});
var RouteContrastToStoryResponseSchema = z76.object({
  contrast: RaceOpponentContrastSchema,
  routedWebsiteId: z76.number()
});
var RouteContrastToTextingResponseSchema = z76.object({
  contrast: RaceOpponentContrastSchema,
  routedOutreachId: z76.number()
});
var RouteContrastResponseSchema = z76.union([
  RouteContrastToStoryResponseSchema,
  RouteContrastToTextingResponseSchema
]);
var ContrastResponseSchema = z76.object({
  contrast: RaceOpponentContrastSchema
});
var GenerateContrastsResponseSchema = z76.object({
  contrasts: z76.array(RaceOpponentContrastSchema),
  routedToReviewCount: z76.number()
});
var ListContrastsResponseSchema = z76.object({
  contrasts: z76.array(RaceOpponentContrastSchema)
});

// src/recommendedLists/IdeologyBucket.schema.ts
import { z as z77 } from "zod";
var IDEOLOGY_BUCKET_VALUES = [
  "progressive",
  "moderate",
  "conservative"
];
var IdeologyBucketSchema = z77.enum(IDEOLOGY_BUCKET_VALUES);

// src/recommendedLists/RecommendedLists.schema.ts
import { z as z78 } from "zod";
var RECOMMENDED_LIST_CHANNEL_VALUES = [
  "sms",
  "robocall",
  "phoneBanking",
  "doorKnocking"
];
var RecommendedListChannelSchema = z78.enum(
  RECOMMENDED_LIST_CHANNEL_VALUES
);
var RECOMMENDED_LIST_INTENT_VALUES = [
  "introduce",
  "persuade",
  "event",
  "earlyVote",
  "electionDay"
];
var RecommendedListIntentSchema = z78.enum(
  RECOMMENDED_LIST_INTENT_VALUES
);
var RECOMMENDED_LIST_VARIANT_VALUES = [
  "introNeverIded",
  "persuadeAffinity",
  "persuadeIdeology",
  "persuadeUndecided",
  "eventSupporters",
  "eventAffinity",
  "eventIdeology",
  "earlyVoteSupporters",
  "earlyVoteAffinity",
  "earlyVoteIdeology",
  "electionDaySupporters",
  "electionDayAffinity",
  "electionDayIdeology",
  "freeOfferElectionEveRobocall"
];
var RecommendedListVariantSchema = z78.enum(
  RECOMMENDED_LIST_VARIANT_VALUES
);
var RECOMMENDED_LIST_VARIANT_INTENT = {
  introNeverIded: "introduce",
  persuadeAffinity: "persuade",
  persuadeIdeology: "persuade",
  persuadeUndecided: "persuade",
  eventSupporters: "event",
  eventAffinity: "event",
  eventIdeology: "event",
  earlyVoteSupporters: "earlyVote",
  earlyVoteAffinity: "earlyVote",
  earlyVoteIdeology: "earlyVote",
  electionDaySupporters: "electionDay",
  electionDayAffinity: "electionDay",
  electionDayIdeology: "electionDay",
  freeOfferElectionEveRobocall: "electionDay"
};
var RecommendedListFilterSchema = z78.object({
  voterStatus: z78.array(z78.string()).optional(),
  supportStatus: z78.array(SupportStatusRollupSchema2).optional(),
  // Every variant but the event invites leaves out voters who have already
  // voted this election ("Voted in election: Unknown").
  votedStatus: z78.array(VotedStatusSchema).optional(),
  independentAffinity: z78.boolean().optional(),
  // The early-vote variants' screen: Early_Vote_Status Very likely or
  // Likely, as the same two booleans a saved list stores.
  earlyVoteVeryLikely: z78.boolean().optional(),
  earlyVoteLikely: z78.boolean().optional(),
  ideologyLiberal: z78.boolean().optional(),
  ideologyModerate: z78.boolean().optional(),
  ideologyConservative: z78.boolean().optional(),
  hasCellPhone: z78.boolean().optional(),
  hasLandline: z78.boolean().optional(),
  hasAnyPhone: z78.boolean().optional(),
  // `county|precinct` pairs (encodePrecinctPair), set only for a
  // door-knocking variant that survived on its precinct-restricted count,
  // and for the free robocall offer (the campaign's treatment precincts).
  precincts: z78.array(z78.string()).optional()
}).strict();
var RecommendedListSchema = z78.object({
  variant: RecommendedListVariantSchema,
  // The intent the variant belongs to. A channel request already knows it
  // (it is the query), but a global request spans every intent, and the
  // list a candidate saves from one records it as provenance.
  intent: RecommendedListIntentSchema,
  filter: RecommendedListFilterSchema,
  count: z78.number().int().nonnegative(),
  // `count` over the race's vote goal. Absent — not null — when the vote
  // goal could not be resolved. Deliberately unbounded above: a list can
  // hold several times the votes the race needs, and a `.max(1)` here
  // would 500 the whole response for the districts where that is true.
  voteGoalShare: z78.number().nonnegative().optional(),
  // Cents, matching the pricing utils that produce it, and absent for the
  // volunteer-run channels (phone banking, door knocking) rather than zero
  // — a zero reads as "free" where the truth is "not applicable".
  estimatedCostCents: z78.number().int().nonnegative().optional(),
  copy: z78.object({
    title: z78.string(),
    criteriaSummary: z78.string()
  }),
  existingFilterId: z78.number().int().nullable()
});
var RecommendedListsResponseSchema = z78.array(RecommendedListSchema);

// src/experiments/ExperimentVariants.schema.ts
import { z as z79 } from "zod";
var ExperimentVariantSchema = z79.object({
  value: z79.string().optional(),
  key: z79.string().optional()
});
var ExperimentVariantsSchema = z79.record(
  z79.string(),
  ExperimentVariantSchema
);
var ExperimentVariantsResponseSchema = z79.object({
  variants: ExperimentVariantsSchema
});

// src/agentRuns/AgentRun.schema.ts
import { z as z80 } from "zod";
var AgentRunCandidateSummarySchema = z80.object({
  firstName: z80.string(),
  lastName: z80.string(),
  campaignId: z80.number().nullable()
});
var AgentRunListItemSchema = z80.object({
  runId: z80.string(),
  experimentType: z80.string(),
  status: ExperimentRunStatusSchema,
  organizationSlug: z80.string(),
  candidate: AgentRunCandidateSummarySchema.nullable(),
  durationSeconds: z80.number().nullable(),
  costUsd: z80.number().nullable(),
  createdAt: zCoerceDate(),
  stage: z80.string().nullable(),
  dataQuality: z80.string().nullable(),
  resumeScheduledFor: zCoerceDate().nullable(),
  resumeAttempts: z80.number()
});
var AgentRunsListQuerySchema = PaginationOptionsSchema.extend({
  experimentType: z80.string().optional(),
  status: ExperimentRunStatusSchema.optional(),
  organizationSlug: z80.string().optional(),
  createdAfter: zCoerceDate().optional(),
  createdBefore: zCoerceDate().optional()
});
var AgentRunSchema = z80.object({
  runId: z80.string(),
  organizationSlug: z80.string(),
  experimentType: z80.string(),
  status: ExperimentRunStatusSchema,
  params: z80.record(z80.string(), z80.unknown()),
  artifactBucket: z80.string().nullable(),
  artifactKey: z80.string().nullable(),
  durationSeconds: z80.number().nullable(),
  costUsd: z80.number().nullable(),
  error: z80.string().nullable(),
  createdAt: zCoerceDate(),
  updatedAt: zCoerceDate(),
  stage: z80.string().nullable(),
  dataQuality: z80.string().nullable(),
  resumeScheduledFor: zCoerceDate().nullable(),
  resumeAttempts: z80.number()
});
var AgentRunDetailSchema = z80.object({
  run: AgentRunSchema,
  artifact: z80.record(z80.string(), z80.unknown()).nullable(),
  conversationLog: z80.string().nullable()
});

// src/agentRuns/JudgeOverride.schema.ts
import { z as z81 } from "zod";
var JUDGE_KEY_PREFIX = "_judge/";
var JUDGE_RUN_ID_PREFIX = "_judge-";
var KEY_SEGMENT_SOURCE = "[A-Za-z0-9_-]{1,64}";
var KEY_SEGMENT = new RegExp(`^${KEY_SEGMENT_SOURCE}$`);
var JUDGE_RUN_ID_MAX_LENGTH = 36;
var judgeRunId = (suffix) => {
  const runId = `${JUDGE_RUN_ID_PREFIX}${suffix}`;
  if (!KEY_SEGMENT.test(suffix)) {
    throw new Error(`unsafe suffix for a judge run id: ${suffix}`);
  }
  if (runId.length > JUDGE_RUN_ID_MAX_LENGTH) {
    throw new Error(
      `judge run id ${runId} is ${runId.length} characters; ECS caps startedBy at ${JUDGE_RUN_ID_MAX_LENGTH}`
    );
  }
  return runId;
};
var judgeObjectKey = (filename) => z81.string().regex(
  new RegExp(
    `^${JUDGE_KEY_PREFIX}${KEY_SEGMENT_SOURCE}/${KEY_SEGMENT_SOURCE}/${filename.replaceAll(".", "\\.")}$`
  ),
  { message: `must be ${JUDGE_KEY_PREFIX}<agentId>/<digest>/${filename}` }
);
var judgeKeyFolder = (key) => key.split("/").slice(0, 3).join("/");
var JudgeOverrideSchema = z81.object({
  manifest_key: judgeObjectKey("manifest.json"),
  instruction_key: judgeObjectKey("instruction.md")
}).refine(
  ({ manifest_key, instruction_key }) => judgeKeyFolder(manifest_key) === judgeKeyFolder(instruction_key),
  {
    message: "manifest_key and instruction_key must name the same _judge/<agentId>/<digest>/ folder"
  }
);
var judgeOverrideKeys = (agentId, configDigest) => {
  if (!KEY_SEGMENT.test(agentId)) {
    throw new Error(`unsafe agentId for a judge key: ${agentId}`);
  }
  if (!KEY_SEGMENT.test(configDigest)) {
    throw new Error(`unsafe configDigest for a judge key: ${configDigest}`);
  }
  const folder = `${JUDGE_KEY_PREFIX}${agentId}/${configDigest}`;
  return {
    manifest_key: `${folder}/manifest.json`,
    instruction_key: `${folder}/instruction.md`
  };
};

// src/agentRuns/JudgeReplay.schema.ts
import { z as z82 } from "zod";
var JUDGE_REPLAY_KEY_PREFIX = `${JUDGE_KEY_PREFIX}replay/`;
var SEGMENT = "[A-Za-z0-9_-]{1,64}";
var AGENT_ID = "[a-z][a-z0-9_]{0,63}";
var CASE_ID = "[A-Za-z0-9_-]{1,80}";
var ATTEMPT = "[1-9][0-9]?";
var SWEEP_KEY = `sweep/${SEGMENT}/${AGENT_ID}/${CASE_ID}-${ATTEMPT}`;
var BASE_KEY = `base/${AGENT_ID}/${SEGMENT}/${CASE_ID}-${ATTEMPT}`;
var SEED_KEY = `seed/${AGENT_ID}/${CASE_ID}`;
var prefixed = (shape) => new RegExp(`^${JUDGE_REPLAY_KEY_PREFIX}${shape}$`);
var SWEEP_KEY_RE = prefixed(SWEEP_KEY);
var BASE_KEY_RE = prefixed(BASE_KEY);
var SEED_KEY_RE = prefixed(SEED_KEY);
var ANY_KEY_RE = prefixed(`(?:${SWEEP_KEY}|${BASE_KEY}|${SEED_KEY})`);
var JudgeReplaySchema = z82.object({
  mode: z82.enum(["record", "replay"]),
  key: z82.string().regex(ANY_KEY_RE, {
    message: `must be a ${JUDGE_REPLAY_KEY_PREFIX}sweep/, base/ or seed/ key`
  })
}).strict().refine(({ mode, key }) => !(mode === "record" && SEED_KEY_RE.test(key)), {
  message: "a seed store is replay-only"
});
var requireKey = (key, shape, label) => {
  if (!shape.test(key)) {
    throw new Error(`unsafe input for a judge replay ${label} key: ${key}`);
  }
  return key;
};
var requireAttempt = (attempt) => {
  if (!Number.isSafeInteger(attempt) || attempt < 1 || attempt > 99) {
    throw new Error(`attempt must be an integer from 1 to 99, got ${attempt}`);
  }
  return attempt;
};
var judgeReplaySweepKey = (sweepId, agentId, caseId, attempt) => requireKey(
  `${JUDGE_REPLAY_KEY_PREFIX}sweep/${sweepId}/${agentId}/${caseId}-${requireAttempt(attempt)}`,
  SWEEP_KEY_RE,
  "sweep"
);
var judgeReplayBaseKey = (agentId, configDigest, caseId, attempt) => requireKey(
  `${JUDGE_REPLAY_KEY_PREFIX}base/${agentId}/${configDigest}/${caseId}-${requireAttempt(attempt)}`,
  BASE_KEY_RE,
  "base"
);
var judgeReplaySeedKey = (agentId, caseId) => requireKey(
  `${JUDGE_REPLAY_KEY_PREFIX}seed/${agentId}/${caseId}`,
  SEED_KEY_RE,
  "seed"
);

// src/adminBriefings/AdminBriefing.schema.ts
import { z as z83 } from "zod";
var BRIEFING_DATE_RANGE_VALUES = [
  "All time",
  "last 12 months",
  "last 30 days",
  "last week"
];
var BriefingDateRangeFilterSchema = z83.enum(BRIEFING_DATE_RANGE_VALUES);
var BRIEFING_REVIEW_STATUS_VALUES = [
  "pending",
  "passed",
  "failed"
];
var BriefingReviewStatusFilterSchema = z83.enum(
  BRIEFING_REVIEW_STATUS_VALUES
);
var BriefingAdminListQuerySchema = PaginationOptionsSchema.extend({
  // Fuzzy match across the owning user's first name, last name, and email.
  q: z83.string().optional(),
  dateRange: BriefingDateRangeFilterSchema.optional(),
  reviewStatus: BriefingReviewStatusFilterSchema.optional()
});
var BriefingAdminRowSchema = z83.object({
  briefingId: z83.string(),
  // The gp-webapp briefing route slug is the meeting date (YYYY-MM-DD).
  meetingDate: z83.string(),
  // Read from the briefing artifact JSON; absent until a briefing is produced.
  meetingName: z83.string().nullable(),
  user: z83.object({
    id: z83.number().int(),
    firstName: z83.string().nullable(),
    lastName: z83.string().nullable(),
    email: z83.string()
  }),
  electedOffice: z83.object({
    id: z83.string(),
    organizationSlug: z83.string(),
    positionName: z83.string().nullable()
  }),
  updatedAt: zCoerceDate(),
  review: ArtifactReviewSchema.nullable()
});

// src/chats/proposalKey.ts
import { v5 as uuidv5 } from "uuid";
var PROPOSAL_KEY_NAMESPACE = "7d3f1a62-9c4e-5b08-a1d7-2f6e8c40b915";
var mintProposalKey = (conversationId, toolCallId) => uuidv5(`${conversationId}:${toolCallId}`, PROPOSAL_KEY_NAMESPACE);

// src/chats/ClarifyQuestion.schema.ts
import { z as z84 } from "zod";
var ChatSourceSchema = z84.object({
  id: z84.string(),
  title: z84.string(),
  url: z84.string().url().optional(),
  publisher: z84.string().optional(),
  kind: z84.enum(["external", "internal"]).optional(),
  excerpt: z84.string().optional(),
  /** When the page was published or last updated, as it shows it ("March 2026"). */
  date: z84.string().optional()
});
var ChatClarifyOptionSchema = z84.object({
  label: z84.string(),
  rationale: z84.string().optional(),
  source: ChatSourceSchema.optional()
});
var ChatClarifyQuestionSchema = z84.object({
  questionId: z84.string(),
  question: z84.string(),
  options: z84.array(ChatClarifyOptionSchema),
  multiSelect: z84.boolean().default(false)
});

// src/priorities/Priority.schema.ts
import { z as z85 } from "zod";
var PrioritySchema = z85.object({
  id: z85.string(),
  electedOfficeId: z85.string(),
  title: z85.string(),
  description: z85.string(),
  source: PrioritySourceSchema,
  sourceCampaignPositionId: z85.number().int().nullable(),
  currentStep: z85.string().nullable(),
  nextAction: z85.string().nullable(),
  createdAt: z85.string(),
  updatedAt: z85.string()
});
var CreatePriorityInputSchema = z85.object({
  title: z85.string().min(1),
  description: z85.string().min(1)
});
var UpdatePriorityInputSchema = z85.object({
  title: z85.string().min(1).optional(),
  description: z85.string().min(1).optional()
});

// src/priorities/PriorityOnboarding.schema.ts
import { z as z86 } from "zod";
var ONBOARDING_PRIORITY_OPTION_KINDS = [
  "ran_on",
  "community",
  "other"
];
var OnboardingPriorityOptionKindSchema = z86.enum(
  ONBOARDING_PRIORITY_OPTION_KINDS
);
var OnboardingPriorityOptionSchema = z86.object({
  key: z86.string(),
  kind: OnboardingPriorityOptionKindSchema,
  title: z86.string(),
  description: z86.string(),
  selected: z86.boolean()
});
var OnboardingPriorityOptionsSchema = z86.object({
  options: z86.array(OnboardingPriorityOptionSchema)
});
var OnboardingOtherPrioritySchema = z86.object({
  title: z86.string().trim().min(1).max(120),
  description: z86.string().trim().min(1).max(600)
});
var SetOnboardingPrioritiesInputSchema = z86.object({
  shownKeys: z86.array(z86.string()),
  selectedKeys: z86.array(z86.string()),
  other: z86.array(OnboardingOtherPrioritySchema).max(10)
});

// src/dashboard/DashboardCard.schema.ts
import { z as z87 } from "zod";
var DASHBOARD_CARD_BUCKET_VALUES = [
  "active",
  "this_week",
  "skipped",
  "missed",
  "done"
];
var DashboardCardBucketSchema = z87.enum(DASHBOARD_CARD_BUCKET_VALUES);
var DashboardCardsQuerySchema = z87.object({
  bucket: DashboardCardBucketSchema.default("active")
});
var DashboardCardSchema = z87.object({
  id: z87.string(),
  type: DashboardCardTypeSchema,
  title: z87.string(),
  summary: z87.string(),
  ctaLabel: z87.string(),
  ctaHref: z87.string(),
  dueDate: z87.string(),
  sourceExternalId: z87.string(),
  sourceItemId: z87.string().nullable(),
  dismissedAt: z87.string().nullable(),
  completedAt: z87.string().nullable(),
  createdAt: z87.string(),
  updatedAt: z87.string()
});
var DASHBOARD_CARD_SNOOZE_DAYS = 3;
var isGoodReadReportBackCard = (card) => card.type === "report_back" && GOOD_READ_STATUSES.some((status) => status === card.sourceItemId);
var MANAGED_CIVIC_PANEL_CARD_PREFIX = "managed-panel:";
var managedCivicPanelCardSourceId = (electedOfficeId) => `${MANAGED_CIVIC_PANEL_CARD_PREFIX}${electedOfficeId}`;
var isManagedCivicPanelCard = (card) => card.type === "civic_panel" && card.sourceExternalId.startsWith(MANAGED_CIVIC_PANEL_CARD_PREFIX);
var MANAGED_CIVIC_PANEL_CARD_CTA = "Build my civic panel";
var managedCivicPanelCardContent = (place) => {
  const where = place?.trim() || "your district";
  return {
    title: `Hear from all of ${where}, not just the loudest voices`,
    summary: `Residents from every part of ${where}, matched by age, gender and race. Free in early access.`
  };
};
var MANAGED_CIVIC_PANEL_PROGRESS_CARD_PREFIX = "managed-panel-progress:";
var managedCivicPanelProgressCardSourceId = (electedOfficeId) => `${MANAGED_CIVIC_PANEL_PROGRESS_CARD_PREFIX}${electedOfficeId}`;
var MANAGED_PANEL_PROGRESS_PHASES = [
  "building",
  "ready",
  "exhausted"
];
var managedPanelProgressPhase = (card) => card.type === "civic_panel" && card.sourceExternalId.startsWith(MANAGED_CIVIC_PANEL_PROGRESS_CARD_PREFIX) ? MANAGED_PANEL_PROGRESS_PHASES.find(
  (phase) => phase === card.sourceItemId
) ?? null : null;
var MANAGED_CIVIC_PANEL_EXHAUSTED_CARD_CTA = "Reach the rest another way";
var MANAGED_CIVIC_PANEL_PROGRESS_CARD_CTA = "See your civic panel";
var DashboardCardsResponseSchema = z87.object({
  bucket: DashboardCardBucketSchema,
  cards: z87.array(DashboardCardSchema)
});

// src/dashboard/OnboardingCard.schema.ts
import { z as z88 } from "zod";
var ONBOARDING_CARD_STATUS_VALUES = [
  "active",
  "skipped",
  "completed"
];
var OnboardingCardStatusSchema = z88.enum(ONBOARDING_CARD_STATUS_VALUES);
var OnboardingCardSchema = z88.object({
  key: OnboardingCardKeySchema,
  status: OnboardingCardStatusSchema
});
var OnboardingCardsResponseSchema = z88.object({
  cards: z88.array(OnboardingCardSchema)
});
var OnboardingCardKeyParamSchema = z88.object({
  key: OnboardingCardKeySchema
});

// src/dashboard/SupportEstimate.schema.ts
import { z as z89 } from "zod";
var SupportEstimateSchema = z89.object({
  likelySupport: z89.number().int().nonnegative(),
  districtSize: z89.number().int().nonnegative(),
  percentOfDistrict: z89.number().min(0).max(100)
});

// src/chats/Chat.schema.ts
import { z as z91 } from "zod";

// src/ordinances/Ordinance.schema.ts
import { z as z90 } from "zod";
var ORDINANCE_DRAFT_DISCLAIMER = {
  lead: "Review before you rely on this.",
  body: "This is an AI-generated first draft, not legal advice. Before you introduce or act on it, have a licensed attorney review it and independently verify every statute, citation, and factual claim against its primary source."
};
var OrdinanceSourceSchema = ChatSourceSchema;
var OrdinanceExistingLawSchema = z90.object({
  sourceUrl: z90.string().url(),
  chapterLabel: z90.string().optional(),
  text: z90.string(),
  // Exact, unedited text of the section(s) being amended, captured from the
  // source. The immutable baseline an amendment's redline is checked against;
  // absent for a brand-new ordinance.
  verbatimText: z90.string().optional(),
  fetchedAt: z90.string()
});
var OrdinanceClarifySchema = z90.object({ synthesis: z90.string() });
var OrdinanceClarifyAnswerSchema = z90.object({
  questionId: z90.string(),
  question: z90.string(),
  answer: z90.string(),
  source: OrdinanceSourceSchema.optional()
});
var OrdinanceClarifyAnswersSchema = z90.array(
  OrdinanceClarifyAnswerSchema
);
var SaveOrdinanceClarifyAnswerRequestSchema = OrdinanceClarifyAnswerSchema;
var OrdinanceClarifyOptionSchema = ChatClarifyOptionSchema;
var OrdinanceClarifyQuestionSchema = ChatClarifyQuestionSchema;
var OrdinanceNextStepOfferSchema = z90.object({
  label: z90.string().optional()
});
var OrdinanceAuthoritySchema = z90.object({
  status: z90.enum(["pass", "flag", "attention"]),
  explanation: z90.string(),
  source: OrdinanceSourceSchema
});
var OrdinanceComparableSchema = z90.object({
  city: z90.string(),
  state: z90.string(),
  population: z90.number().int().optional(),
  govType: z90.string().optional(),
  year: z90.number().int().optional(),
  headline: z90.string().optional(),
  quote: z90.string(),
  outcome: z90.string().optional(),
  status: z90.enum(["passed", "repealed", "unknown"]),
  failureReason: z90.string().optional(),
  source: OrdinanceSourceSchema
});
var OrdinanceComparablesSchema = z90.array(OrdinanceComparableSchema);
var OrdinanceAuthorityFindingSchema = OrdinanceAuthoritySchema.extend({
  headline: z90.string(),
  confirmation: z90.string().optional()
});
var OrdinanceLawPointSchema = z90.object({
  title: z90.string(),
  subtitle: z90.string().optional()
});
var OrdinanceCurrentLawSummarySchema = z90.object({
  chapterLabel: z90.string(),
  source: OrdinanceSourceSchema.optional(),
  does: z90.array(OrdinanceLawPointSchema),
  gaps: z90.array(OrdinanceLawPointSchema)
});
var OrdinanceHistoryEntrySchema = z90.object({
  year: z90.number().int(),
  label: z90.string(),
  summary: z90.string(),
  minutesExcerpt: z90.string().optional(),
  speaker: z90.string().optional(),
  source: OrdinanceSourceSchema.optional()
});
var OrdinanceLegislativeHistorySchema = z90.object({
  chapterLabel: z90.string().optional(),
  entries: z90.array(OrdinanceHistoryEntrySchema)
});
var OrdinancePresentComparablesSchema = z90.object({
  intro: z90.string().optional(),
  comparables: OrdinanceComparablesSchema,
  takeaway: z90.string().optional()
});
var OrdinancePresentDraftSchema = z90.object({
  title: z90.string().min(1),
  description: z90.string().optional(),
  body: z90.string().min(1),
  sources: z90.array(OrdinanceSourceSchema).optional()
});
var OrdinanceQualityCheckSchema = z90.object({
  id: z90.string(),
  label: z90.string(),
  status: z90.enum(["pass", "flag", "attention"]),
  note: z90.string(),
  source: OrdinanceSourceSchema.optional()
});
var OrdinanceQualityReportSchema = z90.object({
  checks: z90.array(OrdinanceQualityCheckSchema),
  tally: z90.object({
    pass: z90.number().int(),
    flag: z90.number().int(),
    attention: z90.number().int()
  }),
  stale: z90.boolean(),
  ranAgainstBodyHash: z90.string()
});
var OrdinanceQualityRunStatusSchema = z90.enum([
  "idle",
  "running",
  "done",
  "error"
]);
var OrdinanceQualityRunSchema = z90.object({
  status: OrdinanceQualityRunStatusSchema,
  report: OrdinanceQualityReportSchema.nullable(),
  error: z90.string().nullable(),
  startedAt: z90.string().nullable()
});
var OrdinanceQualityLoopPhaseSchema = z90.enum(["checking", "revising"]);
var OrdinanceQualityLoopSchema = z90.object({
  status: OrdinanceQualityLoopStatusSchema,
  phase: OrdinanceQualityLoopPhaseSchema.nullable(),
  passNumber: z90.number().int(),
  maxPasses: z90.number().int(),
  updatedAt: z90.string()
});
var OrdinanceQualityIterationSummarySchema = z90.object({
  iteration: z90.number().int(),
  flaggedCheckIds: z90.array(z90.string()),
  report: OrdinanceQualityReportSchema.nullable(),
  draftTitle: z90.string(),
  draftBody: z90.string(),
  // The sources snapshot graded with this iteration's draft, so a restore
  // can put back the sources the restored text actually cites.
  draftSources: z90.array(OrdinanceSourceSchema).nullable(),
  revisedTitle: z90.string().nullable(),
  revisedBody: z90.string().nullable(),
  revisionNotes: z90.array(z90.object({ checkId: z90.string(), note: z90.string() })).nullable(),
  createdAt: z90.string()
});
var OrdinanceQualityIterationsResponseSchema = z90.object({
  loopRunId: z90.string().nullable(),
  iterations: z90.array(OrdinanceQualityIterationSummarySchema)
});
var OrdinanceResearchChapterSchema = z90.object({
  label: z90.string(),
  text: z90.string(),
  citation: z90.string().optional()
});
var OrdinanceResearchSchema = z90.object({
  currentCode: z90.object({
    chapters: z90.array(OrdinanceResearchChapterSchema),
    loadedAt: z90.string().optional()
  }),
  historical: z90.array(OrdinanceSourceSchema.extend({ summary: z90.string() })),
  authority: z90.array(OrdinanceSourceSchema),
  web: z90.array(OrdinanceSourceSchema.extend({ snippet: z90.string() }))
}).partial();
var OrdinanceScratchpadNoteSchema = z90.object({
  step: z90.string(),
  text: z90.string(),
  createdAt: z90.string()
});
var OrdinanceScratchpadSchema = z90.array(OrdinanceScratchpadNoteSchema);
var ORDINANCE_FLOW_STEP_VALUES = [
  "intro",
  "clarify",
  "authority",
  "current_law",
  "comparables",
  "draft",
  // Post-draft review chat on the draft detail page. A lifecycle stage, not a
  // numbered wizard step (like 'intro'), so it stays out of ORDINANCE_NUMBERED_
  // STEPS. Its own conversation, and it omits the draft-synthesis tools.
  "review"
];
var OrdinanceFlowStepSchema = z90.enum(ORDINANCE_FLOW_STEP_VALUES);
var OrdinanceSchema = z90.object({
  id: z90.string(),
  slug: z90.string(),
  electedOfficeId: z90.string(),
  status: OrdinanceStatusSchema,
  seedType: OrdinanceSeedTypeSchema,
  issueSlug: z90.string().nullable(),
  sourceLink: z90.string().nullable(),
  goalText: z90.string().nullable(),
  existingLaw: OrdinanceExistingLawSchema.nullable(),
  clarify: OrdinanceClarifySchema.nullable(),
  clarifyAnswers: OrdinanceClarifyAnswersSchema.nullable(),
  authority: OrdinanceAuthoritySchema.nullable(),
  comparables: OrdinanceComparablesSchema.nullable(),
  draftTitle: z90.string().nullable(),
  draftBody: z90.string().nullable(),
  draftSources: z90.array(OrdinanceSourceSchema).nullable(),
  qualityReport: OrdinanceQualityReportSchema.nullable(),
  // Derived run status (same healing as the GET endpoint), so the draft page
  // can resume polling an in-flight run on mount without an extra fetch.
  qualityRunStatus: OrdinanceQualityRunStatusSchema,
  qualityLoop: OrdinanceQualityLoopSchema.nullable(),
  research: OrdinanceResearchSchema.nullable(),
  scratchpad: OrdinanceScratchpadSchema.nullable(),
  lastViewedStep: z90.string().nullable(),
  createdAt: z90.string(),
  updatedAt: z90.string()
});
var OrdinanceSummarySchema = OrdinanceSchema.pick({
  id: true,
  slug: true,
  status: true,
  seedType: true,
  draftTitle: true,
  goalText: true,
  lastViewedStep: true,
  createdAt: true,
  updatedAt: true
}).extend({
  // Raw column, not the assembled qualityLoop object: the list view only
  // needs a "running" indicator, not passNumber math per row.
  qualityLoopStatus: OrdinanceQualityLoopStatusSchema.nullable()
});
var OrdinanceStatusCountsSchema = z90.record(
  OrdinanceStatusSchema,
  z90.number().int()
);
var OrdinanceListResponseSchema = z90.object({
  items: z90.array(OrdinanceSummarySchema),
  counts: OrdinanceStatusCountsSchema
});
var CreateOrdinanceRequestSchema = z90.object({
  seedType: OrdinanceSeedTypeSchema,
  issueSlug: z90.string().optional(),
  sourceLink: z90.string().url().optional(),
  goalText: z90.string().optional()
}).refine((v) => v.seedType !== "issue" || Boolean(v.issueSlug), {
  message: 'issueSlug is required when seedType is "issue"',
  path: ["issueSlug"]
});
var UpdateOrdinanceRequestSchema = z90.object({
  status: OrdinanceStatusSchema,
  // Non-empty when provided: a persisted draft is never blank (mirrors
  // OrdinancePresentDraftSchema). .partial() keeps them optional, so a
  // status-only or body-only PATCH is still valid.
  draftTitle: z90.string().min(1),
  draftBody: z90.string().min(1),
  draftSources: z90.array(OrdinanceSourceSchema).min(1),
  lastViewedStep: z90.string()
}).partial();
var ORDINANCE_EXPORT_FORMATS = ["pdf", "docx"];

// src/chats/Chat.schema.ts
var ChatAnchorSnapshotSchema = z91.object({
  title: z91.string().max(500),
  summary: z91.string().max(5e3),
  highlightedText: z91.string().max(2e3).optional()
});
var CommunityIssueChatAnchorSchema = z91.object({
  resourceType: z91.literal("community_issue"),
  resourceId: z91.string(),
  url: z91.string(),
  snapshot: ChatAnchorSnapshotSchema
});
var OrdinanceChatAnchorSchema = z91.object({
  resourceType: z91.literal("ordinance"),
  resourceId: z91.string(),
  url: z91.string(),
  snapshot: ChatAnchorSnapshotSchema,
  step: OrdinanceFlowStepSchema
});
var PriorityChatAnchorSchema = z91.object({
  resourceType: z91.literal("priority"),
  resourceId: z91.string(),
  url: z91.string(),
  snapshot: ChatAnchorSnapshotSchema
});
var ChatAnchorSchema = z91.discriminatedUnion("resourceType", [
  CommunityIssueChatAnchorSchema,
  OrdinanceChatAnchorSchema,
  PriorityChatAnchorSchema
]);
var CreateChatRequestSchema = z91.object({
  scope: ChatScopeSchema,
  anchor: ChatAnchorSchema.optional()
});
var CreateChatResponseSchema = z91.object({
  conversationId: z91.string(),
  created: z91.boolean()
});
var CHAT_MESSAGE_MAX_LENGTH = 1e4;
var CAMPAIGN_MANAGER_START_STORY_SENTINEL = "__start_story__";
var CAMPAIGN_MANAGER_PRODUCT_OVERVIEW_SENTINEL = "__product_overview__";
var SendChatMessageRequestSchema = z91.object({
  content: z91.string().min(1).max(CHAT_MESSAGE_MAX_LENGTH),
  clientMessageId: z91.guid().optional(),
  attachmentIds: z91.array(z91.string()).max(10).optional(),
  // The page the message was sent from. A scope that reads it resolves it
  // against its own product map, so an unknown path adds nothing.
  pagePath: z91.string().max(300).optional()
});
var ChatMessageSegmentSchema = z91.object({
  kind: ChatMessageSegmentKindSchema,
  text: z91.string().nullable().optional(),
  toolName: z91.string().nullable().optional(),
  // Structured tool-call arguments for widget-rendering tools (e.g.
  // ask_clarify_question), so the client can replay the widget on reload.
  payload: z91.unknown().nullable().optional(),
  // The provider's id for this tool call. Persisted because a card's outreach
  // id is derived from it, so the browser has to arrive at the same value on
  // a reload as it did while the turn was streaming.
  toolCallId: z91.string().nullable().optional()
});
var ChatFeedbackCommentSchema = z91.string().max(2e3).nullable();
var ChatMessageFeedbackStateSchema = z91.object({
  feedback: ChatFeedbackKindSchema,
  comment: ChatFeedbackCommentSchema
});
var SetChatMessageFeedbackRequestSchema = z91.object({
  feedback: ChatFeedbackKindSchema,
  comment: ChatFeedbackCommentSchema.optional()
});
var ChatMessageFeedbackSchema = z91.object({
  id: z91.string(),
  conversationId: z91.string(),
  messageId: z91.string(),
  feedback: ChatFeedbackKindSchema,
  comment: ChatFeedbackCommentSchema,
  createdAt: zCoerceDate(),
  updatedAt: zCoerceDate()
});
var ChatMessageSchema = z91.object({
  id: z91.string(),
  role: ChatMessageRoleSchema,
  content: z91.string(),
  createdAt: zCoerceDate(),
  // Present only for assistant turns that used tools (persisted display
  // structure). Absent on older messages and pure-text turns — render
  // `content` flat in that case.
  segments: z91.array(ChatMessageSegmentSchema).optional(),
  // The CALLER's own rating of this turn, so the action bar restores its
  // pressed state on reload. Null/absent when they haven't rated it. Other
  // users' ratings are never returned.
  feedback: ChatMessageFeedbackStateSchema.nullable().optional()
});
var ChatConversationUsageSchema = z91.object({
  complete: z91.boolean(),
  byModel: z91.array(
    z91.object({
      model: z91.string(),
      inputTokens: z91.number().int(),
      outputTokens: z91.number().int()
    })
  )
});
var ChatConversationSchema = z91.object({
  conversationId: z91.string(),
  scope: ChatScopeSchema,
  title: z91.string().nullable(),
  messages: z91.array(ChatMessageSchema),
  usage: ChatConversationUsageSchema
});
var ChatHistoryItemSchema = z91.object({
  conversationId: z91.string(),
  title: z91.string().nullable(),
  createdAt: zCoerceDate(),
  updatedAt: zCoerceDate()
});
var ChatHistoryResponseSchema = z91.object({
  conversations: z91.array(ChatHistoryItemSchema)
});
var ChatHistoryQuerySchema = z91.object({
  scope: ChatScopeSchema
});
var CHAT_STREAM_ERROR_CODE_VALUES = [
  "conversation_not_found",
  "upstream_unavailable",
  "rate_limited",
  "aborted",
  "internal"
];
var ChatStreamErrorCodeSchema = z91.enum(CHAT_STREAM_ERROR_CODE_VALUES);
var ChatStreamEventSchema = z91.discriminatedUnion("type", [
  z91.object({ type: z91.literal("text"), delta: z91.string() }),
  z91.object({
    type: z91.literal("tool_call"),
    toolName: z91.string(),
    args: z91.unknown()
  }),
  z91.object({
    type: z91.literal("tool_result"),
    toolName: z91.string(),
    result: z91.unknown()
  }),
  z91.object({
    type: z91.literal("citation"),
    attachmentId: z91.string(),
    page: z91.number().int().optional(),
    charRange: z91.tuple([z91.number().int(), z91.number().int()]).optional(),
    quotedText: z91.string()
  }),
  z91.object({
    type: z91.literal("done"),
    assistantMessageId: z91.string().optional()
  }),
  z91.object({
    type: z91.literal("error"),
    code: ChatStreamErrorCodeSchema,
    message: z91.string(),
    retryable: z91.boolean()
  })
]);

// src/chats/ChiefOfStaffWidgets.schema.ts
import { z as z92 } from "zod";
var ShowListMapSchema = z92.object({
  listId: z92.number().int().positive().describe(
    "Id of the saved list to map, as returned by crud_saved_filters."
  ),
  // Carried so the card can title itself without a second fetch, and so a
  // renamed or deleted list still renders as the thing the conversation was
  // about rather than as an empty frame.
  name: z92.string().min(1).max(80).describe("The saved list's name, for the card heading.")
});
var ListProposalSchema = z92.object({
  name: z92.string().min(1).max(40).describe("The list name, named after the filters it actually applies."),
  summary: z92.string().min(1).max(200).describe("One plain sentence on who the list holds, for the card."),
  count: z92.number().int().nonnegative().describe("The count count_contacts returned for these filters."),
  filters: z92.record(z92.string(), z92.json()).describe("The exact filter you counted with in count_contacts.")
});

// src/chats/ComposeHandoff.schema.ts
import { z as z93 } from "zod";
var ComposeHandoffPayloadSchema = z93.discriminatedUnion("channel", [
  z93.object({
    channel: z93.literal("serve_social"),
    draftText: z93.string().min(1).max(2e3),
    purpose: z93.string().max(120).optional()
  }),
  z93.object({
    channel: z93.literal("win_social"),
    draftText: z93.string().min(1).max(2e3),
    purpose: z93.string().max(120).optional()
  })
]);
var COMPOSE_HANDOFF_CHANNEL_SCHEMAS = {
  serve_social: ComposeHandoffPayloadSchema.options[0],
  win_social: ComposeHandoffPayloadSchema.options[1]
};

// src/chats/ChatAttachment.schema.ts
import { z as z94 } from "zod";
var CHAT_ATTACHMENT_MAX_BYTES = 20 * 1024 * 1024;
var CHAT_ATTACHMENT_MAX_PAGES = 100;
var CHAT_ATTACHMENTS_PER_CONVERSATION = 10;
var CHAT_ATTACHMENT_ALLOWED_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain"
];
var ChatAttachmentSchema = z94.object({
  id: z94.string(),
  source: ChatAttachmentSourceSchema,
  sourceUrl: z94.string().nullable().optional(),
  fileName: z94.string(),
  mimeType: z94.string(),
  sizeBytes: z94.number().int(),
  pageCount: z94.number().int().nullable().optional(),
  status: ChatAttachmentStatusSchema,
  failureReason: z94.string().nullable().optional(),
  createdAt: zCoerceDate()
});
var PresignRequestSchema = z94.object({
  fileName: z94.string().min(1).max(255),
  mimeType: z94.enum(CHAT_ATTACHMENT_ALLOWED_MIME_TYPES),
  sizeBytes: z94.number().int().positive().max(CHAT_ATTACHMENT_MAX_BYTES)
}).strict();
var PresignResponseSchema = z94.object({
  attachmentId: z94.string(),
  uploadUrl: z94.string(),
  uploadFields: z94.record(z94.string(), z94.string()),
  storageKey: z94.string()
});
var FinalizeRequestSchema = z94.object({
  storageKey: z94.string()
}).strict();
var LinkAttachRequestSchema = z94.object({
  url: z94.string().url().max(2048).refine(
    (u) => {
      try {
        const { protocol } = new URL(u);
        return protocol === "http:" || protocol === "https:";
      } catch {
        return false;
      }
    },
    { message: "URL scheme must be http or https" }
  )
}).strict();
var LinkAttachResponseSchema = z94.discriminatedUnion("ok", [
  z94.object({ ok: z94.literal(true), attachment: ChatAttachmentSchema }),
  z94.object({
    ok: z94.literal(false),
    error: z94.enum([
      "unreachable",
      "blocked_url",
      "unsupported_content_type",
      "too_large",
      "timeout",
      "attachment_limit_reached"
    ])
  })
]);
var ChatAttachmentListResponseSchema = z94.object({
  attachments: z94.array(ChatAttachmentSchema)
});
var ChatAttachmentDownloadResponseSchema = z94.object({
  url: z94.string(),
  expiresAt: zCoerceDate()
});
var ChatMessageSegmentCitationPayloadSchema = z94.object({
  attachmentId: z94.string(),
  page: z94.number().int().optional(),
  charRange: z94.tuple([z94.number().int(), z94.number().int()]).optional(),
  quotedText: z94.string()
});

// src/meetings/MeetingAgentDispatch.schema.ts
import { z as z95 } from "zod";
var MeetingAgentDispatchKindSchema = z95.enum(["schedule", "briefing"]);
var DispatchMeetingAgentRequestSchema = z95.object({
  electedOfficeId: z95.string().min(1),
  kind: MeetingAgentDispatchKindSchema,
  useImminenceGate: z95.boolean().optional()
});
var DispatchMeetingAgentResultSchema = z95.object({
  dispatched: z95.boolean(),
  kind: MeetingAgentDispatchKindSchema
});
var BriefingDispatchPreviewSchema = z95.object({
  contextOk: z95.boolean(),
  isServeIcp: z95.boolean().nullable(),
  scheduleKnown: z95.boolean(),
  nextMeetingDate: z95.string().nullable(),
  imminentMeetingDate: z95.string().nullable(),
  coveredByBriefingDate: z95.string().nullable(),
  gateWouldDispatch: z95.boolean(),
  overrideWouldDispatch: z95.boolean()
});

// src/communityIssues/CommunityIssueDispatch.schema.ts
import { z as z96 } from "zod";
var CommunityIssuesDispatchRequestSchema = z96.object({
  orgSlugs: z96.array(z96.string()).min(1).max(200)
});
var CommunityIssuesDispatchResultSchema = z96.object({
  dispatched: z96.number(),
  skipped: z96.number()
});

// src/ordinances/redline.ts
var MARKERS = {
  deletion: { open: "{-", close: "-}" },
  insertion: { open: "{+", close: "+}" }
};
var hasRedline = (body) => body.includes("{-") || body.includes("{+");
var parseRedline = (body) => {
  const segments = [];
  let literal = "";
  const flushLiteral = () => {
    if (literal) {
      segments.push({ type: "unchanged", text: literal });
      literal = "";
    }
  };
  let i = 0;
  while (i < body.length) {
    const two = body.slice(i, i + 2);
    let kind = null;
    if (two === MARKERS.deletion.open) kind = "deletion";
    else if (two === MARKERS.insertion.open) kind = "insertion";
    if (kind) {
      const close = body.indexOf(MARKERS[kind].close, i + 2);
      if (close !== -1) {
        flushLiteral();
        segments.push({ type: kind, text: body.slice(i + 2, close) });
        i = close + 2;
        continue;
      }
    }
    literal += body.charAt(i);
    i += 1;
  }
  flushLiteral();
  return segments;
};
var parseRedlineLines = (body) => {
  const lines = [];
  let current = [];
  lines.push(current);
  for (const seg of parseRedline(body)) {
    seg.text.split("\n").forEach((part, idx) => {
      if (idx > 0) {
        current = [];
        lines.push(current);
      }
      if (part) current.push({ type: seg.type, text: part });
    });
  }
  return lines;
};
var serializeRedline = (segments) => segments.map(
  (s) => s.type === "unchanged" ? s.text : `${MARKERS[s.type].open}${s.text}${MARKERS[s.type].close}`
).join("");
var redlineToOriginal = (body) => parseRedline(body).filter((s) => s.type !== "insertion").map((s) => s.text).join("");
var redlineToAmended = (body) => parseRedline(body).filter((s) => s.type !== "deletion").map((s) => s.text).join("");

// src/outreach/PanelRepliesUploaded.schema.ts
import { z as z97 } from "zod";
var PanelRepliesUploadedEventSchema = z97.object({
  bucket: z97.string(),
  key: z97.string()
});

// src/outreach/EmailTemplate.const.ts
import { z as z98 } from "zod";
var WHITE = "#FFFFFF";
var EMAIL_THEMES = {
  classic_blue: {
    label: "Classic blue",
    colors: {
      bg: "#EFF5FF",
      card: WHITE,
      header: "#1E63EC",
      headerText: WHITE,
      rule: "#1E63EC",
      headline: "#0B1529",
      body: "#1D305C",
      meta: "#1D305C",
      cta: "#1E63EC",
      ctaText: WHITE,
      accent: "#DC1438",
      accentText: WHITE,
      divider: "#D6E7FF"
    }
  },
  fresh_green: {
    label: "Fresh green",
    colors: {
      bg: "#DDF2E8",
      card: WHITE,
      header: "#16695C",
      headerText: WHITE,
      rule: "#16695C",
      headline: "#043630",
      body: "#115449",
      meta: "#115449",
      cta: "#257F68",
      ctaText: WHITE,
      accent: "#FFE06C",
      accentText: "#043630",
      divider: "#B2E1CC"
    }
  },
  warm_sunset: {
    label: "Warm sunset",
    colors: {
      bg: "#FFEBD8",
      card: WHITE,
      header: "#B74932",
      headerText: WHITE,
      rule: "#B74932",
      headline: "#2E030A",
      body: "#511508",
      meta: "#511508",
      cta: "#B80F2E",
      ctaText: WHITE,
      accent: "#FFE291",
      accentText: "#511508",
      divider: "#FFCAA2"
    }
  },
  bold_red: {
    label: "Bold red",
    colors: {
      bg: "#FFF1F2",
      card: WHITE,
      header: "#DC1438",
      headerText: WHITE,
      rule: "#DC1438",
      headline: "#0B1529",
      body: "#1D305C",
      meta: "#1D305C",
      cta: "#0048C2",
      ctaText: WHITE,
      accent: "#FFC523",
      accentText: "#060B17",
      divider: "#FFD9DC"
    }
  },
  cream_and_forest: {
    label: "Cream and forest",
    colors: {
      bg: "#FCF8F3",
      card: WHITE,
      header: WHITE,
      headerText: "#115449",
      rule: "#16695C",
      headline: "#1E1F20",
      body: "#595C5F",
      meta: "#70757A",
      cta: "#16695C",
      ctaText: WHITE,
      accent: "#DDF2E8",
      accentText: "#115449",
      divider: "#E0E6EC"
    }
  }
};
var EmailThemeKeySchema = z98.enum([
  "classic_blue",
  "fresh_green",
  "warm_sunset",
  "bold_red",
  "cream_and_forest"
]);
var EMAIL_LAYOUTS = {
  newsletter: {
    label: "Newsletter",
    defaultTheme: "classic_blue",
    requiresButton: false
  },
  reminder: {
    label: "Reminder",
    defaultTheme: "fresh_green",
    requiresButton: false
  },
  call_to_action: {
    label: "Call to action",
    defaultTheme: "cream_and_forest",
    requiresButton: true
  }
};
var EmailLayoutKeySchema = z98.enum([
  "newsletter",
  "reminder",
  "call_to_action"
]);

// src/outreach/OutreachEmail.schema.ts
import { z as z102 } from "zod";

// src/outreach/EmailContent.schema.ts
import { z as z101 } from "zod";

// src/outreach/EmailBlock.schema.ts
import { z as z99 } from "zod";

// src/outreach/EmailLimits.const.ts
var EMAIL_SUBJECT_MAX_LENGTH = 150;
var EMAIL_URL_MAX_LENGTH = 2e3;

// src/outreach/EmailBlock.schema.ts
var EMAIL_PREVIEW_TEXT_MAX_LENGTH = 140;
var EMAIL_HEADING_MAX_LENGTH = 120;
var EMAIL_PARAGRAPH_MAX_LENGTH = 2e3;
var EMAIL_IMAGE_ALT_MAX_LENGTH = 150;
var EMAIL_BLOCK_BUTTON_LABEL_MAX_LENGTH = 40;
var EMAIL_MAX_BLOCKS = 30;
var EMAIL_CONTENT_TEXT_MAX_LENGTH = 15e3;
var EMAIL_MERGE_TAGS = ["{{first_name}}", "{{last_name}}"];
var MERGE_TAG_HINT = "Only {{first_name}} and {{last_name}} can be merged, written exactly like that";
var MERGE_TAG_NOTE = " To greet each reader by name, write {{first_name}} or {{last_name}} exactly like that; no other {{tags}} work.";
var hasOnlyKnownMergeTags = (value) => {
  const rest = EMAIL_MERGE_TAGS.reduce(
    (text2, tag) => text2.replaceAll(tag, ""),
    value
  );
  return !rest.includes("{{") && !rest.includes("}}");
};
var HTML_TAG_PATTERN = /<\/?[a-z][a-z0-9-]*(\s[^<>]*)?\/?>|<!--/i;
var text = (mode, max, multiline, allowEmpty = false) => {
  const base = z99.string().trim().max(max).refine(hasOnlyKnownMergeTags, MERGE_TAG_HINT).refine(
    (value) => !HTML_TAG_PATTERN.test(value),
    "Plain text only, without HTML tags"
  ).refine(
    (value) => multiline || !/[\r\n\u2028\u2029]/.test(value),
    "Keep this to one line"
  );
  return mode === "final" && !allowEmpty ? base.min(1, "This can\u2019t be empty") : base;
};
var isHttpsUrl = (value) => {
  try {
    return new URL(value).protocol === "https:";
  } catch {
    return false;
  }
};
var url = (mode) => z99.string().trim().max(EMAIL_URL_MAX_LENGTH).refine(
  (value) => mode === "draft" && value === "" || isHttpsUrl(value),
  "Links must start with https://"
);
var blockSchemas = (mode) => {
  const heading = z99.object({
    type: z99.literal("heading"),
    text: text(mode, EMAIL_HEADING_MAX_LENGTH, false).describe(
      "The heading, one line, plain text. Short and specific, like a newspaper headline." + MERGE_TAG_NOTE
    ),
    level: z99.union([z99.literal(1), z99.literal(2)]).describe(
      "1 for the main headline at the top of the email, 2 for a smaller heading further down."
    )
  }).strict().describe("A headline. Level 1 is the big one at the top.");
  const paragraph = z99.object({
    type: z99.literal("paragraph"),
    text: text(mode, EMAIL_PARAGRAPH_MAX_LENGTH, true).describe(
      "Plain text. A single line break starts a new line and a blank line starts a new paragraph. No HTML, no markdown (no **, #, or [links]); put a link in a button." + MERGE_TAG_NOTE
    )
  }).strict().describe("Body text. Write the way you would talk to a neighbor.");
  const image = z99.object({
    type: z99.literal("image"),
    url: url(mode).describe(
      "An https link to an image the sender uploaded. Never invent or guess an image URL; leave the image out if none was provided."
    ),
    alt: text(mode, EMAIL_IMAGE_ALT_MAX_LENGTH, false, true).default("").describe(
      "Optional. Leave it out unless the sender gave a description. Never invent one."
    )
  }).strict().describe("A full-width photo.");
  const button = z99.object({
    type: z99.literal("button"),
    label: text(mode, EMAIL_BLOCK_BUTTON_LABEL_MAX_LENGTH, false).describe(
      'What happens when they tap it, as a verb and an object: "RSVP for the town hall", "Take the survey". Never "Click here" or "Submit".'
    ),
    url: url(mode).describe(
      "The https link the button opens. Use only a link the sender gave you."
    )
  }).strict().describe(
    "A button that opens a link. Use one per email, for the main ask."
  );
  const divider = z99.object({ type: z99.literal("divider") }).strict().describe("A thin line between parts of a long email.");
  return z99.discriminatedUnion("type", [heading, paragraph, image, button, divider]).describe("One block of the email. `type` decides which fields it takes.");
};
var EmailBlockSchema = blockSchemas("final");
var EmailBlockDraftSchema = blockSchemas("draft");
var EMAIL_BLOCK_TYPES = [
  "heading",
  "paragraph",
  "image",
  "button",
  "divider"
];
var emailSubjectSchema = (mode) => text(mode, EMAIL_SUBJECT_MAX_LENGTH, false).describe(
  "The subject line. Under about 60 characters reads best on a phone. Specific, not salesy; no ALL CAPS or emoji strings." + MERGE_TAG_NOTE
);
var emailPreviewTextSchema = (mode) => text(mode, EMAIL_PREVIEW_TEXT_MAX_LENGTH, false).describe(
  "Optional. The gray line inbox apps show after the subject. One sentence that adds to the subject instead of repeating it."
);
var emailBlockTextLength = (block) => {
  switch (block.type) {
    case "heading":
    case "paragraph":
      return block.text.length;
    case "image":
      return block.alt.length;
    case "button":
      return block.label.length;
    case "divider":
      return 0;
  }
};

// src/outreach/EmailLayoutPreset.const.ts
import { z as z100 } from "zod";
var EMAIL_LAYOUT_PRESETS = {
  short_cta: {
    label: "Short",
    description: "A photo, a headline and a few lines.",
    defaultTheme: "bold_red",
    usualBlocks: ["image", "heading", "paragraph", "button"],
    guidance: [
      "Optional photo, and if there is one it comes first.",
      "Exactly one level 1 heading, right after the photo (or first).",
      "1 or 2 paragraphs, 600 characters at most between them.",
      "Exactly one button, and it is the last block."
    ],
    starterBlocks: [
      { type: "image", url: "", alt: "" },
      { type: "heading", text: "", level: 1 },
      { type: "paragraph", text: "" },
      { type: "button", label: "", url: "" }
    ]
  },
  long_update: {
    label: "Long update",
    description: "A longer read: a headline, then several paragraphs broken up with subheadings.",
    defaultTheme: "classic_blue",
    usualBlocks: ["heading", "paragraph", "image", "button", "divider"],
    guidance: [
      "Starts with a level 1 heading (the masthead).",
      "Mostly paragraphs, at least 2. Break up the text with level 2 subheadings and dividers.",
      "Any heading after the masthead is level 2.",
      "At most one photo, and only right after the masthead.",
      "At most one button.",
      'End with a closing paragraph, such as "Thank you," then your name.'
    ],
    starterBlocks: [
      { type: "heading", text: "", level: 1 },
      { type: "paragraph", text: "" },
      { type: "heading", text: "", level: 2 },
      { type: "paragraph", text: "" }
    ]
  },
  personal_letter: {
    label: "Personal letter",
    description: "A plain note from you, in paragraphs, with an optional photo.",
    defaultTheme: "cream_and_forest",
    usualBlocks: ["paragraph", "image", "button"],
    guidance: [
      "Mostly paragraphs. No headings or dividers.",
      "At most one photo, as the very first or the very last block, never in the middle.",
      "The first block after any photo is a paragraph.",
      'Sign off in the last paragraph, such as "Thank you," then your name and office.',
      "At most one button, drawn as a quiet link."
    ],
    starterBlocks: [
      { type: "paragraph", text: "" },
      { type: "paragraph", text: "" },
      { type: "paragraph", text: "" }
    ]
  }
};
var EmailLayoutPresetKeySchema = z100.enum(["short_cta", "long_update", "personal_letter"]).describe(
  Object.keys(EMAIL_LAYOUT_PRESETS).map(
    (key) => `${key}: ${EMAIL_LAYOUT_PRESETS[key].description} Usually: ${EMAIL_LAYOUT_PRESETS[key].usualBlocks.join(", ")}. ${EMAIL_LAYOUT_PRESETS[key].guidance.join(" ")}`
  ).join("\n")
);
var countOf = (blocks, type) => blocks.filter((block) => block.type === type).length;
var checkEmailBlocks = (blocks) => {
  const issues = [];
  if (countOf(blocks, "image") > 1) {
    issues.push({ message: "Use at most one photo", incomplete: false });
  }
  if (countOf(blocks, "button") > 1) {
    issues.push({ message: "Use at most one button", incomplete: false });
  }
  if (countOf(blocks, "paragraph") === 0) {
    issues.push({ message: "Add a paragraph", incomplete: true });
  }
  return issues;
};

// src/outreach/EmailContent.schema.ts
var checkContent = (mode) => (data, ctx) => {
  const textLength = data.subject.length + (data.previewText?.length ?? 0) + data.blocks.reduce((sum, block) => sum + emailBlockTextLength(block), 0);
  if (textLength > EMAIL_CONTENT_TEXT_MAX_LENGTH) {
    ctx.addIssue({
      code: "custom",
      path: ["blocks"],
      message: `Keep the whole email under ${EMAIL_CONTENT_TEXT_MAX_LENGTH.toLocaleString("en-US")} characters`
    });
  }
  for (const issue of checkEmailBlocks(data.blocks)) {
    if (mode === "draft" && issue.incomplete) continue;
    ctx.addIssue({ code: "custom", path: ["blocks"], message: issue.message });
  }
};
var blocksDescription = `The email body, top to bottom. 1 to ${EMAIL_MAX_BLOCKS} blocks, with at least one paragraph, at most one image and at most one button. Shape them the way the layout usually looks. Don't add a footer, unsubscribe link, address or "paid for by" line: the system adds those to every email.`;
var EmailContentSchema = z101.object({
  layout: EmailLayoutPresetKeySchema,
  theme: EmailThemeKeySchema.describe(
    "The color theme. Any theme works with any layout."
  ),
  subject: emailSubjectSchema("final"),
  previewText: emailPreviewTextSchema("final").optional(),
  blocks: z101.array(EmailBlockSchema).min(1).max(EMAIL_MAX_BLOCKS).describe(blocksDescription)
}).strict().superRefine(checkContent("final")).describe(
  "An outreach email: a layout, a color theme, a subject and an ordered list of content blocks."
);
var EmailContentDraftSchema = z101.object({
  layout: EmailLayoutPresetKeySchema,
  theme: EmailThemeKeySchema,
  subject: emailSubjectSchema("draft"),
  previewText: emailPreviewTextSchema("draft").optional(),
  blocks: z101.array(EmailBlockDraftSchema).max(EMAIL_MAX_BLOCKS)
}).strict().superRefine(checkContent("draft"));

// src/outreach/OutreachEmail.schema.ts
var EMAIL_HEADLINE_MAX_LENGTH = 150;
var EMAIL_BODY_MAX_LENGTH = 1e4;
var EMAIL_GOAL_MAX_LENGTH = 500;
var EMAIL_BUTTON_LABEL_MAX_LENGTH = 40;
var EMAIL_SEND_WINDOW_DAYS = 30;
var HttpsUrlSchema = z102.string().max(EMAIL_URL_MAX_LENGTH).url().refine((url2) => url2.startsWith("https://"), "Links must start with https://");
var draftSaveCommon = {
  id: z102.number().int().positive().optional(),
  goal: z102.string().trim().min(1).max(EMAIL_GOAL_MAX_LENGTH),
  date: z102.string().datetime({ offset: true }).optional(),
  // The saved voter-file list the send goes to. Only its people with an
  // email address are counted and sent to.
  voterFileFilterId: z102.number().int().positive().optional(),
  // Ignored: consent is affirmed at the contact import. Still accepted so a
  // client from before that change can save.
  consentConfirmed: z102.boolean().optional()
};
var EmailDraftSaveContentSchema = z102.object({ ...draftSaveCommon, content: EmailContentDraftSchema }).strict();
var EmailDraftSaveFieldsSchema = z102.object({
  ...draftSaveCommon,
  layout: EmailLayoutKeySchema,
  theme: EmailThemeKeySchema,
  subject: z102.string().trim().min(1).max(EMAIL_SUBJECT_MAX_LENGTH),
  headline: z102.string().trim().min(1).max(EMAIL_HEADLINE_MAX_LENGTH).optional(),
  body: z102.string().trim().min(1).max(EMAIL_BODY_MAX_LENGTH),
  imageUrl: HttpsUrlSchema.optional(),
  buttonLabel: z102.string().trim().min(1).max(EMAIL_BUTTON_LABEL_MAX_LENGTH).optional(),
  buttonUrl: HttpsUrlSchema.optional()
}).strict().superRefine((data, ctx) => {
  const hasLabel = data.buttonLabel !== void 0;
  const hasUrl = data.buttonUrl !== void 0;
  if (EMAIL_LAYOUTS[data.layout].requiresButton && !(hasLabel && hasUrl)) {
    ctx.addIssue({
      path: ["buttonLabel"],
      code: "custom",
      message: "This layout needs a button label and link"
    });
    return;
  }
  if (hasLabel !== hasUrl) {
    ctx.addIssue({
      path: [hasLabel ? "buttonUrl" : "buttonLabel"],
      code: "custom",
      message: "A button needs both a label and a link"
    });
  }
});
var EmailDraftSaveSchema = z102.union([
  EmailDraftSaveContentSchema,
  EmailDraftSaveFieldsSchema
]);
var EmailPreviewFieldsRequestSchema = z102.object({
  layout: EmailLayoutKeySchema,
  theme: EmailThemeKeySchema,
  subject: z102.string().max(EMAIL_SUBJECT_MAX_LENGTH),
  headline: z102.string().max(EMAIL_HEADLINE_MAX_LENGTH).optional(),
  body: z102.string().max(EMAIL_BODY_MAX_LENGTH),
  imageUrl: HttpsUrlSchema.optional(),
  buttonLabel: z102.string().max(EMAIL_BUTTON_LABEL_MAX_LENGTH).optional(),
  buttonUrl: HttpsUrlSchema.optional()
}).strict();
var EmailPreviewRequestSchema = z102.union([
  z102.object({ content: EmailContentDraftSchema }).strict(),
  EmailPreviewFieldsRequestSchema
]);
var EmailPreviewResponseSchema = z102.object({ html: z102.string() });
var EmailSenderSchema = z102.object({
  localPart: z102.string(),
  address: z102.string(),
  displayName: z102.string(),
  forwardToEmail: z102.string(),
  pendingForwardToEmail: z102.string().nullable(),
  warmingStep: z102.number().int().nonnegative()
});
var EmailSenderUpdateSchema = z102.object({ forwardToEmail: z102.string().trim().max(254).email() }).strict();
var EmailBlockViewSchema = z102.discriminatedUnion("type", [
  z102.object({
    type: z102.literal("heading"),
    text: z102.string(),
    level: z102.union([z102.literal(1), z102.literal(2)])
  }),
  z102.object({ type: z102.literal("paragraph"), text: z102.string() }),
  z102.object({ type: z102.literal("image"), url: z102.string(), alt: z102.string() }),
  z102.object({ type: z102.literal("button"), label: z102.string(), url: z102.string() }),
  z102.object({ type: z102.literal("divider") })
]);
var EmailContentViewSchema = z102.object({
  layout: EmailLayoutPresetKeySchema,
  theme: EmailThemeKeySchema,
  subject: z102.string(),
  previewText: z102.string().optional(),
  blocks: z102.array(EmailBlockViewSchema)
});
var EmailDraftSchema = z102.object({
  id: z102.number().int().positive(),
  status: z102.string(),
  goal: z102.string(),
  layout: z102.string(),
  theme: z102.string(),
  subject: z102.string(),
  headline: z102.string().nullable(),
  body: z102.string(),
  imageUrl: z102.string().nullable(),
  buttonLabel: z102.string().nullable(),
  buttonUrl: z102.string().nullable(),
  paidForBy: z102.string().nullable(),
  date: z102.string().nullable(),
  voterFileFilterId: z102.number().int().positive().nullable(),
  // Recipient rows on the send. Written at prepare, so 0 until it runs.
  recipientCount: z102.number().int().nonnegative(),
  // The email as blocks. A draft saved with the fixed fields above is
  // mapped to blocks here; for a block draft those fields are left empty.
  content: EmailContentViewSchema
});
var EmailSendSchema = EmailDraftSchema.extend({
  // Frozen at confirm: how many of the recipients this send can reach.
  recipientCap: z102.number().int().nonnegative().nullable(),
  sentCount: z102.number().int().nonnegative(),
  pauseReason: z102.string().nullable(),
  stopping: z102.boolean(),
  // What confirming now would freeze and hold, shown on the review step.
  // Null once the send has left draft, or while it has no audience.
  estimate: z102.object({
    // People in the audience with an email address, counted server-side.
    audienceCount: z102.number().int().nonnegative(),
    warmingCap: z102.number().int().nonnegative(),
    recipientCap: z102.number().int().nonnegative(),
    priceCents: z102.number().int().nonnegative()
  }).nullable()
});
var EmailConfirmRequestSchema = z102.object({ paymentMethodId: z102.string().trim().min(1).max(255) }).strict();
var EmailConfirmResponseSchema = z102.object({
  outcome: z102.enum(["held", "scheduled"]),
  email: EmailSendSchema
});
var EmailConfirmDeclinedSchema = z102.object({
  message: z102.string(),
  // Stripe's decline_code, else its code, else the intent status
  // (requires_action for a card that needs 3-D Secure).
  declineCode: z102.string().nullable()
});
var EMAIL_IMAGE_MAX_BYTES = 1e6;
var EMAIL_IMAGE_ALLOWED_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif"
];
var EmailAiDraftFieldsSchema = z102.object({
  subject: z102.string().trim().min(1).max(EMAIL_SUBJECT_MAX_LENGTH),
  headline: z102.string().trim().min(1).max(EMAIL_HEADLINE_MAX_LENGTH).nullable(),
  body: z102.string().trim().min(1).max(EMAIL_BODY_MAX_LENGTH),
  buttonLabel: z102.string().trim().min(1).max(EMAIL_BUTTON_LABEL_MAX_LENGTH).nullable()
});
var EmailAiDraftRequestSchema = z102.object({
  goal: z102.string().trim().min(1).max(EMAIL_GOAL_MAX_LENGTH),
  tone: SocialToneSchema,
  // A layout preset gets its draft as blocks in `content`; an old layout
  // key is mapped to its preset.
  layout: z102.union([EmailLayoutPresetKeySchema, EmailLayoutKeySchema]),
  // The theme `content` carries. Defaults to the preset's own.
  theme: EmailThemeKeySchema.optional(),
  currentDraft: EmailAiDraftFieldsSchema.optional()
}).strict();
var EmailAiDraftResponseSchema = EmailAiDraftFieldsSchema.extend({
  content: EmailContentViewSchema
});
var EmailImagePresignRequestSchema = z102.object({ contentType: z102.enum(EMAIL_IMAGE_ALLOWED_MIME_TYPES) }).strict();
var EmailImagePresignResponseSchema = z102.object({
  url: z102.string(),
  fields: z102.record(z102.string(), z102.string()),
  publicUrl: z102.string(),
  expiresIn: z102.number().int().positive()
});
var EmailTestSendResponseSchema = z102.object({ sentTo: z102.string() });
var EmailPausedSendSchema = z102.object({
  outreachId: z102.number().int(),
  organizationSlug: z102.string(),
  senderName: z102.string(),
  subject: z102.string(),
  pauseReason: OutreachEmailPauseReasonSchema,
  pausedAt: z102.string(),
  resumedAt: z102.string().nullable(),
  sentCount: z102.number().int().nonnegative(),
  recipientCap: z102.number().int().nonnegative().nullable(),
  metrics: z102.object({
    send: z102.number().nonnegative(),
    bounce: z102.number().nonnegative(),
    complaint: z102.number().nonnegative(),
    bounceRate: z102.number().nonnegative(),
    complaintRate: z102.number().nonnegative()
  }).nullable()
});
var EmailPausedSendsResponseSchema = z102.object({
  items: z102.array(EmailPausedSendSchema)
});

// src/outreach/EmailPublic.schema.ts
import { z as z103 } from "zod";
var EmailPublicModeSchema = z103.enum(["win", "serve"]);
var EmailTokenRequestSchema = z103.object({ token: z103.string().min(1) });
var EmailUnsubscribeStateSchema = z103.object({
  senderName: z103.string(),
  mode: EmailPublicModeSchema,
  unsubscribed: z103.boolean()
});
var EmailForwardConfirmStateSchema = z103.object({
  senderName: z103.string(),
  forwardToEmail: z103.string()
});

// src/outreach/EmailContent.examples.ts
var EMAIL_SAMPLE_IMAGE_URLS = {
  hills: "https://app.goodparty.org/images/email-samples/hills.jpg",
  street: "https://app.goodparty.org/images/email-samples/street.jpg"
};
var EMAIL_CONTENT_EXAMPLES = {
  short_cta: {
    win: {
      layout: "short_cta",
      theme: "bold_red",
      subject: "Knock doors with me this Saturday?",
      previewText: "Two hours, one neighborhood, and coffee on me.",
      blocks: [
        {
          type: "image",
          url: EMAIL_SAMPLE_IMAGE_URLS.street,
          alt: "Volunteers with clipboards on a sidewalk in Maple Heights"
        },
        { type: "heading", text: "Help me meet Maple Heights", level: 1 },
        {
          type: "paragraph",
          text: "Hi {{first_name}},\n\nThe election is four weeks out, and the best way to win is talking with voters face to face. Join me for two hours of door knocking. No experience needed. We\u2019ll pair you with someone who has done it before."
        },
        {
          type: "paragraph",
          text: "Saturday, October 10, 10am to noon, at the Maple Heights Library, 210 Oak Street. Bring comfortable shoes and your phone."
        },
        {
          type: "button",
          label: "Save my spot",
          url: "https://example.org/jordan-ellis/canvass"
        }
      ]
    },
    serve: {
      layout: "short_cta",
      theme: "classic_blue",
      subject: "Town hall on the Elm Street repaving",
      previewText: "Tell us what the construction schedule should work around.",
      blocks: [
        {
          type: "image",
          url: EMAIL_SAMPLE_IMAGE_URLS.street,
          alt: "Elm Street at the corner of Second Avenue"
        },
        { type: "heading", text: "Elm Street is getting repaved", level: 1 },
        {
          type: "paragraph",
          text: "Hi {{first_name}}, work starts in the spring. Before we set the schedule, I want to hear from the people who live and work on Elm. Come tell me what the crews should plan around."
        },
        {
          type: "paragraph",
          text: "Tuesday, November 3, at 6:30pm in Room 2 at Riverton City Hall."
        },
        {
          type: "button",
          label: "RSVP for the town hall",
          url: "https://example.org/riverton/elm-street-town-hall"
        }
      ]
    }
  },
  long_update: {
    win: {
      layout: "long_update",
      theme: "fresh_green",
      subject: "What 1,200 conversations taught me",
      previewText: "What I heard at the doors this month, and what I\u2019ll do about it.",
      blocks: [
        { type: "heading", text: "What I heard at your doors", level: 1 },
        {
          type: "image",
          url: EMAIL_SAMPLE_IMAGE_URLS.hills,
          alt: "A volunteer talking with a resident on a front porch"
        },
        {
          type: "paragraph",
          text: "Hi {{first_name}},\n\nThis month our volunteers and I knocked on 1,200 doors east of the river. I want to tell you what voters told us, because it changed what this campaign will focus on for the next four weeks."
        },
        {
          type: "paragraph",
          text: "I expected to hear about property taxes. Some people did bring them up. But the thing almost everyone mentioned first was their water bill. One retired teacher on Birch Street showed me three months of bills that had gone up by a third, with no letter from the utility explaining why."
        },
        { type: "heading", text: "Why water bills keep going up", level: 2 },
        {
          type: "paragraph",
          text: "The city council approved two rate increases in the last eighteen months. Both passed on the consent agenda, without public discussion. The utility says the money pays for pipe repairs, but it hasn\u2019t published which repairs, where, or what they cost.\n\nI don\u2019t think that\u2019s good enough. If we\u2019re paying more, we deserve to see where the money goes."
        },
        { type: "heading", text: "What I\u2019ll do on the council", level: 2 },
        {
          type: "paragraph",
          text: "First, I\u2019ll ask for an independent audit of the last two rate increases and put the results online. Second, I\u2019ll move every future rate change off the consent agenda so it gets a real public hearing. Third, I\u2019ll push for a simple monthly report showing which pipes were fixed and what each repair cost."
        },
        { type: "divider" },
        {
          type: "paragraph",
          text: "Early voting starts October 26. If you have a question about any of this, just reply. I read every email myself."
        },
        {
          type: "paragraph",
          text: "The candidate forum is Tuesday, October 20, at 7pm at Central High."
        },
        {
          type: "button",
          label: "Read my full water plan",
          url: "https://example.org/jordan-ellis/water-plan"
        },
        {
          type: "paragraph",
          text: "Thank you,\nJordan Ellis\nCandidate for City Council, Ward 3"
        }
      ]
    },
    serve: {
      layout: "long_update",
      theme: "classic_blue",
      subject: "Your October update from Ward 2",
      previewText: "Crosswalks, the library budget and a change to recycling day.",
      blocks: [
        { type: "heading", text: "Your October update from Ward 2", level: 1 },
        {
          type: "paragraph",
          text: "Hi {{first_name}},\n\nA lot moved forward this month on the issues you\u2019ve raised with me. Here\u2019s where things stand, what I voted for and why, and what\u2019s coming up next."
        },
        { type: "heading", text: "A safer crossing at Pine and 5th", level: 2 },
        {
          type: "paragraph",
          text: "After more than 40 of you wrote in about near misses outside Lincoln Elementary, I asked the traffic engineer to study the intersection. The study found that most drivers were going well over the school-zone limit at drop-off time.\n\nOn October 14 the council approved a raised crosswalk and two new flashing signs. Construction starts next week and should finish before winter break."
        },
        {
          type: "heading",
          text: "The library keeps its Sunday hours",
          level: 2
        },
        {
          type: "paragraph",
          text: "The first draft of next year\u2019s budget closed the main library on Sundays to save about $40,000. I voted against that line. Sunday is the only day many working parents can bring their kids, and the library is the only free place in the ward with reliable internet.\n\nThe final budget keeps the library open seven days a week. The savings will come from delaying a vehicle purchase instead."
        },
        { type: "divider" },
        { type: "heading", text: "Recycling moves to Thursdays", level: 2 },
        {
          type: "paragraph",
          text: "Starting November 5, recycling pickup in Ward 2 moves from Monday to Thursday. Trash day doesn\u2019t change. The city will leave a reminder tag on every bin the week before."
        },
        {
          type: "button",
          label: "Tell me what to work on next",
          url: "https://example.org/riverton/ward-2-survey"
        },
        {
          type: "paragraph",
          text: "Thank you,\nDana Whitfield\nCity Council Member, Ward 2"
        }
      ]
    }
  },
  personal_letter: {
    win: {
      layout: "personal_letter",
      theme: "cream_and_forest",
      subject: "Why I\u2019m running",
      blocks: [
        {
          type: "image",
          url: EMAIL_SAMPLE_IMAGE_URLS.hills,
          alt: "Sam Ortega with his Little League team on the field"
        },
        {
          type: "paragraph",
          text: "Dear {{first_name}},\n\nI\u2019ve coached Little League in this town for eleven years. Last spring our field flooded for the third season in a row, and nobody at the county could tell me who was responsible for fixing the drain."
        },
        {
          type: "paragraph",
          text: "That\u2019s when I decided to run for County Commission. I\u2019m not backed by a party or big donors. I\u2019m backed by neighbors who want a county that answers the phone.\n\nIf you have a question for me, just reply to this email. I read every one."
        },
        {
          type: "button",
          label: "See where I stand",
          url: "https://example.org/sam-ortega/issues"
        },
        {
          type: "paragraph",
          text: "Thank you,\nSam Ortega\nIndependent candidate for County Commission"
        }
      ]
    },
    serve: {
      layout: "personal_letter",
      theme: "fresh_green",
      subject: "About Tuesday\u2019s vote on the park fee",
      blocks: [
        {
          type: "paragraph",
          text: "Dear {{first_name}},\n\nOn Tuesday the board voted 4 to 1 to add a $2 parking fee at Lakeside Park on weekends. I was the one no vote, and I want you to hear why from me."
        },
        {
          type: "paragraph",
          text: "The fee covers about a third of the park\u2019s repair backlog. I agree the repairs can\u2019t wait. But families who use the park most told me $2 every weekend adds up, and I think we can close the gap with the state grant we applied for in August.\n\nThe fee is up for review in six months. Before then, I\u2019d like to know what you think."
        },
        {
          type: "paragraph",
          text: "The fee starts Saturday, November 7, and the board will review it at the May meeting."
        },
        {
          type: "paragraph",
          text: "Thank you,\nPriya Natarajan\nTownship Trustee"
        }
      ]
    }
  }
};

// src/outreach/MergeTag.const.ts
var MERGE_TAGS = [
  {
    id: "first_name",
    label: "First name",
    // Shown wherever a message is previewed as the recipient reads it.
    sample: "Sam",
    token: {
      peerly: "{first_name}",
      serve: "{{first_name}}",
      email: "{{first_name}}"
    }
  }
];
var mergeTagToken = (id, channel) => {
  const tag = MERGE_TAGS.find((candidate) => candidate.id === id);
  if (!tag) throw new Error(`Unknown merge tag: ${id}`);
  return tag.token[channel];
};

// src/outreach/SampleSizing.const.ts
var SAMPLE_TARGET_REPLIES = 83;
var DEFAULT_TEXT_REPLY_RATE = 0.03;
var HIGH_CONFIDENCE_MIN_REPLIES = 75;
var HIGH_CONFIDENCE_MIN_SHARE = 0.1;
var PRICE_PER_TEXT_TENTH_CENTS = 35;
var PRICE_PER_TEXT = PRICE_PER_TEXT_TENTH_CENTS / 1e3;
var PRICE_PER_EMAIL_TENTH_CENTS = 10;
var EMAIL_MIN_CHARGE_CENTS = 50;
var recommendedSampleSize = (params) => {
  const usable = Math.min(params.audience, MAX_LIST_SAMPLE_SIZE);
  const needed = (SAMPLE_TARGET_REPLIES - (params.repliesAlready ?? 0)) / (params.replyRate ?? DEFAULT_TEXT_REPLY_RATE);
  return Math.max(0, Math.ceil(Math.min(needed, usable)));
};
var isHighConfidence = (params) => params.replies > HIGH_CONFIDENCE_MIN_REPLIES || params.population > 0 && params.replies / params.population >= HIGH_CONFIDENCE_MIN_SHARE;

// src/outreach/OutreachGoneOut.ts
var outreachHasGoneOut = (send, today) => send.status === "completed" || send.status === "in_progress" && (send.scheduledFor === null || send.scheduledFor <= today);

// src/outreach/OutreachAssignment.schema.ts
import { z as z104 } from "zod";
var OutreachAssigneeSchema = z104.object({
  userId: z104.number(),
  name: z104.string().nullable(),
  role: OrganizationRoleSchema,
  createdAt: zCoerceDate(),
  assignedByUserId: z104.number().nullable(),
  assignedByName: z104.string().nullable(),
  // Per-assignee logged-interaction count on this outreach: a real count for
  // the two native channels (nativePhoneBanking/nativeDoorKnocking), null for
  // every other outreachType (no interaction table to count against).
  loggedCount: z104.number().int().nullable()
});
var OutreachAssigneesResponseSchema = z104.object({
  assignees: z104.array(OutreachAssigneeSchema)
});
var MyAssignmentSchema = z104.object({
  outreachId: z104.number(),
  outreachType: OutreachTypeSchema,
  name: z104.string().nullable(),
  status: OutreachStatusSchema.nullable(),
  assignedAt: zCoerceDate(),
  phoneBanking: PhoneBankingOutreachDetailSchema.optional(),
  doorKnocking: DoorKnockingOutreachDetailSchema.optional()
});
var MyAssignmentsResponseSchema = z104.object({
  assignments: z104.array(MyAssignmentSchema)
});

// src/outreach/PhoneBankingScript.schema.ts
import { z as z105 } from "zod";
var PhoneBankingScriptPurposeSchema = PhoneBankingPurposeSchema2;
var PHONE_BANKING_SCRIPT_MAX_LENGTH = 2e3;
var PHONE_BANKING_INSTRUCTIONS_MAX_LENGTH = 500;
var communityInputQuestionSchema2 = z105.string().trim().max(COMMUNITY_INPUT_QUESTION_MAX_LENGTH).transform((v) => v.length === 0 ? void 0 : v).optional();
var questionOnlyWhereAsked = {
  check: (v) => v.communityInputQuestion === void 0 || v.purpose === COMMUNITY_INPUT_PURPOSE,
  params: {
    message: "communityInputQuestion is only valid with the community_input purpose",
    path: ["communityInputQuestion"]
  }
};
var PhoneBankingScriptDraftRequestSchema = z105.object({
  purpose: PhoneBankingScriptPurposeSchema,
  tone: SocialToneSchema,
  currentDraft: z105.string().min(1).max(PHONE_BANKING_SCRIPT_MAX_LENGTH).optional(),
  previousDraft: z105.string().max(PHONE_BANKING_SCRIPT_MAX_LENGTH).optional(),
  // Whitespace-only is treated as absent, not a violation — a trim-then-
  // min(1) without this transform 400s on '   ' even though the field is
  // optional, since the client has no way to distinguish "blank" from a
  // real schema violation.
  instructions: z105.string().trim().max(PHONE_BANKING_INSTRUCTIONS_MAX_LENGTH).transform((v) => v.length === 0 ? void 0 : v).optional(),
  communityInputQuestion: communityInputQuestionSchema2,
  event: OutreachEventDetailsSchema.optional()
}).refine(
  (v) => v.currentDraft === void 0 || v.previousDraft === void 0,
  {
    message: "currentDraft and previousDraft are mutually exclusive",
    path: ["previousDraft"]
  }
).refine(questionOnlyWhereAsked.check, questionOnlyWhereAsked.params);
var ServePhoneBankingScriptDraftRequestSchema = z105.object({
  purpose: ServePhoneBankingPurposeSchema,
  tone: SocialToneSchema,
  currentDraft: z105.string().min(1).max(PHONE_BANKING_SCRIPT_MAX_LENGTH).optional(),
  previousDraft: z105.string().max(PHONE_BANKING_SCRIPT_MAX_LENGTH).optional(),
  instructions: z105.string().trim().max(PHONE_BANKING_INSTRUCTIONS_MAX_LENGTH).transform((v) => v.length === 0 ? void 0 : v).optional(),
  communityInputQuestion: communityInputQuestionSchema2,
  event: OutreachEventDetailsSchema.optional()
}).refine(
  (v) => v.currentDraft === void 0 || v.previousDraft === void 0,
  {
    message: "currentDraft and previousDraft are mutually exclusive",
    path: ["previousDraft"]
  }
).refine(questionOnlyWhereAsked.check, questionOnlyWhereAsked.params);
var PhoneBankingScriptDraftResponseSchema = z105.object({
  draft: z105.string().min(1).max(PHONE_BANKING_SCRIPT_MAX_LENGTH)
});

// src/outreach/RobocallScript.schema.ts
import { z as z106 } from "zod";
var ROBOCALL_PURPOSE_VALUES = BROADCAST_OUTREACH_PURPOSE_VALUES;
var RobocallPurposeSchema = z106.enum(ROBOCALL_PURPOSE_VALUES);
var RobocallScriptDraftRequestSchema = z106.object({
  purpose: RobocallPurposeSchema,
  tone: SocialToneSchema,
  // On Improve, the whole script, disclosure line included: gp-api hides the
  // parts deriveRobocallProtectedParts locks from the model and restores them.
  currentDraft: z106.string().min(1).max(ROBOCALL_SCRIPT_MAX_LENGTH).optional(),
  // The campaign-local day the call is set to go out, once one is picked:
  // an election-day reminder only says "today" or "tomorrow" when this day
  // is election day or the day before.
  scheduledLocalDate: z106.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional()
});
var RobocallScriptDraftResponseSchema = z106.object({
  draft: z106.string().min(1).max(ROBOCALL_SCRIPT_MAX_LENGTH)
});

// src/outreach/RobocallProtectedParts.ts
var formatRobocallCallbackNumber = (raw) => {
  const digits = raw.replace(/\D/g, "");
  const local = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  return local.length === 10 ? `${local.slice(0, 3)}-${local.slice(3, 6)}-${local.slice(6)}` : raw;
};
var robocallDisclosureLine = (sponsor, callbackNumber) => `Paid for by ${sponsor}, ${formatRobocallCallbackNumber(callbackNumber)}.`;
var escapeRegExp = (text2) => text2.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
var findWords = (script, words) => new RegExp(
  `(?<![\\p{L}\\p{N}])${escapeRegExp(words)}(?![\\p{L}\\p{N}])`,
  "iu"
).exec(script);
var deriveRobocallProtectedParts = (script, context = {}) => {
  const parts = [];
  const phrases = [...script.matchAll(/paid\s+for\s+by/gi)];
  const last = phrases[phrases.length - 1];
  let disclosure = null;
  if (last) {
    const start = last.index ?? 0;
    const line = /^[^\n]*/.exec(script.slice(start))?.[0] ?? "";
    disclosure = { start, text: line.trimEnd() };
  }
  const outside = disclosure ? script.slice(0, disclosure.start) + " ".repeat(disclosure.text.length) + script.slice(disclosure.start + disclosure.text.length) : script;
  const names = (context.candidateNames ?? []).map((name) => name.trim()).filter(Boolean);
  const words = names.flatMap((name) => name.split(/\s+/)).filter((word) => word.length >= 3);
  const found = names.map((name) => findWords(outside, name)).find(Boolean) ?? words.map((word) => findWords(outside, word)).find(Boolean);
  if (found) {
    parts.push({
      rule: "candidate_name",
      kind: "phrase",
      text: found[0],
      start: found.index
    });
  }
  if (disclosure) {
    parts.push({ rule: "disclosure", kind: "phrase", ...disclosure });
  }
  return parts;
};

// src/outreach/RobocallNumber.schema.ts
import { z as z107 } from "zod";
var RobocallNumberResponseSchema = z107.object({
  phoneNumber: z107.string(),
  region: z107.string().nullish()
});

// src/outreach/PaymentHoldCard.schema.ts
import { z as z108 } from "zod";
var PaymentHoldCardIntentResponseSchema = z108.object({
  clientSecret: z108.string()
});
var PaymentHoldCardRequestSchema = z108.object({
  paymentMethodId: z108.string().min(1)
});
var PaymentHoldCardResponseSchema = z108.discriminatedUnion("outcome", [
  z108.object({ outcome: z108.literal("held"), captureBefore: z108.string() }),
  z108.object({ outcome: z108.literal("scheduled") }),
  z108.object({
    outcome: z108.literal("declined"),
    declineCode: z108.string().nullable()
  })
]);

// src/outreach/RobocallSaveCard.schema.ts
import { z as z109 } from "zod";
var RobocallSaveCardIntentResponseSchema = z109.object({
  clientSecret: z109.string(),
  customerId: z109.string()
});

// src/outreach/RobocallAudio.schema.ts
import { z as z110 } from "zod";
var ROBOCALL_AUDIO_ALLOWED_MIME_TYPES = [
  "audio/webm",
  "audio/mp4",
  "audio/ogg",
  "audio/mpeg",
  "audio/wav",
  "audio/x-wav",
  "audio/x-m4a"
];
var ROBOCALL_AUDIO_MAX_BYTES = 15 * 1024 * 1024;
var RobocallAudioPresignRequestSchema = z110.object({
  contentType: z110.enum(ROBOCALL_AUDIO_ALLOWED_MIME_TYPES)
});
var RobocallAudioPresignResponseSchema = z110.object({
  url: z110.string(),
  fields: z110.record(z110.string(), z110.string()),
  // The object key to persist against the send once upload completes.
  key: z110.string(),
  // Seconds the presigned POST stays valid.
  expiresIn: z110.number().int().positive()
});

// src/outreach/RobocallCompliance.schema.ts
import { z as z111 } from "zod";
var RobocallComplianceRequestSchema = z111.object({
  audioKey: z111.string().min(1),
  contentType: z111.enum(ROBOCALL_AUDIO_ALLOWED_MIME_TYPES)
});
var RobocallComplianceChecksSchema = z111.object({
  // Candidate self-identifies ("this is <name>, running for <office>").
  hasSelfIdentification: z111.boolean(),
  // The organization / committee is named.
  hasOrganization: z111.boolean(),
  // The callback number is spoken.
  hasCallbackNumber: z111.boolean()
});
var RobocallComplianceVerdictSchema = z111.object({
  // True only when every check passes.
  passed: z111.boolean(),
  checks: RobocallComplianceChecksSchema,
  // What the transcription heard, so the candidate can see why a check failed.
  transcript: z111.string(),
  // Human-readable reasons for any failed check (empty when passed).
  issues: z111.array(z111.string())
});

// src/outreach/RobocallFreeOffer.schema.ts
import { z as z112 } from "zod";
var ROBOCALL_FREE_OFFER_VARIANT = "freeOfferElectionEveRobocall";
var ROBOCALL_FREE_OFFER_SEND_DATE = "2026-11-02";
var RobocallFreeOfferResponseSchema = z112.object({
  eligible: z112.boolean(),
  variant: z112.literal(ROBOCALL_FREE_OFFER_VARIANT),
  count: z112.number().int().nonnegative().nullable(),
  coveredCalls: z112.number().int().nonnegative().nullable()
});

// src/outreach/RobocallHold.schema.ts
import { z as z113 } from "zod";
var RobocallAuthorizeRequestSchema = z113.object({
  // The vaulted card the hold is placed on. Confirmed to belong to the paying
  // user's Stripe customer server-side before any charge. Optional only when a
  // promotion code remembered on the draft covers the whole estimate: nothing
  // is held, so no card is needed; a partially covered draft still requires it.
  paymentMethodId: z113.string().min(1).optional()
});
var RobocallAuthorizeStatusSchema = z113.enum([
  "authorized",
  "deferred",
  "hold_failed",
  "noop"
]);
var RobocallAuthorizeResponseSchema = z113.object({
  status: RobocallAuthorizeStatusSchema,
  // The satellite's current settle state after this call, so the client can
  // render the exact lifecycle position without a second read.
  settleState: z113.string(),
  // The frozen estimate the hold was placed for, present only when authorized.
  // A fully covered run authorizes 0 with no hold.
  authorizedAmountInCents: z113.number().int().min(0).nullable(),
  // The promotion discount folded into that amount, present only when a code
  // was consumed by this authorize.
  promoDiscountInCents: z113.number().int().min(0).nullable()
});

// src/outreach/OutreachArchive.schema.ts
import { z as z114 } from "zod";
var OutreachArchiveRequestSchema = z114.object({
  archived: z114.boolean()
});
var OutreachArchiveResponseSchema = z114.object({
  id: z114.number(),
  archivedAt: zCoerceDate().nullable()
});

// src/outreach/OutreachDraft.schema.ts
import { z as z115 } from "zod";
var OUTREACH_DRAFT_TYPES = ["p2p", "robocall"];
var CreateOutreachDraftRequestSchema = z115.object({
  outreachType: z115.enum(OUTREACH_DRAFT_TYPES),
  name: z115.string().trim().min(1).max(120),
  voterFileFilterId: z115.coerce.number().int().positive(),
  script: z115.string().trim().min(1).optional(),
  audioKey: z115.string().min(1).optional(),
  callbackNumber: z115.string().min(1).optional(),
  // The campaign-plan task the flow was opened from. Kept on the draft so
  // the task still closes once a later resume schedules it.
  trackerTaskId: z115.string().min(1).optional()
}).superRefine((data, ctx) => {
  if (data.outreachType === "p2p" && !data.script) {
    ctx.addIssue({
      path: ["script"],
      code: z115.ZodIssueCode.custom,
      message: "script is required for a texting draft"
    });
  }
  if (data.outreachType === "robocall" && (!data.audioKey || !data.callbackNumber)) {
    ctx.addIssue({
      path: ["audioKey"],
      code: z115.ZodIssueCode.custom,
      message: "audioKey and callbackNumber are required for a robocall draft"
    });
  }
});
var OutreachDraftConflictSchema = z115.object({
  existingId: z115.number().int()
});

// src/outreach/OutreachCancel.schema.ts
import { z as z116 } from "zod";
var CancelOutreachResponseSchema = z116.object({
  outreach: OutreachDetailSchema,
  refunded: z116.boolean()
});

// src/outreach/OutreachReceipt.schema.ts
import { z as z117 } from "zod";
var OutreachReceiptSchema = z117.object({
  amount: z117.number(),
  cardBrand: z117.string().nullable(),
  cardLast4: z117.string().nullable(),
  receiptUrl: z117.string().nullable(),
  paidAt: z117.string().nullable()
});

// src/payments/ProReceipt.schema.ts
import { z as z118 } from "zod";
var ProReceiptSchema = z118.object({
  amount: z118.number(),
  cardBrand: z118.string().nullable(),
  cardLast4: z118.string().nullable(),
  receiptUrl: z118.string().nullable(),
  paidAt: z118.string().nullable()
});

// src/outreach/OutreachResults.schema.ts
import { z as z119 } from "zod";
var SmsOutreachResultsSchema = z119.object({
  // Recipients the campaign addressed: the per-recipient interaction rows
  // when they exist, else the billable/text count recorded at purchase.
  contacts: z119.number(),
  responded: z119.number(),
  optedOut: z119.number()
});
var SmsOutreachReplySchema = z119.object({
  id: z119.string(),
  personId: z119.string(),
  firstName: z119.string().nullable(),
  lastName: z119.string().nullable(),
  city: z119.string().nullable(),
  state: z119.string().nullable(),
  phone: z119.string().nullable(),
  content: z119.string(),
  receivedAt: z119.string(),
  isOptOut: z119.boolean(),
  // Per-viewer state from OutreachReplyFlag; absent on surfaces that do not
  // read it.
  favorited: z119.boolean().optional(),
  read: z119.boolean().optional(),
  // Contact-level display fields only, never raw voter-file columns.
  crm: z119.object({
    contactId: z119.string(),
    statusLabel: z119.string().nullable()
  }).optional()
});
var SMS_OUTREACH_REPLIES_DEFAULT_LIMIT = 10;
var SMS_OUTREACH_REPLIES_MAX_LIMIT = 200;
var SmsOutreachRepliesSchema = z119.object({
  total: z119.number(),
  replies: z119.array(SmsOutreachReplySchema)
});
var SmsOutreachRepliesFilterSchema = z119.enum([
  "all",
  "unread",
  "favorited"
]);
var SmsOutreachRepliesQuerySchema = z119.object({
  themeId: z119.string().optional(),
  nonClustered: z119.boolean().optional(),
  filter: SmsOutreachRepliesFilterSchema.default("all")
});

// src/outreach/ServePoll.schema.ts
import { z as z120 } from "zod";
var POLL_TOPICS = [
  { id: "roads_infrastructure", label: "Roads and infrastructure" },
  { id: "public_safety", label: "Public safety" },
  { id: "parks_recreation", label: "Parks and recreation" },
  { id: "housing", label: "Housing" },
  { id: "budget_taxes", label: "Local budget and taxes" },
  { id: "schools", label: "Schools" },
  { id: "economic_development", label: "Economic development" },
  { id: "custom", label: "Write my own" }
];
var POLL_TOPIC_IDS = POLL_TOPICS.map((topic) => topic.id);
var PollTopicSchema = z120.enum(POLL_TOPIC_IDS);
var POLL_TONE_VALUES = [
  "Neutral",
  "Warm",
  "Direct",
  "Friendly"
];
var PollToneSchema = z120.enum(POLL_TONE_VALUES);
var POLL_QUESTION_MIN_LENGTH = 10;
var POLL_QUESTION_MAX_LENGTH = 480;
var PollQuestionSchema = z120.string().min(POLL_QUESTION_MIN_LENGTH).max(POLL_QUESTION_MAX_LENGTH);
var ServePollDraftRequestSchema = z120.object({
  topic: PollTopicSchema,
  tone: PollToneSchema,
  currentDraft: PollQuestionSchema.optional()
});
var ServePollDraftResponseSchema = z120.object({
  question: PollQuestionSchema
});
var ServePollAudienceSchema = z120.discriminatedUnion("kind", [
  z120.object({
    kind: z120.literal("sample"),
    size: z120.number().int().positive()
  }),
  z120.object({
    kind: z120.literal("list"),
    voterFileFilterId: z120.number().int().positive()
  })
]);
var ServePollCreateSchema = z120.object({
  topic: PollTopicSchema,
  tone: PollToneSchema.optional(),
  question: PollQuestionSchema,
  imageUrl: z120.string().url().optional(),
  audience: ServePollAudienceSchema,
  scheduledLocalDate: z120.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  biasOverridden: z120.boolean()
});
var ServePollCreateResponseSchema = z120.object({
  outreachId: z120.number().int().positive(),
  recipientCount: z120.number().int().nonnegative(),
  amountCents: z120.number().int().nonnegative()
});
var ServePollExpansionCreateSchema = z120.object({
  size: z120.number().int().positive()
});
var ServePollExpansionCreateResponseSchema = z120.object({
  expansionId: z120.string().min(1),
  recipientCount: z120.number().int().nonnegative(),
  amountCents: z120.number().int().nonnegative()
});
var ReplyFlagUpdateSchema = z120.object({
  favorited: z120.boolean().optional(),
  read: z120.boolean().optional()
});

// src/outreach/PollResults.schema.ts
import { z as z121 } from "zod";
var POLL_THEMES_MAX = 5;
var POLL_MIN_RESPONSES = 20;
var POLL_SAMPLE_QUOTES_MAX = 3;
var PollThemeSentimentSchema = z121.enum([
  "positive",
  "negative",
  "mixed",
  "neutral"
]);
var PollSampleQuoteSchema = z121.object({
  text: z121.string(),
  firstName: z121.string().nullable()
});
var ThemeSchema = z121.object({
  id: z121.string(),
  label: z121.string(),
  summary: z121.string(),
  mentionCount: z121.number().int().nonnegative(),
  sentiment: PollThemeSentimentSchema.optional(),
  // Members whose reply landed after the previous completed analysis. Zero on
  // a poll's first analysis, where nothing is new relative to anything.
  newMentions: z121.number().int().nonnegative(),
  sampleQuotes: z121.array(PollSampleQuoteSchema).max(POLL_SAMPLE_QUOTES_MAX)
});
var PollAnalysisStatusSchema = z121.enum([
  "none",
  "running",
  "completed",
  "failed"
]);
var PollExpansionSummarySchema = z121.object({
  sendSeq: z121.number().int().positive(),
  textCount: z121.number().int().nonnegative(),
  status: z121.string()
});
var PollResultsSchema = z121.object({
  outreachId: z121.number().int().positive(),
  sent: z121.number().int().nonnegative(),
  responses: z121.number().int().nonnegative(),
  responseRate: z121.number().nonnegative(),
  optOutRate: z121.number().nonnegative(),
  // The share of the send that answered, once there are enough responses to
  // call a result; null below POLL_MIN_RESPONSES.
  confidence: z121.number().nullable(),
  isHighConfidence: z121.boolean(),
  notEnoughResponses: z121.boolean(),
  newSinceLastAnalysis: z121.number().int().nonnegative(),
  lastAnalysisAt: zCoerceDate().nullable(),
  themes: z121.array(ThemeSchema).max(POLL_THEMES_MAX),
  // Replies the latest analysis did not place in any theme.
  nonClustered: z121.object({ count: z121.number().int().nonnegative() }),
  analysis: z121.object({ status: PollAnalysisStatusSchema }),
  expansions: z121.array(PollExpansionSummarySchema)
});
var ReplyFlagSchema = z121.object({
  favorited: z121.boolean(),
  read: z121.boolean()
});

// src/outreach/PollAdmin.schema.ts
import { z as z122 } from "zod";
var POLL_QUEUE_KIND_VALUES = ["poll", "expansion"];
var PollQueueKindSchema = z122.enum(POLL_QUEUE_KIND_VALUES);
var POLL_APPROVAL_STATUS_VALUES = [
  "awaiting_review",
  "approved",
  "denied",
  "sent",
  "canceled"
];
var PollApprovalStatusSchema = z122.enum(POLL_APPROVAL_STATUS_VALUES);
var PollQueueItemSchema = z122.object({
  kind: PollQueueKindSchema,
  outreachId: z122.number().int().positive(),
  expansionId: z122.string().nullable(),
  organizationSlug: z122.string(),
  name: z122.string().nullable(),
  question: z122.string().nullable(),
  topic: z122.string(),
  textCount: z122.number().int().nullable(),
  sendAt: zCoerceDate().nullable(),
  createdAt: zCoerceDate(),
  approvalStatus: PollApprovalStatusSchema,
  approvedAt: zCoerceDate().nullable(),
  approvedBy: z122.string().nullable(),
  deniedAt: zCoerceDate().nullable(),
  deniedBy: z122.string().nullable(),
  deniedReason: z122.string().nullable()
});
var PollQueueQuerySchema = z122.object({
  status: PollApprovalStatusSchema.default("awaiting_review")
});
var PollQueueResponseSchema = z122.object({
  items: z122.array(PollQueueItemSchema)
});
var PollReviewDetailSchema = z122.object({
  item: PollQueueItemSchema,
  // The full text as it will send: greeting, question and opt-out line.
  message: z122.string().nullable(),
  imageUrl: z122.string().nullable(),
  tone: z122.string().nullable(),
  audienceKind: PollAudienceKindSchema,
  biasOverridden: z122.boolean(),
  expansions: z122.array(PollQueueItemSchema)
});
var ApprovePollRequestSchema = z122.object({
  approvedBy: z122.string().min(1).max(255),
  expansionId: z122.string().min(1).optional()
});
var DenyPollRequestSchema = z122.object({
  deniedBy: z122.string().min(1).max(255),
  reason: z122.string().min(1).max(2e3)
});
var EditPollRequestSchema = z122.object({
  question: z122.string().min(10).max(480),
  editedBy: z122.string().min(1).max(255)
});

// src/outreach/ServeSms.schema.ts
import { z as z123 } from "zod";
var ServeSmsDraftRequestSchema = z123.object({
  purpose: ServeSmsPurposeSchema,
  tone: SocialToneSchema,
  currentDraft: z123.string().min(1).max(SMS_COMPOSED_MAX_LENGTH).optional(),
  event: OutreachEventDetailsSchema.optional()
});
var ServeSmsDraftResponseSchema = z123.object({
  draft: z123.string().min(1).max(SMS_COMPOSED_MAX_LENGTH)
});
var ROUND_TWO_DRAW_LEAD_BUSINESS_DAYS = 3;
var ROUND_ONE_TEXT_SHARE = 0.5;
var FOLLOW_UP_BUSINESS_DAYS = 10;
var MIN_TEXTS_PER_ROUND = 25;
var splitPriorityText = (total) => {
  const now = Math.ceil(total * ROUND_ONE_TEXT_SHARE);
  return total - now < MIN_TEXTS_PER_ROUND || now < MIN_TEXTS_PER_ROUND ? { now: total, followUp: 0 } : { now, followUp: total - now };
};
var ServeSmsCreateRequestSchema = z123.object({
  name: z123.string().trim().min(1).max(255),
  message: z123.string().min(1).max(SMS_COMPOSED_MAX_LENGTH),
  // Required: the image makes every Serve text an MMS, which is what lets
  // the message run to SMS_COMPOSED_MAX_LENGTH without segmenting.
  imageUrl: z123.string().url(),
  // The send day as a local calendar date. At least 2 business days out and
  // no more than 30, weekends excluded; enforced server-side, not just by the
  // picker.
  scheduledLocalDate: z123.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  voterFileFilterId: z123.number().int().positive(),
  // The earlier text this one reports back on. It marks the send as a
  // report back rather than a new ask, and is how its card is completed.
  reportBackForOutreachId: z123.number().int().positive().optional(),
  // A priority's follow-up: this many more texts paid for in the same
  // checkout, sent FOLLOW_UP_BUSINESS_DAYS after this one and drawn a few
  // business days before, from the same criteria, toward the groups the
  // priority's answers say least about. Needs the priority it belongs to.
  roundTwoSize: z123.number().int().positive().max(MAX_LIST_SAMPLE_SIZE).optional()
}).extend(ProposalLinkSchema.shape);
var ServeSmsCreateResponseSchema = z123.object({
  outreachId: z123.number().int().positive(),
  // Server-derived from the saved list with the opt-out scrub applied. Never
  // a client count: this is what the pay step quotes.
  recipientCount: z123.number().int().nonnegative(),
  excludedOptedOutCount: z123.number().int().nonnegative(),
  excludedDuplicateCount: z123.number().int().nonnegative(),
  // The follow-up held from the same purchase, priced with this one. Absent
  // when none was asked for or the pool left too few to send one.
  followUp: z123.object({
    outreachId: z123.number().int().positive(),
    recipientCount: z123.number().int().nonnegative(),
    scheduledLocalDate: z123.string().regex(/^\d{4}-\d{2}-\d{2}$/)
  }).optional()
});
var OutreachResultsUploadRowSchema = z123.object({
  phone: z123.string().min(1),
  // Deliberately NOT min(1): an inbound row with no text is a real reply.
  // An MMS carrying only an image, a tapback, an emoji the export strips —
  // the constituent did respond, and `respondedAt` should say so. Review
  // asked for min(1) on the grounds that a blank marks a non-responder as
  // having answered; that reasoning does not survive the direction filter,
  // which is what actually separates a reply from the outbound half.
  content: z123.string(),
  receivedAt: z123.coerce.date().optional()
});
var OutreachResultsParseReportSchema = z123.object({
  rowsParsed: z123.number().int().nonnegative(),
  /**
   * Rows of the export that were the official's OWN outbound message, not
   * replies. The fulfilment file is a message log and carries one per
   * recipient, so this is routinely larger than every other count here.
   *
   * Counted separately rather than folded into `unmatched`, which it
   * silently inflated: a 32-recipient send reported 33 unmatched rows when
   * exactly one reply came from a number not on the send. `unmatched` is
   * the number an operator acts on, so it has to mean only that.
   */
  outboundRows: z123.number().int().nonnegative(),
  /**
   * Null for a poll, where they have no meaning rather than a value of
   * zero. A poll file is forwarded to the analysis pipeline, not ingested:
   * there is no recipient map to match a reply against and no opt-out
   * predicate run here, so reporting 0 would read as "nobody replied" when
   * the truth is that the pipeline answers that later by writing PollIssues.
   * A reader that shows these must hide them when they are null.
   */
  matched: z123.number().int().nonnegative().nullable(),
  unmatched: z123.number().int().nonnegative().nullable(),
  optOuts: z123.number().int().nonnegative().nullable(),
  // false on a dry run, true once the rows are written. Always present — an
  // earlier version of this comment said "absent once written", which would
  // have led an implementer to omit it and have Zod reject every real result.
  committed: z123.boolean()
});
var ResultsInboxKindSchema = z123.enum(["sms", "poll"]);
var OutreachAwaitingResultsItemSchema = z123.object({
  kind: ResultsInboxKindSchema,
  id: z123.string().min(1),
  name: z123.string().nullable(),
  organizationSlug: z123.string(),
  outreachType: z123.string(),
  recipientCount: z123.number().int().nonnegative(),
  sentAt: z123.coerce.date().nullable(),
  expectedBy: z123.coerce.date().nullable()
});
var OutreachAwaitingResultsResponseSchema = z123.object({
  items: z123.array(OutreachAwaitingResultsItemSchema)
});
var OutreachResultsTargetSchema = OutreachAwaitingResultsItemSchema.extend({
  message: z123.string().nullable(),
  imageUrl: z123.string().nullable(),
  // Set once results have been ingested. A send that already has results is
  // still openable (re-upload is idempotent server-side) but says so.
  resultsReceivedAt: z123.coerce.date().nullable()
});
var OutreachResultsUploadRequestSchema = z123.object({
  fileName: z123.string().min(1).max(255),
  csv: z123.string().min(1),
  // True asks for the report and nothing else. The page never commits without
  // having shown one first.
  dryRun: z123.boolean(),
  // Who produced the file, for the ingest audit trail.
  sourceLabel: z123.string().min(1).max(255)
});

// src/outreach/SmsAdminConsole.schema.ts
import { z as z124 } from "zod";
var SMS_APPROVAL_STATUS_VALUES = [
  "awaiting_review",
  "denied",
  "canvass_requested",
  "peerly_approved",
  "sent",
  "canceled"
];
var SmsApprovalStatusSchema = z124.enum(SMS_APPROVAL_STATUS_VALUES);
var SMS_STANDARDS_RULE_VALUES = [
  "opt_out_line",
  "first_name_token",
  "candidate_name",
  "paid_for_by",
  "length",
  "link_shortener",
  "restricted_word"
];
var SmsStandardsRuleSchema = z124.enum(SMS_STANDARDS_RULE_VALUES);
var SmsStandardsVerdictSchema = z124.object({
  passed: z124.boolean(),
  failures: z124.array(SmsStandardsRuleSchema)
});
var LINK_SHORTENER_HOSTS = [
  "bit.ly",
  "bitly.com",
  "tinyurl.com",
  "t.co",
  "goo.gl",
  "ow.ly",
  "buff.ly",
  "rebrand.ly",
  "is.gd",
  "cutt.ly",
  "shorturl.at",
  "tiny.cc",
  "rb.gy",
  "t.ly",
  "snip.ly",
  "tr.im",
  "clck.ru"
];
var LINK_SHORTENER_PATTERN = new RegExp(
  `(?:^|[^\\w-])(?:https?://)?(?:www\\.)?(?:${LINK_SHORTENER_HOSTS.map(
    (host) => host.replace(/\./g, "\\.")
  ).join("|")})(?![\\w-])(?!\\.[a-z])`,
  "i"
);
var SMS_RESTRICTED_WORDS = ["sexual", "stop2end", "transfer"];
var findSmsRestrictedWords = (script) => SMS_RESTRICTED_WORDS.filter(
  (word) => new RegExp(`(?<![\\p{L}\\p{N}])${word}(?![\\p{L}\\p{N}])`, "iu").test(
    script
  )
);
var nameWordsOf = (names) => names.filter((name) => !!name).flatMap((name) => name.split(/\s+/)).map((token) => token.trim()).filter((token) => token.length >= 3);
var nameTokensOf = (names) => nameWordsOf(names).map((token) => token.toLowerCase());
var checkSmsStandards = (script, context = {}) => {
  const failures = [];
  const lower = script.toLowerCase();
  if (!/reply\s+["'“”‘’]?stop\b/i.test(script)) {
    failures.push("opt_out_line");
  }
  if (!script.includes("{first_name}")) {
    failures.push("first_name_token");
  }
  const candidateNames = (context.candidateNames ?? []).map((name) => name.trim()).filter(Boolean);
  const candidateTokens = nameWordsOf(candidateNames);
  const namesCandidate = candidateNames.some((name) => findWords2(script, name) !== null) || candidateTokens.some((token) => findWords2(script, token) !== null);
  if (candidateNames.length > 0 && !namesCandidate) {
    failures.push("candidate_name");
  }
  const committeeTokens = nameTokensOf([context.committeeName]);
  const hasPaidForBy = /paid\s+for\s+by/i.test(script);
  const hasCommitteeToken = committeeTokens.length === 0 || committeeTokens.some((token) => lower.includes(token));
  if (!hasPaidForBy || !hasCommitteeToken) {
    failures.push("paid_for_by");
  }
  if (script.length > P2P_SCRIPT_MAX_LENGTH) {
    failures.push("length");
  }
  if (LINK_SHORTENER_PATTERN.test(script)) {
    failures.push("link_shortener");
  }
  if (findSmsRestrictedWords(script).length > 0) {
    failures.push("restricted_word");
  }
  return { passed: failures.length === 0, failures };
};
var escapeRegExp2 = (text2) => text2.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
var findWords2 = (script, words) => new RegExp(
  `(?<![\\p{L}\\p{N}])${escapeRegExp2(words)}(?![\\p{L}\\p{N}])`,
  "iu"
).exec(script);
var deriveSmsProtectedParts = (script, context = {}) => {
  const ignored = new Set(context.ignoredRules ?? []);
  const parts = [];
  if (!ignored.has("first_name_token")) {
    const text2 = mergeTagToken("first_name", context.channel ?? "peerly");
    if (script.includes(text2)) {
      parts.push({
        rule: "first_name_token",
        kind: "token",
        tagId: "first_name",
        text: text2
      });
    }
  }
  let disclaimer = null;
  {
    const phrases = [...script.matchAll(/paid\s+for\s+by/gi)];
    const committee = context.committeeName?.trim();
    const unitAt = (phrase) => {
      const index = phrase.index ?? 0;
      const after = script.slice(index + phrase[0].length);
      if (committee) {
        const named = new RegExp(
          `^[^\\p{L}\\p{N}]+${escapeRegExp2(committee)}\\.?`,
          "iu"
        ).exec(after);
        return named ? { start: index, text: phrase[0] + named[0] } : null;
      }
      const line = /^[^\n]*/.exec(after)?.[0] ?? "";
      const optOutAt = line.search(/\s+reply\s+["'“”‘’]?stop\b/i);
      const rest = (optOutAt === -1 ? line : line.slice(0, optOutAt)).trimEnd();
      return { start: index, text: phrase[0] + rest };
    };
    const last = phrases[phrases.length - 1];
    if (committee) {
      disclaimer = phrases.map(unitAt).filter((unit) => unit !== null).pop() ?? (last ? { start: last.index ?? 0, text: last[0] } : null);
    } else if (last) {
      disclaimer = unitAt(last);
    }
  }
  if (!ignored.has("candidate_name")) {
    const withoutDisclaimer = disclaimer ? script.slice(0, disclaimer.start) + " ".repeat(disclaimer.text.length) + script.slice(disclaimer.start + disclaimer.text.length) : script;
    const committee = context.committeeName?.trim();
    const committeeIsName = (context.candidateNames ?? []).some(
      (name) => name.trim().toLowerCase() === committee?.toLowerCase()
    );
    const outside = committee && !committeeIsName ? withoutDisclaimer.replace(
      new RegExp(escapeRegExp2(committee), "giu"),
      (match) => " ".repeat(match.length)
    ) : withoutDisclaimer;
    const names = (context.candidateNames ?? []).filter(Boolean);
    const found = names.map((name) => findWords2(outside, name.trim())).find(Boolean) ?? nameWordsOf(names).map((token) => findWords2(outside, token)).find(Boolean);
    if (found) {
      parts.push({
        rule: "candidate_name",
        kind: "phrase",
        text: found[0],
        start: found.index
      });
    }
  }
  if (disclaimer && !ignored.has("paid_for_by")) {
    parts.push({
      rule: "paid_for_by",
      kind: "phrase",
      text: disclaimer.text,
      start: disclaimer.start
    });
  }
  {
    const join = findCivicPanelJoinLine(script);
    if (join) {
      parts.push({
        rule: "civic_panel_join",
        kind: "phrase",
        text: join.text,
        start: join.start
      });
    }
  }
  {
    const leave = findCivicPanelLeaveLine(script);
    if (leave) {
      parts.push({
        rule: "civic_panel_leave",
        kind: "phrase",
        text: leave.text,
        start: leave.start
      });
    }
  }
  if (!ignored.has("opt_out_line")) {
    const optOut = [
      ...script.matchAll(
        /reply\s+["'“”‘’]?stop\b["'“”‘’]?(?:\s+to\s+opt[\s-]?out)?\.?/gi
      )
    ].pop();
    if (optOut) {
      parts.push({
        rule: "opt_out_line",
        kind: "phrase",
        text: optOut[0],
        start: optOut.index ?? 0
      });
    }
  }
  return parts;
};
var SmsApprovalQueueItemSchema = z124.object({
  id: z124.number(),
  campaignId: z124.number(),
  campaignSlug: z124.string(),
  candidateName: z124.string().nullable(),
  // The HubSpot company owner (the campaign's assigned success person),
  // resolved best-effort at read time; null when unassigned or the CRM
  // read failed.
  assignedPa: z124.string().nullable(),
  name: z124.string().nullable(),
  createdAt: zCoerceDate(),
  sendAt: zCoerceDate().nullable(),
  scheduledLocalDate: z124.string().nullable(),
  // The candidate's chosen wall-clock send time ("HH:mm"), applied in each
  // contact's local timezone as the Peerly window start at approve. Null on
  // rows created before the field existed (approve falls back to 09:00).
  scheduledLocalTime: z124.string().nullable(),
  script: z124.string().nullable(),
  imageUrl: z124.string().nullable(),
  textCount: z124.number().nullable(),
  billableTextCount: z124.number().nullable(),
  // A free-texts send never records a checkout session.
  paid: z124.boolean(),
  approvalStatus: SmsApprovalStatusSchema,
  approvedAt: zCoerceDate().nullable(),
  approvedBy: z124.string().nullable(),
  deniedAt: zCoerceDate().nullable(),
  deniedBy: z124.string().nullable(),
  deniedReason: z124.string().nullable(),
  canvassRequestedAt: zCoerceDate().nullable(),
  adminEditedAt: zCoerceDate().nullable(),
  adminEditedBy: z124.string().nullable(),
  canceledAt: zCoerceDate().nullable(),
  canceledBy: z124.string().nullable(),
  canceledByAdmin: z124.boolean(),
  // Set when staff moved the send to a replacement vendor job (one the
  // console made, or one made by hand at the vendor and linked); the old
  // job's id is kept for lookups in the vendor's own console.
  jobReplacedAt: zCoerceDate().nullable(),
  jobReplacedBy: z124.string().nullable(),
  previousJobId: z124.string().nullable(),
  // The Peerly job the send follows now.
  jobId: z124.string().nullable(),
  jobReplaceReason: z124.string().nullable(),
  standards: SmsStandardsVerdictSchema.nullable(),
  // Live Peerly job readiness; null when the live read failed (the queue
  // must not 502 because one identity's vendor read did).
  job: z124.object({
    status: z124.string(),
    deliverabilityCheckError: z124.string().nullable(),
    hasCanvassersScheduled: z124.boolean(),
    peerlyApproved: z124.boolean().nullable(),
    leadsRemaining: z124.number().nullable()
  }).nullable()
});
var SmsApprovalQueueResponseSchema = z124.object({
  items: z124.array(SmsApprovalQueueItemSchema)
});
var SmsAdminJobStatsSchema = z124.object({
  sentTotal: z124.number(),
  receivedTotal: z124.number(),
  delivered: z124.number(),
  deliveryFailed: z124.number(),
  deliveryUnconfirmed: z124.number(),
  totalCost: z124.number()
});
var SmsAdminDetailResponseSchema = z124.object({
  item: SmsApprovalQueueItemSchema,
  stats: SmsAdminJobStatsSchema.nullable()
});
var SmsVendorAccountSchema = z124.object({
  balance: z124.number(),
  creditLimit: z124.number(),
  readAt: zCoerceDate()
});
var SmsVendorBalanceResponseSchema = z124.object({
  account: SmsVendorAccountSchema.nullable()
});
var ApproveSmsOutreachRequestSchema = z124.object({
  approvedBy: z124.string().min(1).max(255)
});
var DenySmsOutreachRequestSchema = z124.object({
  deniedBy: z124.string().min(1).max(255),
  reason: z124.string().min(1).max(2e3)
});
var CancelSmsOutreachRequestSchema = z124.object({
  canceledBy: z124.string().min(1).max(255)
});
var EditSmsOutreachRequestSchema = z124.object({
  script: z124.string().min(1).max(P2P_SCRIPT_MAX_LENGTH),
  editedBy: z124.string().min(1).max(255)
});
var EditSmsOutreachDateRequestSchema = z124.object({
  sendAt: zCoerceDate(),
  scheduledLocalDate: z124.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Use yyyy-MM-dd").refine(
    (value) => !Number.isNaN(Date.parse(value)),
    "Not a real calendar day"
  ),
  editedBy: z124.string().min(1).max(255)
});
var SMS_JOB_REPLACE_REASON_LABELS = {
  bad_sending_number: "Peerly flagged the sending number",
  delivery_failure: "Peerly delivery failure",
  message_or_schedule_change: "Message or schedule change",
  other: "Other"
};
var SmsJobReplaceReasonSchema = z124.enum(
  Object.keys(SMS_JOB_REPLACE_REASON_LABELS)
);
var requireOtherReason = (value, ctx) => {
  if (value.reason === "other" && !value.otherReason) {
    ctx.addIssue({
      code: "custom",
      path: ["otherReason"],
      message: "Say why the job is being replaced"
    });
  }
};
var ReplaceSmsOutreachJobRequestSchema = z124.object({
  sendAt: zCoerceDate(),
  scheduledLocalDate: z124.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Use yyyy-MM-dd").refine(
    (value) => !Number.isNaN(Date.parse(value)),
    "Not a real calendar day"
  ),
  // The job the admin saw when they chose to replace it. A retry after
  // the replacement landed names a job the send no longer has, and is
  // refused instead of replacing the new job too.
  currentJobId: z124.string().min(1),
  reason: SmsJobReplaceReasonSchema,
  otherReason: z124.string().trim().min(1).max(500).optional(),
  replacedBy: z124.string().min(1).max(255)
}).superRefine(requireOtherReason);
var LinkSmsOutreachJobRequestSchema = z124.object({
  jobId: z124.string().trim().min(1).max(64),
  currentJobId: z124.string().min(1),
  reason: SmsJobReplaceReasonSchema,
  otherReason: z124.string().trim().min(1).max(500).optional(),
  linkedBy: z124.string().min(1).max(255)
}).superRefine(requireOtherReason);
var SmsTestMessageRequestSchema = z124.object({
  // E.164-ish: digits with optional leading +, 10-15 digits.
  phone: z124.string().regex(/^\+?\d{10,15}$/, "Use digits only, e.g. +15551234567")
});
var SmsTestMessageResponseSchema = z124.object({
  sent: z124.boolean()
});

// src/shared/Bbox.schema.ts
import { z as z125 } from "zod";
var BboxSchema = z125.object({
  minLat: z125.number().min(-90).max(90),
  maxLat: z125.number().min(-90).max(90),
  minLng: z125.number().min(-180).max(180),
  maxLng: z125.number().min(-180).max(180)
}).strict().refine(
  (b) => b.minLat <= b.maxLat && b.minLng <= b.maxLng,
  "bbox min must not exceed max"
);

// src/people/PeopleFilters.schema.ts
import { z as z126 } from "zod";
var INCOME_RANGE_MAPPING = {
  "Under $25k": { min: 0, max: 24999 },
  "$25k - $35k": { min: 25e3, max: 34999 },
  "$35k - $50k": { min: 35e3, max: 49999 },
  "$50k - $75k": { min: 5e4, max: 74999 },
  "$75k - $100k": { min: 75e3, max: 99999 },
  "$100k - $125k": { min: 1e5, max: 124999 },
  "$125k - $150k": { min: 125e3, max: 149999 },
  "$150k - $200k": { min: 15e4, max: 199999 },
  "$200k+": { min: 2e5, max: null }
};
var PEOPLE_FILTER_VALUE_ENUMS = {
  voterStatus: [
    "Super",
    "Likely",
    "Unreliable",
    "Unlikely",
    "Unknown"
  ],
  // Likelihood of voting before Election Day (early in person or by mail).
  // Like voterStatus, a selection that includes 'Unknown' also matches NULL.
  earlyVoteStatus: [
    "Very Likely",
    "Likely",
    "Unlikely",
    "Very Unlikely",
    "Unknown"
  ],
  politicalParty: ["Independent", "Democratic", "Republican", "Other"],
  maritalStatus: [
    "Inferred Married",
    "Inferred Single",
    "Married",
    "Single",
    "Unknown"
  ],
  veteranStatus: ["Yes", "Unknown"],
  educationLevel: [
    "None",
    "High School Diploma",
    "Technical School",
    "Some College",
    "College Degree",
    "Graduate Degree",
    "Unknown"
  ],
  ethnicity: [
    "Asian",
    "European",
    "Hispanic",
    "African American",
    "Other",
    "Unknown"
  ],
  businessOwner: ["Yes", "Unknown"],
  presenceOfChildren: ["Yes", "No", "Unknown"],
  homeowner: ["Yes", "Likely", "No", "Unknown"],
  gender: ["M", "F", "Unknown"],
  // 'Other' and 'Unknown' are separate for the same reason `ethnicity` keeps
  // them apart: `Language_Code` is nullable with no sentinel, so "speaks
  // something else" and "we were never told" are distinguishable facts about
  // a person. 'Other' used to mean both, which reported roughly 60% of a
  // district as Other-language speakers.
  language: ["English", "Spanish", "Other", "Unknown"],
  ideology: ["Conservative", "Liberal", "Moderate", "Unknown"],
  // An enum vocabulary rather than a boolean wire filter because the backing
  // column (`Voter_Independent_Affinity`) is a BOOLEAN set on every voter: a
  // presence check would match every voter, silently un-filtering the
  // request. It is NULL only on consumer-only rows of the constituents table,
  // which never see this Win-only filter.
  independentAffinity: ["Yes", "No"],
  // "Voted in election": Yes is anyone L2 reports as voting early or absentee
  // in the current general, or the campaign recorded as already voted
  // (votedInElectionReportedIds). No is neither, so it includes people whose
  // state does not report.
  votedInElection: ["Yes", "No"]
};
var PEOPLE_FILTER_SOURCES = ["voterFile", "imported"];
var PeopleFilterSourceSchema = z126.enum(PEOPLE_FILTER_SOURCES);
var createEnumFilterSchema = (allowedValues) => {
  return z126.object({
    in: z126.array(z126.enum(allowedValues)).min(1).optional(),
    eq: z126.enum(allowedValues).optional(),
    is: z126.enum(["not_null", "null"]).optional()
  }).refine((data) => {
    const operatorCount = [data.in, data.eq, data.is].filter(Boolean).length;
    return operatorCount === 1;
  }, "Exactly one operator (in, eq, or is) must be specified");
};
var rangeConditionSchema = z126.object({
  gte: z126.coerce.number().optional(),
  lte: z126.coerce.number().optional()
}).refine(
  (data) => data.gte !== void 0 || data.lte !== void 0,
  "At least one of gte or lte must be specified in each _or range"
);
var MAX_ID_FILTER_VALUES = 2e5;
var createIdFilterSchema = () => {
  return z126.object({
    in: z126.array(z126.guid()).min(1).max(MAX_ID_FILTER_VALUES).optional(),
    notIn: z126.array(z126.guid()).min(1).max(MAX_ID_FILTER_VALUES).optional()
  }).refine((data) => {
    const operatorCount = [data.in, data.notIn].filter(Boolean).length;
    return operatorCount === 1;
  }, "Exactly one operator (in or notIn) must be specified");
};
var IdOverridesSchema = z126.object({
  include: z126.array(z126.guid()).min(1).max(MAX_ID_FILTER_VALUES).optional(),
  exclude: z126.array(z126.guid()).min(1).max(MAX_ID_FILTER_VALUES).optional()
});
var PRECINCT_PAIR_DELIMITER = "|";
var encodePrecinctPair = (county, precinct) => `${county}${PRECINCT_PAIR_DELIMITER}${precinct}`;
var decodePrecinctPair = (encoded) => {
  const at = encoded.indexOf(PRECINCT_PAIR_DELIMITER);
  if (at === -1) return { county: encoded, precinct: "" };
  return {
    county: encoded.slice(0, at),
    precinct: encoded.slice(at + PRECINCT_PAIR_DELIMITER.length)
  };
};
var MAX_PRECINCT_FILTER_VALUES = 5e3;
var createPrecinctFilterSchema = () => z126.object({
  in: z126.array(z126.string().min(1).max(200)).min(1).max(MAX_PRECINCT_FILTER_VALUES)
});
var createNumericFilterSchema = () => {
  return z126.object({
    in: z126.array(z126.coerce.number()).min(1).optional(),
    eq: z126.coerce.number().optional(),
    gte: z126.coerce.number().optional(),
    lte: z126.coerce.number().optional(),
    is: z126.enum(["not_null", "null"]).optional(),
    // min(1): an empty _or would pass the operator-count refine below,
    // then be silently dropped by the SQL builder — the field would go
    // unfiltered instead of erroring.
    _or: z126.array(rangeConditionSchema).min(1).optional(),
    _includeNull: z126.boolean().optional()
  }).refine((data) => {
    const operatorCount = [
      data.in,
      data.eq,
      data.gte,
      data.lte,
      data.is,
      data._or
    ].filter((value) => value !== void 0).length;
    return operatorCount >= 1;
  }, "At least one operator must be specified");
};
var PeopleFiltersSchema = z126.object({
  hasCellPhone: z126.boolean().optional(),
  hasLandline: z126.boolean().optional(),
  hasAnyPhone: z126.boolean().optional(),
  hasAddress: z126.boolean().optional(),
  hasEmail: z126.boolean().optional(),
  id: createIdFilterSchema().optional(),
  maritalStatus: createEnumFilterSchema(
    PEOPLE_FILTER_VALUE_ENUMS.maritalStatus
  ).optional(),
  veteranStatus: createEnumFilterSchema(
    PEOPLE_FILTER_VALUE_ENUMS.veteranStatus
  ).optional(),
  educationLevel: createEnumFilterSchema(
    PEOPLE_FILTER_VALUE_ENUMS.educationLevel
  ).optional(),
  ethnicity: createEnumFilterSchema(
    PEOPLE_FILTER_VALUE_ENUMS.ethnicity
  ).optional(),
  businessOwner: createEnumFilterSchema(
    PEOPLE_FILTER_VALUE_ENUMS.businessOwner
  ).optional(),
  presenceOfChildren: createEnumFilterSchema(
    PEOPLE_FILTER_VALUE_ENUMS.presenceOfChildren
  ).optional(),
  homeowner: createEnumFilterSchema(
    PEOPLE_FILTER_VALUE_ENUMS.homeowner
  ).optional(),
  gender: createEnumFilterSchema(PEOPLE_FILTER_VALUE_ENUMS.gender).optional(),
  voterStatus: createEnumFilterSchema(
    PEOPLE_FILTER_VALUE_ENUMS.voterStatus
  ).optional(),
  earlyVoteStatus: createEnumFilterSchema(
    PEOPLE_FILTER_VALUE_ENUMS.earlyVoteStatus
  ).optional(),
  politicalParty: createEnumFilterSchema(
    PEOPLE_FILTER_VALUE_ENUMS.politicalParty
  ).optional(),
  language: createEnumFilterSchema(
    PEOPLE_FILTER_VALUE_ENUMS.language
  ).optional(),
  ideology: createEnumFilterSchema(
    PEOPLE_FILTER_VALUE_ENUMS.ideology
  ).optional(),
  independentAffinity: createEnumFilterSchema(
    PEOPLE_FILTER_VALUE_ENUMS.independentAffinity
  ).optional(),
  votedInElection: createEnumFilterSchema(
    PEOPLE_FILTER_VALUE_ENUMS.votedInElection
  ).optional(),
  votedInElectionReportedIds: z126.object({
    in: z126.array(z126.guid()).min(1).max(MAX_ID_FILTER_VALUES)
  }).optional(),
  estimatedIncomeAmountInt: createNumericFilterSchema().optional(),
  ageInt: createNumericFilterSchema().optional(),
  precinct: createPrecinctFilterSchema().optional(),
  source: z126.array(PeopleFilterSourceSchema).optional()
});

// src/people/PeoplePrecincts.schema.ts
import { z as z127 } from "zod";
var PrecinctOptionSchema = z127.object({
  county: z127.string(),
  precinct: z127.string(),
  voters: z127.number().int().nonnegative()
});
var PeoplePrecinctsResponseSchema = z127.object({
  options: z127.array(PrecinctOptionSchema),
  truncated: z127.boolean()
});

// src/people/PeopleOverlapCount.schema.ts
import { z as z128 } from "zod";
var MAX_OVERLAP_SAVED_FILTER_SETS = 25;
var PeopleOverlapCountRequestSchema = z128.object({
  districtId: z128.guid(),
  filters: PeopleFiltersSchema.optional(),
  search: z128.string().optional(),
  // Capped at the org's most-recently-saved lists; gp-api truncates beyond
  // that and logs a warning (never a silent drop) — this bound is the
  // wire-level enforcement of that same cap.
  savedFilterSets: z128.array(PeopleFiltersSchema).max(MAX_OVERLAP_SAVED_FILTER_SETS)
});
var PeopleOverlapCountResponseSchema = z128.object({
  count: z128.number().int().min(0)
});

// src/doorKnocking/DoorKnockingEvaluation.schema.ts
import { z as z129 } from "zod";
var DoorKnockingEvaluateRequestSchema = z129.object({
  districtId: z129.guid(),
  bbox: BboxSchema,
  filters: PeopleFiltersSchema.optional(),
  // The two id-set clauses that travel beside `filters` rather than inside
  // it, mirroring the CRM read path: `idOverrides` carries per-person
  // voter-likelihood overrides (OR-ed against the voterStatus clause
  // only), `contactsMadeIdOverrides` the mixed "0 plus a non-zero bucket"
  // contacts-made case that can't collapse into `filters.id`. A saved list
  // knocked without these applies a different audience than the same list
  // previewed in Contacts.
  idOverrides: IdOverridesSchema.optional(),
  contactsMadeIdOverrides: IdOverridesSchema.optional(),
  // A guard, not pagination: people-api rejects the request outright when
  // the bbox holds more matches than this, so a city-sized polygon can't
  // stream a whole voter file. gp-api sizes it from the 150-stop cap times
  // observed voters-per-stop, with headroom.
  maxPeople: z129.number().int().positive().max(5e4),
  // People the campaign was told not to visit again (do-not-knock) or was
  // told are not a voter to reach at this door (not-a-voter). One slot for
  // both: they differ in what the candidate was told, not in what
  // evaluation has to do about it. Excluded unconditionally rather than
  // through a filter, because suppression that depends on which filters a
  // candidate happened to pick is suppression that silently stops working.
  excludePersonIds: z129.array(z129.guid()).max(1e5).optional()
}).strict();
var DoorKnockingEvaluatedPersonSchema = z129.object({
  id: z129.guid(),
  firstName: z129.string().nullable(),
  lastName: z129.string().nullable(),
  lat: z129.number(),
  lng: z129.number(),
  // people-api's household grouping key (HOUSEHOLD_KEY_RESIDENCE_COLUMNS
  // normalization). Opaque to gp-api: stored on stop targets at freeze and
  // echoed back in residents-by-address requests.
  addressKey: z129.string().min(1),
  // Residence_Addresses_AddressLine verbatim — people_db's own display
  // format, never re-composed downstream.
  displayAddress: z129.string()
});
var DoorKnockingEvaluateResponseSchema = z129.object({
  people: z129.array(DoorKnockingEvaluatedPersonSchema)
});

// src/doorKnocking/DoorKnockingResidents.schema.ts
import { z as z130 } from "zod";
var DoorKnockingResidentsRequestSchema = z130.object({
  districtId: z130.guid(),
  // One entry per target unit on the route (≤150 stops, multi-unit stops
  // fan out). 5,000 bounds the SQL array param far above any real route.
  addressKeys: z130.array(z130.string().min(1)).min(1).max(5e3),
  // The frozen targets. Residents at a requested addressKey who are NOT in
  // this set come back as otherResidents (household context, name-only).
  targetPersonIds: z130.array(z130.guid()).min(1).max(5e4)
}).strict();
var DoorKnockingDemographicsShape = {
  // `StateVoterID IS NOT NULL`, the same derivation the exploration-map pack
  // calls `registered` (`voterPack.service.ts`). Deliberately NOT
  // `PersonSchema.shape.registeredVoter`, which is `'Yes'` for every
  // gp_api_voters row and reads no column there. A boolean rather than that
  // schema's Yes/No enum so the two can't be mistaken for each other.
  //
  // Nullable only because a route payload target who may have moved has no
  // live row to read it off. The residents response always has a row, so it
  // always answers.
  registeredVoter: z130.boolean().nullable(),
  // `Voter_Status` — Super / Likely / Unreliable / Unlikely, with the file's
  // `Unknown` sentinel mapping to null. **Relabelled deliberately**: the
  // prototype called this "Voter status", meaning active/inactive
  // registration. This is turnout propensity, which is a different fact, and
  // naming it the prototype's way would name it as something it isn't.
  turnoutLikelihood: PersonSchema.shape.voterStatus,
  // `Marital_Status`. The file's `Inferred Married` / `Inferred Single` render
  // as "Likely Married" / "Likely Single" — modelled, not observed, and the
  // wording keeps that distinction visible at the door.
  maritalStatus: PersonSchema.shape.maritalStatus,
  // `Presence_Of_Children` — a HOUSEHOLD Y/N flag, not a count. There is no
  // column for the number of children.
  hasChildrenUnder18: PersonSchema.shape.hasChildrenUnder18,
  // `Veteran_Status`. **Presence-only**: `z.enum(['Yes'])`, because the column
  // holds a value meaning yes or nothing at all, so absence is
  // indistinguishable from unknown. Renderers must never print "No" — see the
  // note on `businessOwner` below.
  veteranStatus: PersonSchema.shape.veteranStatus,
  // `Homeowner_Probability_Model` — Home Owner / Probable Home Owner / Renter
  // → Yes / Likely / No. A model, not a deed record.
  homeowner: PersonSchema.shape.homeowner,
  // `Business_Owner`. **Presence-only, and the weakest of the eleven**:
  // nothing in this repo documents what strings the column holds, and every
  // consumer treats any non-null value as Yes. Like `veteranStatus`, absence
  // is unknown rather than "No", so a renderer that prints "No" states a fact
  // the data does not support.
  businessOwner: PersonSchema.shape.businessOwner,
  // `Education_Of_Person`. Every raw value ends in "Likely"; the mapper strips
  // that rather than inventing its own labels.
  levelOfEducation: PersonSchema.shape.levelOfEducation,
  // `Estimated_Income_Amount_Int` (the Int column; the string twin exists for
  // CSV download only). Sent as the raw amount and bucketed at render through
  // `INCOME_RANGE_MAPPING`, so the door never prints a spuriously precise
  // number for a modelled figure. It is HOUSEHOLD income — label it as such.
  estimatedIncomeAmount: PersonSchema.shape.estimatedIncomeAmount,
  // `Language_Code` (which holds names, not codes) → English / Spanish /
  // Other. **Nullable here where `PersonSchema`'s is not**: that mapper
  // collapses a null column to 'Other', which at the door would assert the
  // person speaks something other than English or Spanish on the strength of
  // no data. Same reasoning — and the same shape — as `politicalParty` above,
  // which stays null for an absent value while a present unrecognized one is
  // a real fact that maps to 'Other'.
  language: PersonSchema.shape.language.nullable(),
  // `EthnicGroups_EthnicGroup1Desc`. Two other ethnicity columns exist on the
  // Voter model and are used nowhere; don't reach for them.
  ethnicityGroup: PersonSchema.shape.ethnicityGroup
};
var DoorKnockingResidentTargetSchema = z130.object({
  personId: z130.guid(),
  firstName: z130.string().nullable(),
  lastName: z130.string().nullable(),
  age: z130.number().nullable(),
  politicalParty: z130.enum(["Independent", "Democratic", "Republican", "Other"]).nullable(),
  // Same two columns the voter-file download already hands candidates as
  // "Cell Phone" and "Landline", behind the same district access check. Live
  // like age and party, so a person who moved carries no number.
  cellPhone: z130.string().nullable(),
  landline: z130.string().nullable(),
  ...DoorKnockingDemographicsShape
});
var DoorKnockingResidentsAddressSchema = z130.object({
  addressKey: z130.string(),
  targets: z130.array(DoorKnockingResidentTargetSchema),
  // Household context shown at the door — deliberately name-only, and that
  // holds all the way through the demographic profile above. A non-target
  // resident is context for the conversation, not someone the candidate asked
  // to contact, so widening this shape needs a product decision rather than a
  // symmetry argument.
  otherResidents: z130.array(
    z130.object({
      personId: z130.guid(),
      firstName: z130.string().nullable(),
      lastName: z130.string().nullable()
    })
  )
});
var DoorKnockingResidentsResponseSchema = z130.object({
  addresses: z130.array(DoorKnockingResidentsAddressSchema)
});

// src/doorKnocking/DoorKnockingAddressPreview.schema.ts
import { z as z131 } from "zod";
var DoorKnockingPreviewDoorSchema = z131.object({
  // Rendered from the unit key exactly as the frozen route renders it
  // (renderDoorAddress), so the address previewed here and the address walked
  // later are the same string rather than two formats of one place.
  //
  // The WHOLE address, unlike the walk view's door rows, which show the unit
  // alone. There is no stop heading above this list to carry the street.
  address: z131.string(),
  people: z131.number().int().nonnegative()
});
var DoorKnockingPreviewLocationSchema = z131.object({
  doors: z131.array(DoorKnockingPreviewDoorSchema).min(1)
});
var DoorKnockingAddressPreviewResponseSchema = z131.object({
  stops: z131.number().int().nonnegative(),
  doors: z131.number().int().nonnegative(),
  people: z131.number().int().nonnegative(),
  // Capped at the 150-stop limit: past it the shape cannot be saved anyway,
  // so materializing more addresses buys nothing. Whole locations only, so a
  // listed stop always shows every door behind it — a truncated location
  // would report fewer doors than the building has. `locations.length` below
  // `stops` is what tells the panel it is showing a prefix.
  locations: z131.array(DoorKnockingPreviewLocationSchema),
  // Which of the two ways of finding nobody this is, when the counts are
  // zero. A shape that encloses none of a real audience is ordinary drawing
  // and stays `false`; `true` means the list's own filters resolved to an
  // empty person-id set, which no boundary can fix and which the create will
  // reject outright. Reported rather than flattened into the zeros because
  // the two used to be indistinguishable here for the same reason the two
  // create errors shared a sentence — and this is the moment the condition
  // is cheap to say, before anything is bought.
  audienceEmpty: z131.boolean()
});

// src/doorKnocking/DoorKnockingAudienceCheck.schema.ts
import { z as z132 } from "zod";
var DoorKnockingAudienceCheckResponseSchema = z132.object({
  // True when the list's id-resolving criteria intersect to nobody.
  //
  // False is the weaker claim, and the asymmetry is the point: it means the
  // id-set resolution did not collapse, NOT that the audience is non-empty.
  // Filters with no id component — party, age, precinct — narrow a query
  // instead of resolving a set, and only the people database knows whether
  // they match. So this gate refuses a list it can prove is empty and stays
  // out of the way otherwise; the create's own 400 remains the backstop for
  // everything else.
  empty: z132.boolean()
});

// src/doorKnocking/DoorKnockingPack.schema.ts
import { z as z134 } from "zod";

// src/doorKnocking/DoorKnockingRoutePayload.schema.ts
import { z as z133 } from "zod";
var RouteTargetActivitySchema = z133.discriminatedUnion("type", [
  DoorKnockConstituentActivitySchema,
  TextConstituentActivitySchema,
  RobocallConstituentActivitySchema,
  PhoneBankingConstituentActivitySchema,
  StatusChangeConstituentActivitySchema
]);
var optionalDemographics = () => Object.fromEntries(
  Object.entries(DoorKnockingDemographicsShape).map(([key, schema]) => [
    key,
    schema.optional()
  ])
);
var ROUTE_TARGET_ACTIVITY_LIMIT = 5;
var ROUTE_TARGET_NOTE_LIMIT = 3;
var RoutePayloadTargetNotesSchema = z133.object({
  entries: z133.array(ContactNoteSchema),
  total: z133.number().int()
});
var DOOR_KNOCK_STATUSES = [
  "unknown",
  "not_home",
  "supporter",
  "non_supporter",
  "inaccessible",
  "refused",
  "not_a_voter",
  "engaged",
  "needs_follow_up"
];
var DoorKnockStatusSchema = z133.enum(DOOR_KNOCK_STATUSES);
var RoutePayloadTargetSchema = z133.object({
  stopTargetId: z133.number().int(),
  personId: z133.string(),
  name: z133.string().nullable(),
  age: z133.number().nullable(),
  politicalParty: z133.enum(["Independent", "Democratic", "Republican", "Other"]).nullable(),
  // For the door that doesn't answer. Live-only, like age and party: a
  // mayHaveMoved target has no live row, so it carries no number rather than a
  // number belonging to whoever lives there now. Screen only — the printed
  // walk sheet deliberately omits these, since paper leaves the building.
  cellPhone: z133.string().nullable(),
  landline: z133.string().nullable(),
  // The eleven-attribute demographic profile, derived from the residents
  // contract's shape so the two cannot drift — `serve()` copies these across
  // one for one, and a field added on one side without the other would be a
  // silent hole rather than a type error.
  //
  // Live-only like age, party and the phones: a `mayHaveMoved` target has no
  // live row, so every one of these is null for them rather than describing
  // whoever lives there now. Screen only — both paper surfaces omit them, for
  // the reason they omit the phone numbers, and with more force: a demographic
  // profile of a named voter on a page that leaves the building is a larger
  // disclosure than a phone number is.
  //
  // Targets only. `otherResidents` below stays name-only.
  //
  // **Optional here and required on the residents response**, which is the same
  // split `history` and `notAVoterReason` above make and for the same reason:
  // this payload is what a service worker snapshots for a walk with no signal,
  // so one taken before this shipped carries none of these keys and has to keep
  // parsing on a phone that cannot refetch. The residents response is an
  // in-process S2S read with no snapshot, so required there is what actually
  // enforces that the SELECT widened.
  //
  // Consequence for renderers, and it is the whole reason this is written down:
  // absent means the same thing as null and must render the same way. A
  // `boolean | null | undefined` fed to a bare ternary makes `undefined` false,
  // which would print "No" against `registeredVoter` on every pre-ship
  // snapshot — see `demographicFacts.ts`, which normalizes both.
  ...optionalDemographics(),
  knockStatus: DoorKnockStatusSchema,
  mayHaveMoved: z133.boolean(),
  // Do-not-knock. A flag rather than a DoorKnockStatus member: a knock
  // status is derived from an interaction, and this comes from the
  // contact-status projection instead. Read live at serve time, so a person
  // flagged this morning is marked on a route frozen yesterday — turf
  // evaluation keeps them out of new routes, but it cannot reach back into
  // one already built.
  doNotKnock: z133.boolean(),
  // Why this person is not a voter to reach here, when someone at
  // the door said so. Read live at serve time for the same reason doNotKnock
  // is: evaluation keeps them out of new routes, but the frozen one in
  // someone's hand already passed it.
  //
  // An absent key rather than a nullable one — `cleared` is the absence of a
  // reason, and the marker is present or it isn't. Keeping it optional also
  // means a payload snapshotted offline before this shipped still parses.
  notAVoterReason: NotAVoterReasonSchema.optional(),
  // This resident's own recent outreach, newest first — never the
  // household's. Two people behind one door disagree, and attributing a
  // neighbor's refusal to the person answering is worse than showing nothing.
  //
  // The server always sends the array, empty included: "we have never been
  // here" is a thing the card says out loud. Optional for the same reason
  // notAVoterReason above is — a payload snapshotted offline before this
  // shipped has to keep parsing on a phone that cannot refetch.
  //
  // Deliberately not `.default([])`, which reads like the safer form and is
  // not: nothing parses this schema at runtime in either direction
  // (ZodResponseInterceptor isn't registered globally and DoorKnockingController
  // doesn't apply it, so serveRoute's @ResponseSchema is inert; the webapp's
  // clientRequest casts ofetch's JSON without parsing). A default would fill in
  // nothing and only promise the compiler a non-optional array, so a service
  // worker's pre-ship snapshot would hand a `.map()` undefined with no type
  // error. Optional keeps that decision at the call site.
  history: z133.array(RouteTargetActivitySchema).optional(),
  // This resident's saved contact notes, newest first, capped at
  // ROUTE_TARGET_NOTE_LIMIT with their true count beside them. Riding the
  // payload rather than fetched per resident for the same reason as
  // `history`: the sheet is deliberately fetch-free, because the moment
  // a canvasser needs it is the moment they are standing on a porch in the
  // dead zone the whole feature is shaped around.
  //
  // Keyed by personId like `history`, never rolled up to the address. Two
  // people behind one door are two records, and free text written about one of
  // them read against the housemate who answered is the same misattribution
  // `history` avoids, with worse material than an outcome enum.
  //
  // The CRM's own `ContactNoteSchema`, not a door-knocking narrowing of it, so
  // one note cannot be worded two ways — and so the webapp can drop the
  // response of its own create/edit straight into `entries` without a
  // translation step that would be a second idea of what a note is.
  //
  // The server always sends the block, `{ entries: [], total: 0 }` included:
  // "nothing written down about this person yet" is a thing the sheet says out
  // loud, and it has to stay distinguishable from a payload that predates this
  // field, where the key is absent and absence is not a claim about anything.
  //
  // Optional and deliberately not `.default([])`, for the reason set out on
  // `history` above: nothing parses this schema at runtime in either
  // direction, so a default fills in nothing anywhere and only promises the
  // compiler a value that a service worker's pre-ship snapshot does not carry.
  //
  // Screen only. Both paper surfaces omit it, for the reason they omit the
  // phones and the demographic profile and with more force again — free text
  // about a named voter, on a page that stops being access-controlled the
  // moment it leaves the building.
  notes: RoutePayloadTargetNotesSchema.optional()
});
var RoutePayloadAddressSchema = z133.object({
  addressKey: z133.string(),
  // Frozen at the lock (the addressKey's address line) — never re-derived
  // from live data, so the walk view matches what was routed.
  //
  // The WHOLE address, street line included, because the surfaces without a
  // stop heading above them need one: the printed walk sheet and the PDF put
  // one row per door on paper, and "Apt 8309" on its own names no house.
  address: z133.string(),
  // Just the unit — "Apt 8309" — and empty for a single-family house.
  //
  // Its own field rather than something the client slices off `address`,
  // because only the key knows where the street line ends: `AddressLine`
  // arrives with the unit already in it, so the split is a subtraction the
  // server does against `ApartmentNum` and cannot be redone downstream
  // without shipping the apartment too.
  //
  // The walk view's door rows render this alone, since the stop above them
  // already carries the street. Empty is the signal that a door needs no row
  // at all: with one unnamed door under a stop there is nothing to tell apart,
  // so the list goes straight to its residents.
  unit: z133.string(),
  targets: z133.array(RoutePayloadTargetSchema),
  // Live household context, deliberately name-only — the demographic profile
  // above is for targets alone.
  otherResidents: z133.array(z133.object({ name: z133.string().nullable() }))
});
var RoutePayloadStopSchema = z133.object({
  id: z133.number().int(),
  seq: z133.number().int(),
  lat: z133.number(),
  lng: z133.number(),
  // The street line alone — "205 Benton Dr", never "205 Benton Dr Apt 8309".
  //
  // A stop is a coordinate and an apartment building is one coordinate with
  // many doors, so naming the stop after a single unit picked whichever
  // resident happened to sort first and then labelled the whole building with
  // their apartment. The units live on `addresses[].unit` below, where a
  // canvasser can read them as the list of doors they actually are.
  //
  // Derived at serve time rather than read straight from the frozen column,
  // which still holds the unit: routes created before this was a distinction
  // would otherwise keep announcing one door's apartment as the building's
  // name for as long as they exist.
  displayAddress: z133.string(),
  legSeconds: z133.number().int(),
  legMeters: z133.number().int(),
  // No stop-level rollup: the webapp's `rollupStopStatus` derives one from
  // `addresses[].targets[].knockStatus`, and shipping a second copy meant two
  // implementations of one rule that had to agree about suppressing
  // do-not-knock and not-a-voter residents. One implementation cannot drift.
  addresses: z133.array(RoutePayloadAddressSchema)
});
var RoutePathGeometrySchema = z133.union([
  z133.object({
    type: z133.literal("LineString"),
    coordinates: z133.array(z133.tuple([z133.number(), z133.number()]))
  }),
  z133.object({
    type: z133.literal("MultiLineString"),
    coordinates: z133.array(z133.array(z133.tuple([z133.number(), z133.number()])))
  })
]);
var RoutePayloadRepresentingSchema = z133.object({
  name: z133.string(),
  office: z133.string()
});
var DoorKnockingRoutePayloadSchema = z133.object({
  route: DoorKnockingRouteHeaderSchema,
  pathGeometry: RoutePathGeometrySchema.nullable(),
  stops: z133.array(RoutePayloadStopSchema),
  // The owning org's surface (the `eo-` slug prefix, the system-wide Win/Serve
  // invariant — see gp-api's `src/contacts/AGENTS.md`), riding the payload for
  // the same reason `PhoneBankingListSchema` carries it: door knocking has ONE
  // route for both surfaces, so nothing in the URL distinguishes them.
  //
  // The webapp has a context (`doorKnockingSurface.tsx`) and could re-derive
  // this while the create flow is open, but the surfaces that read a served
  // route cannot: the printable walk sheet and the PDF render server-side from
  // this payload alone, with no organization provider above them. Deriving it
  // once here is also what keeps the walk, the person sheet and the two paper
  // formats from arriving at four answers about one list.
  //
  // Optional, like `history` and `notes` above and for the identical reason: a
  // service worker's pre-ship snapshot carries no such key and has to keep
  // parsing on a phone that cannot refetch. Absent reads as Win, which is the
  // surface every route frozen before this shipped belonged to.
  isServe: z133.boolean().optional(),
  // Optional for the reason every field above it is: a service worker's
  // pre-ship snapshot carries no such key and has to keep parsing on a phone
  // that cannot refetch. Absent means the door script falls back to what it
  // built before this shipped — the candidate's own opener on the dashboard,
  // and the bare "Hi, I'm {volunteer}." on the volunteer walk.
  //
  // Also absent when the position name cannot be resolved: `serve()` treats
  // this as best-effort, because a walk is worth more than an opener and
  // election-api being down is not a reason a canvasser cannot knock.
  representing: RoutePayloadRepresentingSchema.optional(),
  // The list's frozen talking points, plain text: four lines for a list made
  // before free text, otherwise free text with DOOR_KNOCKING_BULLET lines.
  //
  // Riding the payload rather than fetched by a hook, for the reason `isServe`
  // gives above and `history` gives at length: the printable walk sheet and
  // the PDF render server-side from this payload alone, and the person sheet
  // is deliberately fetch-free because the moment a canvasser needs it is the
  // moment they are standing on a porch in the dead zone this whole feature is
  // shaped around.
  //
  // Optional, and never `.default('')`, like every field above it: absent
  // means a list created before this shipped, and the door script falls back
  // to the static build for exactly those. Absent must render identically to
  // empty.
  talkingPoints: z133.string().optional(),
  // The turf's list can only hold civic panel members (isCivicPanelOnlyList
  // on its saved criteria), so a Serve canvasser asks whether they want to
  // stay on the panel instead of whether they want to join. Optional like
  // every field above it: a snapshot without it asks the join question.
  civicPanelOnly: z133.boolean().optional()
});

// src/doorKnocking/DoorKnockingPack.schema.ts
var AGE_DIM_KEY = "age";
var CONTACTS_MADE_DIM_KEY = "contactsMade";
var CONTACTS_MADE_BUCKETS = ["0", "1", "2", "3", "4", "5+"];
var PACK_CONTACTS_MADE_MAX = 1e5;
var KNOCKABLE_DIM_KEY = "knockable";
var KNOCKABLE_VALUES = ["No", "Yes"];
var PACK_EXCLUDED_PEOPLE_MAX = 1e5;
var PRECINCT_DIM_KEY = "precinct";
var DoorKnockingPackRequestSchema = z134.object({
  districtId: z134.guid(),
  // gp-api's org-wide latest-per-person knock statuses; bounded by doors
  // actually knocked, so far smaller than the district. The cap fits
  // people-api's 32 MiB body limit with headroom.
  knockStatuses: z134.array(
    z134.object({
      personId: z134.guid(),
      status: DoorKnockStatusSchema
    }).strict()
  ).max(2e5).optional(),
  // The second per-organization plane: how many interactions this campaign
  // has logged against each person, bucketed as the saved-list filter
  // buckets it. Only people with at least one are sent — everyone else IS
  // bucket 0, so the plane's default byte is already the right answer for
  // them, and the array is bounded by who the campaign has contacted rather
  // than by the district.
  //
  // ABSENT AND EMPTY MEAN DIFFERENT THINGS, and the encoder treats them so.
  // An empty array is an organization that has contacted nobody, which is a
  // fact the map can shade ("0 prior contacts" is everyone). Absent means
  // gp-api could not answer — see PACK_CONTACTS_MADE_MAX — and the plane is
  // then left out of the pack entirely, which the client reads through the
  // same unpreviewable-filter disclosure that names any other dim it lacks.
  // The people every server-side evaluation removes before it counts
  // anything: do-not-knock and not-a-voter, deduped, exactly as
  // `doorKnockingPreview` and `doorKnockingCreate` build them.
  //
  // ABSENT AND EMPTY MEAN DIFFERENT THINGS, as they do for contactsMade.
  // Empty is an organization that has flagged nobody, which is a fact the
  // map can shade. Absent means gp-api did not answer, and the plane is
  // left out rather than filled with "knockable" — a plane of yeses
  // claims every door is open, which is the wrong way to be wrong about
  // somebody who said don't come back.
  excludedPersonIds: z134.array(z134.guid()).max(PACK_EXCLUDED_PEOPLE_MAX).optional(),
  contactsMade: z134.array(
    z134.object({
      personId: z134.guid(),
      // Index into CONTACTS_MADE_BUCKETS; never 0, since bucket 0 is
      // the plane's default and sending it would be a wasted row.
      bucket: z134.int().min(1).max(CONTACTS_MADE_BUCKETS.length - 1)
    }).strict()
  ).max(PACK_CONTACTS_MADE_MAX).optional()
}).strict();
var PACK_STREAM_MAGIC = "GPPACKS1";
var PACK_STREAM_MAGIC_BYTES = 8;
var PACK_STREAM_FRAME_HEADER_BYTES = 8;
var PACK_STREAM_ALIGNMENT = 8;
var PACK_STREAM_FRAME_KINDS = {
  heartbeat: 1,
  pack: 2,
  error: 3
};
var PACK_ARRAY_TYPES = ["f32", "u32", "u16", "u8"];
var PACK_CORE_ARRAYS = {
  positions: "positions",
  personToHousehold: "personToHousehold",
  householdToDot: "householdToDot"
};
var PACK_DIM_WIDTHS = { u8: 256, u16: 65536 };
var DoorKnockingPackDimSchema = z134.object({
  key: z134.string().min(1),
  // The dim's plane (array named `dim:<key>`, one ELEMENT per person) holds
  // indexes into this list. u8 unless the vocabulary needs more than 256
  // entries, which only precinct does.
  values: z134.array(z134.string().min(1)).min(1).max(PACK_DIM_WIDTHS.u16)
});
var DoorKnockingPackArraySchema = z134.object({
  name: z134.string().min(1),
  type: z134.enum(PACK_ARRAY_TYPES),
  byteOffset: z134.number().int().nonnegative(),
  elementCount: z134.number().int().nonnegative()
});
var PACK_FORMAT_REVISION = 6;
var DoorKnockingPackManifestSchema = z134.object({
  version: z134.literal(1),
  generatedAt: z134.string().datetime(),
  counts: z134.object({
    people: z134.number().int().nonnegative(),
    households: z134.number().int().nonnegative(),
    dots: z134.number().int().nonnegative()
  }).strict(),
  dims: z134.array(DoorKnockingPackDimSchema),
  arrays: z134.array(DoorKnockingPackArraySchema)
}).superRefine((manifest, ctx) => {
  const byName = new Map(manifest.arrays.map((a) => [a.name, a]));
  for (const core of Object.values(PACK_CORE_ARRAYS)) {
    if (!byName.has(core)) {
      ctx.addIssue({
        path: ["arrays"],
        code: z134.ZodIssueCode.custom,
        message: `missing core array "${core}"`
      });
    }
  }
  for (const dim of manifest.dims) {
    const plane = byName.get(`dim:${dim.key}`);
    if (!plane || plane.type !== "u8" && plane.type !== "u16") {
      ctx.addIssue({
        path: ["dims"],
        code: z134.ZodIssueCode.custom,
        message: `dim "${dim.key}" needs a u8 or u16 array named "dim:${dim.key}"`
      });
    } else if (dim.values.length > PACK_DIM_WIDTHS[plane.type]) {
      ctx.addIssue({
        path: ["dims"],
        code: z134.ZodIssueCode.custom,
        message: `dim "${dim.key}" has ${dim.values.length} values, more than a ${plane.type} plane can index`
      });
    } else if (plane.elementCount !== manifest.counts.people) {
      ctx.addIssue({
        path: ["dims"],
        code: z134.ZodIssueCode.custom,
        message: `dim "${dim.key}" elementCount (${plane.elementCount}) must equal counts.people (${manifest.counts.people})`
      });
    }
  }
  const expectedCounts = [
    [PACK_CORE_ARRAYS.positions, manifest.counts.dots * 2],
    [PACK_CORE_ARRAYS.personToHousehold, manifest.counts.people],
    [PACK_CORE_ARRAYS.householdToDot, manifest.counts.households]
  ];
  for (const [name, expected] of expectedCounts) {
    const array = byName.get(name);
    if (array && array.elementCount !== expected) {
      ctx.addIssue({
        path: ["arrays"],
        code: z134.ZodIssueCode.custom,
        message: `${name} elementCount (${array.elementCount}) must equal ${expected}`
      });
    }
  }
});

// src/doorKnocking/PackAgeBuckets.ts
var AGE_FILTER_KEY_RANGES = {
  age18_25: { min: 18, max: 25 },
  age25_35: { min: 25, max: 35 },
  age35_50: { min: 35, max: 50 },
  age50Plus: { min: 50, max: null },
  age18_24: { min: 18, max: 24 },
  age25_34: { min: 25, max: 34 },
  age35_49: { min: 35, max: 49 },
  age50_64: { min: 50, max: 64 },
  age65Plus: { min: 65, max: null }
};
var CURRENT_AGE_FILTER_KEYS = [
  "age18_24",
  "age25_34",
  "age35_49",
  "age50_64",
  "age65Plus"
];
var PACK_AGE_UNKNOWN = "Unknown";
var RANGES = Object.values(AGE_FILTER_KEY_RANGES);
var CUTS = [
  ...new Set(
    RANGES.flatMap(({ min, max }) => max === null ? [min] : [min, max + 1])
  )
].sort((a, b) => a - b);
var INTERVALS = CUTS.map((min, index) => ({
  min,
  max: index === CUTS.length - 1 ? null : CUTS[index + 1] - 1
}));
var intervalName = ({ min, max }) => max === null ? `${min}_plus` : min === max ? `${min}` : `${min}_${max}`;
var PACK_AGE_BUCKETS = [
  PACK_AGE_UNKNOWN,
  ...INTERVALS.map(intervalName)
];
var LAST_INDEXED_AGE = 130;
var BYTE_BY_AGE = new Uint8Array(LAST_INDEXED_AGE + 1);
for (let age = CUTS[0]; age <= LAST_INDEXED_AGE; age += 1) {
  let index = 0;
  while (index + 1 < INTERVALS.length && age >= INTERVALS[index + 1].min) {
    index += 1;
  }
  BYTE_BY_AGE[age] = index + 1;
}
var encodeAgeBucket = (age) => {
  if (age === null || age < CUTS[0]) return 0;
  return age > LAST_INDEXED_AGE ? INTERVALS.length : BYTE_BY_AGE[age];
};
var bucketsForRange = ({ min, max }) => INTERVALS.filter(
  (interval) => interval.min >= min && (max === null || (interval.max ?? Infinity) <= max)
).map(intervalName);
var AGE_KEY_TO_PACK_BUCKETS = Object.fromEntries(
  Object.entries(AGE_FILTER_KEY_RANGES).map(([key, range]) => [
    key,
    bucketsForRange(range)
  ])
);
var PACK_AGE_BANDS = CURRENT_AGE_FILTER_KEYS.map(
  (key) => intervalName(AGE_FILTER_KEY_RANGES[key])
);
var PACK_AGE_BUCKET_TO_BAND = Object.fromEntries(
  CURRENT_AGE_FILTER_KEYS.flatMap((key) => {
    const band = intervalName(AGE_FILTER_KEY_RANGES[key]);
    return bucketsForRange(AGE_FILTER_KEY_RANGES[key]).map((bucket) => [
      bucket,
      band
    ]);
  })
);

// src/shared/GeoJsonShape.schema.ts
import { z as z135 } from "zod";
var GeoJsonMultiPolygonSchema = z135.object({
  type: z135.literal("MultiPolygon"),
  coordinates: z135.array(GeoJsonPolygonSchema.shape.coordinates).min(1)
}).strict();
var GeoJsonShapeSchema = z135.discriminatedUnion("type", [
  GeoJsonPolygonSchema,
  GeoJsonMultiPolygonSchema
]);
var shapePolygons = (shape) => shape.type === "Polygon" ? [shape] : shape.coordinates.map((coordinates) => ({
  type: "Polygon",
  coordinates
}));
var shapePartCount = (shape) => shape.type === "Polygon" ? 1 : shape.coordinates.length;
var MAX_GEO_SHAPE_NAME_LENGTH = 120;
var GeoShapeLabelSchema = z135.object({
  name: z135.string().trim().min(1).max(MAX_GEO_SHAPE_NAME_LENGTH),
  color: z135.string().regex(/^#[0-9a-fA-F]{6}$/)
}).strict();
var GeoShapeLabelsSchema = z135.array(GeoShapeLabelSchema).min(1);

// src/doorKnocking/DoorKnockingInteraction.schema.ts
import { z as z136 } from "zod";
var RecordDoorKnockInteractionSchema = z136.object({
  stopTargetId: z136.number().int().positive(),
  clientKey: z136.guid(),
  outcome: DoorKnockOutcomeSchema,
  supportAnswer: SupportAnswerSchema.optional(),
  willVote: WillVoteAnswerSchema.optional(),
  // The Serve surface's terminal answer, in place of the two above.
  followUp: FollowUpAnswerSchema.optional(),
  // Serve's closing question, asked after follow-up. Same yes/no vocabulary.
  joinCivicPanel: FollowUpAnswerSchema.optional(),
  // Asked in place of joinCivicPanel when the list is panel members only:
  // "Do they want to stay on your civic panel?". A no takes them off it.
  stayOnCivicPanel: FollowUpAnswerSchema.optional(),
  note: z136.string().max(2e3).optional()
}).strict().refine(
  (v) => v.supportAnswer === void 0 || v.outcome === DoorKnockOutcomeSchema.enum.answered,
  {
    message: "supportAnswer is only valid when outcome is answered",
    path: ["supportAnswer"]
  }
).refine(
  (v) => v.willVote === void 0 || v.outcome === DoorKnockOutcomeSchema.enum.answered,
  {
    message: "willVote is only valid when outcome is answered",
    path: ["willVote"]
  }
).refine(
  (v) => v.followUp === void 0 || v.outcome === DoorKnockOutcomeSchema.enum.answered,
  {
    message: "followUp is only valid when outcome is answered",
    path: ["followUp"]
  }
).refine(
  (v) => v.joinCivicPanel === void 0 || v.outcome === DoorKnockOutcomeSchema.enum.answered,
  {
    message: "joinCivicPanel is only valid when outcome is answered",
    path: ["joinCivicPanel"]
  }
).refine(
  (v) => v.joinCivicPanel === void 0 || v.supportAnswer === void 0 && v.willVote === void 0,
  {
    message: "joinCivicPanel belongs to the Serve surface",
    path: ["joinCivicPanel"]
  }
).refine(
  (v) => v.stayOnCivicPanel === void 0 || v.outcome === DoorKnockOutcomeSchema.enum.answered,
  {
    message: "stayOnCivicPanel is only valid when outcome is answered",
    path: ["stayOnCivicPanel"]
  }
).refine(
  (v) => v.stayOnCivicPanel === void 0 || v.supportAnswer === void 0 && v.willVote === void 0,
  {
    message: "stayOnCivicPanel belongs to the Serve surface",
    path: ["stayOnCivicPanel"]
  }
).refine(
  (v) => v.stayOnCivicPanel === void 0 || v.joinCivicPanel === void 0,
  {
    message: "joinCivicPanel and stayOnCivicPanel are never asked together",
    path: ["stayOnCivicPanel"]
  }
).refine((v) => v.followUp === void 0 || v.supportAnswer === void 0, {
  message: "followUp and supportAnswer belong to different surfaces",
  path: ["followUp"]
}).refine((v) => v.followUp === void 0 || v.willVote === void 0, {
  message: "followUp and willVote belong to different surfaces",
  path: ["followUp"]
});
var RecordDoorKnockInteractionResponseSchema = z136.object({
  personId: z136.string(),
  knockStatus: DoorKnockStatusSchema
});

// src/doorKnocking/DoorKnockingDoNotKnock.schema.ts
import { z as z137 } from "zod";
var SetDoNotKnockSchema = z137.object({
  stopTargetId: z137.number().int().positive(),
  value: DoNotKnockStatusSchema2
}).strict();
var SetDoNotKnockResponseSchema = z137.object({
  personId: z137.string(),
  doNotKnock: z137.boolean()
});

// src/doorKnocking/DoorKnockingNotAVoter.schema.ts
import { z as z138 } from "zod";
var SetNotAVoterSchema = z138.object({
  stopTargetId: z138.number().int().positive(),
  value: NotAVoterStatusSchema2
}).strict();
var SetNotAVoterResponseSchema = z138.object({
  personId: z138.string(),
  notAVoterReason: NotAVoterReasonSchema.optional()
});

// src/constituentFeedback/ConstituentFeedback.schema.ts
import { z as z139 } from "zod";
var CONSTITUENT_FEEDBACK_TRANSCRIPT_MAX_LENGTH = 4e3;
var CONSTITUENT_FEEDBACK_ISSUE_LABEL_MAX_LENGTH = 120;
var CONSTITUENT_FEEDBACK_DESIRED_OUTCOME_MAX_LENGTH = 1e3;
var CONSTITUENT_FEEDBACK_AUDIO_KEY_MAX_LENGTH = 300;
var CONSTITUENT_FEEDBACK_MAX_ISSUES = 5;
var ConstituentFeedbackIssueSchema = z139.object({
  id: z139.string(),
  position: z139.number().int(),
  issueLabel: z139.string().max(CONSTITUENT_FEEDBACK_ISSUE_LABEL_MAX_LENGTH),
  stance: ConstituentFeedbackStanceSchema.nullable(),
  desiredOutcome: z139.string().max(CONSTITUENT_FEEDBACK_DESIRED_OUTCOME_MAX_LENGTH).nullable()
});
var RecordConstituentFeedbackBase = {
  // This memo's own replay-idempotency key, distinct from the knock's. A
  // dead-zone retry re-sends the same key and upserts the same row.
  clientKey: z139.guid(),
  // The words, when the phone has them: dictated live or typed.
  transcript: z139.string().min(1).max(CONSTITUENT_FEEDBACK_TRANSCRIPT_MAX_LENGTH).optional(),
  // The recording, when the phone had no signal to dictate over: the key
  // `POST audio-upload-url` handed out, already holding the audio. The
  // server transcribes it later, so the memo arrives with no text.
  audioKey: z139.string().min(1).max(CONSTITUENT_FEEDBACK_AUDIO_KEY_MAX_LENGTH).optional(),
  captureMethod: ConstituentFeedbackCaptureMethodSchema
};
var requireOneSource = (memo, ctx) => {
  const hasText = memo.transcript !== void 0;
  const hasRecording = memo.audioKey !== void 0;
  if (hasText === hasRecording) {
    ctx.addIssue({
      code: "custom",
      message: "Send exactly one of transcript or audioKey",
      path: ["transcript"]
    });
  }
  if (hasRecording !== (memo.captureMethod === "dictation_offline")) {
    ctx.addIssue({
      code: "custom",
      message: "captureMethod dictation_offline goes with audioKey",
      path: ["captureMethod"]
    });
  }
};
var RecordConstituentFeedbackSchema = z139.discriminatedUnion("channel", [
  z139.object({
    channel: z139.literal("door_knock"),
    // The `clientKey` of the knock this memo belongs to, which the server
    // resolves via (organizationSlug, sourceId).
    knockClientKey: z139.guid(),
    // The same frozen stop target the knock itself was recorded against.
    // Sent rather than derived because a knock row carries no turf, and the
    // turf is what holds the effort's question — resolving it from the
    // person instead would pick an arbitrary one when the same resident
    // sits in two turfs.
    stopTargetId: z139.number().int().positive(),
    ...RecordConstituentFeedbackBase
  }).strict().superRefine(requireOneSource),
  z139.object({
    channel: z139.literal("phone_bank"),
    entryId: z139.number().int().positive(),
    personId: z139.string(),
    ...RecordConstituentFeedbackBase
  }).strict().superRefine(requireOneSource)
]);
var RecordConstituentFeedbackResponseSchema = z139.object({
  id: z139.string(),
  personId: z139.string(),
  extractionStatus: ConstituentFeedbackExtractionStatusSchema,
  // Null when extraction failed. An empty list is a note that named no issue.
  extraction: z139.object({ issues: z139.array(ConstituentFeedbackIssueSchema) }).nullable()
});
var ConfirmedIssueSchema = z139.object({
  issueLabel: z139.string().trim().min(1).max(CONSTITUENT_FEEDBACK_ISSUE_LABEL_MAX_LENGTH),
  stance: ConstituentFeedbackStanceSchema.nullable(),
  desiredOutcome: z139.string().max(CONSTITUENT_FEEDBACK_DESIRED_OUTCOME_MAX_LENGTH).nullable(),
  // The `id` of the issue this one accepts or corrects, which keeps that
  // row and the model's proposal on it. An id rather than a position:
  // confirming renumbers positions, so a repeated confirm would point at
  // the wrong issue. Omitted on an issue the canvasser wrote themselves.
  fromIssueId: z139.string().optional()
}).strict();
var ConfirmConstituentFeedbackSchema = z139.object({
  issues: z139.array(ConfirmedIssueSchema).max(CONSTITUENT_FEEDBACK_MAX_ISSUES),
  skipped: z139.boolean().optional()
}).strict().refine((body) => body.skipped !== true || body.issues.length === 0, {
  message: "A skipped memo is confirmed with no issues",
  path: ["issues"]
});
var IssueTagRefSchema = z139.object({
  id: z139.string(),
  name: z139.string(),
  status: IssueTagStatusSchema
});
var ConstituentFeedbackSchema = z139.object({
  id: z139.string(),
  personId: z139.string(),
  occurredAt: zCoerceDate(),
  channel: z139.string(),
  transcript: z139.string().nullable(),
  // In the order they came up. Empty when the memo named no issue, and
  // while it waits on transcription or after its extraction failed.
  issues: z139.array(ConstituentFeedbackIssueSchema),
  extractionStatus: ConstituentFeedbackExtractionStatusSchema,
  confirmedAt: zCoerceDate().nullable(),
  // The outreach envelope the conversation happened under. Null when the
  // phone list it came from was created without one.
  outreachId: z139.number().int().nullable(),
  // Who recorded it. Null when the actor's user row has since been removed,
  // matching how the contact feed renders an authorless note.
  actorName: z139.string().nullable(),
  // Accepted tags only. A proposal is a suggestion nobody has agreed to, so
  // it shows in the report and the curation list, never on a person.
  tags: z139.array(IssueTagRefSchema)
});
var ConstituentFeedbackListResponseSchema = z139.object({
  feedback: z139.array(ConstituentFeedbackSchema)
});
var ISSUE_CAPTURE_OFF_ERROR_CODE = "ISSUE_CAPTURE_OFF";
var CONSTITUENT_FEEDBACK_AUDIO_MAX_BYTES = 5e6;
var AudioUploadUrlRequestSchema = z139.object({
  clientKey: z139.guid(),
  contentType: z139.string().regex(/^audio\/[\w.+-]+(;.*)?$/).max(100)
}).strict();
var AudioUploadUrlResponseSchema = z139.object({
  audioKey: z139.string(),
  uploadUrl: z139.string(),
  fields: z139.record(z139.string(), z139.string()),
  expiresAt: zCoerceDate()
});

// src/constituentFeedback/FeedbackSynthesis.schema.ts
import { z as z140 } from "zod";
var FEEDBACK_SYNTHESIS_SOURCE_TYPE = "constituent_feedback";
var FeedbackSynthesisCompleteEventSchema = z140.object({
  type: z140.literal("feedbackSynthesisComplete"),
  data: z140.object({
    sourceType: z140.literal(FEEDBACK_SYNTHESIS_SOURCE_TYPE),
    sourceId: z140.string(),
    totalResponses: z140.number(),
    responsesLocation: z140.string().nullable(),
    // Whether the cluster-analysis theme prompt came from the hosted
    // Braintrust build or the in-repo fallback. Optional because the
    // pipeline image deploys separately from gp-api and an older pipeline
    // build sends no such field at all.
    promptSource: z140.enum(["hosted", "fallback"]).optional(),
    issues: z140.array(
      z140.object({
        rank: z140.number().int().min(1),
        theme: z140.string(),
        summary: z140.string(),
        analysis: z140.string(),
        responseCount: z140.number(),
        quotes: z140.array(
          z140.object({ quote: z140.string(), respondent_id: z140.string() })
        ),
        memberIds: z140.array(z140.string()).optional()
      })
    )
  })
});
var FeedbackSynthesisResponseRowsSchema = z140.array(
  z140.object({ respondent_id: z140.string(), theme: z140.string() })
);
var SynthesisRunSchema = z140.object({
  id: z140.string(),
  status: SynthesisRunStatusSchema,
  createdAt: zCoerceDate(),
  completedAt: zCoerceDate().nullable(),
  engine: z140.string()
});
var FeedbackReportChannelSchema = ConstituentFeedbackChannelSchema;
var StanceCountsSchema = z140.object({
  supports: z140.number().int(),
  opposes: z140.number().int(),
  mixed: z140.number().int(),
  unclear: z140.number().int()
});
var FeedbackThemeSummarySchema = z140.object({
  id: z140.string(),
  rank: z140.number().int(),
  title: z140.string(),
  summary: z140.string(),
  conversationCount: z140.number().int(),
  stanceCounts: StanceCountsSchema.nullable(),
  // Up to five distinct outcomes people asked for.
  desiredOutcomes: z140.array(z140.string()),
  tag: IssueTagRefSchema.nullable()
});
var FEEDBACK_REPORT_MEMO_LIMIT = 200;
var FeedbackReportMemoSchema = z140.object({
  id: z140.string(),
  personId: z140.string(),
  occurredAt: zCoerceDate(),
  channel: FeedbackReportChannelSchema,
  // The canvasser's own summary, never the other person's words.
  transcript: z140.string().nullable(),
  issues: z140.array(ConstituentFeedbackIssueSchema),
  actorName: z140.string().nullable(),
  // Null means not confirmed: listed, never counted.
  confirmedAt: zCoerceDate().nullable(),
  // With no transcript, `pending` is a recording still being transcribed
  // and `failed` one that could not be read. Null on a text reply, which
  // nothing extracts.
  extractionStatus: ConstituentFeedbackExtractionStatusSchema.nullable()
});
var FeedbackReportResponseSchema = z140.object({
  // The effort's question, from its turf or list. Null when it asked none,
  // and on a text send.
  question: z140.string().nullable(),
  // A turf's envelope is door_knock, a phone list's is phone_bank, a text
  // send's is text, whether or not anything has been recorded on it yet.
  channel: FeedbackReportChannelSchema,
  // The fewest confirmed memos a run accepts. Sent rather than known by the
  // client so the line under the floor cannot drift from the 422.
  floor: z140.number().int(),
  denominators: z140.object({
    // Distinct people who answered on this effort.
    conversations: z140.number().int(),
    memos: z140.number().int(),
    confirmed: z140.number().int(),
    // Memos nobody has confirmed. Never in a theme or a count.
    pending: z140.number().int()
  }),
  // The latest run that has not been superseded: running, failed, or the
  // completed one the themes come from.
  run: SynthesisRunSchema.nullable(),
  // From the latest completed run, so a run in flight or a failed one
  // leaves the previous themes visible.
  themes: z140.array(FeedbackThemeSummarySchema),
  // Confirmed and pending, newest first, at most FEEDBACK_REPORT_MEMO_LIMIT.
  memos: z140.array(FeedbackReportMemoSchema).max(FEEDBACK_REPORT_MEMO_LIMIT)
});
var FeedbackThemeMemberSchema = z140.object({
  feedbackId: z140.string().nullable(),
  textReplyId: z140.string().nullable(),
  personId: z140.string(),
  occurredAt: zCoerceDate(),
  channel: FeedbackReportChannelSchema,
  // The canvasser's own summary, never the other person's words.
  transcript: z140.string().nullable(),
  issues: z140.array(ConstituentFeedbackIssueSchema),
  actorName: z140.string().nullable()
});
var FeedbackThemeDetailSchema = FeedbackThemeSummarySchema.extend({
  details: z140.string(),
  // Every distinct outcome, not the report card's five.
  desiredOutcomes: z140.array(z140.string()),
  // Confirmed members only, newest first.
  members: z140.array(FeedbackThemeMemberSchema)
});
var IssueTagSchema = z140.object({
  id: z140.string(),
  name: z140.string().max(CONSTITUENT_FEEDBACK_ISSUE_LABEL_MAX_LENGTH),
  status: IssueTagStatusSchema,
  source: IssueTagSourceSchema,
  declaredTopIssueId: z140.number().int().nullable(),
  mergedIntoId: z140.string().nullable(),
  proposedByRunId: z140.string().nullable(),
  feedbackCount: z140.number().int()
});
var IssueTagListResponseSchema = z140.object({
  tags: z140.array(IssueTagSchema)
});
var UpdateIssueTagSchema = z140.discriminatedUnion("action", [
  z140.object({ action: z140.literal("accept") }).strict(),
  z140.object({
    action: z140.literal("rename"),
    name: z140.string().trim().min(1).max(CONSTITUENT_FEEDBACK_ISSUE_LABEL_MAX_LENGTH)
  }).strict(),
  // The target must be accepted, so merges never chain onto a suggestion.
  z140.object({ action: z140.literal("merge"), intoTagId: z140.string() }).strict(),
  z140.object({ action: z140.literal("retire") }).strict()
]);
var FEEDBACK_SEED_MAX_COUNT = 200;
var SeedFeedbackRequestSchema = z140.object({
  outreachId: z140.number().int().positive(),
  count: z140.number().int().min(1).max(FEEDBACK_SEED_MAX_COUNT)
}).strict();
var SeedFeedbackResponseSchema = z140.object({
  outreachId: z140.number().int(),
  // Fewer than asked on a phone list, which holds one call per person.
  created: z140.number().int()
});

// src/phoneBanking/PhoneBankingCall.schema.ts
import { z as z141 } from "zod";
var PHONE_BANKING_CALL_NOTE_MAX_LENGTH = 2e3;
var RecordPhoneBankingCallSchema = z141.object({
  entryId: z141.number().int().positive(),
  outcome: PhoneBankCallOutcomeSchema,
  personId: z141.string().optional(),
  supportAnswer: SupportAnswerSchema.optional(),
  willVote: WillVoteAnswerSchema.optional(),
  followUp: FollowUpAnswerSchema.optional(),
  // Serve's closing question, asked after follow-up. Same yes/no vocabulary.
  joinCivicPanel: FollowUpAnswerSchema.optional(),
  // Asked in place of joinCivicPanel when the list is panel members only:
  // "Do they want to stay on your civic panel?". A no takes them off it.
  stayOnCivicPanel: FollowUpAnswerSchema.optional(),
  note: z141.string().max(PHONE_BANKING_CALL_NOTE_MAX_LENGTH).optional(),
  // After an answered upsert, log the entry's remaining un-logged
  // household members as answered too, in the same request.
  markHouseholdDone: z141.boolean().optional()
}).strict().refine(
  (v) => v.personId === void 0 || v.outcome === PhoneBankCallOutcomeSchema.enum.answered || v.outcome === PhoneBankCallOutcomeSchema.enum.refused || v.outcome === PhoneBankCallOutcomeSchema.enum.hung_up,
  {
    message: "personId is only valid when outcome is answered, refused, or hung_up",
    path: ["personId"]
  }
).refine(
  (v) => v.outcome !== PhoneBankCallOutcomeSchema.enum.answered || v.personId !== void 0,
  {
    message: "personId is required when outcome is answered",
    path: ["personId"]
  }
).refine(
  (v) => v.supportAnswer === void 0 || v.outcome === PhoneBankCallOutcomeSchema.enum.answered,
  {
    message: "supportAnswer is only valid when outcome is answered",
    path: ["supportAnswer"]
  }
).refine(
  (v) => v.willVote === void 0 || v.outcome === PhoneBankCallOutcomeSchema.enum.answered,
  {
    message: "willVote is only valid when outcome is answered",
    path: ["willVote"]
  }
).refine(
  (v) => v.followUp === void 0 || v.outcome === PhoneBankCallOutcomeSchema.enum.answered,
  {
    message: "followUp is only valid when outcome is answered",
    path: ["followUp"]
  }
).refine(
  (v) => v.followUp === void 0 || v.supportAnswer === void 0 && v.willVote === void 0,
  {
    message: "followUp is mutually exclusive with supportAnswer and willVote",
    path: ["followUp"]
  }
).refine(
  (v) => v.joinCivicPanel === void 0 || v.outcome === PhoneBankCallOutcomeSchema.enum.answered,
  {
    message: "joinCivicPanel is only valid when outcome is answered",
    path: ["joinCivicPanel"]
  }
).refine(
  (v) => v.joinCivicPanel === void 0 || v.supportAnswer === void 0 && v.willVote === void 0,
  {
    message: "joinCivicPanel belongs to the Serve surface",
    path: ["joinCivicPanel"]
  }
).refine(
  (v) => v.stayOnCivicPanel === void 0 || v.outcome === PhoneBankCallOutcomeSchema.enum.answered,
  {
    message: "stayOnCivicPanel is only valid when outcome is answered",
    path: ["stayOnCivicPanel"]
  }
).refine(
  (v) => v.stayOnCivicPanel === void 0 || v.supportAnswer === void 0 && v.willVote === void 0,
  {
    message: "stayOnCivicPanel belongs to the Serve surface",
    path: ["stayOnCivicPanel"]
  }
).refine(
  (v) => v.stayOnCivicPanel === void 0 || v.joinCivicPanel === void 0,
  {
    message: "joinCivicPanel and stayOnCivicPanel are never asked together",
    path: ["stayOnCivicPanel"]
  }
).refine(
  (v) => !v.markHouseholdDone || v.outcome === PhoneBankCallOutcomeSchema.enum.answered,
  {
    message: "markHouseholdDone is only valid when outcome is answered",
    path: ["markHouseholdDone"]
  }
);
var PhoneBankingCallResultSchema = z141.object({
  personId: z141.string(),
  interaction: PhoneBankingInteractionSchema
});
var RecordPhoneBankingCallResponseSchema = z141.object({
  entryId: z141.number().int(),
  results: z141.array(PhoneBankingCallResultSchema),
  envelopeCompleted: z141.boolean()
});

// src/phoneBanking/PhoneBankingScript.const.ts
var VOTER_NAME_TOKEN = "[voter name]";
var CONSTITUENT_NAME_TOKEN = "[constituent name]";
var CONTACT_NAME_TOKENS = [
  VOTER_NAME_TOKEN,
  CONSTITUENT_NAME_TOKEN
];

// src/testFixtures/testFixtures.schema.ts
import { z as z143 } from "zod";

// src/testMode/testMode.schema.ts
import { z as z142 } from "zod";
var TEST_MODE_ORGANIZATION_TYPE_VALUES = [
  "campaign",
  "elected_office"
];
var TestModeOrganizationTypeSchema = z142.enum(
  TEST_MODE_ORGANIZATION_TYPE_VALUES
);
var TEST_MODE_FAMILY_VALUES = [
  "onboarding",
  "pro",
  "election",
  "term",
  "tenDlc"
];
var TestModeFamilySchema = z142.enum(TEST_MODE_FAMILY_VALUES);
var TEST_MODE_ONBOARDING_PRESET_VALUES = [
  "not_started",
  "complete"
];
var TestModeOnboardingPresetSchema = z142.enum(
  TEST_MODE_ONBOARDING_PRESET_VALUES
);
var TEST_MODE_PRO_PRESET_VALUES = ["on", "off"];
var TestModeProPresetSchema = z142.enum(TEST_MODE_PRO_PRESET_VALUES);
var TEST_MODE_ELECTION_PRESET_VALUES = [
  "in_8_weeks",
  "in_1_week",
  "passed_unanswered",
  "passed_won",
  "passed_lost"
];
var TestModeElectionPresetSchema = z142.enum(
  TEST_MODE_ELECTION_PRESET_VALUES
);
var TEST_MODE_TERM_PRESET_VALUES = [
  "active",
  "ending_soon",
  "ended"
];
var TestModeTermPresetSchema = z142.enum(TEST_MODE_TERM_PRESET_VALUES);
var TEST_MODE_TEN_DLC_PRESET_VALUES = [
  "none",
  "in_progress",
  "filing_hold",
  "awaiting_pin",
  "in_review",
  "approved",
  "rejected",
  "error"
];
var TestModeTenDlcPresetSchema = z142.enum(
  TEST_MODE_TEN_DLC_PRESET_VALUES
);
var TestModeRaceSchema = z142.object({
  zip: z142.string().trim().min(1),
  office: z142.string().trim().min(1)
});
var CreateTestOrganizationRequestSchema = z142.discriminatedUnion(
  "type",
  [
    z142.object({
      type: z142.literal("campaign"),
      race: TestModeRaceSchema,
      onboarding: TestModeOnboardingPresetSchema,
      pro: TestModeProPresetSchema,
      election: TestModeElectionPresetSchema,
      tenDlc: TestModeTenDlcPresetSchema
    }),
    z142.object({
      type: z142.literal("elected_office"),
      race: TestModeRaceSchema,
      onboarding: TestModeOnboardingPresetSchema,
      term: TestModeTermPresetSchema
    })
  ]
);
var ApplyTestModeRequestSchema = z142.discriminatedUnion("family", [
  z142.object({
    family: z142.literal("onboarding"),
    preset: TestModeOnboardingPresetSchema
  }),
  z142.object({ family: z142.literal("pro"), preset: TestModeProPresetSchema }),
  z142.object({
    family: z142.literal("election"),
    preset: TestModeElectionPresetSchema
  }),
  z142.object({ family: z142.literal("term"), preset: TestModeTermPresetSchema }),
  z142.object({
    family: z142.literal("tenDlc"),
    preset: TestModeTenDlcPresetSchema
  })
]);
var TestModeFamilyStateSchema = z142.object({
  current: z142.string().nullable(),
  available: z142.array(z142.string())
});
var TestModeOrganizationSchema = z142.object({
  slug: z142.string(),
  name: z142.string(),
  type: TestModeOrganizationTypeSchema,
  createdAt: z142.string()
});
var TestModeActiveOrganizationSchema = z142.object({
  slug: z142.string(),
  type: TestModeOrganizationTypeSchema,
  families: z142.object({
    onboarding: TestModeFamilyStateSchema.optional(),
    pro: TestModeFamilyStateSchema.optional(),
    election: TestModeFamilyStateSchema.optional(),
    term: TestModeFamilyStateSchema.optional(),
    tenDlc: TestModeFamilyStateSchema.optional()
  })
});
var TestModeStateSchema = z142.object({
  organizations: z142.array(TestModeOrganizationSchema),
  active: TestModeActiveOrganizationSchema.nullable()
});

// src/testFixtures/testFixtures.schema.ts
var TEST_FIXTURE_STATE_VALUES = [
  "free-win",
  "pro-win",
  // A Pro Win candidate whose real 10DLC registration has run to `tcr_approved`
  // against the vendor mocks (VENDOR_MODE=mock only).
  "pro-win-10dlc-mock",
  "serve",
  "serve-won-race"
];
var TestFixtureStateSchema = z143.enum(TEST_FIXTURE_STATE_VALUES);
var TestFixtureCookiesSchema = z143.object({
  token: z143.string(),
  user: z143.string(),
  "organization-slug": z143.string()
});
var TestFixtureUserResponseSchema = z143.object({
  state: TestFixtureStateSchema,
  userId: z143.number(),
  clerkUserId: z143.string(),
  email: z143.string(),
  password: z143.string(),
  campaignId: z143.number().optional(),
  electedOfficeId: z143.string().optional(),
  orgSlug: z143.string(),
  campaignOrgSlug: z143.string().optional(),
  sessionToken: z143.string(),
  // Single-use Clerk sign-in ticket: redeem in the browser on a public page
  // via window.Clerk.client.signIn.create({ strategy: 'ticket', ticket })
  // to establish the real Clerk session gp-webapp's middleware gates on.
  signInToken: z143.string(),
  cookies: TestFixtureCookiesSchema,
  expiresAt: z143.string()
});
var TestFixtureSessionResponseSchema = z143.object({
  userId: z143.number(),
  email: z143.string(),
  sessionToken: z143.string(),
  signInToken: z143.string(),
  cookies: TestFixtureCookiesSchema,
  expiresAt: z143.string()
});
var TestFixtureStateResponseSchema = z143.object({
  state: TestFixtureStateSchema,
  userId: z143.number(),
  campaignId: z143.number(),
  stage: ComplianceStageSchema,
  peerlyIdentityId: z143.string()
});
var DeleteTestFixtureUsersResponseSchema = z143.object({
  deleted: z143.array(z143.object({ userId: z143.number(), email: z143.string() })),
  notFound: z143.array(z143.union([z143.number(), z143.string()]))
});
var TEST_FIXTURE_ACTIVITY_MAX_PEOPLE = 500;
var TestFixtureAnswersSchema = z143.number().int().min(0).max(TEST_FIXTURE_ACTIVITY_MAX_PEOPLE);
var TestFixtureSplitSchema = z143.enum(["lean", "even"]);
var SeedTestFixtureActivityRequestSchema = z143.object({
  people: z143.number().int().min(20).max(TEST_FIXTURE_ACTIVITY_MAX_PEOPLE).optional(),
  answers: TestFixtureAnswersSchema.optional(),
  split: TestFixtureSplitSchema.optional()
}).strict().default({});
var TestFixtureActivityEffortSchema = z143.object({
  outreachId: z143.number(),
  outreachType: z143.string(),
  interactions: z143.number(),
  memos: z143.number(),
  synthesisRunId: z143.string().nullable()
});
var SeedTestFixtureActivityResponseSchema = z143.object({
  organizationSlug: z143.string(),
  people: z143.number(),
  efforts: z143.array(TestFixtureActivityEffortSchema)
});
var TestFixtureRaceQuerySchema = z143.object({
  zip: z143.string().regex(/^\d{5}$/),
  office: z143.string().trim().min(1)
}).strict();
var ApplyTestFixtureElectionRequestSchema = z143.object({ preset: TestModeElectionPresetSchema }).strict();
var ApplyTestFixtureElectionResponseSchema = z143.object({
  campaignId: z143.number(),
  preset: TestModeElectionPresetSchema,
  electionDate: z143.string()
});

// src/testFixtures/vendorMocks.ts
import { z as z144 } from "zod";
var VendorMockRecordSummarySchema = z144.object({
  id: z144.string(),
  vendor: z144.string(),
  kind: z144.string(),
  externalId: z144.string(),
  state: z144.unknown()
});
var MockActionSchema = z144.object({
  campaignId: z144.number().int().positive(),
  action: z144.enum([
    "geoapify.route.fail",
    "callhub.campaign.complete",
    "callhub.campaign.fail",
    "peerly.balance.empty",
    "peerly.cv.approve",
    "peerly.cv.reject",
    "peerly.cv.setPin",
    "peerly.phonelist.fail",
    "peerly.usecase.activate",
    "vercel.order.fail"
  ]),
  params: z144.record(z144.string(), z144.unknown()).optional()
});
var MockActionResponseSchema = z144.object({
  records: z144.array(VendorMockRecordSummarySchema)
});
var MockRecordsQuerySchema = z144.object({
  campaignId: z144.coerce.number().int().positive().optional(),
  organizationSlug: z144.string().min(1).optional()
}).refine(
  (q) => q.campaignId === void 0 !== (q.organizationSlug === void 0),
  {
    message: "Provide exactly one of campaignId or organizationSlug"
  }
);
var MockRecordsResponseSchema = z144.object({
  vendorMode: z144.enum(["live", "mock"]),
  records: z144.array(VendorMockRecordSummarySchema)
});
var RunJobResponseSchema = z144.object({
  ranAt: z144.string().datetime(),
  durationMs: z144.number()
});
var TimeTravelSchema = z144.object({
  outreachId: z144.number().int().positive(),
  action: z144.enum([
    "robocall.send_due_now",
    "robocall.dialed_48h_ago",
    "sms.start_date_today",
    "sms.start_date_passed",
    "email.send_due_now",
    "email.sent_6m_ago"
  ])
});
var TimeTravelResponseSchema = z144.object({
  outreachId: z144.number().int().positive(),
  date: z144.string().datetime().nullable(),
  dialedAt: z144.string().datetime().nullable(),
  poolFreedAt: z144.string().datetime().nullable()
});
var DeliverStripeEventRequestSchema = z144.object({
  type: z144.enum(["checkout.session.completed"]),
  sessionId: z144.string()
});
var DeliverStripeEventResponseSchema = z144.object({
  eventId: z144.string(),
  status: z144.literal("delivered")
});
var AdminOutreachActionRequestSchema = z144.object({
  action: z144.enum(["cas.approve", "results.upload"]),
  payload: z144.unknown().optional()
});
var AdminOutreachActionResponseSchema = z144.object({
  outreachId: z144.number().int().positive(),
  action: z144.string(),
  status: z144.literal("applied")
});
var EMAIL_AUDIENCE_FIXTURE_DOMAIN = "simulator.amazonses.com";
var EmailAudienceFixtureRequestSchema = z144.object({
  campaignId: z144.number().int().positive(),
  people: z144.array(
    z144.object({
      email: z144.string().email().refine(
        (email) => email.toLowerCase().endsWith(`@${EMAIL_AUDIENCE_FIXTURE_DOMAIN}`),
        "Only SES mailbox simulator addresses"
      ),
      firstName: z144.string().max(100).optional(),
      lastName: z144.string().max(100).optional()
    }).strict()
  ).min(1).max(50)
}).strict();
var EmailAudienceFixtureResponseSchema = z144.object({
  organizationSlug: z144.string(),
  count: z144.number().int().nonnegative()
});

// src/testFixtures/pollResults.ts
import { z as z145 } from "zod";
var SeedPollResultsRequestSchema = z145.object({
  personId: z145.string().min(1),
  issueTitle: z145.string().min(1),
  issueSummary: z145.string().min(1)
});
var SeedPollResultsResponseSchema = z145.object({
  pollId: z145.string(),
  pollName: z145.string()
});

// src/devEnv/devEnv.schema.ts
import { z as z146 } from "zod";
var DEV_ENV_PACKAGE_VALUES = ["gp-api", "gp-webapp", "mcp"];
var DevEnvPackageSchema = z146.enum(DEV_ENV_PACKAGE_VALUES);
var DevEnvPackageBundleSchema = z146.object({
  package: DevEnvPackageSchema,
  variables: z146.record(z146.string(), z146.string())
});
var DevEnvBundleResponseSchema = z146.object({
  bundles: z146.array(DevEnvPackageBundleSchema)
});
var DevEnvElectionSeedResponseSchema = z146.object({
  url: z146.string().url(),
  expiresAt: z146.string()
});

// src/chats/ChiefOfStaffNextSteps.ts
var PICKED_NEXT_STEPS_LEAD = "Let's work through these, one at a time:";
var pickedNextStepsMessage = (steps) => [PICKED_NEXT_STEPS_LEAD, ...steps.map((step, i) => `${i + 1}. ${step}`)].join(
  "\n"
);

// src/personProfiles/PersonProfileLink.schema.ts
import { z as z147 } from "zod";
var LinkPersonProfileOwnerInputSchema = z147.object({
  userId: z147.number().int().positive(),
  personId: z147.guid("personId must be a valid UUID"),
  linkedBy: z147.string().min(1, "linkedBy is required").max(200)
}).strict();
var GetPersonProfileLinkQuerySchema = z147.object({
  userId: z147.coerce.number().int().positive()
}).strict();
var PersonProfileLinkSchema = z147.object({
  userId: z147.number(),
  personId: z147.string().nullable(),
  fullName: z147.string().nullable(),
  profileUrl: z147.string().nullable(),
  hasProfile: z147.boolean()
});

// src/contactUploads/ContactUpload.schema.ts
import { z as z148 } from "zod";
var SERVE_IMPORT_CONTACTS_FLAG = "serve-import-contacts";
var CONTACT_UPLOAD_MAX_ROWS = 1e5;
var CONTACT_UPLOAD_MAX_BYTES = 25 * 1024 * 1024;
var CONTACT_UPLOAD_NAME_MAX_LENGTH = 60;
var CONTACT_UPLOAD_FIELDS = [
  "firstName",
  "lastName",
  "email",
  "cellPhone",
  "landline",
  "addressLine",
  "city",
  "zip"
];
var ContactUploadColumnMappingSchema = z148.object({
  firstName: z148.string().min(1),
  lastName: z148.string().min(1),
  email: z148.string().min(1).nullable(),
  cellPhone: z148.string().min(1).nullable(),
  landline: z148.string().min(1).nullable(),
  addressLine: z148.string().min(1).nullable(),
  city: z148.string().min(1).nullable(),
  zip: z148.string().min(1).nullable()
});
var PresignContactUploadFileSchema = z148.object({
  byteSize: z148.number().int().positive().max(CONTACT_UPLOAD_MAX_BYTES),
  fileName: z148.string().trim().min(1).max(255),
  name: z148.string().trim().min(1).max(CONTACT_UPLOAD_NAME_MAX_LENGTH),
  consentAffirmed: z148.literal(true),
  columnMapping: ContactUploadColumnMappingSchema
});
var PresignContactUploadFileResponseSchema = z148.object({
  uploadId: z148.string(),
  uploadUrl: z148.string(),
  expiresAt: z148.string()
});
var ContactUploadStatusSchema2 = z148.enum([
  "awaiting_file",
  "processing",
  "needs_input",
  "complete",
  "failed"
]);
var ContactUploadFailureKindSchema2 = z148.enum(["file", "transient"]);
var ContactUploadMatchOutcomeSchema2 = z148.enum([
  "pending",
  "matched",
  "new",
  "needs_input",
  "resolved",
  "skipped",
  "invalid"
]);
var ContactUploadSchema = z148.object({
  id: z148.string(),
  createdAt: z148.string(),
  name: z148.string(),
  fileName: z148.string(),
  uploadedBy: z148.object({ id: z148.number(), name: z148.string().nullable() }).nullable(),
  status: ContactUploadStatusSchema2,
  columnMapping: ContactUploadColumnMappingSchema,
  // Null until the file has been read into rows.
  rowCount: z148.number().nullable(),
  matchedCount: z148.number(),
  newCount: z148.number(),
  needsInputCount: z148.number(),
  skippedCount: z148.number(),
  invalidCount: z148.number(),
  updatedCount: z148.number(),
  unchangedCount: z148.number(),
  completedAt: z148.string().nullable(),
  failureReason: z148.string().nullable(),
  failureKind: ContactUploadFailureKindSchema2.nullable()
});
var ListContactUploadsResponseSchema = z148.object({
  uploads: z148.array(ContactUploadSchema)
});
var ContactUploadCandidateSchema = z148.object({
  personId: z148.string(),
  firstName: z148.string().nullable(),
  lastName: z148.string().nullable(),
  addressLine: z148.string().nullable(),
  city: z148.string().nullable(),
  zip: z148.string().nullable(),
  age: z148.number().nullable()
});
var ContactUploadRowSchema = z148.object({
  id: z148.string(),
  rowIndex: z148.number(),
  firstName: z148.string().nullable(),
  lastName: z148.string().nullable(),
  email: z148.string().nullable(),
  cellPhone: z148.string().nullable(),
  landline: z148.string().nullable(),
  addressLine: z148.string().nullable(),
  city: z148.string().nullable(),
  zip: z148.string().nullable(),
  outcome: ContactUploadMatchOutcomeSchema2,
  personId: z148.string().nullable(),
  isNewPerson: z148.boolean(),
  changedFields: z148.array(z148.string()),
  // Filled only for rows that need input: the people the user can pick from.
  candidates: z148.array(ContactUploadCandidateSchema),
  suggestedPersonId: z148.string().nullable()
});
var ListContactUploadRowsQuerySchema = z148.object({
  outcome: z148.enum(["needs_input", "processed", "skipped", "invalid"]).default("processed"),
  search: z148.string().trim().max(200).optional(),
  cursor: z148.coerce.number().int().min(0).optional(),
  take: z148.coerce.number().int().min(1).max(100).default(50)
});
var ListContactUploadRowsResponseSchema = z148.object({
  rows: z148.array(ContactUploadRowSchema),
  nextCursor: z148.number().nullable(),
  total: z148.number()
});
var SetContactUploadRowMatchSchema = z148.union([
  z148.object({ personId: z148.guid() }),
  z148.object({ newPerson: z148.literal(true) }),
  z148.object({ skip: z148.literal(true) })
]);
var AcceptSuggestedMatchesResponseSchema = z148.object({
  accepted: z148.number(),
  upload: ContactUploadSchema
});
var ContactFieldSourceSchema = z148.discriminatedUnion("kind", [
  z148.object({ kind: z148.literal("constituent_file") }),
  z148.object({
    kind: z148.literal("upload"),
    uploadId: z148.string(),
    uploadName: z148.string(),
    uploadedAt: z148.string()
  })
]);
var ContactSourcesResponseSchema = z148.object({
  fields: z148.object({
    email: ContactFieldSourceSchema.nullable(),
    cellPhone: ContactFieldSourceSchema.nullable(),
    landline: ContactFieldSourceSchema.nullable(),
    address: ContactFieldSourceSchema.nullable()
  }),
  uploadRows: z148.array(
    z148.object({
      rowId: z148.string(),
      uploadId: z148.string(),
      uploadName: z148.string(),
      uploadedAt: z148.string()
    })
  ),
  // Notes, statuses, interactions or outreach recorded against this person:
  // Change match does not carry them to the new person.
  hasActivity: z148.boolean()
});
export {
  ACTIVE_WEEKS_BEFORE_ELECTION,
  ACTIVITY_CONDITION_ACTION_VALUES,
  AGE_DIM_KEY,
  AGE_FILTER_KEY_RANGES,
  AGE_KEY_TO_PACK_BUCKETS,
  ANNOTATION_KIND_VALUES2 as ANNOTATION_KIND_VALUES,
  ANNOTATION_RESOURCE_TYPE_VALUES2 as ANNOTATION_RESOURCE_TYPE_VALUES,
  ARTIFACT_FEEDBACK_KIND_VALUES2 as ARTIFACT_FEEDBACK_KIND_VALUES,
  ARTIFACT_RESOURCE_TYPE_VALUES2 as ARTIFACT_RESOURCE_TYPE_VALUES,
  ARTIFACT_REVIEW_VERDICT_VALUES,
  ATTACHMENT_MAX_BYTES,
  AcceptInviteResponseSchema,
  AcceptSuggestedMatchesResponseSchema,
  AcceptedAssignmentSchema,
  ActivityConditionActionSchema,
  AdminOutreachActionRequestSchema,
  AdminOutreachActionResponseSchema,
  AgentRunCandidateSummarySchema,
  AgentRunDetailSchema,
  AgentRunListItemSchema,
  AgentRunSchema,
  AgentRunsListQuerySchema,
  AnnotationAnchorSchema,
  AnnotationBugReportSchema,
  AnnotationChatSchema,
  AnnotationKindSchema2 as AnnotationKindSchema,
  AnnotationNoteAttachmentSchema,
  AnnotationNoteSchema,
  AnnotationResourceTypeSchema2 as AnnotationResourceTypeSchema,
  AnnotationResponseSchema,
  AnnotationReviewSchema,
  AnnotationSchema,
  AnnotationsListResponseSchema,
  ApplyTestFixtureElectionRequestSchema,
  ApplyTestFixtureElectionResponseSchema,
  ApplyTestModeRequestSchema,
  ApproveManagedCivicPanelInputSchema,
  ApprovePollRequestSchema,
  ApproveSmsOutreachRequestSchema,
  ArtifactFeedbackKindSchema2 as ArtifactFeedbackKindSchema,
  ArtifactFeedbackResponseSchema,
  ArtifactFeedbackSchema,
  ArtifactResourceTypeSchema2 as ArtifactResourceTypeSchema,
  ArtifactReviewSchema,
  ArtifactReviewVerdictSchema,
  AttachmentDownloadUrlResponseSchema,
  AttachmentPresignRequestSchema,
  AttachmentPresignResponseSchema,
  AudioUploadUrlRequestSchema,
  AudioUploadUrlResponseSchema,
  BALLOT_ACCESS_CATEGORY,
  BALLOT_READY_POSITION_LEVEL_VALUES,
  BRIEFING_DATE_RANGE_VALUES,
  BRIEFING_REVIEW_STATUS_VALUES,
  BUILD_CITIZENS_PANEL_PURPOSE,
  BallotReadyPositionLevel,
  BallotReadyPositionLevelSchema,
  BboxSchema,
  BriefingAdminListQuerySchema,
  BriefingAdminRowSchema,
  BriefingDateRangeFilterSchema,
  BriefingDispatchPreviewSchema,
  BriefingFeedbackListResponseSchema,
  BriefingReviewLookupResponseSchema,
  BriefingReviewStatusFilterSchema,
  BuildDoorKnockingRouteSchema,
  CAMPAIGN_CREATED_BY_VALUES,
  CAMPAIGN_LAUNCH_STATUS_VALUES,
  CAMPAIGN_MANAGER_PRODUCT_OVERVIEW_SENTINEL,
  CAMPAIGN_MANAGER_START_STORY_SENTINEL,
  CAMPAIGN_SORT_KEYS,
  CAMPAIGN_STATUS_VALUES,
  CAMPAIGN_STORY_CATEGORY,
  CAMPAIGN_STORY_FIELD_MAX_LENGTH,
  CAMPAIGN_TASK_CATALOG,
  CAMPAIGN_TIER_VALUES,
  CAMPAIGN_UPDATE_HISTORY_TYPE_VALUES,
  CHANNEL_FANOUT,
  CHAT_ATTACHMENTS_PER_CONVERSATION,
  CHAT_ATTACHMENT_ALLOWED_MIME_TYPES,
  CHAT_ATTACHMENT_MAX_BYTES,
  CHAT_ATTACHMENT_MAX_PAGES,
  CHAT_ATTACHMENT_SOURCE_VALUES,
  CHAT_ATTACHMENT_STATUS_VALUES,
  CHAT_CARD_KINDS,
  CHAT_FEEDBACK_KIND_VALUES,
  CHAT_MESSAGE_MAX_LENGTH,
  CHAT_STREAM_ERROR_CODE_VALUES,
  CIVIC_PANEL_BALANCE_STATUSES,
  CIVIC_PANEL_BALANCE_STATUS_LABELS,
  CIVIC_PANEL_JOIN_KEYWORD,
  CIVIC_PANEL_JOIN_LINE,
  CIVIC_PANEL_JOIN_LINES,
  CIVIC_PANEL_JOIN_REFUSED_MESSAGE,
  CIVIC_PANEL_LEAVE_KEYWORD,
  CIVIC_PANEL_LEAVE_LINE,
  CIVIC_PANEL_PAGE_HREF,
  CIVIC_PANEL_PLACE_KINDS,
  CIVIC_PANEL_REACH_CHANNELS,
  CIVIC_PANEL_SEAT_COUNT,
  CIVIC_PANEL_SEGMENT,
  CIVIC_PANEL_SHORT_GROUPS_SHOWN,
  CIVIC_PANEL_STATUS_LABELS,
  COMMITTEE_NAME_PLACEHOLDER_MESSAGE,
  COMMITTEE_TYPE_VALUES,
  COMMUNITY_INPUT_PURPOSE,
  COMMUNITY_INPUT_QUESTION_MAX_LENGTH,
  COMPLIANCE_DEFAULT_ISSUE_TITLE,
  COMPLIANCE_STAGE_VALUES,
  COMPOSE_HANDOFF_CHANNEL_SCHEMAS,
  CONSTITUENT_FEEDBACK_AUDIO_KEY_MAX_LENGTH,
  CONSTITUENT_FEEDBACK_AUDIO_MAX_BYTES,
  CONSTITUENT_FEEDBACK_CAPTURE_METHOD_VALUES,
  CONSTITUENT_FEEDBACK_CHANNEL_VALUES,
  CONSTITUENT_FEEDBACK_DESIRED_OUTCOME_MAX_LENGTH,
  CONSTITUENT_FEEDBACK_EXTRACTION_STATUS_VALUES,
  CONSTITUENT_FEEDBACK_ISSUE_LABEL_MAX_LENGTH,
  CONSTITUENT_FEEDBACK_MAX_ISSUES,
  CONSTITUENT_FEEDBACK_STANCE_VALUES,
  CONSTITUENT_FEEDBACK_TRANSCRIPT_MAX_LENGTH,
  CONSTITUENT_NAME_TOKEN,
  CONTACTS_MADE_BUCKETS,
  CONTACTS_MADE_DIM_KEY,
  CONTACT_NAME_TOKENS,
  CONTACT_REST_DAYS,
  CONTACT_UPLOAD_FIELDS,
  CONTACT_UPLOAD_MAX_BYTES,
  CONTACT_UPLOAD_MAX_ROWS,
  CONTACT_UPLOAD_NAME_MAX_LENGTH,
  CONTENT_TYPE_VALUES,
  CURRENT_AGE_FILTER_KEYS,
  CampaignCreatedBy,
  CampaignCreatedBySchema,
  CampaignLaunchStatus,
  CampaignLaunchStatusSchema,
  CampaignSchema,
  CampaignStatus,
  CampaignStatusSchema,
  CampaignStoryRewriteSchema,
  CampaignStorySchema,
  CampaignStrategyPhaseKeySchema,
  CampaignTaskDefinitionSchema,
  CampaignTierSchema,
  CampaignUpdateHistoryTypeSchema,
  CampaignWithLiveContextSchema,
  CampaignWithPositionNameSchema,
  CancelOutreachResponseSchema,
  CancelSmsOutreachRequestSchema,
  ChatAnchorSchema,
  ChatAnchorSnapshotSchema,
  ChatAttachmentDownloadResponseSchema,
  ChatAttachmentListResponseSchema,
  ChatAttachmentSchema,
  ChatAttachmentSourceSchema,
  ChatAttachmentStatusSchema,
  ChatCardKindSchema,
  ChatCardSchema,
  ChatClarifyOptionSchema,
  ChatClarifyQuestionSchema,
  ChatConversationSchema,
  ChatConversationUsageSchema,
  ChatFeedbackKindSchema,
  ChatHistoryItemSchema,
  ChatHistoryQuerySchema,
  ChatHistoryResponseSchema,
  ChatMessageFeedbackSchema,
  ChatMessageFeedbackStateSchema,
  ChatMessageSchema,
  ChatMessageSegmentCitationPayloadSchema,
  ChatMessageSegmentSchema,
  ChatSourceSchema,
  ChatStreamErrorCodeSchema,
  ChatStreamEventSchema,
  CivicPanelActivitySchema,
  CivicPanelBalanceSchema,
  CivicPanelBalanceStatusSchema,
  CivicPanelCompositionGroupSchema,
  CivicPanelCompositionPlaceSchema,
  CivicPanelCompositionSchema,
  CivicPanelJoinedBySchema,
  CivicPanelPlaceKindSchema,
  CivicPanelProgressSchema,
  CivicPanelReachChannelSchema,
  CivicPanelReachGroupSchema,
  CivicPanelReachListResponseSchema,
  CivicPanelReachOptionSchema,
  CivicPanelReachOptionsResponseSchema,
  CivicPanelStatusResponseSchema,
  CivicPanelStatusSchema2 as CivicPanelStatusSchema,
  CivicPanelSummarySchema,
  CommitteeNameSchema,
  CommitteeTypeSchema,
  CommunityEventSchema,
  CommunityEventsGeneratingSchema,
  CommunityEventsReadySchema,
  CommunityEventsResponseSchema,
  CommunityEventsResultSchema,
  CommunityIssueChatAnchorSchema,
  CommunityIssuesDispatchRequestSchema,
  CommunityIssuesDispatchResultSchema,
  ComplianceStage,
  ComplianceStageSchema,
  ComplianceStateDomainSchema,
  ComplianceStateOutputSchema,
  ComposeHandoffPayloadSchema,
  ConfirmConstituentFeedbackSchema,
  ConstituentActivityEventSchema,
  ConstituentActivityEventTypeSchema,
  ConstituentActivitySchema,
  ConstituentActivityTypeSchema,
  ConstituentFeedbackCaptureMethodSchema,
  ConstituentFeedbackChannelSchema,
  ConstituentFeedbackExtractionStatusSchema,
  ConstituentFeedbackIssueSchema,
  ConstituentFeedbackListResponseSchema,
  ConstituentFeedbackSchema,
  ConstituentFeedbackStanceSchema,
  ConstituentPriorityAnswerSchema,
  ConstituentRefSchema,
  ContactFieldSourceSchema,
  ContactImportConstituentActivitySchema,
  ContactNoteInputSchema,
  ContactNoteListResponseSchema,
  ContactNoteSchema,
  ContactRefSchema,
  ContactSourcesResponseSchema,
  ContactStatusFieldSchema2 as ContactStatusFieldSchema,
  ContactStatusSourceSchema2 as ContactStatusSourceSchema,
  ContactStatusesSchema,
  ContactUploadCandidateSchema,
  ContactUploadColumnMappingSchema,
  ContactUploadMatchOutcomeSchema2 as ContactUploadMatchOutcomeSchema,
  ContactUploadRowSchema,
  ContactUploadSchema,
  ContactUploadStatusSchema2 as ContactUploadStatusSchema,
  ContentTypeSchema,
  ContrastResponseSchema,
  CreateAnnotationRequestSchema,
  CreateChatRequestSchema,
  CreateChatResponseSchema,
  CreateCivicPanelReachListInputSchema,
  CreateContrastRequestSchema,
  CreateDoorKnockingTurfSchema,
  CreateOrdinanceRequestSchema,
  CreateOutreachDraftRequestSchema,
  CreatePriorityInputSchema,
  CreateServeDoorKnockingTurfSchema,
  CreateTestOrganizationRequestSchema,
  CreateUserInputSchema,
  DASHBOARD_CARD_BUCKET_VALUES,
  DASHBOARD_CARD_SNOOZE_DAYS,
  DASHBOARD_CARD_TYPE_VALUES,
  DEFAULT_TEXT_REPLY_RATE,
  DEV_ENV_PACKAGE_VALUES,
  DISTRICT_GRID_CELL_DEGREES,
  DOMAIN_STATUS_VALUES,
  DOOR_KNOCKING_BULLET,
  DOOR_KNOCKING_INSTRUCTIONS_MAX_LENGTH,
  DOOR_KNOCKING_LEGACY_UNIT_KEY_COLUMNS,
  DOOR_KNOCKING_TALKING_POINTS_MAX_LENGTH,
  DOOR_KNOCKING_UNIT_KEY_COLUMNS,
  DOOR_KNOCK_OUTCOME_VALUES,
  DOOR_KNOCK_STATUSES,
  DO_NOT_KNOCK_LABELS,
  DashboardCardBucketSchema,
  DashboardCardSchema,
  DashboardCardTypeSchema,
  DashboardCardsQuerySchema,
  DashboardCardsResponseSchema,
  DayOfWeekSchema,
  DeleteTestFixtureUsersResponseSchema,
  DeliverStripeEventRequestSchema,
  DeliverStripeEventResponseSchema,
  DenyPollRequestSchema,
  DenySmsOutreachRequestSchema,
  DevEnvBundleResponseSchema,
  DevEnvElectionSeedResponseSchema,
  DevEnvPackageBundleSchema,
  DevEnvPackageSchema,
  DispatchMeetingAgentRequestSchema,
  DispatchMeetingAgentResultSchema,
  DoNotKnockStatusSchema2 as DoNotKnockStatusSchema,
  DomainStatusSchema,
  DoorKnockConstituentActivitySchema,
  DoorKnockOutcomeSchema,
  DoorKnockStatusSchema,
  DoorKnockingAddressPreviewResponseSchema,
  DoorKnockingArchiveRequestSchema,
  DoorKnockingAudienceCheckResponseSchema,
  DoorKnockingDemographicsShape,
  DoorKnockingEvaluateRequestSchema,
  DoorKnockingEvaluateResponseSchema,
  DoorKnockingEvaluatedPersonSchema,
  DoorKnockingModeSchema,
  DoorKnockingOutreachDetailSchema,
  DoorKnockingPackArraySchema,
  DoorKnockingPackDimSchema,
  DoorKnockingPackManifestSchema,
  DoorKnockingPackRequestSchema,
  DoorKnockingPreviewDoorSchema,
  DoorKnockingPreviewLocationSchema,
  DoorKnockingPurposeSchema,
  DoorKnockingResidentTargetSchema,
  DoorKnockingResidentsAddressSchema,
  DoorKnockingResidentsRequestSchema,
  DoorKnockingResidentsResponseSchema,
  DoorKnockingRouteHeaderSchema,
  DoorKnockingRoutePayloadSchema,
  DoorKnockingTalkingPointsDraftResponseSchema,
  DoorKnockingTalkingPointsPurposeSchema,
  DoorKnockingTurfSchema,
  ELECTION_LEVEL_VALUES,
  EMAIL_AUDIENCE_FIXTURE_DOMAIN,
  EMAIL_BLOCK_BUTTON_LABEL_MAX_LENGTH,
  EMAIL_BLOCK_TYPES,
  EMAIL_BODY_MAX_LENGTH,
  EMAIL_BUTTON_LABEL_MAX_LENGTH,
  EMAIL_CONTENT_EXAMPLES,
  EMAIL_CONTENT_TEXT_MAX_LENGTH,
  EMAIL_GOAL_MAX_LENGTH,
  EMAIL_HEADING_MAX_LENGTH,
  EMAIL_HEADLINE_MAX_LENGTH,
  EMAIL_IMAGE_ALLOWED_MIME_TYPES,
  EMAIL_IMAGE_ALT_MAX_LENGTH,
  EMAIL_IMAGE_MAX_BYTES,
  EMAIL_LAYOUTS,
  EMAIL_LAYOUT_PRESETS,
  EMAIL_MAX_BLOCKS,
  EMAIL_MERGE_TAGS,
  EMAIL_MIN_CHARGE_CENTS,
  EMAIL_PARAGRAPH_MAX_LENGTH,
  EMAIL_PREVIEW_TEXT_MAX_LENGTH,
  EMAIL_SAMPLE_IMAGE_URLS,
  EMAIL_SEND_WINDOW_DAYS,
  EMAIL_SUBJECT_MAX_LENGTH,
  EMAIL_THEMES,
  EMAIL_URL_MAX_LENGTH,
  EXPERIMENT_RUN_STATUS_VALUES,
  EditContrastRequestSchema,
  EditPollRequestSchema,
  EditSmsOutreachDateRequestSchema,
  EditSmsOutreachRequestSchema,
  ElectedOfficeSchema,
  ElectedOfficeSupportSchema,
  ElectionLevel,
  ElectionLevelSchema,
  EligibilitySchema,
  EmailAiDraftFieldsSchema,
  EmailAiDraftRequestSchema,
  EmailAiDraftResponseSchema,
  EmailAudienceFixtureRequestSchema,
  EmailAudienceFixtureResponseSchema,
  EmailBlockDraftSchema,
  EmailBlockSchema,
  EmailConfirmDeclinedSchema,
  EmailConfirmRequestSchema,
  EmailConfirmResponseSchema,
  EmailContentDraftSchema,
  EmailContentSchema,
  EmailContentViewSchema,
  EmailDraftSaveContentSchema,
  EmailDraftSaveFieldsSchema,
  EmailDraftSaveSchema,
  EmailDraftSchema,
  EmailForwardConfirmStateSchema,
  EmailImagePresignRequestSchema,
  EmailImagePresignResponseSchema,
  EmailLayoutKeySchema,
  EmailLayoutPresetKeySchema,
  EmailPausedSendSchema,
  EmailPausedSendsResponseSchema,
  EmailPreviewFieldsRequestSchema,
  EmailPreviewRequestSchema,
  EmailPreviewResponseSchema,
  EmailPublicModeSchema,
  EmailSchema,
  EmailSendSchema,
  EmailSenderSchema,
  EmailSenderUpdateSchema,
  EmailTestSendResponseSchema,
  EmailThemeKeySchema,
  EmailTokenRequestSchema,
  EmailUnsubscribeStateSchema,
  ExperimentRunStatusSchema,
  ExperimentVariantSchema,
  ExperimentVariantsResponseSchema,
  ExperimentVariantsSchema,
  FEEDBACK_REPORT_MEMO_LIMIT,
  FEEDBACK_SEED_MAX_COUNT,
  FEEDBACK_SYNTHESIS_SOURCE_TYPE,
  FOLLOW_UP_ANSWER_VALUES,
  FOLLOW_UP_BUSINESS_DAYS,
  FOLLOW_UP_STATUS_LABELS,
  FeedbackReportChannelSchema,
  FeedbackReportMemoSchema,
  FeedbackReportResponseSchema,
  FeedbackSynthesisCompleteEventSchema,
  FeedbackSynthesisResponseRowsSchema,
  FeedbackThemeDetailSchema,
  FeedbackThemeMemberSchema,
  FeedbackThemeSummarySchema,
  FilingInstructionsContentSchema,
  FilterablePaginationSchema,
  FinalizeRequestSchema,
  FollowUpAnswerSchema,
  FollowUpStatusResponseSchema,
  FollowUpStatusSchema2 as FollowUpStatusSchema,
  GENERATION_STATUS_VALUES,
  GET_ANSWERS_MARKER,
  GET_ANSWERS_MESSAGE,
  GOTV_WINDOW_DAYS,
  GenerateContrastsResponseSchema,
  GenerationStatus,
  GenerationStatusSchema,
  GeneratorSourceSchema,
  GeoJsonMultiPolygonSchema,
  GeoJsonPolygonSchema,
  GeoJsonShapeSchema,
  GeoShapeLabelSchema,
  GeoShapeLabelsSchema,
  GetIndividualActivitiesResponseSchema,
  GetPersonPriorityAnswersResponseSchema,
  GetPersonProfileLinkQuerySchema,
  HIGH_CONFIDENCE_MIN_REPLIES,
  HIGH_CONFIDENCE_MIN_SHARE,
  HOUSEHOLD_KEY_RESIDENCE_COLUMNS,
  IDEOLOGY_BUCKET_VALUES,
  INCOME_RANGE_MAPPING,
  ISSUE_CAPTURE_OFF_ERROR_CODE,
  ISSUE_TAG_SOURCE_VALUES,
  ISSUE_TAG_STATUS_VALUES,
  IdOverridesSchema,
  IdentifyOpponentsResponseSchema,
  IdeologyBucketSchema,
  InviteMemberResponseSchema,
  IssueSalienceSchema,
  IssueTagListResponseSchema,
  IssueTagRefSchema,
  IssueTagSchema,
  IssueTagSourceSchema,
  IssueTagStatusSchema,
  JUDGE_KEY_PREFIX,
  JUDGE_REPLAY_KEY_PREFIX,
  JUDGE_RUN_ID_MAX_LENGTH,
  JUDGE_RUN_ID_PREFIX,
  JudgeOverrideSchema,
  JudgeReplaySchema,
  KNOCKABLE_DIM_KEY,
  KNOCKABLE_VALUES,
  LinkAttachRequestSchema,
  LinkAttachResponseSchema,
  LinkPersonProfileOwnerInputSchema,
  LinkSmsOutreachJobRequestSchema,
  ListCampaignsPaginationSchema,
  ListContactUploadRowsQuerySchema,
  ListContactUploadRowsResponseSchema,
  ListContactUploadsResponseSchema,
  ListContrastsResponseSchema,
  ListDetailContactsResponseSchema,
  ListDetailDemographicsSchema,
  ListDetailOutreachHistoryEntrySchema,
  ListDetailReachabilitySchema,
  ListProposalSchema,
  ListSampleSchema,
  ListUsersPaginationSchema,
  LogContactInteractionInputSchema,
  LogContactInteractionResponseSchema,
  MAJOR_GROUP_SHARE,
  MANAGED_CIVIC_PANEL_ACTIONS,
  MANAGED_CIVIC_PANEL_BACKED_OUT_MESSAGE,
  MANAGED_CIVIC_PANEL_CARD_CTA,
  MANAGED_CIVIC_PANEL_CONSENT_VERSION,
  MANAGED_CIVIC_PANEL_EXHAUSTED_CARD_CTA,
  MANAGED_CIVIC_PANEL_EXHAUSTED_MARKER,
  MANAGED_CIVIC_PANEL_EXHAUSTED_MESSAGE,
  MANAGED_CIVIC_PANEL_HOW_IT_WORKS,
  MANAGED_CIVIC_PANEL_PROGRESS_CARD_CTA,
  MANAGED_CIVIC_PANEL_SET_UP_MESSAGE,
  MANAGED_CIVIC_PANEL_STATUSES,
  MANAGED_PANEL_PROGRESS_PHASES,
  MAX_CHECK_RAISES,
  MAX_GEO_SHAPE_NAME_LENGTH,
  MAX_LIST_SAMPLE_SIZE,
  MAX_OVERLAP_SAVED_FILTER_SETS,
  MAX_PAGE,
  MAX_PAGINATION_OFFSET,
  MAX_PRECINCT_FILTER_VALUES,
  MAX_RESULTS_PER_PAGE,
  MERGE_TAGS,
  MIN_BIO_LENGTH,
  MIN_TEXTS_PER_ROUND,
  MIN_VOICES_PER_GROUP,
  ManagedCivicPanelProgressSchema,
  ManagedCivicPanelResponseSchema,
  ManagedCivicPanelSchema,
  ManagedCivicPanelStatusSchema2 as ManagedCivicPanelStatusSchema,
  MeetingAgentDispatchKindSchema,
  MilestoneWindowSchema,
  MockActionResponseSchema,
  MockActionSchema,
  MockRecordsQuerySchema,
  MockRecordsResponseSchema,
  MyAssignmentSchema,
  MyAssignmentsResponseSchema,
  MyElectedOfficeSchema,
  MyPendingInviteResponseSchema,
  NOT_A_VOTER_LABELS,
  NO_CIVIC_PANEL_JOINS,
  NewContactsReachableSchema,
  NextElectionForPositionSchema,
  NotAVoterReasonSchema,
  NotAVoterStatusSchema2 as NotAVoterStatusSchema,
  OCR_STATUS_VALUES2 as OCR_STATUS_VALUES,
  OFFICE_LEVEL_VALUES,
  ONBOARDING_CARD_KEY_VALUES,
  ONBOARDING_CARD_STATUS_VALUES,
  ONBOARDING_PRIORITY_OPTION_KINDS,
  ONBOARDING_STEP_VALUES,
  ORDINANCE_DRAFT_DISCLAIMER,
  ORDINANCE_EXPORT_FORMATS,
  ORDINANCE_FLOW_STEP_VALUES,
  ORDINANCE_QUALITY_LOOP_STATUS_VALUES,
  ORDINANCE_SEED_TYPE_VALUES,
  ORDINANCE_STATUS_VALUES,
  ORGANIZATION_ROLE_VALUES,
  ORGANIZATION_STATUS_VALUES,
  OUTREACH_DRAFT_TYPES,
  OUTREACH_EVENT_LOCATION_MAX_LENGTH,
  OUTREACH_PURPOSE_VALUES,
  OUTREACH_STATUS_VALUES,
  OUTREACH_TYPE_VALUES,
  OcrStatusSchema2 as OcrStatusSchema,
  OfficeLevelSchema,
  OnboardingCardKeyParamSchema,
  OnboardingCardKeySchema,
  OnboardingCardSchema,
  OnboardingCardStatusSchema,
  OnboardingCardsResponseSchema,
  OnboardingOtherPrioritySchema,
  OnboardingPriorityOptionKindSchema,
  OnboardingPriorityOptionSchema,
  OnboardingPriorityOptionsSchema,
  OnboardingStep,
  OnboardingStepSchema,
  OpponentProfileResponseSchema,
  OrdinanceAuthorityFindingSchema,
  OrdinanceAuthoritySchema,
  OrdinanceChatAnchorSchema,
  OrdinanceClarifyAnswerSchema,
  OrdinanceClarifyAnswersSchema,
  OrdinanceClarifyOptionSchema,
  OrdinanceClarifyQuestionSchema,
  OrdinanceClarifySchema,
  OrdinanceComparableSchema,
  OrdinanceComparablesSchema,
  OrdinanceCurrentLawSummarySchema,
  OrdinanceExistingLawSchema,
  OrdinanceFlowStepSchema,
  OrdinanceHistoryEntrySchema,
  OrdinanceLawPointSchema,
  OrdinanceLegislativeHistorySchema,
  OrdinanceListResponseSchema,
  OrdinanceNextStepOfferSchema,
  OrdinancePresentComparablesSchema,
  OrdinancePresentDraftSchema,
  OrdinanceQualityCheckSchema,
  OrdinanceQualityIterationSummarySchema,
  OrdinanceQualityIterationsResponseSchema,
  OrdinanceQualityLoopPhaseSchema,
  OrdinanceQualityLoopSchema,
  OrdinanceQualityLoopStatusSchema,
  OrdinanceQualityReportSchema,
  OrdinanceQualityRunSchema,
  OrdinanceQualityRunStatusSchema,
  OrdinanceResearchChapterSchema,
  OrdinanceResearchSchema,
  OrdinanceSchema,
  OrdinanceScratchpadNoteSchema,
  OrdinanceScratchpadSchema,
  OrdinanceSeedTypeSchema,
  OrdinanceSourceSchema,
  OrdinanceStatusCountsSchema,
  OrdinanceStatusSchema,
  OrdinanceSummarySchema,
  OrganizationRoleSchema,
  OrganizationSchema,
  OrganizationStatus,
  OrganizationStatusSchema,
  OrganizationWithStatusSchema,
  OutreachArchiveRequestSchema,
  OutreachArchiveResponseSchema,
  OutreachAssigneeSchema,
  OutreachAssigneesResponseSchema,
  OutreachAwaitingResultsItemSchema,
  OutreachAwaitingResultsResponseSchema,
  OutreachConstituentActivitySchema,
  OutreachDetailSchema,
  OutreachDraftConflictSchema,
  OutreachEventDetailsSchema,
  OutreachProposalSchema,
  OutreachPurposeSchema,
  OutreachReceiptSchema,
  OutreachResultsParseReportSchema,
  OutreachResultsTargetSchema,
  OutreachResultsUploadRequestSchema,
  OutreachResultsUploadRowSchema,
  OutreachRobocallDetailSchema,
  OutreachSocialDetailSchema,
  OutreachStatusSchema,
  OutreachTypeSchema,
  OutsideContactSchema,
  P2P_SCRIPT_MAX_LENGTH,
  PACK_AGE_BANDS,
  PACK_AGE_BUCKETS,
  PACK_AGE_BUCKET_TO_BAND,
  PACK_AGE_UNKNOWN,
  PACK_ARRAY_TYPES,
  PACK_CONTACTS_MADE_MAX,
  PACK_CORE_ARRAYS,
  PACK_DIM_WIDTHS,
  PACK_EXCLUDED_PEOPLE_MAX,
  PACK_FORMAT_REVISION,
  PACK_STREAM_ALIGNMENT,
  PACK_STREAM_FRAME_HEADER_BYTES,
  PACK_STREAM_FRAME_KINDS,
  PACK_STREAM_MAGIC,
  PACK_STREAM_MAGIC_BYTES,
  PANEL_ACTIVE_WINDOW_DAYS,
  PANEL_ASSUMED_REPLY_RATE,
  PANEL_MEMBERS_PER_GROUP,
  PANEL_MIN_MEMBERS_FOR_BALANCE,
  PANEL_SEED_ASSUMED_JOIN_RATE,
  PANEL_SEED_SAMPLE_SIZE,
  PEERLY_CV_VERIFICATION_STATUS_VALUES,
  PEOPLE_FILTER_SOURCES,
  PEOPLE_FILTER_VALUE_ENUMS,
  PHONE_BANKING_CALL_NOTE_MAX_LENGTH,
  PHONE_BANKING_CREATE_SCRIPT_MAX_LENGTH,
  PHONE_BANKING_INSTRUCTIONS_MAX_LENGTH,
  PHONE_BANKING_MAX_SHEET_COUNT,
  PHONE_BANKING_NAME_MAX_LENGTH,
  PHONE_BANKING_PURPOSE_VALUES2 as PHONE_BANKING_PURPOSE_VALUES,
  PHONE_BANKING_SCRIPT_MAX_LENGTH,
  PHONE_BANKING_SHEET_SIZE,
  PHONE_BANK_CALL_OUTCOME_VALUES,
  PICKED_NEXT_STEPS_LEAD,
  PIN_DELIVERY_METHOD_VALUES,
  POLL_APPROVAL_STATUS_VALUES,
  POLL_AUDIENCE_KIND_VALUES,
  POLL_CONFIDENCE_VALUES,
  POLL_INDIVIDUAL_MESSAGE_SENDER_VALUES,
  POLL_MIN_RESPONSES,
  POLL_QUESTION_MAX_LENGTH,
  POLL_QUESTION_MIN_LENGTH,
  POLL_QUEUE_KIND_VALUES,
  POLL_SAMPLE_QUOTES_MAX,
  POLL_STATUS_VALUES,
  POLL_THEMES_MAX,
  POLL_TONE_VALUES,
  POLL_TOPICS,
  POLL_TOPIC_IDS,
  PRECINCT_DIM_KEY,
  PRECINCT_PAIR_DELIMITER,
  PRICE_PER_EMAIL_TENTH_CENTS,
  PRICE_PER_TEXT,
  PRICE_PER_TEXT_TENTH_CENTS,
  PRIORITY_ANSWER_CODE_VALUES,
  PRIORITY_ANSWER_SOURCE_VALUES,
  PRIORITY_CHECK_SIDES,
  PRIORITY_CHECK_STATES,
  PRIORITY_GATE_STEPS,
  PRIORITY_LISTEN_GATES,
  PRIORITY_RESULTS_CHANNELS,
  PRIORITY_SOURCE_VALUES,
  PRIORITY_STATUS_VERSION,
  PRIORITY_STEP_IDS,
  PRIORITY_STEP_LABELS,
  PRIORITY_STEP_PURPOSE,
  PROPOSAL_CHANNELS,
  PROPOSAL_SENT_MARKER,
  PaginationMetaSchema,
  PaginationOptionsSchema,
  PaginationSchema,
  PanelRepliesUploadedEventSchema,
  PasswordSchema,
  PastOutreachRefSchema,
  PaymentHoldCardIntentResponseSchema,
  PaymentHoldCardRequestSchema,
  PaymentHoldCardResponseSchema,
  PeerlyCvVerificationStatus,
  PeerlyCvVerificationStatusSchema,
  PendingInviteSchema,
  PeopleAggregatesResponseSchema,
  PeopleFilterSourceSchema,
  PeopleFiltersSchema,
  PeopleListDetailAggregatesResponseSchema,
  PeopleListPaginationSchema,
  PeopleListResponseSchema,
  PeopleOverlapCountRequestSchema,
  PeopleOverlapCountResponseSchema,
  PeoplePrecinctsResponseSchema,
  PersonPriorityAnswerSchema,
  PersonProfileLinkSchema,
  PersonSchema,
  PhoneBankCallOutcomeSchema,
  PhoneBankingCallResultSchema,
  PhoneBankingConstituentActivitySchema,
  PhoneBankingCreateResponseSchema,
  PhoneBankingCreateSchema,
  PhoneBankingInteractionSchema,
  PhoneBankingListEntrySchema,
  PhoneBankingListPersonSchema,
  PhoneBankingListSchema,
  PhoneBankingOutreachDetailSchema,
  PhoneBankingPurposeSchema2 as PhoneBankingPurposeSchema,
  PhoneBankingScriptDraftRequestSchema,
  PhoneBankingScriptDraftResponseSchema,
  PhoneBankingScriptPurposeSchema,
  PhoneSchema,
  PinDeliveryMethod,
  PinDeliveryMethodSchema,
  PinDeliverySchema,
  PollAnalysisStatusSchema,
  PollApprovalStatusSchema,
  PollAudienceKindSchema,
  PollConfidenceSchema,
  PollConstituentActivitySchema,
  PollExpansionSummarySchema,
  PollIndividualMessageSenderSchema,
  PollQueueItemSchema,
  PollQueueKindSchema,
  PollQueueQuerySchema,
  PollQueueResponseSchema,
  PollResultsSchema,
  PollReviewDetailSchema,
  PollSampleQuoteSchema,
  PollStatusSchema,
  PollThemeSentimentSchema,
  PollToneSchema,
  PollTopicSchema,
  PrecinctOptionSchema,
  PresignContactUploadFileResponseSchema,
  PresignContactUploadFileSchema,
  PresignRequestSchema,
  PresignResponseSchema,
  PriorityAnswerCodeSchema,
  PriorityAnswerSourceSchema,
  PriorityChatAnchorSchema,
  PriorityCheckSideSchema,
  PriorityCheckStateSchema,
  PriorityReadStatusSchema,
  PriorityResultsChannelSchema,
  PriorityResultsGroupSchema,
  PriorityResultsPointSchema,
  PriorityResultsSchema,
  PriorityResultsSendSchema,
  PrioritySchema,
  PrioritySourceSchema,
  PriorityStatusSchema,
  PriorityStepCheckInputSchema,
  PriorityStepCheckSchema,
  PriorityStepContrastInputSchema,
  PriorityStepContrastSchema,
  PriorityStepIdSchema,
  PriorityStepSchema,
  PriorityStepStateSchema,
  PriorityThemeCommentKindSchema,
  PriorityThemeCommentSchema,
  PriorityThemeCommentsSchema,
  PriorityThemeSchema,
  PriorityTierSchema,
  ProReceiptSchema,
  ProposalAudienceFiltersSchema,
  ProposalChannelSchema,
  ProposalEventSchema,
  ProposalLinkSchema,
  RACE_OPPONENT_COLLECTION_STATUS_VALUES,
  RACE_OPPONENT_CONTRAST_ROUTING_VALUES,
  RACE_OPPONENT_CONTRAST_STATUS_VALUES,
  RACE_OPPONENT_FINDING_KIND_VALUES,
  RACE_OPPONENT_RESEARCH_STATUS_VALUES,
  RACE_OPPONENT_SOURCE_TYPE_VALUES,
  READ_REPRESENTATIVENESS_LABELS,
  RECOMMENDED_LIST_CHANNEL_VALUES,
  RECOMMENDED_LIST_INTENT_VALUES,
  RECOMMENDED_LIST_VARIANT_INTENT,
  RECOMMENDED_LIST_VARIANT_VALUES,
  REPORT_BACK_MARKER,
  REPORT_BACK_PURPOSE,
  ROBOCALL_AUDIO_ALLOWED_MIME_TYPES,
  ROBOCALL_AUDIO_MAX_BYTES,
  ROBOCALL_FREE_OFFER_SEND_DATE,
  ROBOCALL_FREE_OFFER_VARIANT,
  ROBOCALL_PURPOSE_VALUES,
  ROBOCALL_SCRIPT_MAX_LENGTH,
  ROUND_ONE_TEXT_SHARE,
  ROUND_TWO_DRAW_LEAD_BUSINESS_DAYS,
  ROUTE_CONTRAST_TARGET_VALUES,
  ROUTE_TARGET_ACTIVITY_LIMIT,
  ROUTE_TARGET_NOTE_LIMIT,
  RaceCandidateSchema,
  RaceFrequencyByBrHashSchema,
  RaceFullSchema,
  RaceListItemArraySchema,
  RaceListItemSchema,
  RaceMilestonesSchema,
  RaceOpponentActivityItemSchema,
  RaceOpponentActivityResponseSchema,
  RaceOpponentCollectionStatusSchema,
  RaceOpponentContrastRoutingSchema,
  RaceOpponentContrastSchema,
  RaceOpponentContrastStatusSchema,
  RaceOpponentFieldAnalysisSchema,
  RaceOpponentFindingKindSchema,
  RaceOpponentFindingSchema,
  RaceOpponentReportResponseSchema,
  RaceOpponentResearchSchema,
  RaceOpponentResearchStatusResponseSchema,
  RaceOpponentResearchStatusSchema,
  RaceOpponentResearchWithFindingsSchema,
  RaceOpponentResponseSchema,
  RaceOpponentReviewSchema,
  RaceOpponentSchema,
  RaceOpponentSourceTypeSchema,
  RaceOpponentStandoutActionHaystaqSchema,
  RaceOpponentStandoutActionSchema,
  RaceOpponentSummarySchema,
  RaceOpponentThreatTierSchema,
  RaceTargetMetricsSchema,
  ReadCampaignOutputSchema,
  ReadRepresentativenessSchema,
  ReadUserOutputSchema,
  RecommendedListChannelSchema,
  RecommendedListFilterSchema,
  RecommendedListIntentSchema,
  RecommendedListSchema,
  RecommendedListVariantSchema,
  RecommendedListsResponseSchema,
  RecordConstituentFeedbackResponseSchema,
  RecordConstituentFeedbackSchema,
  RecordDoorKnockInteractionResponseSchema,
  RecordDoorKnockInteractionSchema,
  RecordPhoneBankingCallResponseSchema,
  RecordPhoneBankingCallSchema,
  ReplaceSmsOutreachJobRequestSchema,
  ReplyFlagSchema,
  ReplyFlagUpdateSchema,
  ResultsInboxKindSchema,
  RobocallAudioPresignRequestSchema,
  RobocallAudioPresignResponseSchema,
  RobocallAuthorizeRequestSchema,
  RobocallAuthorizeResponseSchema,
  RobocallAuthorizeStatusSchema,
  RobocallComplianceChecksSchema,
  RobocallComplianceRequestSchema,
  RobocallComplianceVerdictSchema,
  RobocallConstituentActivitySchema,
  RobocallDraftCreateRequestSchema,
  RobocallDraftCreateResponseSchema,
  RobocallFreeOfferResponseSchema,
  RobocallNumberResponseSchema,
  RobocallPromoApplyRequestSchema,
  RobocallPromoStateResponseSchema,
  RobocallPurposeSchema,
  RobocallSaveCardIntentResponseSchema,
  RobocallScriptDraftRequestSchema,
  RobocallScriptDraftResponseSchema,
  RolesSchema,
  RouteContrastRequestSchema,
  RouteContrastResponseSchema,
  RouteContrastTargetSchema,
  RouteContrastToStoryResponseSchema,
  RouteContrastToTextingResponseSchema,
  RoutePathGeometrySchema,
  RoutePayloadAddressSchema,
  RoutePayloadRepresentingSchema,
  RoutePayloadStopSchema,
  RoutePayloadTargetNotesSchema,
  RoutePayloadTargetSchema,
  RouteTargetActivitySchema,
  RunJobResponseSchema,
  SAMPLE_TARGET_REPLIES,
  SERVE_IMPORT_CONTACTS_FLAG,
  SERVE_OUTREACH_PURPOSE_VALUES,
  SERVE_PHONE_BANKING_PURPOSE_VALUES,
  SERVE_SMS_PURPOSE_VALUES,
  SERVE_SOCIAL_PLATFORM_EXCLUSIONS,
  SERVE_SOCIAL_PURPOSE_VALUES,
  SHOW_MANAGED_CIVIC_PANEL_INVITE,
  SIGN_UP_MODE,
  SMS_APPROVAL_STATUS_VALUES,
  SMS_BODY_MAX_LENGTH,
  SMS_COMPLIANCE_WINDOW_VALUES,
  SMS_COMPOSED_MAX_LENGTH,
  SMS_JOB_REPLACE_REASON_LABELS,
  SMS_OUTREACH_REPLIES_DEFAULT_LIMIT,
  SMS_OUTREACH_REPLIES_MAX_LIMIT,
  SMS_PURPOSE_VALUES,
  SMS_RESTRICTED_WORDS,
  SMS_STANDARDS_RULE_VALUES,
  SOCIAL_ASSET_KIND_VALUES,
  SOCIAL_ASSET_PLATFORM_VALUES,
  SOCIAL_DRAFT_MESSAGE_MAX_LENGTH,
  SOCIAL_PLATFORM_EXCLUSION_REASON,
  SOCIAL_POST_COPY_MAX_LENGTH,
  SOCIAL_PURPOSE_VALUES,
  SOCIAL_TONE_VALUES,
  SOCIAL_VIDEO_PLATFORMS,
  SOCIAL_VIDEO_SCRIPT_MAX_LENGTH,
  SPEECH_SYNTHESIS_ENGINE_VALUES,
  SPEECH_SYNTHESIS_VOICE_VALUES,
  START_MANAGED_CIVIC_PANEL_MARKER,
  START_MANAGED_CIVIC_PANEL_MESSAGE,
  SUPPORT_ANSWER_VALUES,
  SUPPORT_STATUS_ROLLUP_LABELS,
  SYNTHESIS_RUN_STATUS_VALUES,
  SYNTHESIZE_SPEECH_MAX_TEXT_LENGTH,
  SaveOrdinanceClarifyAnswerRequestSchema,
  SeedFeedbackRequestSchema,
  SeedFeedbackResponseSchema,
  SeedPollResultsRequestSchema,
  SeedPollResultsResponseSchema,
  SeedTestFixtureActivityRequestSchema,
  SeedTestFixtureActivityResponseSchema,
  SendChatMessageRequestSchema,
  ServeDoorKnockingTalkingPointsPurposeSchema,
  ServeOutreachPurposeSchema,
  ServePhoneBankingCreateSchema,
  ServePhoneBankingPurposeSchema,
  ServePhoneBankingScriptDraftRequestSchema,
  ServePollAudienceSchema,
  ServePollCreateResponseSchema,
  ServePollCreateSchema,
  ServePollDraftRequestSchema,
  ServePollDraftResponseSchema,
  ServePollExpansionCreateResponseSchema,
  ServePollExpansionCreateSchema,
  ServeSmsCreateRequestSchema,
  ServeSmsCreateResponseSchema,
  ServeSmsDraftRequestSchema,
  ServeSmsDraftResponseSchema,
  ServeSmsPurposeSchema,
  ServeSocialDraftRequestSchema,
  ServeSocialGenerateRequestSchema,
  ServeSocialPurposeSchema,
  ServeSocialSaveRequestSchema,
  SetArtifactFeedbackRequestSchema,
  SetArtifactReviewVerdictRequestSchema,
  SetChatMessageFeedbackRequestSchema,
  SetContactUploadRowMatchSchema,
  SetDistrictOutputSchema,
  SetDoNotKnockResponseSchema,
  SetDoNotKnockSchema,
  SetNotAVoterResponseSchema,
  SetNotAVoterSchema,
  SetOnboardingPrioritiesInputSchema,
  ShowListMapSchema,
  SmsAdminDetailResponseSchema,
  SmsAdminJobStatsSchema,
  SmsApprovalQueueItemSchema,
  SmsApprovalQueueResponseSchema,
  SmsApprovalStatusSchema,
  SmsComplianceWindow,
  SmsComplianceWindowSchema,
  SmsDraftRequestSchema,
  SmsDraftResponseSchema,
  SmsJobReplaceReasonSchema,
  SmsOutreachRepliesFilterSchema,
  SmsOutreachRepliesQuerySchema,
  SmsOutreachRepliesSchema,
  SmsOutreachReplySchema,
  SmsOutreachResultsSchema,
  SmsPurposeSchema,
  SmsStandardsRuleSchema,
  SmsStandardsVerdictSchema,
  SmsTestMessageRequestSchema,
  SmsTestMessageResponseSchema,
  SmsVendorAccountSchema,
  SmsVendorBalanceResponseSchema,
  SocialAssetKindSchema,
  SocialAssetPlatformSchema,
  SocialAssetSchema,
  SocialDraftRequestSchema,
  SocialDraftResponseSchema,
  SocialGenerateRequestSchema,
  SocialGenerateResponseSchema,
  SocialPurposeSchema,
  SocialSaveRequestSchema,
  SocialToneSchema,
  SortablePaginationSchema,
  SpeechSynthesisEngineSchema,
  SpeechSynthesisVoiceSchema,
  StanceCountsSchema,
  StartOpponentResearchRequestSchema,
  StartOpponentResearchResponseSchema,
  StartSelfResearchResponseSchema,
  StatusChangeConstituentActivitySchema,
  SubmitToPeerlyOutputSchema,
  SubmitToPeerlyPinDeliveryChannelsSchema,
  SummarySourceSchema,
  SupportAnswerSchema,
  SupportEstimateSchema,
  SupportStatusRollupSchema2 as SupportStatusRollupSchema,
  SynthesisRunSchema,
  SynthesisRunStatusSchema,
  SynthesizeSpeechRequestSchema,
  SynthesizeSpeechResponseSchema,
  SynthesizeSpeechSegmentSchema,
  TCR_COMPLIANCE_STATUS_VALUES,
  TEAM_INVITE_ROLE_VALUES,
  TEMPLATE_BIO_MARKER,
  TEST_FIXTURE_ACTIVITY_MAX_PEOPLE,
  TEST_FIXTURE_STATE_VALUES,
  TEST_MODE_ELECTION_PRESET_VALUES,
  TEST_MODE_FAMILY_VALUES,
  TEST_MODE_ONBOARDING_PRESET_VALUES,
  TEST_MODE_ORGANIZATION_TYPE_VALUES,
  TEST_MODE_PRO_PRESET_VALUES,
  TEST_MODE_TEN_DLC_PRESET_VALUES,
  TEST_MODE_TERM_PRESET_VALUES,
  TEXT_SEND_ROBOCALL_SWAPS,
  THEME_VOICES_PER_GROUP,
  TRACKER_TASK_SKIP_REASON_VALUES,
  TRACKER_TASK_SNOOZE_DAYS,
  TaskChannelFanoutSchema,
  TaskChannelSchema,
  TaskPersonalizationSchema,
  TaskStatusSchema,
  TaskTimingSchema,
  TaskTypeSchema,
  TcrComplianceStatusSchema,
  TeamInviteMetadataSchema,
  TeamInviteRoleSchema,
  TeamMemberSchema,
  TeamMemberStatsSchema,
  TeamResponseSchema,
  TeamStatsResponseSchema,
  TenDlcStatusBucketKeySchema,
  TenDlcStatusBucketSchema,
  TenDlcStatusEntrySchema,
  TenDlcStatusSnapshotSchema,
  TestFixtureActivityEffortSchema,
  TestFixtureAnswersSchema,
  TestFixtureCookiesSchema,
  TestFixtureRaceQuerySchema,
  TestFixtureSessionResponseSchema,
  TestFixtureSplitSchema,
  TestFixtureStateResponseSchema,
  TestFixtureStateSchema,
  TestFixtureUserResponseSchema,
  TestModeActiveOrganizationSchema,
  TestModeElectionPresetSchema,
  TestModeFamilySchema,
  TestModeFamilyStateSchema,
  TestModeOnboardingPresetSchema,
  TestModeOrganizationSchema,
  TestModeOrganizationTypeSchema,
  TestModeProPresetSchema,
  TestModeRaceSchema,
  TestModeStateSchema,
  TestModeTenDlcPresetSchema,
  TestModeTermPresetSchema,
  TextConstituentActivitySchema,
  ThemeSchema,
  ThemeVoicesSchema,
  TimeTravelResponseSchema,
  TimeTravelSchema,
  TrackerTaskSkipReasonSchema,
  TranscribeSessionRequestSchema,
  TranscribeSessionResponseSchema,
  UNDERREPRESENTED_GROUP_NAMES,
  UNSURE_AREAS_NAME,
  USER_ROLE_VALUES,
  USER_SORT_KEYS,
  UnderrepresentedGroupSchema,
  UpdateCampaignM2MSchema,
  UpdateCivicPanelInputSchema,
  UpdateCommitteeNameOutputSchema,
  UpdateCommitteeNameSchema,
  UpdateContactStatusInputSchema,
  UpdateDoorKnockingTurfSchema,
  UpdateFilingUrlOutputSchema,
  UpdateFilingUrlSchema,
  UpdateFollowUpInputSchema,
  UpdateIssueTagSchema,
  UpdateManagedCivicPanelInputSchema,
  UpdateNoteRequestSchema,
  UpdateOrdinanceRequestSchema,
  UpdatePasswordSchema,
  UpdatePriorityInputSchema,
  UpdateUserInputSchema,
  UserMetaDataObjectSchema,
  UserMetaDataSchema,
  UserRoleSchema,
  VOTED_STATUS_VALUES,
  VOTER_CONTACT_SCHEDULE,
  VOTER_LIKELIHOOD_LABELS,
  VOTER_NAME_TOKEN,
  VOTER_OUTREACH_ATTRIBUTION_SOURCE_VALUES,
  VendorMockRecordSummarySchema,
  VotedStatusSchema,
  VoterLikelihoodSchema2 as VoterLikelihoodSchema,
  VoterOutreachAttributionSourceSchema,
  WEBSITE_STATUS_VALUES,
  WHY_BROWSING_VALUES,
  WILL_VOTE_ANSWER_VALUES,
  WIN_SOCIAL_PLATFORM_EXCLUSIONS,
  WebsiteStatusSchema,
  WhyBrowsingSchema,
  WillVoteAnswerSchema,
  ZipCodesArraySchema,
  ZipSchema,
  allocateSeats,
  answersNeeded,
  campaignPhaseWindows,
  campaignWasEverPro,
  canPutOffTask,
  canSetTaskAsideForGood,
  checkEmailBlocks,
  checkSmsStandards,
  cityFromDistrictName,
  cityNameCase,
  civicPanelFreshnessText,
  civicPanelShortGroups,
  countCivicPanelLines,
  createEnumFilterSchema,
  createIdFilterSchema,
  createNumericFilterSchema,
  createPrecinctFilterSchema,
  decodePrecinctPair,
  deriveRobocallProtectedParts,
  deriveSmsProtectedParts,
  emptyPriorityStatus,
  encodeAgeBucket,
  encodePrecinctPair,
  excludedSocialPlatformsForPurpose,
  findCivicPanelJoinLine,
  findCivicPanelLeaveLine,
  findSmsRestrictedWords,
  formatRobocallCallbackNumber,
  hasGenuineIssue,
  hasRedline,
  isCheckAnswered,
  isCivicPanelOnlyList,
  isGenuineBioPlainText,
  isGenuineIssue,
  isGetAnswersMessage,
  isGoodReadReportBackCard,
  isHighConfidence,
  isLegacyDoorKnockingUnitKey,
  isManagedCivicPanelCard,
  isPlaceholderCommitteeName,
  isReportBackMessage,
  isSocialPlatformAllowed,
  isToolRefusal,
  isTrackerTaskSetAside,
  joinGroupNames,
  judgeOverrideKeys,
  judgeReplayBaseKey,
  judgeReplaySeedKey,
  judgeReplaySweepKey,
  judgeRunId,
  makeOptional,
  managedCivicPanelCardContent,
  managedCivicPanelCardSourceId,
  managedCivicPanelExplanation,
  managedCivicPanelHowItWorks,
  managedCivicPanelOneInN,
  managedCivicPanelProgressCardSourceId,
  managedPanelProgressPhase,
  mergeStepCheck,
  mergeTagToken,
  mintProposalKey,
  openListenBefore,
  outreachHasGoneOut,
  paginationFilter,
  panelExpectedAnswers,
  panelGoalMembers,
  panelSeedSampleSize,
  parsePriorityStatus,
  parseRedline,
  parseRedlineLines,
  phaseForDate,
  phaseStart,
  pickedNextStepsMessage,
  placeSeats,
  recommendedSampleSize,
  redlineToAmended,
  redlineToOriginal,
  reportBackMessage,
  resolveContactStatusLabel,
  resolveTrackerTaskDate,
  robocallDisclosureLine,
  serializeRedline,
  shapePartCount,
  shapePolygons,
  socialAssetKindForPlatform,
  splitPriorityText,
  timelineElectionDate,
  timelinePhase,
  trackerTaskPutOffDate,
  trackerTimelineStart,
  underrepresentedGroupName,
  voterContactSendDate,
  voterContactSendOffsetDays,
  zCoerceDate,
  zDate
};
//# sourceMappingURL=index.mjs.map